webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/HkoM2M/%3F1704484106521&title=Herbaceous%20Perennial%20Plants&summary=The%20long-awaited%20third%20edition%20of%20Allan%20Armitage%19s%20masterpiece%20on%20garden%20perennials%20was%20released%20in%20April%20of%202008.%20Armitage%19s%20extensive%20traveling%2C%20teaching%20and%20trialing%20experiences%20provide%20a%20depth%20of%20understanding%20of%20the%20best%20ornamental%20perennials%20for%20&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/HkoM2M/%3F1704484106521",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=The%20long-awaited%20third%20edition%20of%20Allan%20Armitage%19s%20masterpiece%20on%20garden%20perennials%20was%20released%20in%20April%20of%202008.%20Armitage%19s%20extensive%20trave%0Dhttps://textcafe.co/books/HkoM2M/%3F1704484106521&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/HkoM2M/%3F1704484106521&posttype=link&caption=The%20long-awaited%20third%20edition%20of%20Allan%20Armitage%19s%20masterpiece%20on%20garden%20perennials%20was%20released%20in%20April%20of%202008.%20Armitage%19s%20extensive%20traveling%2C%20teaching%20and%20trialing%20experiences%20provide%20a%20depth%20of%20understanding%20of%20the%20best%20ornamental%20perennials%20for%20",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/HkoM2M/%3F1704484106521&description=The%20long-awaited%20third%20edition%20of%20Allan%20Armitage%19s%20masterpiece%20on%20garden%20perennials%20was%20released%20in%20April%20of%202008.%20Armitage%19s%20extensive%20traveling%2C%20teaching%20and%20trialing%20experiences%20provide%20a%20depth%20of%20understanding%20of%20the%20best%20ornamental%20perennials%20for%20&media=https://textcafe.co/books/HkoM2M/tc-custom/9781610583800.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9781610583800&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=kA6VgfxsstIC&amp;rdid=book-kA6VgfxsstIC&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781610583800').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/HkoM2M/tc-custom/9781610583800.jpg?1704484106521',
        alt: 'Herbaceous Perennial Plants'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "xhtml/cover", "xhtml/title", "xhtml/preface01", "xhtml/preface02", "xhtml/preface03", "xhtml/preface04", "xhtml/ch01", "xhtml/ch01a", "xhtml/ch01b", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/HkoM2M/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_xhtml_cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_xhtml_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_xhtml_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_xhtml_title__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_xhtml_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_xhtml_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_xhtml_preface01__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_xhtml_preface01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_xhtml_preface01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_xhtml_preface02__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_xhtml_preface02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_xhtml_preface02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_xhtml_preface03__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_xhtml_preface03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_xhtml_preface03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_xhtml_preface04__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_xhtml_preface04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_xhtml_preface04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_xhtml_ch01__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_xhtml_ch01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_xhtml_ch01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_xhtml_ch01a__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_xhtml_ch01a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_xhtml_ch01a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_xhtml_ch01b__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_xhtml_ch01b___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_xhtml_ch01b__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_xhtml_ch02__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_xhtml_ch02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_xhtml_ch02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_xhtml_ch03__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_xhtml_ch03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_xhtml_ch03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_xhtml_ch03a__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_xhtml_ch03a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_xhtml_ch03a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_xhtml_ch04__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_xhtml_ch04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_xhtml_ch04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_xhtml_ch05__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_xhtml_ch05___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_xhtml_ch05__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_xhtml_ch06__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_xhtml_ch06___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_xhtml_ch06__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_xhtml_ch07__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_xhtml_ch07___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_xhtml_ch07__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_xhtml_ch08__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_xhtml_ch08___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_xhtml_ch08__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_xhtml_ch09__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_xhtml_ch09___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_xhtml_ch09__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_xhtml_ch10__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_xhtml_ch10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_xhtml_ch10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_xhtml_ch11__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_xhtml_ch11___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_xhtml_ch11__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_xhtml_ch12__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_xhtml_ch12___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_xhtml_ch12__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_xhtml_ch13__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_xhtml_ch13___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_xhtml_ch13__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_xhtml_ch14__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_xhtml_ch14___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_xhtml_ch14__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_xhtml_ch15__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_xhtml_ch15___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_xhtml_ch15__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_xhtml_ch16__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_xhtml_ch16___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_xhtml_ch16__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_xhtml_ch16a__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_xhtml_ch16a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_xhtml_ch16a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_xhtml_ch17__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_xhtml_ch17___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_xhtml_ch17__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_xhtml_ch18__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_xhtml_ch18___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_xhtml_ch18__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_xhtml_ch18a__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_xhtml_ch18a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_xhtml_ch18a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_xhtml_ch19__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_xhtml_ch19___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_xhtml_ch19__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_xhtml_ch20__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_xhtml_ch20___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_xhtml_ch20__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_xhtml_ch21__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_xhtml_ch21___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_xhtml_ch21__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_xhtml_ch22__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_xhtml_ch22___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_xhtml_ch22__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_xhtml_ch23__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_xhtml_ch23___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_xhtml_ch23__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_xhtml_ch24__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_xhtml_ch24___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_xhtml_ch24__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_xhtml_gloss__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_xhtml_gloss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_xhtml_gloss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_xhtml_index01__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_xhtml_index01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_xhtml_index01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_xhtml_index01a__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_xhtml_index01a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_xhtml_index01a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_xhtml_index02__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_xhtml_index02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_xhtml_index02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_xhtml_credit__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_xhtml_credit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_xhtml_credit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_xhtml_ded__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_xhtml_ded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_xhtml_ded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_xhtml_ack__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_xhtml_ack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_xhtml_ack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_xhtml_copy__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_xhtml_copy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_xhtml_copy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_last__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_last__);
/*jshint esversion: 6 */


















































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/xhtml/cover",
    "name": "xhtml/cover",
    "component": __WEBPACK_IMPORTED_MODULE_4__components_xhtml_cover___default.a
  }, {
    "path": "/xhtml/title",
    "name": "xhtml/title",
    "component": __WEBPACK_IMPORTED_MODULE_5__components_xhtml_title___default.a
  }, {
    "path": "/xhtml/preface01",
    "name": "xhtml/preface01",
    "component": __WEBPACK_IMPORTED_MODULE_6__components_xhtml_preface01___default.a
  }, {
    "path": "/xhtml/preface02",
    "name": "xhtml/preface02",
    "component": __WEBPACK_IMPORTED_MODULE_7__components_xhtml_preface02___default.a
  }, {
    "path": "/xhtml/preface03",
    "name": "xhtml/preface03",
    "component": __WEBPACK_IMPORTED_MODULE_8__components_xhtml_preface03___default.a
  }, {
    "path": "/xhtml/preface04",
    "name": "xhtml/preface04",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_xhtml_preface04___default.a
  }, {
    "path": "/xhtml/ch01",
    "name": "xhtml/ch01",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_xhtml_ch01___default.a
  }, {
    "path": "/xhtml/ch01a",
    "name": "xhtml/ch01a",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_xhtml_ch01a___default.a
  }, {
    "path": "/xhtml/ch01b",
    "name": "xhtml/ch01b",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_xhtml_ch01b___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_47__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/HkoM2M/tc-custom/9781610583800.jpg?1704484106521",
      "alt": "This image is the cover for the book Herbaceous Perennial Plants"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Herbaceous Perennial Plants\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The third edition of the comprehensive—and entertaining—gardening reference by the master horticulturalist.")]), _c('br'), _c('br'), _vm._v("This is the long-awaited third edition of Allan Armitage’s masterpiece on garden perennials. Armitage’s extensive traveling, teaching, and trialing experiences provide a depth of understanding of the best ornamental perennials for North American gardens unparalleled by any other garden writer. "), _c('br'), _c('br'), _vm._v("One of the most definitive and conclusive books written about perennials, the first edition was designated as one of the best seventy-five books written in the last seventy-five years by the American Horticulture Society. Now the third edition of “The Big Perennial Book” (as it is fondly referred to by many practitioners) describes 3,600 species in 1224 pages. More than three hundred color photos complement detailed text filled with the author’s pointed observations of plant performance, cultivar selection, and current taxonomy. In addition, his trademark wit and passion are both in abundance, making reading as pleasurable as it is informative.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Allan M. Armitage\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    University of Georgia\n   ")])])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('svg:svg', {
    attrs: {
      "viewbox": "0 0 825 1184"
    }
  }, [_c('svg:image', {
    attrs: {
      "height": "1184",
      "transform": "translate(0 0)",
      "width": "825",
      "xlink:href": "../images/9781610583800.jpg"
    }
  })], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "title"
    }
  }), _c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('strong', [_vm._v("HERBACEOUS PERENNIAL PLANTS")])])]), _c('a', {
    attrs: {
      "id": "page_ii"
    }
  }, [_c('p', {
    staticClass: "h1sub"
  }, [_c('strong', [_vm._v("A Treatise on their Identification, Culture, and Garden Attributes")])]), _vm._v(" "), _c('p', {
    staticClass: "edition"
  }, [_vm._v("Third Edition")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('strong', [_vm._v("Allan M. Armitage")]), _c('br'), _vm._v("University of Georgia")])])])])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "preface01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('strong', [_vm._v("Some Thoughts of the Author")])])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_c('strong', [_vm._v("On a Third Edition:")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While awash in obscure cultivars of an obscure genus at 5:00 on an obscure morning, I asked myself why I was doing this. In fact, that question arose on many obscure mornings. The reasons are many, but the only one that counts is “Because I want to”. I love this book; I love seeing it in peoples’ hands, on bookshelves, in retail garden centers, on coffee tables, and worn out and tattered in the garden. As I’ve wandered around gardens and nurseries since the second edition was published, it was obvious that new cultivars, new genera and new names had to be brought up to date. Books on perennials come and go, but damned if I was going to watch this one end up on the clearance table in some Book Mart. Writing a new edition is not nearly as sexy as writing a new book, but almost as difficult. So, here it is, not because I had to, but because I wanted to.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_c('strong', [_vm._v("On the Internet vs. Books:")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the first edition was written in 1989, the Internet was in its infancy, crashing around like a drunken sophomore. As I finished the second edition in 1997, far more information was available, and the future of this medium was pretty obvious. In 2008, there is no subject that cannot be searched, found, and occasionally believed on the Internet. Information about plants is everywhere, from catalogs and photos, to personal opinions about every plant (and author) known to man. How many times have I been told that people (especially young people) don’t read any more, so why bother with all those printed words when you can find an e-book online? I have been asked “Why write a reference book that will be out of date when the next catalog appears, especially when anyone can find information for free at home?” Perhaps I am an old fogey, but for me, books will never go away, and a good book becomes a friend. I have never felt the same contentment hunched over a laptop wired to God knows where, as I have when curled in a comfy chair with a good book. Never will. Perhaps books will go the way of the VCR, and perhaps Gens X, Y and Z may never read a word I write, but I’ll still keep penning away. See you in that comfy chair.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Having said that, the Internet has made buying plants, especially unusual plants, easier than ever before. Specialty nurseries can attract customers from all over the country more efficiently and with less expense than sending out thousands of paper catalogs. If the Internet has changed anything, it is not what we read but how we buy. Today, the successful nurseryman and the inquisitive gardener more frequently meet online in the ether, not in line at the store.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('em', [_c('strong', [_vm._v("On the Decline of Gardening:")])])])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("If I listened to the plant marketing gurus out there, I would believe that gardening is on its deathbed. According to them, nobody cares about plants, only plant function. Nobody cares about gardens, only lifestyles. Heck, so few people actually garden anymore that it is amazing any plants are sold at all. I have heard so many times that “gardening is work”, nobody wants to work, too much time, too much effort, yada, yada, yada, that I am nauseated. I might even believe such drivel if I was a marketing fellow, but those comments aren’t at all consistent with my experiences. Perhaps they need to join me for a few weeks when I speak to gardeners and industry people like you. The hundreds and hundreds of “gardeners” who find their way to my talks are not coming to see my pretty face. They are there because they love the subject, and can’t get enough. Good grief, look at the catalogs, look at the stores—people would not be spending money on breeding, promotion and distribution of plants if they believed nobody cared. I have no doubt the markets are changing, and no doubt that the data are real, but gardening and gardeners aren’t going anywhere for a long time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That is not to say change has not occurred. One of the disturbing trends has been the closing of some fine nurseries since the last edition was published. Most times, such shut-downs are normal; competition, poor management, or tired owners who want to relax a little more. Online sites and newer ventures have more than made up for the number of nurseries that have been lost; however, when places like Heronswood Nursery in Oregon shutters its northwestern doors, we are all a little wounded.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_c('strong', [_vm._v("On the Meaning of Gardening:")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When gardeners are asked to describe reasons for gardening, three words emerge time and again: therapeutic, creative and exciting. Such words are more often associated with sporting events than gardening, however, therapy, creativity, and excitement are integral parts of gardening.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Therapeutic, because of the feeling that all is well with the world when our hands are in Mother Earth. Therapeutic because when a seed is sown, a cutting rooted, or seedling planted, we have accomplished something important.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Creative, because artistry is an inescapable part of gardening. A swath of "), _c('em', [_vm._v("Astilbe")]), _vm._v(" brightens the shade, a grouping of cool-leaved "), _c('em', [_vm._v("Artemisia")]), _vm._v(" brings calm to its neighbors, and a half dozen forget-me-nots sing of spring. Each grouping creates vistas of beauty. We do not require a degree in landscape architecture to create such beauty; all we need is the simple love of gardening.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Exciting is a word seldom attributed to gardening. But is it not exciting to watch a garden change with time? To watch "), _c('em', [_vm._v("Asarum")]), _vm._v(", wild ginger, bull through the soil in early spring, anticipate the popping of the buds of balloon flower, and anticipate the magic of the re-emergence of resurrection flower, is truly exciting.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_c('strong', [_vm._v("Voices about Gardening:")])])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("Perhaps a couple of quotes from the past are also appropriate. The first is attributed to the great plant hunter Ernest Henry Wilson, who wrote it just three years ")]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("before his death in 1930. “There are no happier folk than plant-lovers and none more generous than those who garden. There is a delightful freemasonry about them; they mingle on a common plane, share freely their knowledge and with advice help one over the stepping stones that lead to success. It is truthfully said that a congenial companion doubles the pleasures and halves the discomforts of travel and so it is with the brotherhood who love plants.” E. H. Wilson, "), _c('em', [_vm._v("Plant Hunting")]), _vm._v(", v.1, 1927.")])]), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("A second quote comes from another one of my former students, who wrote an essay on the why people embrace perennials in their gardens. Those who believe our students aren’t among the finest in the world need to come and visit my classes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Americans, as a rule, live with a certain sense of urgency. Perhaps this is the price we pay for living in such a young country. Why waste time with some fickle plant which will flower only for a few short moments each year when there are countless annuals just begging to bloom all summer long? The commitment perennials require represents the driving force behind gardening as a whole. When someone kills a window box of petunias, there is no love lost. Odds are that a quick trip to Kmart will have the window box blooming again in short order. Let there be no doubt about the glorious beauty of a well-planted annual garden. But, for all their show and eager-ness-to-please, annuals provoke no anticipation. To be among an established garden teaches one why we have gardens at all; gardens are our refuge from the irritations of everyday life, a place of peace, serenity and provide the hope and anticipation of good things to come.” Ken James, student, 1995. By the way, today, Ken and his wife Leah are proud owners of James Greenhouses in beautiful Colbert, Georgia, and are exceptional growers of perennials.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_c('strong', [_vm._v("On a Garden:")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A garden is a melding of different plants, including trees, shrubs, and herbaceous species. A garden lacks grandeur and grace without the architecture and framework provided by stately trees. A single specimen, such as a cedar of Lebanon, can define an entire garden. Like a snow-capped mountain in the distance, it is never out of sight or out of mind. Shrubs are indispensable for screening, massing, form and texture. From abelia to Zenobia, they provide the glue that bonds the trees and herbaceous plants together. Broad sweeps of annuals such as geraniums, celosia and marigolds provide interest through the gardening season and, like magnets, draw the eye to their carpet of color. Herbaceous perennials add a unique charm and flavor to any garden.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }, [_vm._v("There are few times when perennials do not add interest and change. From barren winter ground, through frenzied activity in the spring, until flower buds are visible, perennials are always changing. Finally, the flowers can wait no longer and islands of color blaze like flares in the night. Many have foliage more colorful than flowers, fruits that compete with holly, and fall colors as dramatic as sugar maples. To the connoisseur and amateur, there is nothing more colorful and interesting than a well-conceived perennial border. However, all great borders have backdrops of hedges or tree canopies, and annuals to fill in gaps. Perennials are an important part of the garden but are just that, a part of the garden. Perennials or a perennial border should ")]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("be woven into a garden, rather than being the garden. Such a garden is much more beautiful than the sum of the beauty of the individual parts.")])]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_c('strong', [_vm._v("On a Gardener:")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gardening is hard work! Low maintenance does not mean no maintenance. “No maintenance” gardening does not exist, although lower maintenance is possible with proper plant selection. I travel and talk with gardeners of all ages all the time. I have met sore gardeners, tired gardeners and broke gardeners, but I’ve never met an old gardener. If anything defines a gardener, it is his belief in the future. It is impossible to get old when one is always thinking about the future. Planting bulbs in the fall turns one’s thoughts to spring, planting a small tree today transports us to its cool shade tomorrow. Gardening simply does not allow one to be mentally old, because there are too many plants and beauty yet to be realized.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The one absolute of gardeners is faith. Regardless of how bad past gardens have been, every gardener believes that next year’s will be better. We even still believe that the descriptions and photos in catalogs are true! Yes, we are a trusting bunch. It is easy to age when there is nothing to believe in, nothing to hope for; gardeners, however, simply refuse to grow up. As Thomas Jefferson so eloquently stated “Though an old man, I am but a young gardener”.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_c('strong', [_vm._v("On North and South:")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many of the same species are cultivated in Montreal, Canada, and Athens, Georgia, areas characterized, as far north and deep south. I have gardened in both places as well as in East Lansing, Michigan and traveled with open eyes throughout the United States, Canada, Australia, New Zealand, the Mideast, South Africa and much of Europe. Certain species may thrive in one area but perform poorly in another. Obvious climatic differences exist among areas in North America, and even subtle differences within a garden influence plant performance. No absolute demarcation exists where North ends and South begins, but in this book the South incorporates zones 7-10 of the United States Department of Agriculture Hardiness Zone Map. Zone 7 (minimum 0-10°F) ranges as far north as Rhode Island, into Virginia, and cuts across Tennessee, Arkansas, central Oklahoma, central Texas, southern New Mexico and into Arizona and California. Many climatic factors interact with the plants’ ability to thrive or languish in a given zone, and hardiness ratings must be treated cautiously (see On Hardiness Ratings).")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }, [_vm._v("Several differences are obvious between plants of the same species grown in northern and southern locales. In the South, temperate zone plants flower earlier, are taller and may have weaker stems due to the accumulated heat. Tall forms tend to collapse without support and dwarf selections are usually more effective in the southern garden. Fertilizer need not be applied as generously in the South as in the North, particularly on tall cultivars, as additional growth is not the goal. Lanky, leggy growth occurs at the expense of flower production if too much nitrogen is applied. This happens regardless of latitude, but is more prominent in the South. The lack of snow is ")]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("a major detriment to overwintering perennials anywhere. Snow provides insulation from the cold and plants tucked beneath the protective eiderdown survive cold winters well. That is why my friends in the Gaspe’ of Quebec (zone 3) claim that gardening is so easy there.")])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Where rain replaces snow (as in the South), the major survival problem is inadequate drainage. This is particularly true on heavy clay where cold winter rains result in soggy, water-logged soils and roots, crowns, and bulbs are immersed in free-standing water. Rot organisms proliferate and plants disappear, not because of lack of cold hardiness but because they rotted in the ground. Addition of bark, peat moss or other materials that aid drainage alleviate root rot problems. Summer temperatures and humidity in the South are also detriments to perenniality. Plants not adapted to the South often perform poorly because of high night temperatures. Plants use oxygen and release carbon dioxide (similar to humans) in the process of respiration. Heat significantly affects the rate of plant respiration. In general, for every 16°F rise in temperature, respiration doubles. When night temperatures remain above 70°F the process of respiration continues unabated and competes more aggressively for the carbohydrates produced during the day by photosynthesis. This results in lack of stored carbohydrates, inhibition of chlorophyll synthesis, and lack of secondary cell wall formation. The consequence is reduced vigor, weak stunted plants and small foliage. Species not capable of acclimatization cannot store the reserves necessary to survive the winter. In many cases, death is due not to lack of winter hardiness, but lack of summer tolerance. Many problems may be minimized with fall planting, allowing plants time to build starch reserves and develop an extensive root system prior to the onset of winter. Fall planting is more critical in the South than the North for most temperate species.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Reading all the problems associated with gardening in the South, one would believe that I think southern gardening is more difficult than northern gardening. I do. More difficult, but equally wonderful. I have gardened in Athens for over 25 years now, and I think I am finally getting the hang of it. I have a ball every day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Regardless of where one gardens, two things become self-evident. The first is that soil preparation is half the battle. The second has to do with the plants one selects. Choosing plants that are adapted to the site and climate makes more sense than constantly trying to grow plants that are doomed to failure within a year or two. This is not to say that we shouldn’t experiment with plant selection—half the fun of gardening is to try plants that “are not supposed to grow here”. A quick read of good catalogs quickly shows that there is no end to species and cultivars to try, without trying to overwinter a plant native to the tropics.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_c('strong', [_vm._v("On Hardiness Ratings:")])])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("United States Department of Agriculture (USDA) hardiness zones have been used by commercial growers and gardeners for many years. Zones provide guidelines to measure plants’ ability to survive cold temperatures. To be sure, they are imperfect but they are the best we have at present to objectively evaluate geographical limits ")]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_vm._v("of adaptability. The USDA hardiness map, published in 1990 (see page xxviii), is based on minimum winter temperatures and must be interpreted cautiously. In fact, with the obvious climate changes occurring today, minimum temperatures will rise and zone designations throughout North America are bound to inch up. Many factors affect plant growth other than average minimum temperatures. For example, zone 7 in Athens, Georgia is a different world from zone 7 in central California. Although minimum temperatures may be similar, summer temperatures during the night, humidity and rainfall are quite different. Valleys and mountains in the same hardiness zone are different climatically and plants that survive in higher elevations may perish when they descend 500 feet. Experienced gardeners will tell you they have multiple zones in their own gardens. Microclimates exist even in a small garden and plants that perform poorly in one location often perk up when moved to a more sheltered environment.")])]), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Heat tolerance is more difficult to evaluate than cold tolerance. Plants respond to cold by dying; to heat by languishing. However, heat tolerance or summer hardiness ratings are equally important in predicting plant performance. European garden literature is a rich source of information but descriptions must be taken with a grain of salt. Similarly, descriptions of plant habit in the North and West may not mirror performance in the South or East. This is primarily due to differences in summer hardiness. In this text, I have attempted to provide summer hardiness ratings for all species based on experimentation, observation, existing literature, and discussions with gardeners. The southern hardiness range listed is one in which the species performs well, if other factors such as shade, sun, or proper drainage are provided. Plants may survive south of that rating, but performance is significantly reduced. The ratings must not be considered gospel, but it is hoped they will add to the body of horticultural knowledge. Plants do not read, and testing species where they are not supposed to grow often provides pleasant surprises.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_c('strong', [_vm._v("On Garden Design:")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Design is an important aspect of gardening. Great garden designers are born, not made, and nurtured through observation and experience. Principles of design abound and even I try to adhere to the basics. Most importantly, the design should be pleasing to the owner and not planned with others in mind. Select one or two dominant colors that appeal and use colors that complement, rather than distract from each other. The aim of color is to tie plants together and then wed the planting to the site. One of the reasons for the popularity of gray and silver foliage, as well as white flowers, is their ability to unite the garden.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, I am the first to admit that I am a poor designer. To me, the most important part of design is that the plants perform well in the site. I can usually be found with a trowel in one hand and a potted plant in the other, searching for any empty ground in which to place the sucker. Good performance is defined by persistent, fresh foliage, vigorous growth, and copious flower production. Selection on the basis of plant performance is more important than selection based on the color wheel. To totally ignore design, however, is to relegate a garden to a collection of plants.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_vm._v("Water features should be included in every garden. The presence of water, be it a birdbath, fountain, pond, or stream, does more to soften and define a garden than all other features combined. I am always learning about garden design and someday will discourse competently on hues, shapes, feelings, and combinations. Until then, however, I will enjoy the eclectic combination of plant material around my garden pond.")])]), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_c('strong', [_vm._v("On Plant Nomenclature:")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plant names are no different than any other names; some are long and complicated, others are short and sweet. A scientific name defines a single species only, but a common name may describe a dozen or more. A valid scientific name is accepted throughout the world, regardless of language or politics. The science of nomenclature is practiced by taxonomists who attempt to bring order out of chaos. Because one of their goals is to validate current scientific names and replace incorrect ones, scientific names are constantly evolving. Two main problems occur when taxonomist meets gardener. The first occurs when a new scientific name replaces one of long standing. "), _c('em', [_vm._v("Chrysanthemum leucanthemum")]), _vm._v(" became "), _c('em', [_vm._v("Leucanthemum vulgare;")]), _vm._v(" "), _c('em', [_vm._v("Vinca rosea")]), _vm._v(" is "), _c('em', [_vm._v("Catharanthus roseus; Helleborus corsicus")]), _vm._v(" has become "), _c('em', [_vm._v("H. argutifolius;")]), _vm._v(" and the entire "), _c('em', [_vm._v("Aster")]), _vm._v(" and "), _c('em', [_vm._v("Cimicifuga")]), _vm._v(" genera have essentially disappeared. At times, it seems like a change in nomenclature is accomplished just to keep someone busy, however, if the new name is agreed on by taxonomic authorities, it should also be accepted by horticulturists and gardeners.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This brings up the second problem. Taxonomists don’t always agree. Names accepted by one authority aren’t necessarily accepted by other equally respected authorities due to valid differences of opinion and methodology. That leaves everyone in a muddle, so muddle we do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants are listed by genus, species, variety and cultivar. A genus is a closely related group of plants consisting of one or more species. Species within a genus have more characteristics in common with each other than they do with species in other genera. Often genera are closely related and differences are difficult to discern. "), _c('em', [_vm._v("Silene")]), _vm._v(" and "), _c('em', [_vm._v("Delphinium")]), _vm._v(" are obviously different but telling the difference between "), _c('em', [_vm._v("Silene")]), _vm._v(", "), _c('em', [_vm._v("Agrostemma")]), _vm._v(" and "), _c('em', [_vm._v("Lychnis")]), _vm._v(" is difficult. The genus name begins with an upper case letter and is underlined or written in italics. A species is difficult to define but may be thought of as a type of plant distinct from other types by identifiable features. The unique characteristics are reproducible from one generation to generation through seed. A species name begins with a lower case letter and is underlined or written in italics.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xv"
    }
  }, [_vm._v("Often, individual plants may be slightly different from other members of the species and the definable characteristic is reproduced each generation. This group of plants is known as a variety and has enough similarities with others to be in the same species but is sufficiently different to be grouped as a separate variety. Often varieties are geographically distinct and have their own range. Varieties breed relatively true from seed, passing on their definable differences from parent to offspring. Varieties are preceded with “var.” and underlined or written in italics. For example, "), _c('em', [_vm._v("Muscari")])]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('em', [_vm._v("comosum")]), _vm._v(" var. "), _c('em', [_vm._v("monstrosum")]), _vm._v(" infers that a group of plants of "), _c('em', [_vm._v("Muscari comosum")]), _vm._v(" differs in some way to be placed in var. "), _c('em', [_vm._v("monstrosum")]), _vm._v(", and reproduces this difference by seed.")])]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("A cultivar refers to a cultivated variety and may be the result of hybridization, random mutation, or plant selection. For our purposes, cultivar differs from variety in that the definable factors that make a cultivar unique are not passed on from generation to generation by seed. Cultivars are propagated vegetatively by tissue culture, cuttings, grafting or divisions (although commercial breeders maintain homozygous lines so seed-propagated cultivars may be offered). Cultivars begin with upper case letters and are enclosed by single quotation marks. For example, "), _c('em', [_vm._v("Lychnis coronaria")]), _vm._v(" ‘Abbotswood Rose’ has lighter pink flowers than the species. Seeds produced by plants of ‘Abbotswood Rose’ do not result in similar plants.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The distinction between variety and cultivar diminishes when varieties are given cultivar names. For example, var. "), _c('em', [_vm._v("alba")]), _vm._v(" is a common variety of many species and usually refers to the presence of white flowers. If those plants are marketed under a cultivar name such as ‘White Knight’ or ‘Snow White’, it is impossible to know if plants are reproducible sexually or asexually. Unfortunately, in horticultural and gardening circles, the terms cultivar and variety are used interchangeably.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hybrids are common and characteristics from each parent may be found in the offspring. Interspecific hybrids are designated by an “x” and are usually reproducible only vegetatively. For example, "), _c('em', [_vm._v("Polygonatum")]), _vm._v(" x "), _c('em', [_vm._v("hybridum")]), _vm._v(" is a hybrid between "), _c('em', [_vm._v("P. multiflorum")]), _vm._v(" and "), _c('em', [_vm._v("P. odoratum")]), _vm._v(" and is reproduced by division of the rootstock. Intergeneric hybrids occasionally occur and are designated by an uppercase (X) before the name. X "), _c('em', [_vm._v("Heucherella alba")]), _vm._v(" is a hybrid between "), _c('em', [_vm._v("Heuchera brizoides")]), _vm._v(" and "), _c('em', [_vm._v("Tiarella wherryi.")]), _vm._v(" The X is not sounded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have attempted to sort out the nomenclature where possible. There is still a long way to go. Comments from readers are welcome.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_c('strong', [_vm._v("On Common Names:")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I like common names. Names like cardinal flower, resurrection lily, pussytoes, and blackberry lily are far more interesting than "), _c('em', [_vm._v("Lobelia cardinalis, Lycoris squamigera, Antennaria dioica")]), _vm._v(", and "), _c('em', [_vm._v("Belamcanda chinensis.")]), _vm._v(" They also bring with them part of the history of discovery and use of the species. Lily-of-the-valley tells me more about the plant I am about to buy than "), _c('em', [_vm._v("Convallaria majalis")]), _vm._v(", while lungwort describes a philosophy of naming plants much better than does "), _c('em', [_vm._v("Pulmonaria officinalis.")]), _vm._v(" Common names may describe the flower, such as pincushion flower ("), _c('em', [_vm._v("Scabiosa")]), _vm._v("); leaves, spotted geranium, ("), _c('em', [_vm._v("Geranium maculatum")]), _vm._v("); origin, Persian buttercup ("), _c('em', [_vm._v("Ranunculus asiaticus")]), _vm._v("); medicinal properties, self-heal ("), _c('em', [_vm._v("Prunella vulgaris")]), _vm._v("); or the discoverer, Stokes aster, ("), _c('em', [_vm._v("Stokesia")]), _vm._v("). Unfortunately, the same common name may be used for more than one species or a single species may be known by several common names, depending on area of the country.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }, [_vm._v("I have heard arguments from purists that common names are irrelevant and their use should not be encouraged. What nonsense! If one wants to see the demise of gardening, keep making it complicated. Gardening is way too complicated as it is, ")]), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_vm._v("what with 30 cultivars of this, 10 of that and names that are unpronounceable even by Professor Higgins. Gardeners and professionals should encourage common names; they make what we do so much more user-friendly.")])]), _c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_c('strong', [_vm._v("On Pronunciation:")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most people like to pronounce names with some degree of confidence. Scientific names can be intimidating and often we will not say them for fear of sounding ignorant. Like anything else, pronunciation is something that one feels confident with only with continued use. If scientific names are seldom part of one’s gardening vocabulary, we will always stumble and stutter. I have provided pronunciation guides for most genera and specific epithets principally based on books and articles but with a definite Armitage bias as well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, let’s get real. Does it really matter if "), _c('em', [_vm._v("paniculata")]), _vm._v(" is pronounced (pa-nik-ew-lah' ta) or (pa-nik-ew-lay' ta)? I prefer to pronounce "), _c('em', [_vm._v("Stokesia")]), _vm._v(" as (stokes' ee-a), in recognition of Dr. John Stokes, for whom the genus was named. However (stow-keys' ee-a) is commonly used and equally understood. So, here is the important part. Get the syllables in the right order, then fire away. Don’t worry about sounding silly, it is only the garden snob who continually tries to correct you. And who needs snobs in a garden?")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_c('em', [_c('strong', [_vm._v("On The Most Important Thing:")])])])]), _c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The most important thing about gardening is to have fun. There will be aches, frustration, money poorly spent and disappointment, but the pleasure should always outweigh the pain. Don’t get serious, ever, about gardening. The worst oxymoron in all of horticulture is “serious gardener”. Don’t be one; let it wash over you and enjoy the day.")])])])])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "preface02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xix"
    }
  }, [_c('strong', [_vm._v("An Explanation of Plant Headings")])])]), _c('a', {
    attrs: {
      "id": "page_xix"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Generic entries are provided with a pronunciation guide, common name and family. Each specific epithet (the species term) has a pronunciation guide, common name, and average height and width of mature plants. The height and width are guides to help with placement in the garden. Climate, soils, rainfall, irrigation practices and fertility will influence these guidelines. The next line provides season of flowering (based on zone 5-7), flower color, origin and cold hardiness range, based on the USDA zone hardiness map.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0xix-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indentp"
  }, [_vm._v("A quick reference table is provided for genera with two or more cultivated species. Easily identifiable differences among species are listed. Descriptions for each species and known cultivars and varieties are also included. Not every cultivar or variety has found its way into the book, but ideally most of available selections are present. Related species and hybrids are then described briefly. In general, related species are not always as available to the gardening public but have worthy garden characteristics.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Descriptions such as flower color and height are based on my experience and travels and they will differ slightly from North to South and East to West. All the bad jokes and opinions are mine, made proudly and without shame. But, regardless of how opined I may be, they are still only opinions. I welcome yours.")])])])])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "preface03"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  }, [_c('strong', [_vm._v("Leaf and Flower Terminology")])])]), _c('a', {
    attrs: {
      "id": "page_xx"
    }
  }), _c('p', {
    staticClass: "imagen"
  }, [_c('a', {
    attrs: {
      "id": "page_xx"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img-1.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xxi"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img-2.jpg",
      "width": "550px"
    }
  })])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img-3a.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }, [_c('p', {
    staticClass: "imagen"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img-3b.jpg",
      "width": "550px"
    }
  })])]), _c('div', {
    staticStyle: {
      "height": "550px"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/fxxiii-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxiv"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fxxiv-01.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xxiv"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_xxiv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxv"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fxxiv-06.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xxv"
    }
  }), _c('div', {
    staticStyle: {
      "height": "550px",
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xxv"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/f0xxv-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxvii"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/fxxvi-01a.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_xxvii"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "550px",
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/fxxvi-01b.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "550px",
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/img-4.jpg"
    }
  })])])])])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "preface04"
    }
  }, [_vm._v("USDA Plant Hardiness Zone Map")])]), _c('a', {
    attrs: {
      "id": "preface04"
    }
  }), _c('div', {
    staticStyle: {
      "height": "450px"
    }
  }, [_c('a', {
    attrs: {
      "id": "preface04"
    }
  }), _c('p', {
    staticClass: "imagen"
  }, [_c('a', {
    attrs: {
      "id": "preface04"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xxviii"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/fxxviii-01a.jpg"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xxix"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xxix"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xxix"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xxix"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "550px"
    }
  }, [_c('p', {
    staticClass: "imagen"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/fxxviii-01b.jpg"
    }
  })])])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('strong', [_vm._v("A")])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Acaena")])]), _vm._v(" (a-sane' a)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("New Zealand Bur")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Rosaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Of the 100 species in this genus, we are lucky to see a half a dozen in even the better public gardens in North America. As the common name suggests, many species are native to New Zealand, including its namesake, "), _c('em', [_vm._v("A. novae-zelandiae")]), _vm._v(". Other common names for this plant are much more alliterative and any plant with names like pirripirri bur, bidgee-widgee and biddy biddy is probably worth the price of purchase alone. The excellent plantings one sees in New Zealand and throughout the British Isles have not made the transition to the North American garden particularly well. Being native to New Zealand generally equates to sure and rapid death for eastern and southern gardeners, but a reasonable chance of success for West Coasters. Nevertheless, where conditions are favorable, the dense, 2-3\" tall mat-forming plants make attractive ground covers and are highly sought after.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some gardeners find them a little too aggressive (some lucky gardeners call them thugs), as plants can take over significant areas of the rock garden or small border. They root at the nodes and are excellent for placing between stepping stones or trailing over walls. All species prefer full sun, although "), _c('em', [_vm._v("A. microphylla")]), _vm._v(", rosy-spined New Zealand bur, "), _c('em', [_vm._v("A. inermis")]), _vm._v(", spineless acaena, and its cultivar ‘Purpurea’ and "), _c('em', [_vm._v("A. myriophylla")]), _vm._v(", fern-leaved New Zealand bur, are more shade tolerant than others. All species prefer low humidity and excellent drainage and are cold hardy to about 10°F (zones 7-8), although some sources have them hardy to zone 6.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In general, the flowers are not particularly noticeable, being small, greenish and lacking petals (apetalous). However, the pea-green to steel-blue leaves are pinnately compound and often finely serrated, and colorful bur-like fruit (achenes) keep gardeners wanting more. The burs are carried well above the foliage and are the most interesting part of the plants. Most leaves are about 2\" long but "), _c('em', [_vm._v("A. myriophylla")]), _vm._v(" has 6-8\" long green leaves with 15-17 leaflets with burs held at the end of the 6-9\" flower stems. The spherical burs are often spiny and brightly colored relative to the foliage.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("The more “burs” I see, the more I would like to see selection work done to enhance their tolerance to “real” weather. Hardiness is always a topic of discussion for those few people who know about these plants. Most books suggest zone 7 for cold hardiness, but Arrowhead Alpines in Fowlerville, Michigan (zone 5) says that "), _c('em', [_vm._v("A. inermis")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("‘Purpurea’ is “hardy and nearly indestructible here”. ‘Blue Haze’ seems to be fairly tolerant, but I have managed to kill it in my Athens garden. The vigor of "), _c('em', [_vm._v("A. fissistipula")]), _vm._v(" is well known and if crossed with blue foliage forms might provide some potentially tough, handsome offspring. Many other combinations await the bur breeder.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagation is usually by division, but cuttings and seed are also used. Seed should be sown in open containers in the fall, and placed in cold frames over winter.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_vm._v("-")]), _c('em', [_c('strong', [_vm._v("anserinifolia")])]), _vm._v(" (an-sir-in-i-foe' lee-a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Bronze Pirri-Pirri Bur")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-4\"/10\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Rose")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("New Zealand")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 7b-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This species bears dull green hairy leaves which are paler green beneath, and bronze or red fruit. Five to eight pairs of leaflets are tinged with pink and the combination is handsome indeed. The species is seldom offered but ‘Bronzette’, a cross with "), _c('em', [_vm._v("A. novae-zelandiae")]), _vm._v(", is occasionally found. Plants have bronze fruit and green-bronze foliage and grow about 6\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_vm._v("-")]), _c('em', [_c('strong', [_vm._v("microphylla")])]), _vm._v(" (mike' ro-fil-ah)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Rosy-spined New Zealand Bur")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-4\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Dull Rose")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("New Zealand")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 7-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The short plant has small silver-blue to blue-green compound leaves with a strong hint of copper and makes an exceptionally good ground cover. The flowers are rather forgettable but the handsome pink to rosy red fruit, nearly an inch across, looks like a spiny wicked thing, but is in fact quite soft. Plants are a little more cold hardy and more tolerant of poorly-drained soils than other species. If conditions are right, it can be quite aggressive.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Copper Carpet’ is about 2\" tall with copper-bronze foliage and showy red burs.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pewter Carpet’ is similar to the above but with a dull glaze to the foliage.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pulchella’ is about 4\" tall, with coppery foliage bearing hints of silver. The fruit is reddish-brown.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. buchananii")]), _vm._v(" is sometimes offered by specialist nurseries and bears pea-green, 3\" long leaves and amber burs. The leaflets, which occur in 3-6 pairs, are about an inch long and have soft silky margins on the underside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. inermis")]), _vm._v(" produces mats of low-growing foliage but has a smooth, rather than a spiny bur. Less fun, but more huggable.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. saccaticupula")]), _vm._v(" ‘Blue Haze’ is still one of the most popular cultivars for the bur gardener. The leaves are a beautiful glaucous blue and the brownish red flowers and red fruit are handsome as well. Plants are 2-4\" tall, spread well, and make attractive ground covers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Confusion")]), _vm._v(":")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("I often confuse plants of "), _c('em', [_vm._v("Acaena")]), _vm._v(" with "), _c('em', [_vm._v("Leptinella")]), _vm._v(" (which see), known as brass buttons, particularly when flowers or fruit are not present. They are both low, fernlike ground covers, both can have dark green foliage and both are made for rock gardens ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("and even for walking upon. The flowers and fruit however are obviously different; "), _c('em', [_vm._v("Acaena")]), _vm._v(" is grown for the large ornamental fruit and not the rather inconspicuous flower, while "), _c('em', [_vm._v("Leptinella")]), _vm._v(" is grown for the opposite reasons, the fruit is unexciting. They are in very different families and are not really confusing if they are seen together in flower, but let’s get real here, do you really think anyone actually plants burs and buttons together?")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Acantholimon")])]), _vm._v(" (a-kanth-o-lee' mon)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Prickly Thrift")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Plumbaginaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("This large group of plants (about 120 species) occurs predominantly in rocky, high altitude habitats and thus you would not expect to see grand swaths in St. Louis or Atlanta. The genus, however, has a loyal, if small, following among gardeners. Plants are becoming better known in the North where rock gardens and alpine gardens are reasonably common. They are evergreen and grow in dense clumps of short, prickly 3-angled narrow leaves. They look like they belong more to the cactus family than the plumbago family, that is, until they flower, at which time the resemblance to the latter is obvious. To be brutally honest, when not in flower, plants resemble green hedgehogs stuck in the middle of a garden. They are slow growing, but when they produce those long-lasting sprays of small pink flowers, they can be quite irresistible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants are well known by alpine enthusiasts but alpine people are by definition somewhat strange, so this should not be surprising. While these plants will always be thought of as weird, they should be looked upon by other gardeners as exceptionally good subjects for the xeric garden. They need to be used far more often in areas of low rainfall and poor soils.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is still difficult to find "), _c('em', [_vm._v("Acantholimon")]), _vm._v(" in the trade and gardeners are often forced to raise plants from seeds or softwood cuttings. However, hope is on the way, as species such as "), _c('em', [_vm._v("A. glumaceum")]), _vm._v(", with bright rosy pink flowers, "), _c('em', [_vm._v("A. olivieri")]), _vm._v(", with whitish pink flowers held well above the mat, and "), _c('em', [_vm._v("A. ulicinum")]), _vm._v(", with hot pink flowers, are becoming better known. One nursery provides 6 distinct taxa while another lists 20 taxa of "), _c('em', [_vm._v("Acantholimon")]), _vm._v(", once again verifying that there is simply no accounting for taste in American gardening.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cuttings can be gingerly obtained from other enthusiasts. They can be painful, so root with care. Rooting near the base of the plant is encouraged by spreading sand around the base.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All species need gritty soils but may be grown on dry stone wall, gravel beds or sunny slopes with stony soils. Areas of high rainfall may not be a problem as long as drainage is impeccable. Full sun and cool nights are necessary. An excellent collection is in the alpine garden at the Denver Botanic Garden, but private collections are also well worth searching out.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Acanthus")])]), _vm._v(" (a-kanth' us)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Bear’s Breeches")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Acanthaceae")])]), _c('p', {
    staticClass: "indent1"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("The genus contains approximately 30 species of which three or four are particularly ornamental, providing foliage of great beauty and statuesque flowers. The basal leaves are simple, opposite, and often have soft, thorny margins. The flowers are held in long, ")]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("erect spikes and each flower is subtended by a showy, spiny, leaflike bract. The spikes are lovely, albeit somewhat unnerving, but the true ornamental value of the genus resides in the handsome foliage. Once established, "), _c('em', [_vm._v("Acanthus")]), _vm._v(" is almost indestructible and will colonize an area with its invasive roots. If one tires of bear’s breeches and wishes to remove same, it is next to impossible not to leave some root pieces behind, which, like amoebae, will regenerate and recolonize their old homesite.")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I have always wondered where the name bear’s breeches came from, for the combination of the two words makes no sense at all, and it is difficult to even imagine a pair of bear’s breeches. Nowhere could I find an explanation, therefore I felt much better when I learned that the eminent British horticulturist Graham Stuart Thomas was equally stumped. He contacted Professor William Stearn who shed some possible light on the subject. Professor Stearn believed that the term resulted from a confusion of the medieval Latin description “"), _c('em', [_vm._v("branca ursina")]), _vm._v("”, meaning bear’s claw. The upper part of the hooded flower, upon proper squinting, could be said to resemble a bear’s claw. But the breeches, where did they come from? Madame Audrey Serreau, a gardener from Pultiers, France, believes that additional confusion between two Latin words resulted in the “breeches”. The word “branca” which means claw, was confused with the old Gaul word “braca” which later became “braies” and finally “breeches”. Is this clear yet? Such explanations may be confusing in themselves, however, as Madame Serreau stated, “Isn’t it fascinating to reflect upon such word changes, bringing, as they do across the centuries, echoes of long-silenced voices?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Acanthus")]), _vm._v(" is popular throughout the country although most authors state that it is insufficiently hardy for much of the North. Those authors need to see the wonderful plantings in Gardenview, Henry Ross’s fine horticultural park in Strongsville, Ohio (zone 6). And if they need other proof of toughness, they should visit the wonderful garden of Dale and Lila Critz in Savannah, Georgia, where heat, humidity and acanthus are all doing well. Persistent, long-lived and certainly weather hardy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The leaves are hardier than the flowers, and foliage may survive in particularly cold winters, but plants may not flower. Plants do well in full sun or partial shade and are relatively drought resistant although leaves will wilt often. Poor drainage is synonymous with poor performance and death. The foliage is occasionally evergreen in the South, but in severe winters becomes tattered and torn. In the North, plants are deciduous.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The most effective means of propagation is by 2-3\" long root cuttings taken in the spring. Insert vertically in a well-drained medium and keep moist and warm. Shoots appear in 3-5 weeks. In the garden, I can attest to the wonders of my handy-dandy tiller, with which I inadvertently tilled up a dormant patch of "), _c('em', [_vm._v("A. spinosus")]), _vm._v(". Next spring, every little mangled piece had sprouted. Plants may also be divided in early spring but adequate moisture is necessary to insure establishment. Fresh seed germinates in about 3 weeks if kept moist and warm (70-75°F).")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Acanthus Species")])])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Leaves spiny")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Leaf color")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. caroli-alexandri")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("15-18")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Dark green")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. dioscoridis")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("12-24")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Gray green")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. hungaricus")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("30-48")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Dark green")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. mollis")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("30-48")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Dark green")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. spinosus")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("36-48")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Dark green")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-hungaricus")])]), _vm._v(" (hun-gar' i-cus)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Balkan Bear’s Breeches")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("36-60\"/36\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Purple")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Balkan Countries, Romania")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sold under the names of "), _c('em', [_vm._v("A. balcanicus")]), _vm._v(" and "), _c('em', [_vm._v("A. longifolius")]), _vm._v(", plants are also similar in habit and flower to "), _c('em', [_vm._v("A. mollis")]), _vm._v(". The dull green leaves are lobed with wide gaps between the lobes (the gap is referred to as a sinus). The sinuses are connected to each other with a flange of leaf parallel to the midrib. The sinuses are deep and the lobes are tapered at the base, characteristics which distinguish it from "), _c('em', [_vm._v("A. mollis")]), _vm._v(". The flower stems rise an additional 3-4' and bear numerous white and purple flowers in mid to late summer. The bracts surrounding the flowers have 5-7 veins and are painfully sharp. Plants are taller than most species, and the leaves more deeply cut. The foliage is more winter hardy than the flowers. After particularly cold winters, the leaves may emerge in the spring but no flowers may occur.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants perform well in most gardens and since they are native to the Balkans, Romania and northern Yugoslavia, are probably the most cold hardy. They also perform better in southeastern gardens than "), _c('em', [_vm._v("A. mollis")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-mollis")])]), _vm._v(" (mol' lis)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Common Bear’s Breeches")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("30-48\"/36\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Purple")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southern Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 7-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the fifth century B.C., one of the species of "), _c('em', [_vm._v("Acanthus")]), _vm._v(" was immortalized in the design of the sculptured leaves on Greek Corinthian columns. Some historians believe the design to be based on this species, others believe it is based on the foliage of "), _c('em', [_vm._v("A. spinosus")]), _vm._v(". The lustrous green, 8-12\" wide foliage is lobed but not as deeply as "), _c('em', [_vm._v("A. hungaricus")]), _vm._v(". Although small, soft spines are borne at the end of the lobes, the foliage does not feel at all spiny. The flowers are similar to those of "), _c('em', [_vm._v("A. hungaricus")]), _vm._v(". The plants, having a spread of up to 3', are best used as specimens or in groups of 3 to 5 plants. I have grown a number of species in the heat of north Georgia (zone 7b) and this one has flowered poorly. The magnificent plantings seen in southern California can not be duplicated in hot, humid weather.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('strong', [_vm._v("Cultivars:")])])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Albus’ has mostly white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Hollard’s Gold’ was originally sold in this country in 1994. The foliage is chartreuse; not bright enough to brag on its beauty but yellow enough to think about a need for fertility. Nevertheless I like this plant, even though it is not as vigorous as the species and tends to disappear in inclement conditions, like my garden. Plants are often sold as ‘Fielding Gold’, as it originally came from Fielding, New Zealand.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("latifolius")]), _vm._v(" is most common although less free flowering than the species. Plants bear 3-5' tall stalks of mauve-pink flowers and glossy green arching leaves which are sometimes scarcely dissected. Plants appear to be more robust and more cold tolerant than the species. There are a number of similar forms, and plants are often classified as Laterifolius Group.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Rue Ledan’ was found in Matignon, France in the early 1990s. It is an excellent cultivar growing about 3' tall and producing shiny green leaves. The flowers are white rather than purple, and essentially sterile. It likely belongs to the Laterifolius Group.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Tasmanian Angel’ is the first variegated acanthus and should be a hit. Plants also produce really wonderful pink and cream colored flowers on 4' tall stems. The foliage is unique in that the leaves have creamy yellow irregular margins. During the summer, the leaves may revert to green.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-spinosus")])]), _vm._v(" (spine-o' sus)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spiny Bear’s Breeches")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("36-48\"/36\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Mauve")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southern Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 6-10")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The main difference between this species and the previous is the presence of spiny leaf margins which look a good deal more lethal than they really are. The 10\" diameter leaves are lanceolate, and more deeply divided than those of "), _c('em', [_vm._v("A. mollis")]), _vm._v(". The flowers are similar except that three to four veins occur on the purplish bracts rather than five to seven found in common bear’s breeches. If late freezes occur, "), _c('em', [_vm._v("A. mollis")]), _vm._v(" is killed to the ground while this species is little affected. The flowers are produced consistently each year and the leaves remain fresh all season. Plants also tolerate warm, humid summers better than the previous species, a definite advantage for southern gardeners.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Lady Moore’ is an interesting plant occasionally seen in the British Isles but seldom in the United States. The foliage is creamy white in the spring, greening up as the weather warms up. Named for the wife of Sir Frederick Moore, former keeper of the Botanic Gardens at Glasnevin, Dublin.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("var. "), _c('em', [_vm._v("spinosissimus")]), _vm._v(" can be a man-eater but taxonomists have placed other plants in this group, diluting the pain. Originally plants bore leaves which were more sharply cut than those of the species, and enjoyed only by masochists or those who could command someone else to handle such vicious plants. I have enough trouble with ")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("belligerent people, why tolerate belligerent plants? Today, sufficient variation is thought to exist among plants and they are now referred to as the Spinosissimus Group.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species and Hybrids:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. caroli-alexandri")]), _vm._v(" has borne other names ("), _c('em', [_vm._v("A. syriacus")]), _vm._v("), but if you want a shorter classy plant, look for this species. Plants grow only about 18\" tall and bear typical white and purple flowers. However, the leaves are deeply cut and the tips can be spiny. The bracts beneath the flowers are also painful. Nevertheless, this is an excellent selection for a smaller garden.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. dioscoridis")]), _vm._v(" is 1-2' tall and has rosy pink bracts. The lanceolate leaves are petioled, gray green, and in var. "), _c('em', [_vm._v("dioscoridis")]), _vm._v(" are usually entire, perhaps with a few shallow lobes. Good drainage is essential. Native to mountainous areas of Asia Minor, it is likely hardy in zones 6-9, although not enough plants have been evaluated to provide confident hardiness ratings. var. "), _c('em', [_vm._v("perringii")]), _vm._v(" is more common, bearing deeply cut, almost spiny leaves and with more pink in the bracts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Summer Beauty’ is likely a hybrid between "), _c('em', [_vm._v("A. mollis")]), _vm._v(" and "), _c('em', [_vm._v("A. spinosus")]), _vm._v(". The leaves are more deeply cut than "), _c('em', [_vm._v("A. mollis")]), _vm._v(" but are still shiny and handsome. The plants are vigorous, 4-5' tall and bear white flowers with purple bracts. This is far superior than either of the parents, and I rate it highly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Achillea")])]), _vm._v(" (a-kill' ee-a)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Yarrow")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Asteraceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Although there are approximately 100 species, fewer than a dozen are truly ornamental. They range in height from four inches ("), _c('em', [_vm._v("A. nana")]), _vm._v(") to four feet ("), _c('em', [_vm._v("A. filipendulina")]), _vm._v(") and provide flowers of almost every hue. Leaves of all species are alternate and, with the exception of "), _c('em', [_vm._v("A. ageratum")]), _vm._v(", sweet yarrow, and "), _c('em', [_vm._v("A. ptarmica")]), _vm._v(", sneezewort, the foliage is deeply divided into a fine fernlike appearance. In several species, the foliage has a heavy spicy odor and a gray-green tint. A member of the aster family, its heads are made up of two distinct types of flowers. The outer ray flowers are pistillate (female only), and may be yellow, white, or pink while the inner disc flowers are bisexual (male and female together), and usually yellow. The flower heads (inflorescences) look like small table tops called corymbs. Another advantage of growing yarrow is the gardener’s ability to cut the flowers and enjoy them indoors. The flowers of most species make excellent fresh or dried specimens but the pollen must be visible before the flowers are cut or vase life will essentially be nil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some yarrows are at times considered weeds, particularly those which multiply rapidly from invasive rhizomes. This characteristic, however, is true for only one or two species; most others behave themselves and stay at home. Unless otherwise noted, all species should be grown in full sun and well-drained soils. They tolerate poor, slightly acid soils (if well-drained), although "), _c('em', [_vm._v("A. clavennae")]), _vm._v(" performs well in limey soils. Do not fertilize yarrows heavily; many of the upright species will grow too tall and lanky if fertilized or grown in rich soil.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Achillea Species")])])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (ft.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower color")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Foliage color")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A")]), _vm._v(". ‘Coronation Gold’")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("2-3")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Gray-green")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. filipendulina")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3-5")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Green")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. grandifolia")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("2-3")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Gray-green")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. millefolium")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("1-2")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Pink, red")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Green")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A")]), _vm._v(". ‘Moonshine’")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("1-2")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Sulphur")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Gray-green")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. ptarmica")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("1-2")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Green")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. tomentosa")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("1/2-1")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Gray-green")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('strong', [_vm._v("-‘Coronation Gold’")])]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Coronation Gold Yarrow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-4'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Hybrid origin")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This hybrid was first offered in 1953 by Miss Pole of Lye End Nursery in southern England to commemorate the coronation of Elizabeth II. An amateur hybridizer, she crossed "), _c('em', [_vm._v("A. filipendulina")]), _vm._v(" with "), _c('em', [_vm._v("A. clypeolata")]), _vm._v(", a small yellow-flowered species, to raise the best upright golden yellow yarrow available at that time, and arguably, still the best today. Plants were subsequently sold and distributed by Blooms of Bressingham of Diss, England and rapidly became popular throughout the world. It is sometimes incorrectly listed as a cultivar of fern-leaf yarrow, "), _c('em', [_vm._v("A. filipendulina")]), _vm._v(", but that is unfair to this excellent hybrid.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The plant is shorter than "), _c('em', [_vm._v("A. filipendulina")]), _vm._v(", better branched, and does not require staking. It requires less maintenance and should be the plant of choice for landscapers. The inflorescences are 3-4\" across and look like shiny golden plates. Flowering begins in late May in north Georgia, June in the Northeast, late June in the Midwest, and continues for 8-12 weeks. The foliage is gray-green and has a strong aromatic smell. It tolerates a wide range of climates and soils and is grown in gardens from Manitoba to Florida.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Coronation Gold’ is also popular as a cut flower throughout the world. It is interesting to note the differences in stem and flower size between northern and southern climates. In north Georgia, over 50 flowering stems per plant were produced while the same plants growing in Holland yielded fewer than 15 stems but each one was 1 1/2-2 times longer with larger flowers. Propagate by terminal cuttings in spring or early summer, or by spring or fall division every 3-4 years. Stay away from seed labeled ‘Coronation Gold’; it will likely be "), _c('em', [_vm._v("A. filipendulina")]), _vm._v(" or one of its cultivars.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-filipendulina")])]), _vm._v(" (fi-li-pen-dew' lye-na)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Fern-leaf Yarrow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-5'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Caucasus")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("The foliage is deeply cut and feathery but bears little of the gray-green tint that is so appealing in ‘Coronation Gold’. In general, foliage is greener, flowers are larger and plants are taller than those of ‘Coronation Gold’. This is a wonderfully handsome plant but when grown in rich soils, warm temperatures or over-fertilized, it ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("generally requires staking, a job most sane people view with disdain. The flat yellow flower heads are 3-4\" across and make excellent cut flowers. Provide full sun. Yellow-flowered yarrows combine well with pink phlox, purple-foliaged plants, blue delphiniums and red hot pokers.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0009-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Achillea filipendulina")])]), _vm._v(" "), _c('p', {
    staticClass: "indentp"
  }, [_vm._v("Plants may be propagated by spring division, terminal cuttings in early summer, or by seed. Seed sown in a mixture of 1:1 peat:vermiculite and placed at 70-72°F in a humid area germinates within 21 days. Most cultivars are available from seed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars and Hybrids:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Altgold’ stands about 3' tall and bears deep yellow flowers in late spring and again in early fall. An interesting rebloomer.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Cloth of Gold’ bears large pure yellow flowers and grows 3-4' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Flowers of Sulphur’ is a 2' tall, slow-spreading hybrid of "), _c('em', [_vm._v("A. filipendulina")]), _vm._v(" and "), _c('em', [_vm._v("A. ptarmica")]), _vm._v(". One of the best sulphur-colored flowers in the genus.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Gold Coin’ is a dwarf form of ‘Parker’s Variety’, and grows only about 15\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Gold Plate’ has deep yellow flowers on stems up to 5' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Parker’s Variety’ bears golden yellow flowers on 3-4' tall stems. This one and ‘Gold Plate’ produce large numbers of flowers and have better stem strength than the species but may require support in areas with hot, humid summers.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("‘Schwellenburg’ is likely a hybrid with "), _c('em', [_vm._v("A. filipendulina")]), _vm._v(" and a yet to be determined species. The golden flowers sit atop silvery, ferny foliage and stand 1 1/2-2' tall. Plants do not appear to be particularly vigorous or tolerant of adverse weather, however if old flowers are removed and plants are not over-fertilized, better results can be expected.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-millefolium")])]), _vm._v(" (mil-lee-fo' lee-um)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Common Yarrow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1-2'/5'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White to Cerise Red")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Common yarrow is “common” because of its ability to spread rapidly and take over any ground available. Often seeded as a wildflower on roadsides, the ferny foliage and off-white flowers fill in median strips and combine well with other roadside plants such as bachelor’s buttons and poppies. In Europe, it is often discarded as a troublesome weed not to be included on the grounds of any self-respecting gardener. Yet the same people will find fresh and dried flowers of common yarrow in florist ")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("shops where they are widely used in colorful bouquets. The species was cultivated in Europe before 1440, used as a remedy for toothache, and mixed in ale in place of hops to increase the inebriating quality of that drink. It was thought to have a magical quality similar to our “apple a day keeps the doctor away”; and was said to grow in churchyards as a reproach to the dead, “who need never have come there if they had taken their yarrow broth faithfully every day while living”. The main use, however, was that of an herb to heal wounds. The genus was named after Achilles, who is said to have used "), _c('em', [_vm._v("A. millefolium")]), _vm._v(" to staunch the wounds of his soldiers, thus acquiring the common name of soldier’s woundweed and woundwort. And everyone thought this was just a common old flower!")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0010-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Achillea millefolium")])]), _vm._v(" "), _c('p', {
    staticClass: "indentp"
  }, [_vm._v("The habit is matlike and the dark green foliage is deeply cut. In early summer, the flower stalks rise about two feet and are quite strong where night temperatures consistently stay below 70°F. Where night temperatures are too warm, the stems do not acquire enough carbohydrates to “fatten up” and topple. Plants fill in rapidly and those placed four feet apart produce an unbroken mat in 2 years. If planted two feet apart, they fill in by the end of the first year.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A number of cultivars are offered from seed but it is just as easy to divide good specimens to retain the desired colors.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some of the following are selections of "), _c('em', [_vm._v("A. millefolium")]), _vm._v(", many are hybrids. Most of the hybrids are of questionable parentage but all have "), _c('em', [_vm._v("A. millefolium")]), _vm._v(" in them. The Galaxy hybrids ("), _c('em', [_vm._v("A. aegyptiaca")]), _vm._v(" var. "), _c('em', [_vm._v("taygetea")]), _vm._v(" (formerly "), _c('em', [_vm._v("A")]), _vm._v(". ‘Taygetea’) x "), _c('em', [_vm._v("A. millefolium")]), _vm._v(") have similar foliage to that of "), _c('em', [_vm._v("A. millefolium")]), _vm._v(" but the flower heads are larger and the stems much stronger. The only problem I have seen is the tendency of the flowers to fade, particularly when temperatures are above 80°F. In our trials in north Georgia, ‘Beacon’ and ‘Great Expectations’ faded less than others. In climates with cool night temperatures, little fading is seen.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Appleblossom’ is a vigorous 3' tall plant with peach to lilac-pink flowers. A Galaxy hybrid.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Apricot Beauty’ is likely a hybrid. It is difficult to find in this country but with its flat-topped soft yellow to apricot flower heads, it should be more common.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Apricot Delight’, ‘Strawberry Seduction’, and ‘Wonderful Wampee’ are part of the Tutti-Frutti series of seed-grown yarrows, designed primarily for rapid greenhouse production. And, no, I have no idea what they were smoking when these names were selected. Flower colors are light apricot, rose and light pink, respectively. All stand 12-20\" tall, the former being the shortest and the seducer being the tallest.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Belle Epoque’ has dusky pink flowers and gray green leaves. Plants earned an Award of Garden Merit (1999) from the Royal Horticultural Society.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Borealis’ (var. "), _c('em', [_vm._v("borealis")]), _vm._v(") bears dense clusters of rose-pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Cassis’ is about 2' tall with flat heads of cherry-red flowers. Plants bloom first year from seed.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Cerise Queen’ is one of the oldest and still popular cultivars. Plants are grown for the cerise-red flowers. It grows about 18\" tall and provides bright drifts of color.")])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0012-01.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Achillea Galaxy hybrid")])]), _vm._v(" "), _c('p', {
    staticClass: "bibp"
  }, [_vm._v("‘Chamois’ has interesting tan-colored flowers (like a chamois?) which fade somewhat to a creamy yellow. Sounds awful, but not so bad.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Christel’ is a relatively new hybrid, with deeper green foliage than most “millefolium” forms. The flowers are deep rose-pink and if cut back may rebloom.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Christine’ has fernlike foliage, grows about 2' tall and is topped with light rose flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Citronella’ bears butter yellow flowers on an erect habit.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Colorado mix is grown from seed and provides flowers in a wide range of colors, including apricot, pink, red, russet, yellow, apricot, pink, and cream.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Creamy’ bears large heads of creamy-yellow flowers. Plants fill in quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Credo’ was bred in Germany, resulting from "), _c('em', [_vm._v("A. filipendula")]), _vm._v(" x "), _c('em', [_vm._v("A. millefolium")]), _vm._v(". It is a tall (3-4') cultivar with light yellow flowers that tend to fade to creamy-white. Good for cut flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Debutante’ is a mixture of plants, bearing rose to creamy white flowers. ‘Pink Debutante’ is also an excellent selection.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Fire King’ and ‘Fire Beauty’ have dark red flowers; there is little difference between them.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("‘Fireland’ opens red then fades to pink and finally to a tawny gold. The plants grow about 3' tall but the stems are reasonably stout.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Great Expectations’ (‘Hope’) produces primrose yellow flowers on 2' high stems. A Galaxy hybrid.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Heidi’ has pastel pink flowers on 20\" stems in the spring and reblooms a little later in the summer.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Hidden Pond Pink’ is a silly name for a pink-flowered, relatively short (15-24\") yarrow.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Island Pink’ has deep pink flowers and a deep green foliar color.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Jambo’ bears medium yellow flowers on 15-18\" tall stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Jungfrau’ has pastel yellow, almost white, flowers on 15\" plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Kelwayi’ bears magenta-red flowers on 18\" stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Lansdorferglut’ is an ugly name for a pretty 2-3' tall plant with soft pink flowers in flattened heads. Good for cutting.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Lilac Beauty’ produces lilac flowers on strong upright stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Lilac Queen’ has flat heads of pastel lilac flowers and is offered occasionally by mail order nurseries.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Lusaka’ has white flowers and is a vigorous grower. ‘Madelein’ bears apricot colored flowers on 2' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Martina’ has large, flat yellow flower heads on 2-2 1/2' tall stems. The foliage is ferny and green.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Marmalade’ has flowers in autumn colors of dark yellow and orange.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Mary Ann’ bears lemon-yellow flowers over silvery-gray foliage and grows only about a foot tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Maskarade’ produces interesting pale yellow flower heads with red flecks along the edges as they mature. Quite a different look.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Moneymaker’ has salmon-pink flowers. I’m not sure where the money will be made, as there are many others with similar flower color as well.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Nakuru’ produces purple and white bicolor flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Natalie’ is 2-3' tall with light pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Orange Queen’ has unusual orange-gold flowers. About 30\" tall and 18\" wide.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Paprika’ produces red and yellow flowers on a flattened inflorescence. One of the most handsome cultivars available.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Petra’ resulted from a cross between ‘Credo’ and ‘Fanal’. Plants bear fiery red flowers and stand about 20\" tall. Plants are unique because they are sterile and no wishy-washy seedlings will sneak into the garden.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Proa’ is similar to, if not the same as, the white yarrow that has become naturalized along roadsides in this country. Plants were originally selected for high oil content of the seeds. A pretty enough plant, but quite aggressive.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Oertel’s Rose’ was introduced by Goodness Grows Nursery in Lexington, Georgia and blooms heavily with rosy pink and white flowers. A terrific selection for Southern gardeners.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Red Beauty’ bears 2' tall cerise-red flowers in midsummer.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("‘Red Velvet’ has dark red to rosy red flowers on 18-20\" tall plants. Supposedly the flowers do not fade during the summer, but I have not be able to verify that, at least in zone 7.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Richard Nelson’ was selected at Bluestone Nursery in Madison, Ohio, for its handsome pale pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Rose Beauty’ has rather nondescript rose-pink flowers on 2' tall stems. This name is also used with var. "), _c('em', [_vm._v("roseum")]), _vm._v(", and includes pink seedlings in general.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Rougham series of yarrows were developed at Rougham Hall Nursery, Rougham, Suffolk, England. They are about 2' in height and separate colors are available. ‘Rougham Beauty’ is light pink, ‘Rougham Bright Star’ is cherry-rose with a white eye, ‘Rougham Cream’ is an off-white, ‘Rougham Salmon’ is just that, ‘Rougham White’ is a cleaner white than most white yarrows. Plants do not seem to fade as badly as many others.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Salmon Beauty’ bears large heads of salmon flowers on 3' tall stems. A Galaxy hybrid.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Sawa Sawa’ bears lavender-purple flowers on 20\" stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Schneetaler’ is a hybrid with pure white flowers. Plants are good for cut flowers and may rebloom if cut back hard after the initial bloom.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Snow Sport’ is a vigorous grower with dark green foliage and dozens of clean white flowers on 18\" tall stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Summer Berries’ is a seed strain introduced in 2003. Pastel flower colors range from pink to light salmon to cherry.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Summer Pastels’ is a seed-propagated hybrid, which includes numerous pastel colors (pink, rose, lavender, salmon to orange) on 2' tall plants. Plants flower the first year from seed. The yellow hues are particularly good.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Summer Wine’ is taller than 3' and is used as a cut flower commercially. The bright wine red flowers are immediately visible, however they fade as they age to a rose pink color. This is not all bad as it provides some color contrast over the season.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Terracotta’ is an exceptional selection, with 2-3' tall plants of the finest salmon to peach colors I have seen. The foliage has a little silver hue to it as well. Its only drawback is that it may become too tall in rich soils or in areas with warm nights.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Tickled Pink’ is a cute name for a seed-propagated mix of pink to rose colored flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘The Beacon’ stands 2-3' tall and bears rich red flowers with yellow centers. It is the best cultivar I have seen. A Galaxy hybrid.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Walther Funcke’ has gray foliage and deep red flowers on 2' tall stems. Quite handsome.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Weser River Sandstone’ has deep rose-pink flowers on 2-3' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘White Beauty’ produces creamy white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('strong', [_vm._v("‘Moonshine’")])]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Moonshine Yarrow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1-2'/1'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Lemon Yellow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Hybrid origin")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("This hybrid, between "), _c('em', [_vm._v("A. clypeolata")]), _vm._v(" and "), _c('em', [_vm._v("A.")]), _vm._v(" "), _c('em', [_vm._v("aegyptiaca")]), _vm._v(" var. "), _c('em', [_vm._v("taygetea")]), _vm._v(" (formerly "), _c('em', [_vm._v("A")]), _vm._v(". ‘Taygetea’), was introduced in the 1950s by Alan Bloom of Bressingham Gardens in ")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Diss, England. In the garden, ‘Moonshine’ is similar to ‘Coronation Gold’ except in size and shade of flower color. The inflorescences are flat-topped, dense, deep lemon-yellow and 2-3\" in diameter while the gray-green foliage is filigreed. It is one of the most popular yarrows in American landscapes and is often recommended because of habit and bright flower color. While a handsome plant, ‘Moonshine’ tends to become twiggy, lose some of its foliage and die out after 2-3 years in the garden.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0015-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Achillea")]), _vm._v(" ‘Moonshine‘")])]), _c('p', {
    staticClass: "indentp"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("The flowers appear in early June (late June in New England) and continue until September. However, it is much more perennial in the North than in the South. In the Southeast where summer days are frequently punctuated by late afternoon rains and high humidity, ‘Moonshine’ tends to “melt out”. This is not surprising considering that one of its parents, "), _c('em', [_vm._v("A. aegyptiaca")]), _vm._v(" var. "), _c('em', [_vm._v("taygetea")]), _vm._v(", is also susceptible to many foliar diseases. ‘Moonshine’ does best during summers with little rainfall, otherwise don’t waste your money. The Southeast is particularly taxing on plants susceptible to root fungi, however, regardless of the region of the country in which it is grown, excellent drainage is necessary to ensure more than 2 years garden longevity. Spraying for diseases such as "), _c('em', [_vm._v("Botrytis")]), _vm._v(" and root rot organisms such as "), _c('em', [_vm._v("Pythium")]), _vm._v(" is helpful and should be practiced in July and August. Regardless of the drawbacks, this was one of the ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("finest hybrid yarrows developed in many years and, if sited properly and grown well, can still be a popular plant for commercial landscapers and gardeners.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate by division any time during the growing season.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-ptarmica")])]), _vm._v(" (tar' mah-ca)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Sneezewort")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1-2'/1'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 2-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I can think of few other common names in the plant kingdom as ugly as sneezewort. Hearing the name for the first time certainly doesn’t endear this species to anyone. The common name is derived from the fact that “the floures make one neese exceedingly”. In Victorian England, the leaves and roots were also dried and reduced to powder and used as an inexpensive substitute for snuff.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("The species is unusual among yarrows due to the lack of dissected leaves. The sessile foliage is finely toothed and fernlike, and the shape is linear to lanceolate. The species itself is of little ornamental value but a number of good cultivars are available. ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("The cut flowers are occasionally used as a substitute for baby’s breath and dry well. It is an aggressive plant and will spread considerably in good soils. Susceptible to powdery mildew in wet soils and shady conditions.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0016-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Achillea ptarmica")])]), _vm._v(" "), _c('p', {
    staticClass: "indentp"
  }, [_vm._v("Propagate by division in the spring.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many of these look the same. Some may differ in height, and perhaps garden performance as well.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Angels’ Breath’ bears many half-inch wide clean white flowers on 15-18\" tall plants. Good filler for bouquets.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Aunt Stientje’ has dark green leaves, and bears flowers with large creamy white rays. I don’t see this plant in this country at all, however it earned an Award of Garden Merit from the Royal Horticultural Society in 1999.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Ballerina’ is an excellent cultivar with clean white flowers, topping out at about 18\". Good as a dried cut flower. A dwarf form, ‘Nana Ballerina’, grows only 8\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Globe’ has small buttonlike blossoms on 12-18\" tall stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Gypsy White’ appeared in our trials in 2005, and flowered for months on 9-12\" tall plants. An excellent introduction where a dwarf white is called for.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘The Pearl’ is more correctly listed as The Pearl group, consisting of a number of closely related white double-flowered taxa. In general, plants bear a profusion of double white flowers on 2' high stems but in warm summers, plants sprawl and are weedy looking. All double-flowered cultivars produce some single flowers as well. Up to 30% single flowers may be produced depending on weather and cultivar.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Snowball’ is similar to The Pearl group and may be part of it. The white double-flowered plants are about 2' tall and are supposed to be a little more compact than plants in The Pearl group. I can see little difference.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Perry’s White’ is taller (up to 30\"), with flowers similar to the species but opening about a week earlier.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-tomentosa")])]), _vm._v(" (tow-men-tos' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Woolly Yarrow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-12\"/18\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The common name provides an excellent description of the deeply cut, light green foliage, which is covered with long hairs, providing a truly woolly appearance. Good drainage is essential and the rock garden is a particularly suitable location, however, plants also make good subjects for the front of the border. It is most handsome in the spring when the hairy new growth begins to clamber over rocks and invades small niches. Many sulphur-yellow flowers, similar to, but smaller than those of ‘Moonshine’, are produced in June (May in the South) and continue for 3-5 weeks.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Unfortunately, plants are intolerant of hot, humid conditions and cannot be recommended for areas south of zone 6. Although they will survive in zone 7, plants perform well only through early summer and decline by mid to late July, unlikely to be seen again. This is not a species for southern landscapes unless frequent fungicide applications are made. I used to grow it in zone 7 as an annual because I enjoyed the ")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("woolly texture enough to replace it in the spring. I am too lazy to do that anymore, but I still enjoy it in other people’s gardens.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Most cultivars are usually propagated by division but the species and var. "), _c('em', [_vm._v("aurea")]), _vm._v(" may also be seed propagated.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("nana")]), _vm._v(" (‘Nana’) has golden yellow flowers on 3-6\" tall stems. Sometimes sold as ‘Little Beauty’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Maynard’s Gold’ produces bright yellow flowers on 10-12\" stems. Some authorities believe var. "), _c('em', [_vm._v("aurea")]), _vm._v(" and ‘Maynard’s Gold’ to be one and the same. They are probably correct.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species and Hybrids:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. ageratum")]), _vm._v(" (formerly "), _c('em', [_vm._v("A. decolorans")]), _vm._v(") ‘W.B. Childs’ bears single creamy-white flowers similar to sneezewort. If not for the difference in leaf shape, one would be challenged to tell the two apart by looking only at the flowers. The plants, however, have dissected deep green leaves whereas those of sneezewort are almost entire.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Alabaster’, a hybrid from Germany, bears flat heads of pale yellow flowers on stiff 30\" tall gray-green foliage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Anthea’ was introduced by Alan Bloom by crossing ‘Moonshine’ with "), _c('em', [_vm._v("A. clypeolata")]), _vm._v(". Plants are more erect and the foliage is soft and silver-gray while the flowers are more sulphur-yellow than those of ‘Moonshine’. In our trials at Georgia, the flower heads were about 3\" across but tended to fade to creamy yellow as they mature. At the same time, secondary flowers emerged freely. Flower heads should be deadheaded to extend flowering. A terrific introduction named after Mr. Bloom’s daughter, far better than ‘Moonshine’ in yarrow-challenged environments.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. chrysocoma")]), _vm._v(", yellow yarrow, is similar to "), _c('em', [_vm._v("A. tomentosa")]), _vm._v(" but the leaves are more hairy, appear to be coated with white fur and the golden yellow flowers are a little wider. ‘Grandiflora’ has larger flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. clavennae")]), _vm._v(" grows 2-3' tall and bears up to 25 small white flowers in the inflorescence. Plants form handsome clumps of silky gray foliage. Prefers limey soils. Hardy to about zone 5-8.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A.")]), _vm._v(" x "), _c('em', [_vm._v("jaborneggii")]), _vm._v(" is a hybrid between "), _c('em', [_vm._v("A. clavennae")]), _vm._v(" and the alpine species "), _c('em', [_vm._v("A. erborotta")]), _vm._v(" subsp. "), _c('em', [_vm._v("moschata")]), _vm._v(". Clean white flowers over deeply cut clumps of gray-green foliage occur in late spring. Plants are only about 4-6\" tall and most suitable for the rock garden.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A.")]), _vm._v(" x "), _c('em', [_vm._v("kellereri")]), _vm._v(" also bears creamy white flowers but with soft yellow centers on 6-8\" tall plants. The plant is a hybrid between "), _c('em', [_vm._v("A. clypeolata")]), _vm._v(" and "), _c('em', [_vm._v("A. ageratifolia")]), _vm._v(", which has small white daisies and silver foliage. The resulting hybrid has wonderful fernlike gray foliage that is as pretty as the flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A.")]), _vm._v(" x "), _c('em', [_vm._v("lewisii")]), _vm._v(", a hybrid between "), _c('em', [_vm._v("A. clavennae")]), _vm._v(" and "), _c('em', [_vm._v("A. tomentosa")]), _vm._v(", bears woody stems and soft silver-green foliage. The leaves are not as hairy as "), _c('em', [_vm._v("A. tomentosa")]), _vm._v(" and plants are a little taller.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘King Edward’ bears primrose yellow flowers on 4-10\" stems. This and the previous hybrid require excellent drainage and are useful only in areas of cool summer nights.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('em', [_vm._v("A. sibirica")]), _vm._v(" is highly variable and still poorly known. Its leathery pinnatifid leaves are sessile, more compact, deeper green and in many ways far more handsome than "), _c('em', [_vm._v("A. millefolium")]), _vm._v(" or "), _c('em', [_vm._v("A. ptarmica")]), _vm._v(". The ray flowers are yellow and the discs are brown. ‘Stephanie Cohen’ was named for our brilliant plant lady in Pennsylvania and bears soft pink flowers all summer. ‘Kiku-San’ is about 18\" tall with creamy white ray flowers and brown centers. It was an exceptional performer in the Gardens at UGA. The var. "), _c('em', [_vm._v("kamtschatica")]), _vm._v(" has pastel pink flowers but its cultivar ‘Love Parade’ is a wonderful 2' tall plant with lavender-rosy pink flowers and the same glossy green foliage. Flowers fade to an off-white as they mature.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A.")]), _vm._v(" x "), _c('em', [_vm._v("wilczekii")]), _vm._v(" is a low-growing white-flowered hybrid between "), _c('em', [_vm._v("A. ageratifolia")]), _vm._v(" and "), _c('em', [_vm._v("A. lingulata")]), _vm._v(". The plants form mats under conditions of good drainage and sunshine. Particularly useful for the rock garden.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Aconitum")])]), _vm._v(" (ak-ko-ny' tum)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Monkshood")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Ranunculaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_c('em', [_vm._v("Aconitum")]), _vm._v(" has a number of common names, one of which is monkshood, so called because of the enlarged sepal that resembles a hood, under which the rest of the floral parts are hidden. Roots were used as poison bait for wolves, thus accounting for another popular common name, wolfsbane. All aconitums have poisonous roots, leaves, and stems and warnings concerning their poisonous properties have been sounded since the late 1500s. In "), _c('em', [_vm._v("A New Herbal")]), _vm._v(", William Turner writes, “Let oure Londiners which of late have receyved this blewe wolfes bayne ... take hede that poyson of the rote of this herbe one daye do not more harme than the freshness of the flower hath done pleasure in seven yeres, let them not saye but they are warned.” It may even have been used to rid oneself of an unwanted husband or wife, but “it was considered rather a vulgar poison and was not employed by persons of high rank, who probably thought Socrates’ hemlock more distinguished.” The turnip-shaped tuberous roots, however, are the most toxic and should not be planted near root crops such as potatoes or horseradish in case of accidental harvesting. Roots have even been confused with those of celery while incredibly, some people ate leaves thinking they were parsley! What were they thinking? Use of aconitum alkaloids in modern medicine was largely discontinued by the late 1930s and early 1940s, although they are still available as a local analgesic in liniments and as a heart sedative.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Regardless of the morbid properties, aconitums are excellent garden plants. The ornamental part of the flower consists of 5 sepals, not petals, with the uppermost one enlarged to form a “hood” or “helmet”. Petals vary in number from 2 to many, but are found inside the hood. The flowers are arranged in terminal racemes or panicles and flower in summer to early fall. Flowers of the more common species occur in various shades of blue, however, several species have sulphur-yellow flowers, while rose-colored flowers occur in "), _c('em', [_vm._v("A. pyramidale")]), _vm._v(".")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("All species have been undergoing serious taxonomic reshuffling, and many subspecies have been described. Their identification is difficult at best, impossible without resorting to checking floral parts with a microscope. The leaves are alternate, dark green and usually palmately divided. They superficially resemble those of "), _c('em', [_vm._v("Delphinium")]), _vm._v(" but the flowers of the two genera are distinctly different. Among other things, ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("flowers of "), _c('em', [_vm._v("Aconitum")]), _vm._v(" usually have two petals whereas those of "), _c('em', [_vm._v("Delphinium")]), _vm._v(" have four. If people were to mix up aconitum with delphinium, I can understand, but parsley!")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Aconitums should be planted in full sun but will tolerate afternoon shade, particularly when planted near the southern boundary of their range (zone 6). They also tolerate moist soils but abhor swampy conditions. Plants need cool nights to flourish, and languish in southern regions of the country. If summer night temperatures do not regularly fall below 70°F, they should not be planted. A couple of native species, "), _c('em', [_vm._v("A. uncinatum")]), _vm._v(" and "), _c('em', [_vm._v("A. reclinatum")]), _vm._v(" extend as far south as North Carolina but are always found at higher elevations. One of the few disappointments I have had in gardening in the South is the absence of the stately spires of "), _c('em', [_vm._v("Aconitum")]), _vm._v(". It did well in southern Ontario (zone 4), but try as I may, I cannot grow monkshood well in north Georgia (zone 7).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most species are at least 3' tall and look out of place in the front of the garden, however "), _c('em', [_vm._v("A.")]), _vm._v(" ‘Ivorine’, a 2-3' tall plant with ivory-colored blossoms in early summer, may be planted in the foreground. A few species, such as the Asian "), _c('em', [_vm._v("A. volubile")]), _vm._v(" and the eastern United States natives, "), _c('em', [_vm._v("A. uncinatum")]), _vm._v(" and "), _c('em', [_vm._v("A. reclinatum")]), _vm._v(" are ramblers and can be trained to run through small trees and shrubs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Flowering time for most of the monkshoods is late summer and fall, however, the 6' stately dark-purple spires of "), _c('em', [_vm._v("A. henryi")]), _vm._v(" open with the summer phlox and late daylilies. "), _c('em', [_vm._v("Aconitum")]), _vm._v(" produces good cut flowers but care should be taken not to get any sap from the cut stem on open wounds, or to mistake the leaves for parsley garnish.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plant the tuberous roots in the fall to establish the root system before the first hard frost. Set the crowns just below the soil surface about 12-18\" apart. Do not disturb established plants as they do not transplant well. Plant in full sun in a well-drained area where you would like them to be for the next ten years for that is where they should stay. If conditions are too wet, various fungi such as "), _c('em', [_vm._v("Sclerotinia")]), _vm._v(" will cause root rot and serious decline of the population. The upright forms make excellent cut flowers, persisting in the vase for 4-7 days.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Seed propagation is particularly difficult because the seed develops a deep dormancy upon ripening. Sow seed as soon as collected from the plant. Germination of old seed will occur, but very slowly (12-18 months is not uncommon). Seed-grown plants take 2-3 years to flower. To propagate vegetatively, the brittle tuberous roots can be separated in late fall or very early spring.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Aconitum Species")])])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (ft.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower color")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Leaves divided all the way to base")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("cammarum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3-4")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Various")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. carmichaelii")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3-6")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Dark blue")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. lamarckii")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3-4")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. napellus")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3-4")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Dark blue")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. reclinatum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-8")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Cream")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('strong', [_vm._v("-x")]), _vm._v(" "), _c('em', [_c('strong', [_vm._v("cammarum")])]), _vm._v(" (kam-mar' um)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Bicolor Monkshood")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-4'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Various")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Hybrid")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The plant is often described as a species, but as far as I can tell it is a hybrid between "), _c('em', [_vm._v("A. variegatum")]), _vm._v(" and "), _c('em', [_vm._v("A. napellus")]), _vm._v(". The growth habit is quite variable depending on the dominant parent in a particular cultivar. The inflorescences are often branched and the “helmet” may be strongly arched forward. The leaves are 2-4\" long and divided into 5-7 segments. Seldom is the hybrid found, however, a few cultivars call this plant home.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bicolor’ is 3-4' tall and has blue and white flowers loosely borne on wide branching panicles derived from "), _c('em', [_vm._v("A. variegatum")]), _vm._v(". This is sometimes sold incorrectly as "), _c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("bicolor")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-carmichaelii")])]), _vm._v(" (kar-my-keel' lee-eye)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Azure Monkshood")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-6'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Dark Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Central China")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The leaves are thicker and more leathery than those of "), _c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("cammarum")]), _vm._v(" and not as deeply dissected. The leaves are cut about two-thirds of the way to the midrib into 3-5 lobes. It is a sturdy plant that seldom needs staking and has dark blue flowers in late summer and early fall. Afternoon shade and sufficient moisture are necessary for plants to be at their best. When planting, large amounts of organic matter should be incorporated in the planting hole. This species flowers about 2 weeks later than "), _c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("cammarum")]), _vm._v(" and is often referred to as the fall-flowering aconitum. The flowers are deep purple within and lighten to pale mauve on the outside. A planting incorporating Japanese anemones, late monkshoods, and autumn sedums such as ‘Autumn Joy’ is truly breathtaking. Some taxonomic shenanigans are going on, and some want to separate the species "), _c('em', [_vm._v("Aconitum fischeri")]), _vm._v(" from "), _c('em', [_vm._v("A. carmichaelii")]), _vm._v(", others, like myself, see little enough difference, and lump them. For the gardener, either will do well.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Arendsii’ (syn. "), _c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("arendsii")]), _vm._v(") is a hybrid between "), _c('em', [_vm._v("A. carmichaelii")]), _vm._v(" and its var. "), _c('em', [_vm._v("wilsonii")]), _vm._v(". Raised by Georg Arends of Arend’s Nursery in Ronsdorf, Germany, this definitely deserves to be used more. Plants bear large helmets of intense blue in September and October and stand 3-4' tall. The stems are sturdy enough to be self-supporting and, everything considered, is the best late-flowering aconitum in cultivation.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Barker’s Variety’ has deep blue flowers and comes true from seed.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("‘Kelmscott Variety’ has lavender blue flowers and is similar in habit to ‘Bakers Variety’. Both cultivars were raised by Mr. Barker of Kelmscott, near Ipswich, eng-land. They grow to a height of 6' under ideal conditions. var. "), _c('em', [_vm._v("wilsonii")]), _vm._v(" (‘Wilsonii’) is up to 6' tall with 12\" long loose panicles of deep blue flowers.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-lycoctonum")])]), _vm._v(" (lye-cock' tone-um)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow Wolfsbane, Badger’s Bane")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-4'/1'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southern Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-6")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is nice to see some yellow flowers in a genus so seemingly populated with blues and purples. The light green leaves consist of 5-7 deeply divided lobes arranged up the 4' long stalk. The plants are laden with terminal racemes of small yellow flowers in late summer and early fall and stems may topple on other plants when in flower. This is not altogether bad as a little touch of aconitum can do wonders to some old tired plants in the fall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two subspecies are occasionally sold but quite mixed up. subsp. "), _c('em', [_vm._v("neapolitanum")]), _vm._v(" ("), _c('em', [_vm._v("A. lamacrkii")]), _vm._v(") has a many-branched inflorescence and flowers quite heavily while subsp. "), _c('em', [_vm._v("vulparia")]), _vm._v(" ("), _c('em', [_vm._v("A. vulparia")]), _vm._v(") has a few terminal inflorescences with pale yellow flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Russian Yellow’ has large, deeply cut leaves and pale yellow flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-napellus")])]), _vm._v(" (na-pel' lus)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Common Monkshood")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-4'/1'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Dark Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-6")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is the most common of the monkshoods and easiest to locate in catalogs and garden centers. The leaves are divided to the base and divided again into linear or lancelike segments. The flowers are in spikelike terminal racemes. Unfortunately, the species is exceptionally variable, and is divided into numerous subspecies differing in height, flower color and structure of the inflorescence. It is tough enough to determine which aconitum you are growing, without the confusion apparent in a single species.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The popularity of "), _c('em', [_vm._v("A. napellus")]), _vm._v(" has declined with the introduction of newer garden cultivars but it is still an outstanding plant. Although plants are toxic, the ground-up leaves have been used as an external treatment for rheumatism and neuralgia, and internally to relieve fevers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Album’ ("), _c('em', [_vm._v("A. napellus")]), _vm._v(" subsp. "), _c('em', [_vm._v("vulgare")]), _vm._v(" ‘Albidum’) bears white flowers on erect 3-4' tall stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Blue Valley’ grows about 3' tall with deep to medium blue flowers. Plants are upright and strong. The foliage is dull green.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Snow White’ is equally handsome, and may be nothing more than ‘Album’ with a better name. Regardless, it is worth the effort to try some of these non-blue forms.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-reclinatum")])]), _vm._v(" (re-clin-a' tum)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Trailing Wolfsbane")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-8'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Cream")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southeast United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Unlike most others in the genus, this native is a vining, sprawling plant, which needs to be grown through other plants in the garden. The species is native from Virginia to West Virginia and south to north Georgia. Plants look great in the spring as the basal leaves emerge, but they can get a little wild as they loop their way here and there. They provide more of a curious journey than a destination, but they are fun to ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("try. All aconitums are best grown in climates with cool nights—this one is way too weedy-looking in hot, humid climates to even try it.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. henryi")]), _vm._v(" has leaves divided into 3 segments and indigo blue flowers. ‘Spark’s Variety’ is thought to be a cultivar but may be a hybrid. Regardless, it is dark blue and 4-5' tall, similar to ‘Bicolor’ in habit. Both cultivars may require staking, particularly if grown in too much shade.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Hybrids")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Blue Lagoon’ grows only 12-15\" tall with medium blue flowers and dark green leaves. Plants flower in mid to late summer.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Blue Sceptre’ has erect 2-3' stems terminating in dense inflorescences of blue and white flowers. Flowering stems are not as branched as in ‘Bicolor’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bressingham Spire’ is 2 1/2-3' tall with violet blue flowers in dense upright panicles suggesting the influence of "), _c('em', [_vm._v("A. napellus")]), _vm._v(". Lateral flowers develop after the terminal flower begins to open. This cultivar is particularly valuable because staking is not required. The latter two cultivars resulted from seedlings from crosses by Alan Bloom between ‘Newry Blue’ and the bicolored "), _c('em', [_vm._v("A. cammarum")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Carneum’ is a pink to salmon-flowered form that is sometimes offered as ‘Roseum’ or ‘Rubellum’. The pink color adds another dimension to "), _c('em', [_vm._v("Aconitum")]), _vm._v(" but plants must be grown where night temperatures are consistently cool or flowers fade to a dingy washed-out white. Spectacular where happy.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Eleonara’ bears terminal racemes of handsome white flowers with blue edges over rigid stems that grow to 3' tall. The glossy green leaves have 5-7 deeply incised toothed lobes.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("‘Ivorine’ was raised in the early 1950s by Alan Bloom and is an outstanding compact, early-flowering plant. The creamy white flowers are held in short spikes. Becoming more popular as plants become more available. If you can grow "), _c('em', [_vm._v("Aconitum")]), _vm._v(", try this one.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Newry Blue’, raised by Mr. Tom Smith of Daisy Hill Nursery in Newry, Northern Ireland, is 4-5' tall with navy blue flowers and has the same upright flowering habit as ‘Bressingham Spire’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pink Sensation’ bears many light pink flowers with a deeper colored margin. Plants are 2-3' tall and about 2' wide.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Stainless Steel’ is a relatively new introduction, with many flowering stems of metallic pale lilac flowers with a metallic silver sheen.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Acorus")])]), _vm._v(" (a-core- us)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Sweet Flag")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Araceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Looking at the foliage of this fine genus, one would be sure that these are ornamental grasses. The flowers are rather inconspicuous and plants are grown mainly for their handsome grasslike foliage. They are naturalized in shallow water by lakes and slow rivers, therefore excellent for wet areas or bog gardens. While wet conditions are important, they may be grown in well-irrigated garden conditions. These terrific plants have earned a spot in the American garden.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Acorus Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (ft.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Foliage highly fragrant")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. calamus")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("2-4")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. gramineus")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("1/2-1 1/2")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-calamus")])]), _vm._v(" (kal' a-mus)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Sweet Flag")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-3'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Foliage")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Asia, Southeast United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The foliage, which resembles a large flag iris, releases a pleasing cinnamon scent when crushed or broken. One of the first air fresheners, sweet flag leaves were strewn around rooms to counteract the smells of cooking or garbage. Calamus root was also used at one time in the manufacture of cosmetics. The aromatic chemicals, known as oil of calamus, are extracted from the foliage and roots, and may still be purchased today. Leaves also contain a chemical, asarone, which was once used as a flavoring ingredient.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The leaves may sometimes reach 4', but around 2 1/2 feet is more common. The flowers are minute and greenish, on a 2-3\" long spadix without the ornamental spathe seen in most members of this family. Full sun and moist soils are preferred but partial shade is also tolerated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate by division when plants become crowded.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Argentostriatus’ is the proper name of the plant that is often sold as ‘Variegatus’. It is by far the most popular cultivated form, bearing long narrow leaves with clean lines of creamy white bands. I grow mine in shallow water in my pond.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-gramineus")])]), _vm._v(" (gram-in' ee-us)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Dwarf Sweet Flag")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-15\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Foliage")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Eastern Asia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The differences between this species and the previous include a smaller stature, shorter, more pendulous sedgelike leaves and a greater choice of cultivars. The foliage is not as sweet as "), _c('em', [_vm._v("A. calamus")]), _vm._v(" but the greater choices of leaf color and stature provide worthy plants for the garden. Plants perform well in partial shade to full sun where they form a wide clump, often used as a slow-growing ground cover. I give an ice cream cone to the first student who can find the flowers. They consist of a small narrow spadix enveloped in a 2-3\" long creamy white spathe, well hidden within the leaves. However, after sufficient brushing and combing of the foliage, serious calories are dispensed. The species is not always available but many of the selections are terrific.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Golden Edge’ bears 1' tall fans of colorful gold and green variegated foliage.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Golden Pheasant’ is similar to but taller than ‘Ogon’. Plants bear narrow, straplike leaves, which are chartreuse when young then mature to a handsome gold.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("‘Licorice’ is from the U.S. National Arboretum and must be abused to be enjoyed. Rub your fingers against the foliage or dig a few roots and the anise scent will be quite obvious. From the outside, it is similar to the species.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Masamune’ is a dwarf form (6-8\") with creamy variegation on the narrow leaves.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Minimus’ is only 3\" tall with dark green leaves. ‘Minimus Aureus’ is a golden form of this dwarf cultivar that is a sock-knocker-offer, particularly when combined with some of the purple heucheras. Because of its small size and brilliant color, it has become a favorite with the garden train enthusiasts. I have also seeen this listed as ‘Miniature Gold’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Oborozuki’ is a robust grower with green leaves and yellow variegation. Plants grow 10-12\" tall. A little more green than ‘Ogon’, but similar in the winter.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Ogon’ has been and continues to be the most popular cultivar for good reason. The fanlike leaves appear golden yellow because of the chartreuse and cream variegations on the evergreen foliage. Plants are 8-10\" tall. I have grown this one for years in my garden; it keeps trying to grow into the path, but my trusty Lawn-Boy keeps it in bounds.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pusillus Nanus’ bears fan-shaped fronds of 2-4\" tall dark green foliage. Hard to find much difference between this and ‘Minimus’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Tanimanoyuki’ can’t be pronounced but can be enjoyed. The green leaves are brushed with yellow along the blades.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Variegatus’ grows about 12\" tall and bears narrow leaves nicely striped with cream.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Yodo-no-yuki’ has variegated pale green leaves with narrow silver stripes. Growing about 12\" tall, the foliage is slightly more muted than ‘Ogon’.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Actaea")])]), _vm._v(" (ak-tee'-a)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Baneberry, Bugbane")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Ranunculaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Since the last edition of this book (1997), the genus has become a Fat Albert, gobbling up "), _c('em', [_vm._v("Cimicifuga")]), _vm._v(" while no one was paying attention. As a scientist, I understand the credo of “let’s get it right”, therefore evaluation and revaluation of scientific issues are normal and important aspects of any field of study. In the field of taxonomy, new techniques have allowed much more in-depth studies, occasionally resulting in lumping and splitting of families and genera, and wholesale changes to species. For the most part, these changes have been of little interest to gardeners, most gardeners did not deal with botanical names anyway. However retailers and producers do, and were caught between what is correct, and what their clients understood. And most changes in the last thirty years were simple enough. However, some blockbusters have recently come our way and we have been forced to come face to face with the science, and accept or ignore the changes. Often, we ignore them. We did not go gently into that good night with the wholesale changes made to "), _c('em', [_vm._v("Chrysanthemum")]), _vm._v("; we hated them and dug our heels in hoping they would go away. Similar changes in the genus "), _c('em', [_vm._v("Aster")]), _vm._v(" are upon us, to say nothing of movement between families, an almost daily taxonomic occurrence.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("I mention all this now because the genus "), _c('em', [_vm._v("Cimicifuga")]), _vm._v(" has all but disappeared. Like every other change, it has been a slow journey from accepted publication in a scientific journal to finding its way into the gardening and industry literature—and ")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("even longer before it is accepted by any of us. The official dismissal of "), _c('em', [_vm._v("Cimicifuga")]), _vm._v(" occurred in 1998 with a paper from James Compton, and to my amazement, many people have already accepted it, a record for sure. Personally, I dislike it, and have trouble understanding the rationale, however it looks like the changes are here to stay, so let’s get with the program. Here we go, welcome to the wide, wide world of "), _c('em', [_vm._v("Actaea")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In the original genus, three common species are grown for their compound leaves and colorful berries. Unfortunately, the berries and roots are poisonous, which accounts for the common name, baneberry. It is reported that eating only 6 berries can produce severe symptoms. For this reason plants should not be grown where children and pets play. The other common name, bugbane, is a translation from "), _c('em', [_vm._v("cimex")]), _vm._v(", a bug, and "), _c('em', [_vm._v("fugo")]), _vm._v(", to drive away. When Linnaeus named this plant in 1750, he knew that "), _c('em', [_vm._v("Cimicifuga foetida")]), _vm._v(", a species from Asia, was dried and ground into powder and used to stuff pillows, mattresses and cushions as a protection against biting insects. For retailers, however, this name does little to attract customers, perhaps we could call it “white spire plant” or something a little less itchy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All plants are woodland species and do well in moist, shady location and rich, acid soil similar to its native habitat at the edge of woods where leaf mold is plentiful. In early spring, the white flowers appear in terminal racemes, and give way to 1/4\" long oval berries in late summer and early fall. The fruit is equally ornamental as the flowers, but they are eaten by varmints with tougher constitutions than ours.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With the inclusion of the new species, the genus also includes slender, tall plants with much longer long wands of white flowers. The species of garden value have white flowers with minute petals and the stamens provide much of the beauty. All species have ternately compound leaves, a fancy term meaning that the leaves are divided into three segments, three times. All plants in the genus prefer moist, humus-rich soil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They often require 3-4 years before decent flowering occurs and patience is necessary. Unfortunately for gardeners dealing with warm summer nights and high humidity, plants are often disappointing. Unless they receive just the right micro-environment in such a setting, they tend to be stunted and do not flower particularly well. Perhaps if plants were never seen growing in their prime in other gardens, people wouldn’t be so picky. They continue to flower in the Armitage garden, but I wouldn’t put them in a landscape I was designing for someone else.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Seed should be sown when fresh, as old seed is much more difficult to germinate uniformly. In sowing this and other genera of the Ranunculaceae, place the moist seed tray at about 70°F for 3 weeks, then transfer to freezing conditions (28-30°F) for about 5 weeks. After the cold treatment, remove the tray from the freezer and place at 40-50°F until germination occurs. All this is more easily accomplished by sowing in the fall, allowing snow cover or mulch to maintain slightly freezing temperatures followed by cool spring temperatures to satisfy the requirements. A more rapid means of propagation is by root division in the spring.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Actaea Species")])])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (ft.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Fruit ornamental")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. matsumurae")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3-4")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("No")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. pachypoda")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("2-4")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yes, white")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. podocarpa")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3-6")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("No")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. racemosa")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-8")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("No")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. rubra")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("2-4")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yes, red")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. spicata")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("2-4")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yes, black")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("- matsumurae")])]), _vm._v(" (mat-sue' mur-aye)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Kamchatka Bugbane")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-4'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Fall")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Russia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("("), _c('em', [_vm._v("Cimicifuga simplex")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although Kamchatka bugbane does not have the majesty of some other species, it has gained a significant following. The flower stalks are more arching than those of "), _c('em', [_vm._v("A. racemosa")]), _vm._v(" and the secondary stalks are often taller than the terminal raceme. Flowers of this species are generally the last of the bugbanes to open, often taking a minor frost or two, a bonus for gardeners looking for late season color. Plants are more tolerant of basic soils than other species. They are also the best species for the south.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate similar to "), _c('em', [_vm._v("A. podocarpa")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Atropurpurea Group is probably the best way to classify these dark foliage forms. They look alike at first glance and only subtle differences in foliage color can be found. The group includes ‘Bernard Mitchell’, ‘Black Negligee’, ‘Braunlaub’, ‘Brunette’, ‘Hillside Black Beauty’, and ‘James Compton’. They all have bronze to deep purple foliage, stand 3-4' tall and can all be spectacular. I am perhaps a little biased towards the latter two selections, but I have never seen them all lined up side by side for a critical comparison.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘White Pearl’ has large (over 2' long), dense white flower spikes. Flowers open in late October in my garden.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Elstead Variety’ has finely cut dark green foliage, over which purplish brown flower buds open to pure white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pritchard’s Giant’ is an immense cultivar, easily growing 4-5' tall. All cultivars are vast improvements on the species.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-pachypoda")])]), _vm._v(" (pak-ee' poe-da)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White Baneberry, Doll’s Eye")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-4'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Eastern North America")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7a")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("(syn. "), _c('em', [_vm._v("A. alba")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("The species keeps changing from "), _c('em', [_vm._v("A. pachypoda")]), _vm._v(" to "), _c('em', [_vm._v("A. alba")]), _vm._v(" and back again, but if you ask for doll’s eyes, it won’t matter at all. The compound leaves, similar to those ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("of "), _c('em', [_vm._v("Astilbe")]), _vm._v(", are handsome even without the flowers and fruit. The fringed flowers are borne in 2-4\" long terminal racemes on green flower stalks well above the foliage. The flower stalks (pedicels) become thicker ("), _c('em', [_vm._v("pachypoda")]), _vm._v(" means “thick foot”, referring to the pedicel) and turn a pinkish red as the white berries develop. Although the fruit of "), _c('em', [_vm._v("A. pachypoda")]), _vm._v(" and "), _c('em', [_vm._v("A. rubra")]), _vm._v(" usually are different colors, there is a red-fruited form of "), _c('em', [_vm._v("A. pachypoda")]), _vm._v(" (forma "), _c('em', [_vm._v("rubrocarpa")]), _vm._v("), making the shape of the pedicel the best means of distinguishing the two species. This is a handsome plant for the shady area of a woodland setting or border. The deep green leaves appear fresh well into the late summer and the berries provide interest into late fall. Abundant moisture is required in areas of hot summers; plants perform better in areas of cool nights. I coaxed mine along in my garden in north Georgia for a few years, but it kicked its legs up and finally succumbed.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0028-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Actaea pachypoda")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('strong', [_vm._v("Cultivars")]), _vm._v(":")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("‘Misty Blue’ is similar to the species but the showy leaves are blue-green, similar to the color of the foliage of fringed bleeding heart. The plant was named in 1998 by Richard Lighty of Mt. Cuba Center in Greenville, Delaware.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_vm._v("-")]), _c('em', [_c('strong', [_vm._v("podocarpa")])]), _vm._v(" (po-do-car' pa)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("American Bugbane")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-6'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Fall")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Eastern United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("("), _c('em', [_vm._v("Cimicifuga americana")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although not as common in gardens as the other species, it is easier to cultivate. Native from New York to Pennsylvania and as far south as the mountains of Georgia, plants are adaptable to a wide range of conditions. The 1-3\" long, rounded leaflets have 3-5 toothed lobes and heart-shaped bases. The flower stalks are sometimes branched near their base providing additional flowers as the season progresses. If you look closely at the flowers, the bracts at the base of the flower stalks (pedicels) are evident, a distinguishing characteristic of this species.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Propagation by seed is difficult and best results are obtained with fresh seed. Even then, germination is erratic and seedlings emerge over a long time. After collecting the seed, place in sand in the cold (35-40°F) for 6-8 weeks. Sow seed in a 1:1 mix of ")]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("peat: vermiculite and place in a warm (70-75°F), humid area. Plants can be divided but this should not be done for at least three years after planting. They have a deep root system and do not divide well.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0029-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Actaea podocarpa")])]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticStyle: {
      "height": "450px"
    }
  }, [_c('p', {
    staticClass: "imagen"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/f0030-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Actaea racemosa")])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-racemosa")])]), _vm._v(" (ray-ce-mo' sa)")])]), _c('p', {
    staticClass: "table"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Snakeroot, Cohosh")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "table"
  }, [_vm._v("6-8'/4'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Eastern United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("("), _c('em', [_vm._v("Cimicifuga racemosa")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("This is the aristocrat of the genus whose tall white spires provide an unforgettable sight in the late summer garden. It is also the easiest to locate at nurseries and from mail order catalogs. The leaves are deeply cut and the 1-3\" long leaflets are ovate and irregularly toothed. The long racemes of creamy white flowers reach 2' in length, and are often branched near the base of the terminal inflorescence. They may look like rockets on their way to the stars, or bent and twisted in raucous contortions. To the herbalist Patricia Kyritsi Howell, they are reminiscent of a symphony, with gentle music and loud drumrolls. Pat also tells us that these plants are excellent for the treatment of anxiety, or as she calls it “the ax-murderer syndrome.” Flowers open in midsummer in zone 7 but not until late summer or early fall in zones 3 and 4. The 1-2 pistils of the flowers are sessile, that is, they have no pistil stem. This lack of stem is not particularly easy to notice, but it is one of the characteristics that make this species unique. The flowers persist for about four weeks and the spent flower spires ")]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("continue to be decorative for many more weeks. I can’t think of a more beautiful planting than at Naumkeag Garden, designed by Fletcher Steele, in the Berkshires of western Massachusetts. Plants have naturalized in the woodland setting and are absolutely stunning in mid July.")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticStyle: {
      "height": "450px"
    }
  }, [_c('p', {
    staticClass: "imagen"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/f0031-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Actaea racemosa")])])]), _vm._v(" "), _c('p', {
    staticClass: "indentp"
  }, [_vm._v("Fewer flower stalks are produced on this species than others but its graceful yet wiry form has made it popular in American gardens. They look terrific with many cultivars of "), _c('em', [_vm._v("Phlox paniculata")]), _vm._v(". Plants need a constant supply of moisture or leaf margins turn brown and plants become stunted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate similar to "), _c('em', [_vm._v("A. podocarpa")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("cordifolia")]), _vm._v(", ("), _c('em', [_vm._v("Actaea cordifolia")]), _vm._v(") grows 4-5' tall. Leaves consist of 4-10\" long leaflets, the base of the terminal leaflet is heart shaped. Flowers are similar to those of the species.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-rubra")])]), _vm._v(" (rew' bra)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Red Baneberry")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-4'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("North America")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7a")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The flowers appear about a week earlier and are larger and not as fringed as those of the previous species. The 1/4\" long red berries are borne on slender green pedicels, which turn red as they mature. The berries are particularly poisonous and roots are violent purgatives, irritants, and emetics. The leaves are usually more hairy than those of "), _c('em', [_vm._v("A. pachypoda")]), _vm._v(" but except for the color of fruit and shape of pedicels, few differences exist. Plants require the same growing conditions as "), _c('em', [_vm._v("A. alba.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Filkins’ Selection was selected by John Filkins of New York. Plants are similar to the species, but are said to be more vigorous, and bear reliably heavy fruit each year.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Neglecta’ (forma "), _c('em', [_vm._v("neglecta")]), _vm._v(") is a white-berried form with slender stalks. Plants are also a little taller.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Actaea japonica")]), _vm._v(" now includes what was once "), _c('em', [_vm._v("Cimicifuga acerina")]), _vm._v(" as well as "), _c('em', [_vm._v("C. japonica")]), _vm._v(". Plants have dark green maple-like leaves with long pointed lobes and purple stems. An outstanding species.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Actaea dahurica")]), _vm._v(" "), _c('em', [_vm._v("(Cimicifuga dahurica)")]), _vm._v(" is native to China and Japan and is hardy in zone 5 to zone 7. All leaflets are cordate (heart-shaped). Plants grow 5-6' tall and bear creamy white flowers in simple or compound racemes. Flowers, which occur in midsummer, have a subtle fragrance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. spicata")]), _vm._v(", also known as "), _c('em', [_vm._v("A. nigra")]), _vm._v(", black baneberry, is similar to "), _c('em', [_vm._v("A. rubra")]), _vm._v(" but has jet black berries (also very poisonous) carried on short black slender pedicels.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Adenophora")])]), _vm._v(" (a-den-off' or-a)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Ladybells, Gland Bellflower")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Campanulaceae")])]), _c('p', {
    staticClass: "indent1"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("The ladybells are often confused with members of "), _c('em', [_vm._v("Campanula")]), _vm._v(" but are unique in having a thick disc-like structure (the gland) at the base of the style of the flower. ")]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("If you really don’t relish the thought of tearing apart flowers to find such mundane organs, it is helpful to know that "), _c('em', [_vm._v("Adenophora")]), _vm._v(" has numerous branched, slender stems and nodding bell-shaped lilac blue flowers. The leaves are alternate, and sessile or have very short petioles. Plants prefer a rich, well-drained soil in full sun or partial shade. In Montreal, I regarded "), _c('em', [_vm._v("Adenophora")]), _vm._v(" as an innocuous weedy member of gardens. Although plants are better behaved in Georgia, I still have trouble getting excited about it. More tolerant of heat than many of the campanulas, it may be included in the southern garden where other members of the Campanulaceae must be excluded. There are about 50 species and most gardeners know not a one of them. By far the most available members are "), _c('em', [_vm._v("A. confusa")]), _vm._v(" and "), _c('em', [_vm._v("A. liliifolia")]), _vm._v(" (often incorrectly listed as "), _c('em', [_vm._v("A. lilifolia")]), _vm._v("), but occasionally species such as "), _c('em', [_vm._v("A. pereskiifolia")]), _vm._v(" and "), _c('em', [_vm._v("A. bulleyana")]), _vm._v(" are also offered.")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Adenophora Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Leaf arrangement")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower color")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. bulleyana")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("30-36")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Alternate")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Blue, lilac")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. confusa")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("24-30")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Alternate")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Blue, lilac")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. liliifolia")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("18-24")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Alternate")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Blue, lilac")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. pereskiifolia")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("24-30")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Whorled")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Blue, purple")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-confusa")])]), _vm._v(" (con-fuse' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Common Ladybells")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-2 1/2'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("China")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This 2-2 1/2' tall species bears 3/4\" long, nodding bell-shaped, deep blue flowers in late spring. The leaves are ovate, bluntly dentate and are often sessile with leaf bases 2-3\" wide and tapered. The flowers have entire petals and open in late May to early June and continue for about 3-4 weeks. Seed is fine and should be mixed with sand or talcum powder to insure even distribution. Press seed in gently, do not cover. Keep seed tray at 70-75°F soil temperature and moist at all times. Germination takes 2-3 weeks. The roots are deep and fleshy and therefore difficult to divide or move without significant damage.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-liliifolia")])]), _vm._v(" (lily-foe' lee-a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Lilyleaf Ladybells")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1 1/2-2'/1 1/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Pale Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This species resembles "), _c('em', [_vm._v("A. confusa")]), _vm._v(" but is not as tall and the flowers are paler blue or creamy white. The style of the flowers is obviously exserted (projects from the petals) whereas the style of the former is only slightly so. The petals are finely serrated and the leaves are linear to lanceolate and approximately 1\" wide. This species tolerates heat better than "), _c('em', [_vm._v("A. confusa")]), _vm._v(" and is also a good plant for southern gardeners, and even better, it is the most fragrant of the ladybells.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species and Hybrids:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Amethyst Chimes’ was introduced by Joy Creek Nursery and grows 3-4' tall and bears smoky lilac flowers. I believe this is the same as ‘Amethyst’.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('div', {
    staticStyle: {
      "height": "500px"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('p', {
    staticClass: "imagen"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/f0034-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Adenophora confusa")])])])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('p', {
    staticClass: "indentp"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('em', [_vm._v("A. aurita")]), _vm._v(" has branching stalks of blue bell-shaped flowers with strong basal leaves. Plants grow about 2' tall.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. bulleyana")]), _vm._v(" is native to western China and differs from the above species by having glossy green, ovate leaves with single serrations. The leaves are wider than the above species, all but the uppermost being about an inch wide. The pale blue flowers are often borne in threes. Handsome but uncommon. Hardy to zone 3.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. pereskiifolia")]), _vm._v(" bears purple bell flowers on 2-2 1/2' tall stems. The whorled leaves are pointed and slightly hairy. Excellent plants for heat and humidity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. potaninii")]), _vm._v(" is native to China and hardy to USDA zone 3. The stems are upright but not particularly strong, but the flowers, usually violet to blue, are pendulous. A white form, ‘Alba’, is occasionally offered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. stricta")]), _vm._v(" is taking a while to find its way to America, but it is a most handsome plant. Seeds of "), _c('em', [_vm._v("A. stricta")]), _vm._v(" var. "), _c('em', [_vm._v("sessilifolia")]), _vm._v(" were brought to England by Roy Lancaster of Hampshire, England from northwest Sichuan, China. Nodding blue bell-shaped flowers are produced on a branching raceme over kidney-shaped basal leaves. The lower leaves are stalked while the upper ones are sessile. It was originally identified as "), _c('em', [_vm._v("A. aurita")]), _vm._v(" and plants may appear in catalogs that way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. tashiroi")]), _vm._v(" is occasionally offered. Native to Japan, plants stand about 15\" tall and bear whorls of nodding blue flowers in summer.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('em', [_vm._v("A. triphylla")]), _vm._v(" is a charming 12-20\" tall plant that flowers in late summer and fall. Long exserted styles protrude from the late summer blue to violet flowers. The leaves are whorled, usually four per whorl. Native to China, hardy in zone 4-7.")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Adiantum")])]), _vm._v(" (add-ee' an-tum)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Maidenhair Fern")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Pteridaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("The maidenhairs provide some of the most handsome ferns in the garden. The stems are dark purple to black and the blades are arranged in fanlike segments. Of the 200 or so species, two or three are easily found by gardeners, but others are available with a little searching. Many maidenhairs are not sufficiently cold hardy for much of the country and if seen at all, are seen as houseplants. However, a number of species are quite cold tolerant and may be used as far north as zone 2, if spores or plants are available. The Aleutian maidenhair, "), _c('em', [_vm._v("A. aleuticum")]), _vm._v(", and the northern maidenhair, "), _c('em', [_vm._v("A. pedatum")]), _vm._v(", are the most cold hardy while Argentine maidenhair, "), _c('em', [_vm._v("A. lorentzii")]), _vm._v(", delta maidenhair, "), _c('em', [_vm._v("A. raddianum")]), _vm._v(", and southern maidenhair, "), _c('em', [_vm._v("A. capillus-veneris")]), _vm._v(", are most at home south of zone 7. Trailing or walking maidenhair, "), _c('em', [_vm._v("A. caudatum")]), _vm._v(", is native to the tropics but its long pendulous fronds and attractively lobed segments make a handsome summer fern regardless of winter temperatures.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The maidenhairs do not perform as well in deep shade as many other species. An area with bright filtered light and good air circulation is made for maidenhairs. Well-drained alkaline soils are best and pH may be raised if necessary with the addition of marble chips or dolomitic lime. Sand and peat moss at a pH of about 7 to 8.5 is satisfactory.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants are relatively easy to produce from spores.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Adiantum Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Foliage arranged in horseshoe shape on stem")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Hardy to at least zone 7")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. aleuticum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-24")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. capillus-veneris")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("12-18")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. pedatum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("12-20")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. raddianum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-12")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-capillus-veneris")])]), _vm._v(" (ca-pill' us ven-er' is)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southern Maidenhair")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("12-18\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Light Green Foliage")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe, Tropics")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 7-10")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Southern maidenhair fern is widely distributed from semi-tropical to tropical areas and often grown as a greenhouse plant. My daughter Laura keeps surprising me, she always has flowers in her home, but she also uses 4\" pots of southern maidenhair in decorative containers in her den. Bright girl, that Laura.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although plants are difficult to perennialize outdoors in cold temperate areas due to lack of cold tolerance and susceptibility to disease, they are showstoppers where they are happy. A great deal of variability occurs, particularly in plant performance. Plants of southern maidenhair exuberantly grow on the rock walls at Birmingham Botanical Gardens; the bright light and sheltered location made these plants glisten. The petioles are dark brown to black and the lacy, delicate foliage is light green, particularly when young. Steve Bender at "), _c('em', [_vm._v("Southern Living")]), _vm._v(" recommends southern maidenhair combined with white caladiums and nippon lily ("), _c('em', [_vm._v("Rhodea japonica")]), _vm._v(") as an outstanding combination but they combine nicely with most plants if they are grown well. Bright light is essential for good growth and if overgrown with other plants, they tend to develop dark spots on the fronds and decline. Good air movement and basic pH are essential.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Fimbriatum’ has segments cut into deeply cut finger-like lobes.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Imbricatum’ is smaller with cascading fronds.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Rock Springs’ was found in 2000 in the Edwards Plateau region of Texas near the town of Rock Springs, Texas by Scott Ogden and Tony Avent. Good heat tolerance is a bonus for this 2' tall cultivar.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_vm._v("-")]), _c('em', [_c('strong', [_vm._v("pedatum")])]), _vm._v(" (pe-day' tum)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Northern Maidenhair Fern")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("12-20\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Mid Green")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("North America, East Asia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is one of the most sought-after and popular ferns in temperate gardens. That it is one of our natives to boot provides added pleasure. The northern maidenhair fern provides a graceful and lacy feel in the shaded garden and quickly spreads in moist, bright areas. They thrive in cold areas but are difficult south of zone 7b. The foliage is forked and consists of 8-20 segments held in a horseshoe-like arrangement. The black shiny stems are among the most handsome in the plant kingdom. They are deciduous and slow to emerge in the spring, compared to other more vigorous ferns.")])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0037-01.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Adiantum pedatum")])]), _vm._v(" "), _c('p', {
    staticClass: "indentp"
  }, [_vm._v("Plants perform well in areas of bright filtered light and good air circulation. A basic pH is also beneficial for best performance.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A number of forms have been selected or developed but few are easy to find, and none is any better than the species.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Japonicum’ has pinkish-bronze new fronds.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Miss Sharples’ produces larger leaflets and has a noticeable chartreuse color.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Montanum’ is much more compact and dense than the species.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Adiantum aleuticum")]), _vm._v(" ("), _c('em', [_vm._v("A. pedatum")]), _vm._v(" var. "), _c('em', [_vm._v("aleuticum")]), _vm._v("), Aleutian maidenhair, is native to the western half of the country and as far north as Alaska. USDA zones 2-7. Plants are particularly cold hardy, but not recommended for areas of high heat and humidity. The branches are pendulous and weeping, and the fronds are deeply cut. Two other varieties of northern maidenhair, var. "), _c('em', [_vm._v("subpumilum")]), _vm._v(", a dwarf form, and var. "), _c('em', [_vm._v("calderi")]), _vm._v(" have recently been folded into this species.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('em', [_vm._v("Adiantum hispidulum")]), _vm._v(", rosy maidenhair, has possibilities for gardeners in the southern part of the country and as far north as zone 7. It is variable in form but generally has rough stems and dark glossy green horseshoe-shaped fronds, and is adaptable to ")]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("a wide range of soil conditions. The new growth is rosy pink, and in the spring well-grown plants are outstanding. Harsh winters will damage the fronds and impede the new growth and some mulching to protect from winter winds may be useful. ‘Bronze Venus’ bears new foliage that is more bronze than that of the species.")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Adiantum raddianum")]), _vm._v(", delta maidenhair fern, grows 1-2' tall and is native to central and South America. Hardy only in zones 8-10. Probably the most common maiden-hair in the world, it is little seen in gardens in this country because of its lack of cold tolerance. Even in my garden in Athens (zone 7b), plants overwinter only in mild winters and struggle to multiply. They grow naturally in rocky area and bluffs and generally prefer neutral to alkaline soils. The segments are lobed and narrowly triangular and are borne on handsome black stems. It is renowned for its variability, with over 60 cultivars named by fern growers, but few are commonly available. However, fern organizations may supply spores or plantlets for fern fanciers. ‘Bridal Veil’ has drooping fronds with small teardrop segments. ‘Elegans’ bears lobed, wedge-shaped segments and is one of the easiest to raise; ‘Fritz Luthi’ has overlapping fronds, grows 1-2' tall and bears similar handsome black stems. Plants appear to be more cold hardy than most cultivars, an RHS Award of Garden Merit plant in 1997; ‘Variegatum’ produces upright fronds with segments flecked with white. Spores gathered from the strongest variegated fronds tend to produce variegated sporelings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Adiantum venustum")]), _vm._v(", Himalayan maidenhair fern, provides reasonable cold tolerance (to zone 5), but is not particularly heat tolerant. The 1-2 1/2' tall fern bears large, coarsely divided fronds and each segment is divided. Plants are becoming more available.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Genus")]), _vm._v(":")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('em', [_vm._v("Adiantopsis")]), _vm._v(" appears more similar to "), _c('em', [_vm._v("Cheilanthes")]), _vm._v(" than "), _c('em', [_vm._v("Adiantum")]), _vm._v(", however a couple of forms have become available to gardeners. Neither is cold hardy much below 15°F, so think about zone 7b as its limit. So few of these are out there that I, along with all others, am guessing at best. "), _c('em', [_vm._v("A. chlorophylla")]), _vm._v(" is about 2' tall while the more common "), _c('em', [_vm._v("A. raddiata")]), _vm._v(" is shorter with fronds arranged in a starfish pattern. Both are native to Costa Rica and northern South America.")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Adlumia")])]), _vm._v(" (add-loom-ee' a)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Allegheny Vine, Climbing Fumitory")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Fumariaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("This climbing biennial vine is represented by "), _c('em', [_vm._v("A. fungosa")]), _vm._v(", native to the northeastern United States, thus its common names, mountain fringe and Allegheny vine. The delicate, light green foliage is three times pinnate, resulting in a fernlike appearance. Plants use the petioles of new leaves to clamber and scramble over shrubs and bushes, or gardeners may train the vine along fences or arbors. The pale pink and whitish flowers are similar to those of bleeding heart ("), _c('em', [_vm._v("Dicentra")]), _vm._v(") and are formed in hanging clusters at the axils. Plants are hardy to zone 3 and may be grown as far south as zone 7.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants form a low bushy mound the first year and then, after winter, climb as fast as helium balloons released from the football stadium. Growing 10-12' tall in a few weeks, it is one of those vines that one should plant and then get out of the way. Provide some afternoon shade for best performance. The flowers are not bright or big enough to allow this to ever become a mainstream garden plant, but is fun and easy to grow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many European and some American taxonomists put "), _c('em', [_vm._v("Adlumia")]), _vm._v(" in the family Papaveraceae. However, the members of the Fumariaceae are quite distinct from those of the Papaveraceae in several respects, including floral symmetry, sap character, and stamen number and fusion. So let’s keep it with its friends "), _c('em', [_vm._v("Dicentra")]), _vm._v(" and "), _c('em', [_vm._v("Corydalis")]), _vm._v(" for a while longer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate from seed; they will self-sow in areas where plants are happy.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Adonis")])]), _vm._v(" (a-don' is)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Adonis")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Ranunculaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Greek legend has it that these were favorites of Adonis, who, upon his death, was changed into this flower by the goddess Aphrodite. Adonis was regarded as the God of Plants by the Greeks, and he was believed to disappear every autumn and reappear in the spring.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("About 20 species occur but only "), _c('em', [_vm._v("A. amurensis")]), _vm._v(" and "), _c('em', [_vm._v("A. vernalis")]), _vm._v(" are perennial throughout most of the country. The leaves are alternate, dissected and light green. The plants are erect but normally do not exceed 18\" in height and are most effective as rock garden plants or in the front of a small border. They should be planted in masses as one or two plants do not provide enough “flower power”. Although said to perform better at a basic pH, they don’t seem particularly fussy about soil as long as it is well drained. An area that receives some afternoon shade should be chosen in the South, although full sun north of zone 5 is satisfactory. Slugs relish them and spring application of slug preventative reduces damage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Approximately 6 weeks of temperatures below 40°F are necessary for the rhizomes to break dormancy in the spring. Both species go dormant by midsummer. Plant late-emerging perennials such as "), _c('em', [_vm._v("Platycodon")]), _vm._v(" or "), _c('em', [_vm._v("Gladiolus")]), _vm._v(" or summer annuals to cover the vacant area.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sow fresh seed in the spring, grow seedlings throughout the summer and transplant to the garden in the fall; plants will likely flower the next spring. Seed is notoriously difficult to germinate if not fresh, and even if collected from garden plants, seeds will need more than one year to germinate. Division is not required, however it the best means of multiplication; divide in late spring after the foliage dies down.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Adonis Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Number of leaves")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower color")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flowering time")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. amurensis")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("9-12")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Few")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Early Spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. vernalis")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("12-15")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Many")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Late Spring")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-amurensis")])]), _vm._v(" (am-ew-ren' sis)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Amur Adonis")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("9-12\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Japan, Manchuria")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("This species flowers as early as February in southern gardens and progressively later further north. The stems are branched, each stem branch bearing triangular, 3-6\" long leaves which are cut into 3 sections to the base. Each of those sections is in turn divided into linear segments. At the base of each petiole are leafy stipules. The ")]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("2\" wide flowers are usually buttercup-yellow but may occasionally be white, rose, or have red stripes. Each flower has 20-50 petals, slightly longer than the sepals. The flowers generally appear just before the leaves fully emerge.")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The leaves unfurl as the flowers begin to open. If the weather remains cool when flowers open, they persist for up to 6 weeks, fewer if hot weather comes along. The golden flowers contrast well with the reticulated iris ("), _c('em', [_vm._v("I. reticulata")]), _vm._v("), crocus, and other spring-flowering bulbs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagation is best accomplished by division in late spring or early summer.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Flore-plena’ is a common double cultivar and is much showier than the species.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Fukuju Kai’ has fully open sulfur-yellow flowers and is the earliest to bloom. Other cultivars with copper, orange, pink, and white flowers have been developed by Japanese nurserymen, but have not been widely distributed.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Sandanzaki’ is certainly interesting, if not calming. Plants grow about 15\" in height and bear flowers consisting of layers of yellow petals often edged in green. Unfortunately, plants are rare at best.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-vernalis")])]), _vm._v(" (ver-nah' lis)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring Adonis, Pheasant’s Eye")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("12-15\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants are more winter hardy (zone 3 with protection) than the former and flowers emerge 3-6 weeks later. It differs from the previous species by having unbranched stems and many more leaves that are sessile (no petioles) and 1-2\" long. The flowers have fewer petals than "), _c('em', [_vm._v("A. amurensis")]), _vm._v(" (10-15), which are slightly toothed, and about 2 1/2\" wide. They open as flat as a dinner plate, as if knowing their time in the sun was fleeting, to be enjoyed while they could. Plants do not go completely dormant as do those of "), _c('em', [_vm._v("A. amurensis.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagation is more difficult than "), _c('em', [_vm._v("A. amurensis")]), _vm._v(" and may take several years to recover from the disturbance of dividing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. apennina")]), _vm._v(" is similar to "), _c('em', [_vm._v("A. vernalis")]), _vm._v(" but has larger flowers (up to 3\") and the lower leaves are rounded and sheathlike.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Aegopodium")])]), _vm._v(" (aye-go-pow' dee-um)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Goutweed, Bishop’s Weed")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Apiaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("About 6 species have been described in this genus; all grow by creeping rhizomes and all can be incredibly invasive. The foliage occurs in threes and the flowers are usually white. The only species commonly seen in cultivation is "), _c('em', [_vm._v("A. podagraria")]), _vm._v(", bishop’s weed.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-podagraria")])]), _vm._v(" (pod-a-grair' ee-a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Bishop’s weed, Goutweed")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-9\"/spreading")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe, Western Asia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 2-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("Some people politely call this plant “fast growing and a good filler”. Others curse it as they wrench their backs while wrenching out this loathsome invader. No doubt it ")]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("can be invasive, and jump and frolic through the garden. In some cases, this no way diminishes its value, for if areas require some greenery or soil must be conserved, this plant is perfect. The leaves are produced in two groups of three (biternate) and creamy-white flowers are produced in late spring and summer. In Montreal, this plant was everywhere, in Michigan, it was not much different. However, in the southeastern United States, plants are much better behaved. It is still invasive, but takes a few more minutes to take over. Plants are tolerant of nearly all soils, and prefer partially shaded areas. They burn up in full sun, so you end up with an ugly thing all over the place. Plants multiply with creeping rhizomes and spread more quickly in cooler soil temperatures. This plant also looks good in nursery pots, therefore it is a favorite of nursery people who can sell weeds in a pot. Marketing is alive and well in North America. Plants were at one time thought to cure gout, thus one of its common names.")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0041-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Aegopodium podagraria")]), _vm._v(" ‘Variegata’")]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bengt’ supposedly is a non-running form from Sweden. The margins are somewhat wavy. I have not trialed this, so cannot verify this claim.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("‘Variegatum’ is more common than the species and much more ornamental. The green leaves bear creamy-white margins and plants are only a little less invasive than the species. The leaves, however, are clean and bright and if this genus must ")]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("be used, the variegated form is far more handsome. I yank it up from my garden and stick it the woods to brighten them up, and it still does well.")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Aethionema")])]), _vm._v(" (ieth-ee-o-nee' ma)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Stonecress")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Brassicaceae")])]), _c('p', {
    staticClass: "indent1"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('em', [_vm._v("Aethionema")]), _vm._v(" has never hit the mainstream of North American gardening, although plants have regional followings where rock gardens and alpine gardening are popular. Plants do poorly in warm climates, but they may be fall planted for spring enjoyment. After flowering, they generally decline. In northern areas, however, "), _c('em', [_vm._v("Aethionema")]), _vm._v(" is underused and if small stature and colorful plants are needed, stonecress may fill that need. Numerous handsome species and cultivars are available from seed and given sharp drainage, they are easily grown. All flowers consist of 4 petals and 4 sepals.")])]), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Aethionema Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower color")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Foliage color")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. armenum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-8")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Pink")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Light green")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. grandiflorum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("12-20")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Rose-red")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Blue-green")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. iberideum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-9")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Blue-green")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-armenum")])]), _vm._v(" (ar-meen' um)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Turkish Stonecress")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-8\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Pink-white")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Turkey, Caucasus")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This highly variable species bears narrow, linear light green to gray-green leaves and whitish pink flowers held in tightly clustered racemes. Plants dislike moist clay soils and shade, performing best on sunny, well-drained slopes or raised beds. Plants respond well to slightly alkaline soils. It is difficult to find the species but a number of handsome cultivars can usually be located in the trade.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-grandiflorum")]), _vm._v(" (gran-di-flo' rum)")])]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Persian Stonecress")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("12-20\"/15\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Rose-pink")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Western Asia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants produce dozens of flowers in crowded upright terminal racemes, showy for many weeks. The rose-colored flowers bear petals about 4 times as long as the sepals. The blue-green leaves are needle-like and the base of the plant becomes woody. There is some variability in this species as well, and this variable group is referred to as "), _c('em', [_vm._v("A. grandiflorum")]), _vm._v(" Pulchellum group.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-iberideum")])]), _vm._v(" (i-be-ri' dee-um)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Iberis Stonecress")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-9\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Eastern Mediterranean")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The white flowers are similar to those of "), _c('em', [_vm._v("Iberis")]), _vm._v(", thus its common name. Gray-green silvery mats of leaves carry many small, fragrant flowers less than 1\" long in a terminal raceme. Plants require excellent drainage and are best used in the rock garden or in raised beds. The diminutive height and free-flowering nature of this plant makes it highly sought after by alpine enthusiasts. In warm humid climates, it melts like an ice cream cone.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species and Hybrids:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. cordifolium")]), _vm._v(", heart-leaf stonecress, is similar to "), _c('em', [_vm._v("A. grandiflorum")]), _vm._v(" but is smaller in almost every way. The foliage has a blue-green hue. Plants grow to 8\" and the flowers are only about 1/5\" long. Native to Lebanon.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. oppositifolium")]), _vm._v(" is only 1-2\" tall but makes handsome mats of pink-lilac flowers. Perfect for the rock garden, this woody-based plant creeps from rock to rock.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. schistosum")]), _vm._v(", Persian stonecress, bears dozens upon dozens of pink flowers in early spring which as a group provide pleasant fragrance to go with the color. The evergreen leaves are tiny with an obvious blue hue.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Warley Rose’ is the most popular stonecress and carries brilliant dark pink flowers densely borne over 6-8\" tall mats of gray-green foliage. The cultivar was awarded an Award of Garden Merit in 1993 by the Royal Horticultural Society. Introduced in the early 1920s by the eccentric Mrs. Wilmott of Warley House, England (see "), _c('em', [_vm._v("Eryngium giganteum")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Warley Ruber’ has dark maroon flowers. Both cultivars have been placed with various species, but now plants are thought to be natural hybrids.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Agapanthus")])]), _vm._v(" (ag-a-pan' thus)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("African Lily")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Alliaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Agapanthus is a rhizomatous plant with fleshy roots and elongated leathery leaves. Most species have strap-shaped, glossy dark green 2-3' long leaves. The flowers are carried in a rounded umbel on a thick scape and appear in late summer. In favorable climates, plants are extremely tough and durable. In areas of Britain, southern Europe and throughout New Zealand, agapanthus is common and long lasting, used as edgings, roadway dividers and hedging.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The most common species are the evergreen "), _c('em', [_vm._v("A. africanus")]), _vm._v(", lily of the Nile, "), _c('em', [_vm._v("A. praecox")]), _vm._v(", and the deciduous "), _c('em', [_vm._v("A. campanulatus")]), _vm._v(". Few obvious differences occur in foliage and flower, and many selections and hybrids are far more common than the species themselves. Although "), _c('em', [_vm._v("A. praecox")]), _vm._v(" and "), _c('em', [_vm._v("A. campanulatus")]), _vm._v(" are fully hardy in areas of California and Florida, the hardiest and most available forms of "), _c('em', [_vm._v("Agapanthus")]), _vm._v(" are the hybrids; old ones like the ‘Headbourne Hybrids’ are still popular while newer cultivars are popping up in retail establishments throughout the country.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even in north Georgia (zone 7b), it is difficult to overwinter agapanthus, yet there are areas as far north as zone 5, where winter temperatures may routinely reach –10°F, where they overwinter. Moderation of temperatures by a lake effect, sandy well-drained soils, and snow cover help create this unusual situation. Without doubt, the majority of gardeners in this country should use agapanthus in a combination container for the deck, porch or around a garden pool, to be brought into a frost-free area during the winter. Many of the newer introductions may be hardy to zone 7.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On a taxonomic note, a good deal of discussion concerns whether the genus should be included in the Liliaceae, where it has resided or in the Alliaceae, a relatively new family. Both are accepted, I have opted to include it with the onions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Allow the crowns to dry out over the rest period and begin adding water as spring approaches. The crowns should be set approximately 2\" below ground level, watered well and left undisturbed. During the growing season, plants require copious amounts of water and must not be allowed to dry out.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars and Hybrids:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many beautiful garden forms and hybrids have been developed and a few are gaining popularity. Some cultivars are particularly good for cut flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Albus’ (‘Albidus’) bears creamy white flowers on 2-3' tall plants. Evergreen.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alice Gloucester’ has purple flower buds and stems and bears large warm white flowers in mid to late summer.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Back in Black’ bears dark blue flowers, which in itself is not unusual. The “black” part comes from the flower stem which starts out dark green and ages to black.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Blue Giant’ produces rich blue trumpets on plants that may reach 3 1/2' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Blue Globe’ is deciduous, growing about 3' tall with light blue flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Blue Moon’, raised by Eric Smith of Hillier’s Nursery, has densely packed pale blue flowers on 2-2 1/2' tall stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Blue Triumphator’ is 2-3' tall and produces clean blue flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bressingham Blue’ grows about 3' tall and produces deep amethyst-blue flowers. ‘Bressingham Bounty’, with slightly broader leaves and large rich blue flowers was introduced in 1992. ‘Bressingham White’ is a vigorous plant with clean white flowers. All arose from initial seedlings raised in 1967 at Blooms of Bressingham, Diss, England.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Cayles Lilac’ came from New Zealand and bears soft lilac flowers on 15-18\" tall plants with broad leaves.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Cobalt Blue’, selected by Beth Chatto of Elmstead Market, England, has cobalt blue flowers on 2' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Elaine’ was a wild hybrid found among seedlings at the Los Angeles State and County Arboretum. Plants bear large dense umbels of dark violet-blue flowers. Flower stalks are up to 4' long.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Ellamae’, also selected by the Los Angeles State and County Arboretum, appears to be a cross from "), _c('em', [_vm._v("A. orientalis")]), _vm._v(" ‘Praecox’ and "), _c('em', [_vm._v("A. inapertus")]), _vm._v(". Very vigorous, plants produce dozens of violet flowers on long stalks.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Gayle’s Lilac’ is a good dwarf form, standing about 1 1/2-2' tall. Plants bear many scapes of pale lilac flowers above the evergreen foliage.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Getty White’ is a hybrid with dense heads of creamy white flowers. Vigorous and handsome.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Glenavon’ is hard to find in the United States, but well worth the effort. Plants bear dozens of blue flowers with deep blue stripes. They are not short, growing up to 3'.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Headbourne’ hybrids arose during the 1950s and 60s from Mr. Lewis Palmer of Headbourne Worthy near Winchester, England. As a mix, they have 2-3\" long deep violet to pale blue flowers. These are among the taller of the available cultivars as well as the most cold hardy. Mr. Palmer was a leader in the breeding of agapanthus and many of his original crosses were used in the continued improvement of this genus.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Isis’ bears large inflorescences (6\" across) of deep blue flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Kingston Blue’ is about 2' tall and produces blue-black flower buds that open to dark royal blue flowers in early summer.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("‘Liliput’ has 8-12\" long leaves, grows only 12-18\" tall and produces small pendulous dark blue flowers. Terrific for containers but slow to divide.")])]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Loch Hope’ is one of the finest blue agapanthus in cultivation today. It is late flowering and produces flowers of the deepest violet atop 4-5' tall stems. In many of the older blue selections, the flowers fade to an unsightly reddish purple. This is not the case with this hybrid as the flowers maintain their deep color until they fall from the plant.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Peter Pan’ is a dwarf (about 12\" tall) cultivar with narrow foliage and handsome sky blue flowers. Excellent in containers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Profusion’ grows to 3' in height and bears many light to dark blue flowers. The variability in flower color produces a striped effect.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Silver Baby’ has a tinge of blue all over the white flowers. Dwarf (1-2' tall), handsome and unusual.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Snow Drops’ is a dwarf form with white flowers. Introduced from New Zealand.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Snowy Owl’ is an excellent clone with creamy white flowers on 3' high stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Snow Pixie’ produces many clean white flowers on 9-15\" tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("The Storm series, presently consisting of ‘Blue Storm’ and ‘Snowstorm’, has become quite popular due to plants’ heavy flowering tendencies. Developed in Australia by the Tesselaar Company.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Streamline’ arose from the Auckland Botanic Gardens and is about 18\" tall and produces blue flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Tinkerbell’ is a short (10-12\" tall) plant with variegated foliage consisting of light green leaves with narrow clean white edges. The foliage is truly beautiful but plants seldom flower. As beautiful as the foliage is, it simply looks like a variegated liriope if the blue flowers don’t appear. Beautiful when placed in sunny, moist area.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘White Christmas’ is about 2' tall when not in flower but the white spires of flowers reach nearly 5' in height.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. inapertis")]), _vm._v(" bears long narrow blue-green foliage on 2-3' tall plants. I have always admired the plants in the British Isles but have not seen many in this country. The tubular flowers are dark blue, erect at first, then becoming pendulous. Sometimes the var. "), _c('em', [_vm._v("pendulus")]), _vm._v(" can be found where the flowers droop all the time. ‘Sky’ is one such cultivar with tall stems bearing pendulous, sky blue flowers in summer. A white form, ‘Alba’, also occurs.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Agastache")])]), _vm._v(" (a-gah' sta-kee)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Anise Hyssop")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Lamiaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("A genus consisting of approximately 20 species, mostly native to southwest United States and Mexico, often smelling of licorice or other childhood fragrances. Plants produce many spikes of flowers in lavender, red, orange and red although yellow flowers are occasionally seen ("), _c('em', [_vm._v("A. nepetoides")]), _vm._v(").")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("A good many species are not cold hardy north of zone 8, but enough are sufficiently cold tolerant to zone 7 and a few into zone 5 and 6. Many wonderful plants such as "), _c('em', [_vm._v("A. foeniculum")]), _vm._v(", "), _c('em', [_vm._v("A. cana")]), _vm._v(" and "), _c('em', [_vm._v("A. rupestris")]), _vm._v(" as well as the golden "), _c('em', [_vm._v("A. aurantiaca")]), _vm._v(" are native to the United States, and becoming more common as the popularity of ")]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("native plants increases. However, some species are far more useful as contributing parents for the many hybrids that have recently appeared. As more gardeners discover the xeric properties of these plants, the popularity of the hybrids will continue to increase. All plants do well in full sun and slightly alkaline well-drained soils.")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Agastache Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower Color")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. cana")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("12-36")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Rose-pink")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. foeniculum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("20-30")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Purple")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. rugosa")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("24-30")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Violet-rose")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. rupestris")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("36-48")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Orange-salmon")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-cana")])]), _vm._v(" (can' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Mosquito Plant")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1-3'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Pink, Rose")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southwest United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 7-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The blue-green foliage and pink-rose tubular flowers on many, branched stems make this an excellent plant to try in the garden. Flower colors are difficult to describe with people calling them deep rose, off-pink, near scarlet and various combinations thereof. The upright racemes consist of 6-12 flowers held in each whorl. The whorls are loosely arranged on 12-18\" flowering stems. The foliage is fragrant but not nearly as much as "), _c('em', [_vm._v("A. rupestris")]), _vm._v(". Full sun and well-drained soils are essential.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate from seed at 72°F and high humidity.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Sonoran Sunset’ grows 12-15\" tall and equally wide and is covered with lavender-rose flowers most of the summer. May be cold hardy to zone 6. A Plant Select"), _c('sup', [_vm._v("®")]), _vm._v(" Winner in 2002.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_vm._v("-")]), _c('em', [_c('strong', [_vm._v("foeniculum")])]), _vm._v(" (foe-nick' ew-lum)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Anise Hyssop")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("20-36\"/30\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Purple")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("North America")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 6-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Growing tall, bearing many flower stems that are easily dried, anise hyssop is a favorite for cut flower producers and gardeners alike. The flowers are tightly arranged in long dense racemes. The flowers range from lavender to purple and the foliage is distinctly anise-like. They perform well in full sun but get tall and lanky if grown in too much shade. Easily propagated by seed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alba’ (‘Alabaster’) is a common creamy white form of the species.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Golden Jubilee’ has been one of my favorites since we first trialed it in 2002. The anise-scented leaves are a muted yellow, although sufficiently golden to deserve the name, and they maintain their color throughout the summer. Plants produce many upright candles of lavender blue flowers in mid to late summer as well. Probably cold hardy to zone 6.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("‘Licorice Blue’ and ‘Licorice White’ bear lavender-blue and off-white flowers respectively.")])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Snowspire’ is offered by only a handful of nurseries, but the 3' tall plants bear many white flowers atop mid green foliage.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-rugosa")])]), _vm._v(" (rew-go' sa)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Anise Hyssop")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("24-30\"/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Violet-rose")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("China, Japan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("This oriental visitor is offered by a number of nurseries because of enhanced cold tolerance. The branching flower stems carry violet-rose whorled flowers on 2-3' tall plants over fragrant foliage. The wonderfully mint-scented leaves are 2-3\" long and 2\" wide with serrated margins and are pubescent chiefly along the veins on the underneath. Not as ornamental as some of the hybrids but a good performer.")])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alba’ is a white-flowered form of the species.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Honey Bee Blue’ is a uniform long-flowering cultivar. Plants received an Award of Quality from Fleuroselect, an association of flower seed breeders and sales companies in europe, similar to our All American Selection association.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Honey Bee White’ is similar to ‘Alba’ and may be the same. The creamy white flowers bloom for a long time on 2-3' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-rupestris")])]), _vm._v(" (rew-pes' tris)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Rock Anise Hyssop")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-4'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Salmon-orange")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southwest United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("The striking rosy-orange whorled flowers and gray-green foliage provide a lovely wildflower to add color to the garden. One of the hardiest of the native hyssops, it has been used to incorporate cold tolerance to a number of hybrids. The flower color is unusual and flowering persists for at least 8 weeks. The best part of these plants is the fragrance of the foliage. People keep coming back to get their sniff, then bring their friends to get theirs. I call it the licorice plant, and plants transport me to the old-fashioned candy store. A Plant Select"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_vm._v("®")])]), _vm._v(" Winner in 1987.")])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Full sun and well-drained soils are necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_c('strong', [_vm._v("Hybrids")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Apache Sunset’ produces gray, finely cut leaves on 18-22\" plants with salmon-orange flowers in midsummer to late fall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Apricot Sprite’ and ‘Apricot Sunrise’ are stunning crosses between "), _c('em', [_vm._v("A. aurantiaca")]), _vm._v(", golden hyssop, and "), _c('em', [_vm._v("A. coccinea")]), _vm._v(", both hybridized by Richard Dufresne of North Carolina. The former is about 2' tall and filled with apricot flowers in the summer. The latter is taller, up to 3 1/2' with many golden orange tubular flowers in the summer. Both are eye-catching and attractive to butterflies and hummingbirds. Water and fertilize well. Zones 7-9.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Black Adder’ appears to be a cross between "), _c('em', [_vm._v("A. foeniculum")]), _vm._v(" and "), _c('em', [_vm._v("A. rugosa")]), _vm._v(". It is a long bloomer, usually starting in midsummer and flowering until September or October. The flowers are rosy violet and held well above the foliage.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0048-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Agastache rupestris")])]), _vm._v(" "), _c('p', {
    staticClass: "indentp"
  }, [_vm._v("‘Blue Fortune’ is also a cross between "), _c('em', [_vm._v("A. foeniculum")]), _vm._v(" and "), _c('em', [_vm._v("A. rugosa")]), _vm._v(", and is without doubt one of the best new plants recently introduced to gardens. Plants can grow up to 3' in height and bear beautiful lavender-blue flowers on upright spires. The foliage has lovely licorice-scented leaves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Coronado’ is an upright grower with silvery aromatic leaves. The tubular yellow flowers are heavily stained with orange, and open in late summer. Plants grow about 2 1/2' tall. I have seen this rated to be hardy as far north as zone 4, but more likely to zones 5-6. Selected a winner by Colorado’s Plant Select"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_vm._v("®")])]), _vm._v(" Program in 2001.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("‘Firebird’, also from Richard Dufresne, is a hybrid of "), _c('em', [_vm._v("A. coccinea")]), _vm._v(" and "), _c('em', [_vm._v("A. rupestris")]), _vm._v(" and bears many orange-salmon flowers on 3' tall plants. Plants are fuller than either of the parents and are cold hardy to zone 6. Terrific plant for hummingbirds. Probably hardy to zone 8, perhaps zone 7.")])]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Fragrant Delight’ produces pale blue flowers on 3' tall stems. The foliage is particularly fragrant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Heather Queen’ is 2' tall with many rosy pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Just Peachy’, introduced by High Country Gardens of Santa Fe, New Mexico, provides subtle shades of pink- and peach-colored flowers. The 2 1/2' tall plants are perhaps hardy to zone 6.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Pink Panther’ ("), _c('em', [_vm._v("A. coccinea")]), _vm._v(" x "), _c('em', [_vm._v("A. mexicana")]), _vm._v(") grows 3-4' tall and produces many 1 1/2\" long tubular rose-pink flowers held in long racemes, starting in midsummer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Purple Haze’ is only about 2' tall, taller in warmer weather, with lavender flowers in the summer. Not as fragrant as many other hybrids, but plants are consistently hardy to zone 6. Plants were introduced by Dutch plantsman Coen Jansen.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Red Fortune’ did not come as a sport of ‘Blue Fortune’, thus one should not give the high grades of the latter to this plant. However, having said that, it is still a fine introduction, more like a dwarf form of ‘Tutti Frutti’. Probably a hybrid of "), _c('em', [_vm._v("A. mexicana")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Shades of Orange’ was also introduced by High Country Gardens. Plants are about 2 1/2' tall and produce many tubular blooms from peach to dark orange. Zones 6-10.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Summer Breeze’ is becoming better known as more plants find American gardens. Introduced by Canyon Creek Nursery in northern California, plants are 3-4' tall and bear dozens of apricot-orange flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Summer Lustre’, also from Canyon Creek, is even more vigorous, easily attaining 4-5' in height if not trimmed. Flowers are peach colored with a hint of pink.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Tutti Frutti’ ("), _c('em', [_vm._v("A. barberi")]), _vm._v(" x "), _c('em', [_vm._v("A. mexicana")]), _vm._v(") has tubular pink flowers from midsummer to frost. The foliage, to some noses, smells like tutti frutti. What does tutti frutti smell like anyway? Many people like this plant, but I was not one of them until I saw plants in Chanticleer Garden in Pennsylvania. They were upright, colorful and an exciting part of the garden; I am a born-again tutti-man. Hardy to zones 7-8.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("Ageratina")])])]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("See "), _c('em', [_vm._v("Eupatorium rugosum")])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("Ajania")])]), _vm._v(" (a-jan-ee' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Silver and Gold")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Asteraceae")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Ajania pacifica")]), _vm._v(" is the accepted name for plants that were classified as "), _c('em', [_vm._v("Chrysanthemum pacificum")]), _vm._v(", and although its name has changed, the beauty and the challenges have not. This native Japanese species grows 1-1 1/2' tall and bears late yellow pom-pon flowers in late fall. Plants potentially offer a little something for everybody. The foliage is the most ornamental part of the plant, providing mounds of light green leaves edged in well-defined narrow bands of silver throughout the spring and summer. As early as late September and as late as October and November, dozens of flower buds give rise to bright golden yellow buttonlike flowers providing some of the brightest color in the fall garden. They are particularly handsome growing through gray-leafed plants such as "), _c('em', [_vm._v("Artemisia")]), _vm._v(" ‘Powis Castle’ but also are wonderful container plants that can be used as a substitute for fall mums. Because of the outstanding contrast between the bright flowers and the variegated foliage, garden centers offer them for sale as both spring and fall plantings. Plants perform reasonably well in zones 5-8.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, not all is rosy in silver and gold land. Plants have been plagued with reports of poor winter hardiness, disappearing for no apparent reason. However, such death is as much a problem of poor drainage as cold temperatures. Provide excellent drainage and full sun but regardless, they should not be expected to give more than 3 years of good performance. Enjoy them, then replace with something else. Propagate by terminal cuttings in the spring or summer.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('strong', [_vm._v("Cultivars")]), _vm._v(":")])]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pink Ice’, introduced in this country in 1994, has light pink petals around a yellow center over 18\" tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Ajuga")])]), _vm._v(" (a-jew' gah)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Bugle Weed")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Lamiaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Bugle weed is one of the best-known perennials, even to non-gardeners. Plants popular with “normal” people are those that are easily grown, spread well, and provide good flowers and foliage, all without maintenance. "), _c('em', [_vm._v("Ajuga")]), _vm._v(" grows in any reasonably well-drained soil and although tolerant of full sun, growth is more rapid in partial shade. "), _c('em', [_vm._v("Ajuga reptans")]), _vm._v(" can become a persistent weed particularly if planted on the edge of a lawn, but other slower-growing species are available.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Approximately 40 species are known, however, only three have become available to American gardeners. Flowers are usually violet-blue although pink- and white-flowered cultivars have also been developed. All have square stems, opposite leaves and whorled flowers. A large drift in full bloom is spectacular but the foliage is the main reason for its popularity. In the South, crown rot (caused by "), _c('em', [_vm._v("Sclerotium rossii")]), _vm._v(") can be a problem, particularly with "), _c('em', [_vm._v("A. reptans")]), _vm._v(". Entire plantings may die or large patches develop infection. Planting in well-ventilated areas, dividing every 2-3 years, and applying fungicides help reduce this problem. Cut away and dispose of affected leaves and often plants recover without long-lasting damage when temperatures cool down.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Seed should be sown in late summer for fall planting or in November for spring planting. Cultivars will not come true to type from seed but cuttings and divisions may be used. Division is the easiest method and may be accomplished any time the ground is workable. Tissue culture techniques have also been developed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Ajuga Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Stoloniferous (Y or N)")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Stems (erect or prostrate)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. genevensis")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-12")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("N")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Prostrate")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. pyramidalis")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-9")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("N")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Erect")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. reptans")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("4-12")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Y")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Prostrate")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-genevensis")])]), _vm._v(" (gen-e-ven' sis)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Geneva Bugle Weed")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-12\"/9\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Various")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This species is becoming more popular because it produces fewer runners, therefore spreads much less vigorously than "), _c('em', [_vm._v("A. reptans")]), _vm._v(". Plants, however, grow faster than "), _c('em', [_vm._v("A. pyramidalis")]), _vm._v(".")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("If constant moisture is provided, it tolerates more sun than "), _c('em', [_vm._v("A. pyramidalis")]), _vm._v(" or "), _c('em', [_vm._v("A. reptans")]), _vm._v(". The dark green basal leaves are coarsely toothed, not hairy, and about 3\" long. The upper leaves are 1-3\" long, sessile and only slightly serrated. The stems are coarsely hairy, which makes it different than common bugle weed. The 4-6\" tall ")]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("flower spikes are often pink but may be blue or white. Although most "), _c('em', [_vm._v("Ajuga")]), _vm._v(" grow in zone 3, this species should receive winter protection in zone 4.")])]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alba’ bears creamy white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pink Beauty’ is 4-5\" tall with light pink flowers in May and June.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Robusta’ is more vigorous and produces larger flowers and bigger foliage. Flowers are lavender-blue.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Rosea’ has rosy-pink flowers but is otherwise identical to the species.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Tottenham’ (‘Tottenham Blue’) is the best cultivar, bearing dense spikes of lilac-pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Variegata’ has dark green leaves, mottled creamy white.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-pyramidalis")])]), _vm._v(" (pi-ra-mid-ah' lis)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Upright Bugle Weed")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-9\"/9\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("(syn. "), _c('em', [_vm._v("A. alpina")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This good-looking plant incorporates the fine flowers and dark foliage of "), _c('em', [_vm._v("A. reptans")]), _vm._v(" without the spreading habit. The basal rosette is slightly toothed and hairy. The stems are hairy and the 4-6\" long flower spikes consist of large purple bracts which appear to press against the blue flowers. The leaves subtending the flowers are 2-4 times as long as the violet-blue flowers. Although the plant does not spread as rapidly as "), _c('em', [_vm._v("A. reptans")]), _vm._v(", it does produce short stolons late in the season in response to short days.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alba’ produces crinkled oval leaves and white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Metallica-crispa’ (‘Crispa’) has deep blue flowers and brownish red crinkly foliage with a metallic luster. Ugly as sin, but nevertheless, an outstanding garden plant. Also listed as ‘Metallica-crispa Purpurea’ and ‘Min Crispa Red’.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-reptans")])]), _vm._v(" (rep' tanz)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Common Bugle Weed")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("4-12\"/24\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Violet")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Much of the breeding and selection in this genus has been accomplished with "), _c('em', [_vm._v("A. reptans")]), _vm._v(" and remarkable advances in foliage color have resulted. Regardless of cultivar, "), _c('em', [_vm._v("A. reptans")]), _vm._v(" is stoloniferous and can spread rapidly. This characteristic makes this species an excellent ground cover and a large clump in flower is a spectacular sight. Plant where its invasive qualities are welcome, such as on a bank or under the dappled shade of trees. Do not plant it as an edging to the lawn or the insidious disease of “buglelawn” will occur. One of the symptoms includes the appearance of small islands of green foliage soon forming a large archipelago in an ocean of lawn. Weapons to destroy these islands include shovels, sprayers, or as one gardener did, simply expanding the flower bed to include all the bugleweed in the lawn. His lawn became smaller every year. (Hmmm, perhaps he is on to something.) The best prevention is proper planning; plan to keep the "), _c('em', [_vm._v("Ajuga")]), _vm._v(" away from all grassy areas. If all else fails, remember that the ingestion of leaves of "), _c('em', [_vm._v("A. reptans")]), _vm._v(" is a mild narcotic. After trying some of the leaves, buglelawn will not seem as serious.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('strong', [_vm._v("Cultivars:")])])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Some may be hybrids with other species.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Selections for flower color or size.")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alba’ has creamy white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Linda Applegate’ is a reasonably compact form with white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pink Elf’ is a dwarf cultivar with clear pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pink Spire’ is a fine green-leaved cultivar bearing 7\" long pink flower spikes.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pink Surprise’ has bronze-green leaves, narrower than many others species’, and purplish pink flowers. Introduced by Terra Nova Nursery, Tigard, Oregon.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Purple Torch’ bears tall torches of 12\" lavender-pink flowers with glossy green foliage.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Rosea’ produces rose flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_vm._v("Selections for leaf color, all have blue to violet flowers")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Arboretum Giant came from Tony Avent of Plant Delights Nursery in Raleigh, North Carolina. This is a big robust plant whose large green leaves are outlined in deep purple. Bigger and uglier than ‘Catlan’s Giant’.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0052-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Ajuga reptans")])])]), _c('p', {
    staticClass: "bibp"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("‘Arctic Fox’ was introduced by Henry Ross, one of our great horticulturists, whose Gardenview Horticulture Park in Strongsville, Ohio is a must-see venue. ‘Arctic Fox’ bears small leaves with white centers and green margins, and blue flowers.")])]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Atropurpurea’ (‘Purpurea’) has dark bronzy-purple leaves that color best in full sun. It is an excellent landscape plant to provide drifts of bronze.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Black Scallop’ produces deep purple, glossy foliage with a wavy or scalloped margin. The flowers are deep blue. Plants were developed by Mike Tristram of the UK.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bronze Heart’ bears glossy, wine-red leaves and deep blue flowers. Very eye-catching.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bronze Beauty’ produces metallic bronze foliage with bright blue flowers. Very popular, very handsome selection.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Burgundy Glow’ has foliage with shades of white, pink, rose and green. In the fall, the older leaves turn a deep bronze and the young leaves have a rosy tint. The combination is interesting if your eyes can stand the clashing hues.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Catlin’s Giant’ has tall (up to 8\" long) spikes of blue flowers and bronze-green foliage. Continues to produce fine foliage even after flowering and fills in rapidly.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Chocolate Chip™ (‘Valfredda’) rapidly became a popular plant soon after its introduction to this country in 2000. Plants are compact, dwarf and bear deep purple foliage. The flowers are also deep blue. Not as rapid a spreader as many other cultivars. They are occasionally sold under the correct name ‘Valfredda’, from the Italian nursery from which they originated. Arguments abound as to whether the plant is a cultivar of "), _c('em', [_vm._v("A. reptans")]), _vm._v(" or "), _c('em', [_vm._v("A. tenorii")]), _vm._v(", from the mountains of Italy and Sicily. Stay tuned.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Cristata’ is probably one of the ugliest little plants available today. The leaves are crinkled and distorted and the whole plant looks like crumpled spinach. To each his own. May go under such names as ‘Ripple Leaf’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Emerald Chip’ supposedly came from Chocolate Chip™, resulting in a green chip. Same properties as Chocolate Chip™ but without the chocolate.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Gaiety’ has bronze purple leaves and lilac flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Golden Glow’ has light golden margins around the green centers of the leaves. A good selection where variegated ground covers are useful. The blue flowers are held on short stems in spring.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Gray Lady’ produces classy gray-green foliage and blue flowers. Growth is relatively slow but clumps are most handsome.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Jungle Beauty’, originally introduced by Allen Bush when he owned Holbrook Farms in North Carolina, bears dark purple leaves outlined with a soft red border. A similar form known as ‘Jungle Beauty Improved’, selected by Beth Chatto in East Anglia, England, seems to have larger leaves and more persistent purple color. Both are good selections.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Leprechaun’ is a dwarf form with ugly spinach-like leaves. Want spinach? Grow spinach.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Mahogany’ is another dark-leaved short form, similar to Chocolate Chip™, growing about 3\" tall and bearing bright blue flowers in the spring.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Multicolor’ (syn. ‘Rainbow’, ‘Tricolor’) is similar to, but more vigorous than ‘Burgundy Glow’ but the foliage colors are deeper. Sometimes comments concerning leaf colors are best left to the gardener. This is one of those times.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("‘Pink Silver’ produces bronze leaves with a touch of pink.")])]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Purple Brocade’ is 6-8\" tall, with deep purple brocaded leaves. A slow grower, but very handsome.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Royalty’ has some of the darkest purple flowers (almost black) with scalloped edges. Terrific cultivar.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Ruffled Lace’ came from plantsman extraordinaire Dr. Darrell Apps of Woodside Nursery in Bridgeton, New Jersey. It is a clumping form, producing burgundy leaves with ruffled edges. Blue flowers are formed in the spring.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Silver Beauty’ has gray-green leaves irregularly edged with silver-white. Plants are particularly handsome.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Silver Carpet’ produces leaves which are uniformly silver-gray but with green margins. Plants are about 6\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Silver Queen’ bears white splashes on gray foliage. Blue flowers are produced in the spring.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Toffee Chip’ is as compact as Chocolate Chip™ but bears variegated green and white foliage. Stands out in a crowd in a semi-shaded area.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. australis")]), _vm._v(" is native to Australia and is a 3-4\" tall mat former. The thick dark green pubescent (hairy) leaves are aromatic when crushed and the light blue flowers rise to about 8\" in height. Probably effective in zones 5-8. Underused and well worth trying.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A.")]), _vm._v(" ‘Brockbankii’ ("), _c('em', [_vm._v("A. genevensis")]), _vm._v(" x "), _c('em', [_vm._v("A. pyramidalis")]), _vm._v(") is smaller and more vigorous than common bugle weed. Plants have deep blue flowers and shorter stolons.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Alcea")])]), _vm._v(" (al-see' a)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Hollyhock")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Malvaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Approximately 60 species of biennial and short-lived perennial species are found and some of them are exceptionally popular. Hollyhocks ("), _c('em', [_vm._v("A. rosea")]), _vm._v(") have been gracing gardens for centuries and continue to undergo a renaissance in the United States. All species are found in sunny, well-drained habitats and provide exceptional color for short periods of time. Although hollyhock is the best-known member, one or two other species provide additional interest as well. Flowers are generally large and appear singly or in racemes and the stems are usually hairy. All can be grown from seed and require little more than sun and good air circulation.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("The genus is part of the Malvaceae, which contain genera such as "), _c('em', [_vm._v("Lavatera")]), _vm._v(", "), _c('em', [_vm._v("Malva")]), _vm._v(" and "), _c('em', [_vm._v("Sidalcea")]), _vm._v(". To me, many of these plants are difficult to distinguish, especially when people ask me “Why is that a hollyhock and not a malva, or lavatera or . . . ?” Since they are closely related and appear so similar, particularly to my leaden brain, I have to find a way to try to answer that question, without resorting to details seen only in a laboratory. If people should be silly enough to ask, I grab a flower, turn it over and say “Look at the bracts.” They seldom ask again. Upon close inspection, "), _c('em', [_vm._v("Alcea")]), _vm._v(" differs from other genera by having 6-9 bracts (botanically known as the epicalyx) immediately beneath the sepals and they completely envelop the emerging bud. Also, the bracts are joined rather than separate as in the genus "), _c('em', [_vm._v("Malva")]), _vm._v(". This seems a little ")]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("much for some, but for others it is quite enlightening. For those who like to be lit up, I have provided a basic chart to help discriminate between these genera. Unfortunately, hybrids muddle up this simple scenario, but it is a start.")])]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('strong', [_vm._v("Bracts below sepals")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('strong', [_vm._v("Flower arrangement")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("Alcea")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("6-11, joined at base")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Solitary, raceme")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("Althaea")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("6-9, united at base")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Raceme, panicle")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("Lavatera")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("3, joined, pointed")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Raceme")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("Malva")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("3, narrow, distinct")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Solitary, clusters")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("Sidalcea")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Usually none")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Raceme, spike")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-rosea")])]), _vm._v(" (rose-ee' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Hollyhock")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("4-8'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring, Early Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Mixed Colors")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Turkey, Asia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My mother knew very little about gardening, other than that the lawnmower was a good way to keep her sons out of trouble. But how she loved her hollyhocks. They grew with their backs up the stucco wall of our garage, held up with ugly white strings that extended from rusty nails on either side. Like tape measures across a boxer’s chest, these strings were often more visible than the plants. But every year, they would come back from roots or seeds and provide a riot of color along an otherwise drab path. By midsummer, the leaves were eaten up by rust but by that time, hollyhocks gave way to other activities and thus ignored, disappeared once again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She would be pleased to see hollyhocks today. The old red single flowers are still around, but so are many other colors and forms, including double flowers and saucersized singles, up to 5\" across. Plants are generally 3 to 6 feet tall, but 8' monsters are not uncommon. They are unbranched, thus are rather pole-like, and the stems are hairy to the point of being bristly. The leaves have 3, 5 or 7 lobes and the flowers occur in terminal racemes, made up of 3-10 flowers. The 6-11 bracts beneath the flowers are joined and turn brown as the flowers mature. Cultivars today are also less susceptible to the nemesis of hollyhock, hollyhock rust. Caused by a fungus, "), _c('em', [_vm._v("Puccinia malvacearum")]), _vm._v(", orange-brown pustules occur on the undersides of the leaves and stems. If my mother had known that the spores overwintered on the blistered, ignored leaves by the garage, she would have removed them. Actually, she would have told her sons to do it, and we would have probably taken the trusty Lawn-Boy to them. Fungal sprays are available, removing any affected leaves and rotating cultivars from year to year is much more effective.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Japanese beetles can also crunch, chew, disfigure and destroy hollyhocks within days of their arrival. Japanese beetles love most members of the Malvaceae, and they can be sprayed, picked off, or crushed between two bricks. Regardless, if you have Japanese beetles, think twice about giving them hollyhocks for dessert.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate by planting seeds directly in the prepared soil immediately after the last frost date or in containers about two weeks before that time. If sowing in containers, place the container at 72-75°F and cover the moist soil with a plastic until the seedlings emerge. Do not germinate the seeds too early or plants will be weak and stretched before the transplant date.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('strong', [_vm._v("Cultivars:")])])]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Single flowers")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Barnyard Mix is offered by an enterprising nursery who claim seeds were collected from an old barnyard in Vermont. They are single, in various colors, tall and old-fashioned. I bet they collected them from my mother’s house.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Black Beauty’ has deep purple to almost black flowers on 6' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Indian Spring’ is available in white, yellow, rose and pink. Plants are 7-8' tall. This has been around for quite a while, as noted by its AAS selection in 1949.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Nigra’ has some of the deepest purple flowers of any cultivar. Plants attain about six feet in height.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Simplex’ is a mixture of colors on 4-5' tall stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘The Watchman’ has deep purple flowers on 5-6' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_vm._v("Double, semi-double flowers")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Appleblossom’ bears large light pink to rose fully double flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Chaters Double Hybrids occur in a range of colors. Each double flower resembles a ruffled peony. Plants in single colors may be purchased including ‘Chaters Pink’, ‘Chaters Scarlet’, ‘Chaters Violet’, ‘Chaters White’ and ‘Chaters Yellow’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Crème de Cassis’ produces mostly semi-double 3-4\" wide flowers of burnished purple with yellow centers. Some flowers may also be single. The petals are also wavy. An interesting look and color.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fruity Mix is a mixture of pink and rose, bloated, fully double flowers. To each his own.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Nigrita’ has dark, almost purple-red double flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Peaches ’n’ Dreams’ bears many fully double, peach and raspberry flowers on 4-6' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pinafore’ is more branched and compact than other cultivars and bears semi-double flowers in numerous colors. Plants are 3-4' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Powder Puffs’ grows 6-8' tall and produces 4\" wide fully double flowers in white, yellow, rose and red.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Queeny series is a seed-propagated mix of semi-double flowers on short (2-3' tall) plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Queeny Purple’ was an All-America winner in 2003. ‘Summer Carnival’ is name given for a mixture of colors with double blooms on 2 1/2-3' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('em', [_vm._v("A. ficifolia")]), _vm._v(" has many common names including figleaf hollyhock, Antwerp hollyhock and Russian hollyhock. The leaves are 7-lobed, irregularly toothed and resemble fig leaves, probably the best means of identification. Flower color is all over the map, many being pale yellow (most common) to deep red, copper or orange. These are robust plants and will easily attain 6' tall. They are native to Siberia, and their exceptional cold hardiness has made them popular as a parent for the many hybrids of hollyhocks hitting the market today. In the Gardens at UGA, plants are 5' tall, have nary a smudge of leaf disease, and bear dozens of velvet flowers. Outstanding. ")]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("Hybrids of "), _c('em', [_vm._v("A. rosea")]), _vm._v(" and "), _c('em', [_vm._v("A. ficifolia")]), _vm._v(" with single flowers have been released as ‘Summer Memories Mix’.")])]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. rugosa")]), _vm._v(", Russian hollyhock, is becoming more popular due to its classical nature and fewer problems with hollyhock rust. The large 4\" wide single flowers are pale yellow and the leaves are deeply 5-lobed. The 5-6' tall stems are hairy all over. This can be a terrific plant.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Genus:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Althaea")]), _vm._v(", also known as hollyhock, is often confused with "), _c('em', [_vm._v("Alcea")]), _vm._v(", for obvious reasons. Most of the ornamental hollyhocks belong to "), _c('em', [_vm._v("Alcea")]), _vm._v(". The flowers of "), _c('em', [_vm._v("Althaea")]), _vm._v(" are smaller, seldom exceeding 1-1 1/2\" wide and usually rose, rose-pink or occasionally white. While not as flashy as "), _c('em', [_vm._v("Alcea")]), _vm._v(", they are useful for naturalistic plantings. Approximately 12 species are known; the 3-5' tall "), _c('em', [_vm._v("A. officinalis")]), _vm._v(", which has small rose, pink or white flowers, is best known. The roots of this species were the original source of marshmallows.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Alchemilla")])]), _vm._v(" (al-kem-ill' a)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Lady’s Mantle")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Rosaceae")])]), _c('p', {
    staticClass: "indent1"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("The genus may have received its name because of its popularity with alchemists and was reputed to have many healing powers. Today we know it as a wonderful low-growing shade tolerant plant with sprays of small yellow flowers in the spring. Some 300 species are known, most of which are palmately lobed and make excellent garden plants. The foliage is light green, pubescent and soft to the touch, particularly on the underside. The apetalous (no petals) flowers are only about 1/4\" wide and range from green to yellow. Although many species have been described, only two or three are easily located through catalogs or retail centers in the United States and Canada.")])]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Alchemilla requires partial shade and consistent soil moisture to thrive. Plants will be stunted if planted in full sun or allowed to dry out. Cool climates are preferable but they do quite well as far south as zone 7 providing there is ample shade and moisture. I have grown lady’s mantle in Athens, Georgia and it is lovely to those who have never seen large drifts grown under favorable conditions, however, the luxuriant growth taken for granted further north is never attained.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fresh seed germinates readily but purchased or old seed should be given a cold treatment similar to "), _c('em', [_vm._v("Actaea")]), _vm._v(". "), _c('em', [_vm._v("Alchemilla")]), _vm._v(" self-sows readily which helps increase the planting size. Plants should be divided in early spring prior to flowering.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Alchemilla Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Lobes cut more than half way")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Hairiness on leaves")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. alpina")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-8")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Lower surface")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. ellenbeckii")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3-6")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Both surfaces")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. erythropoda")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-9")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Both surfaces")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. glaucescens")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("9-12")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Both surfaces")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. mollis")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("20-24")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Both surfaces")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-alpina")])]), _vm._v(" (al-pine' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Mountain Mantle")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-8\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Green")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Every time I redo this book, I seem to repeat myself; that is, this species is not used enough in the United States. The flowers may not be extraordinary but the silver edges of the deeply cut 2\" wide foliage and the low neat habit make this a wonderful garden plant. The 5-lobed leaves have small, sharp teeth at the end of each lobe and are hairy on the lower surface only, being kind of naked above. Self-seeding is common, and if this becomes a problem, the seed heads may be removed prior to maturity. I have never had that problem in the Armitage garden, being happy just to keep plants alive. Reseeding is more common in the North than in the South. It is native to mountainous areas and as far north as Greenland. Cold hardiness is not a problem in most of the northern states and Canada but they are not as heat tolerant as "), _c('em', [_vm._v("A. mollis")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-ellenbeckii")])]), _vm._v(" (el-len-beck-ee' eye)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Carpet Lady’s Mantle")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-6\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow-green")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("East Africa")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This shade-loving little plant also deserves more use in American gardens. The diminutive height and spreading nature make this a charming ground cover for a shady nook. The 1\" wide leaves are deeply 5-lobed and the plant spreads by rooting at the nodes. The yellow-green flowers are not as freely produced as on the larger species but are handsome nevertheless. Plants are not as cold hardy as others but should be fine to zone 5 with some protection.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants are best propagated vegetatively by division.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-erythropoda")])]), _vm._v(" (e-rith-ro-po' da)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Red-stemmed Lady’s Mantle")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-9\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow-green")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Turkey, Russia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Similar to other medium-sized species but with small scalloped gray or blue-green leaves and dense hairs on the petioles (leaf stalks). These diminutive plants often develop red stems when grown in a partially sunny location. The lobes of this species look like they were cut across their width with pinking shears whereas the lobes of similar species are rounded. What some people will study!")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-glaucescens")])]), _vm._v(" (glock' es-sends)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Hairy Lady’s Mantle")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("9-12\"/18\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring, Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow-green")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This small plant is densely hairy throughout and bears circular leaves with 7-9 shallowly cut lobes. The kidney-shaped foliage may be slightly blue-green (glaucous) but not always. Dense clusters of yellow-green flowers are produced in late spring and into summer. Similar to "), _c('em', [_vm._v("A. erythropoda")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-mollis (mol' lis)")])])]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Lady’s Mantle")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("20-24\"/24\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellowish")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Asia Minor")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("This is grown at least ten times more often than all the other species combined. The common lady’s mantle is a splendid ground cover and will grow in almost any ")]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("moist, shady area except a bog. The dense pubescence gives the foliage a soft velvet feel. Leaves have 9-11 shallow lobes and are particularly pretty after a soft rain when the captured droplets glisten in the sun. The yellow-green starry flowers, which are held above the foliage, make long-lasting cut flowers. When grown side by side, the flowers are obviously the most showy of any of the commonly seen "), _c('em', [_vm._v("Alchemilla")]), _vm._v(" species. This species may be too large for the rock garden but can be used successfully to edge a path or border. The densely hairy leaves create a problem in areas such as the Southeast where thundershowers punctuate hot summer afternoons. The water trapped in the leaves and crown does not dry out during the night and provides excellent breeding grounds for a number of foliar diseases. Use of a fungicide during wet, rainy periods partially alleviates the problem.")])]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0059-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Alchemilla mollis")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Auslese’ is offered by a few nurseries and differs little from the species. Perhaps the flowers are more chartreuse and plants are a little more compact.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Robusta’ is more robust and simply larger in every way than the species. However, since most of the "), _c('em', [_vm._v("A. mollis")]), _vm._v(" in cultivation is propagated from seed, there may be little difference between a vigorous seedling and this cultivar.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("‘Senior’ is shorter than the species, growing only about 12\" tall.")])]), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Thriller’ has large pleated leaves with many chartreuse foamy flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although "), _c('em', [_vm._v("A. mollis")]), _vm._v(" dominates, many other species are offered, which are generally less vigorous but equally beautiful. In general, however, lady’s mantle, regardless of species, is still more suited to areas where summer night temperatures routinely fall below 70°F.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. abysinnica")]), _vm._v(", Abyssinnian lady’s mantle, is similar in spreading habit but differs in having larger (2\" across) 7-lobed leaves. Also native to East African mountains. Little is known about hardiness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. caucasica")]), _vm._v(", Caucasus lady’s mantle, is indistinguishable from "), _c('em', [_vm._v("A. erythropoda")]), _vm._v(", differing mainly in the arrangement of the hairs on the flowering stems.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. conjuncta")]), _vm._v(" is closely related to "), _c('em', [_vm._v("A. alpina")]), _vm._v(" and is often sold as such. Plants are a little more robust, growing 12-18\" tall. Leaves generally have 7 deep cut lobes but without the sharp teeth found in "), _c('em', [_vm._v("A. alpina")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. faeroensis")]), _vm._v(" is another small plant, growing only 3-6\"tall. I have grown this in my garden, and one would think that a plant native to the Faeroe Islands would quickly perish in Athens. However, it came back for at least 10 years, and while never overly showy, I always enjoyed it. var. "), _c('em', [_vm._v("pumila")]), _vm._v(" is a smaller form yet and terrific for rock gardens, but can easily get lost if crowded with other more vigorous taxa.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. pectinata")]), _vm._v(" is the neatest lady’s mantle I have seen. Plants produce exceedingly long stems and they are best suited for hanging baskets or tumbling from a stone wall. Dull green leaves and soft yellow flowers are part of the plant’s charm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. saxatilis")]), _vm._v(", rocky lady’s mantle, is only about 6-9\" tall, and is normally found in alpine locales, growing among rocks. The foliage has 5 lobes, light green on the top, silvery on the underside. Great for the rock garden, but not the “regular” garden.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. sericea")]), _vm._v(" is similar to "), _c('em', [_vm._v("A. alpina")]), _vm._v(" but has more conspicuous and irregular teeth in the upper half of the leaves. The upper surface of the leaves have small hairs, whereas those of "), _c('em', [_vm._v("A. alpina")]), _vm._v(" are smooth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. vulgaris")]), _vm._v(", common lady’s mantle, is similar to "), _c('em', [_vm._v("A. mollis")]), _vm._v(" but is less pubescent and has much smaller, greener flowers. The foliage is also more deeply lobed. Most of the plants of "), _c('em', [_vm._v("A. vulgaris")]), _vm._v(" sold in the United States are "), _c('em', [_vm._v("A. mollis")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. xanthochlora")]), _vm._v(" is a relatively large plant like "), _c('em', [_vm._v("A. mollis")]), _vm._v(", growing 15-20\" tall. The plant differs in that the leaves are almost hairless on the upper surface and are more kidney shaped compared to the circular leaves of "), _c('em', [_vm._v("A. mollis")]), _vm._v(". Good garden plants with chartreuse, airy flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Allium")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Ornamental Onion")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Alliaceae")])]), _c('p', {
    staticClass: "indent1"
  }, [_c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("I have always enjoyed growing ornamental onions. They allow me to converse with vegetable gardeners without feelings of guilt. While they don’t garnish my hamburgers, they certainly embellish my garden. The genus contains approximately 500 species including onions ("), _c('em', [_vm._v("A. cepa")]), _vm._v("), garlic ("), _c('em', [_vm._v("A. sativum")]), _vm._v("), and chives ("), _c('em', [_vm._v("A. schoenoprasum")]), _vm._v("). Although ornamental forms of chives such as the rosy pink ‘Forescate’ have been ")]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("developed, the presence of these tasty but breathy members of the onion family has given the ornamental alliums a particularly difficult time in the marketplace. The species are bulbous or rhizomatous and are all characterized by the presence of a superior ovary, umbels of small flowers and the emission of an onion or garlic smell when crushed. The flowers consist of many petal-like flower parts called tepals. Scientists in several locations have tried to eliminate the odor from alliums, particularly the culinary species, but I, for one, hope they have little success. An allium without odor is like a book without a cover. The odor occurs only when plants are broken or crushed and is not given off spontaneously. In fact, the flowers of some members have a mild fragrance of violets.")])]), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The family that "), _c('em', [_vm._v("Allium")]), _vm._v(" calls home is in flux. It was a part of the Liliaceae because of the superior ovary but some taxonomists argued that the presence of the umbel-late inflorescence should place "), _c('em', [_vm._v("Allium")]), _vm._v(" in the Amaryllidaceae. Others then argued for a separate family, Alliaceae, to be created for all genera with a superior ovary and an umbellate inflorescence. After the smoke cleared, it appears "), _c('em', [_vm._v("Allium")]), _vm._v(" and 20 other genera, such as "), _c('em', [_vm._v("Agapanthus")]), _vm._v(", "), _c('em', [_vm._v("Brodiaea")]), _vm._v(", and "), _c('em', [_vm._v("Ipheion")]), _vm._v(" belong to this onion family. Most gardeners don’t really care, but now you know why you don’t.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The number of species has also always been in question. When Linnaeus (1707-1778) wrote "), _c('em', [_vm._v("Species Plantarum")]), _vm._v(" in 1753, he distinguished 30 species. Many additional species were described since Linnaeus and continue to be discovered today. There is no modern monograph of "), _c('em', [_vm._v("Allium")]), _vm._v("; the last work that embraced all the known species was produced by Eduard von Regel (1815-1892) in 1875 and included 256 species. Other botanists have placed the number at 325 (1925), 400 (1976) and 700 (1987). William Stearn took the major accounts of the genus and subtracted species listed in other accounts and added those not covered in any. Stearn concluded that the genus "), _c('em', [_vm._v("Allium")]), _vm._v(" comprises about 750 known species and is the largest genus of petaloid monocotyledons. Two things are self-evident. That the genus is large, and that any self-respecting "), _c('em', [_vm._v("Allium")]), _vm._v(" geek will be hard-pressed to run out of onions to plant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The ornamental alliums range in size from the 2-3\" tall plants of "), _c('em', [_vm._v("A. circinatum")]), _vm._v(" to the 4' tall scapes of "), _c('em', [_vm._v("A. giganteum")]), _vm._v(". Although many onions bear lilac-blue flowers, some species send up umbels of white ("), _c('em', [_vm._v("A. neapolitanum")]), _vm._v("), pink ("), _c('em', [_vm._v("A. acuminatum")]), _vm._v("), mauve ("), _c('em', [_vm._v("A. validum")]), _vm._v("), yellow ("), _c('em', [_vm._v("A. moly")]), _vm._v("), greenish ("), _c('em', [_vm._v("A. obliquum")]), _vm._v(") or interesting multicolors. Most species bear 3-8 linear leaves (except "), _c('em', [_vm._v("A. karataviense")]), _vm._v(") that die back before or soon after flowering. While most species are native elsewhere, a number of fine forms native to America occur, including "), _c('em', [_vm._v("A. canadense")]), _vm._v(" and "), _c('em', [_vm._v("A. texanum")]), _vm._v(", both about 1 1/2' tall and both with white flowers. The seed heads are persistent in many species and extend the ornamental value of plants well into summer.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("In general, the planting depth of the bulb should be approximately 3 times the diameter. Bulbs should be fall planted in full sun and in well-drained areas. As lovely as many of these species are, they are poor plants if not combined with other perennials or annuals. Because the foliage dies during or immediately after flowering, many gaps in the garden eventually exist. Planting in ground covers or having other plants growing around them camouflages the empty spaces. That there are so many onions running around out there should be a warning that not all are as wonderful as the ")]), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("photo or catalog says they are. Some can look weedy, others can be aggressive and many will be short lived. Given that as a suitable warning, enjoy as many as you can stand. However, an area devoted strictly to alliums (or any genera of bulbs) is a collection, not a garden, and should be avoided like the plague.")])]), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Allium Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower color")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Fragrant flowers")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flowering time")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. acuminatum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("8-12")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Pink")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Early summer")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. aflatunense")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("24-36")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Lilac")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Late spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. caeruleum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("12-24")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Blue")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Late spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. christophii")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("12-24")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Violet")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Summer")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. giganteum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("36-60")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Lilac")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Late spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. karataviense")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-12")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Lilac")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Late spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. moly")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("12-15")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Early spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. narcissiflorum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-12")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Pink-rose")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. neapolitanum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("8-12")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Early spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. nigrum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("24-36")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Early spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. oreophilum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("8-12")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Violet")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Early summer")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. schubertii")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("18-24")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Pink")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. senescens")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-12")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Lilac-pink")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Summer")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. sphaerocephalum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("18-36")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Lilac")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Late spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. thunbergii")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("18-24")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Violet")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Fall")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. triquetrum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("8-15")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Summer")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-acuminatum")])]), _vm._v(" (a-cum-in-aye' tum)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Tapertip Onion")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("8-12\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Rose-pink")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Western North America")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two or four narrow, channeled leaves emerge from a round bulb, above which an 8\" scape holds erect, star-shaped flowers with pointed segments. Many 1/2\" long flowers form a loose umbel approximately 2\" wide. The 10-30 flowers range from deep rose to lilac-pink and bloom for about 2 weeks starting the end of May. Leaves are usually withered by flowering time. Plants do best in dry areas, and in hot, rainy, climates such as the Southeast, do not often persist more than 2 years. Plant in a well-drained sunny location. Flowers dry well when cut from the garden, retaining color when placed in a warm dry room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is a pretty plant when used in colonies of at least a dozen bulbs. Bulbils that form at the base of the bulbs result in a slow-spreading colony.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-aflatunense")])]), _vm._v(" (a-fla-tun-en' se)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Persian Onion")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-3'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Lilac")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("China")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("This tall allium produces fine 4\" diameter spherical umbels of star-shaped flowers atop 3' tall scapes. The lilac to violet flowers have yellow anthers and tend to twist ")]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("and reflex with age. Often thought of as a smaller version of "), _c('em', [_vm._v("A. giganteum")]), _vm._v(", it lacks the majesty and grandeur of the latter. The bulbs, however, are available at one-third the cost and allow the gardener to plant onions with abandon. The 6-8 basal, strap-shaped basal leaves are up to 4\" wide and disappear soon after the flower appears.")])]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("This is one of the few species in the genus truly at home among other plants in the border. Plants do well in any sunny well-drained location, however, they are susceptible to root rot organisms prevalent in heavy soils. I have seen wonderful plantings in Philadelphia gardens and as far north as Cleveland. Results in the South have been variable. Some years it is outstanding, others years, disappointing. This may be due to the fact that a number of impostors are sold under the banner of "), _c('em', [_vm._v("A. aflatunense")]), _vm._v(". As cut flowers, they are excellent and last nearly 2 weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Seed should be sown in moist seed trays and placed at about 70°F for 2-4 weeks, then placed at 30-40°F for an additional 4-6 weeks. After the cold treatment, bring the tray to 50-60°F until germination occurs. Keep moist at all times. Plants self-sow on the West Coast and occasionally in the Northeast.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Purple Sensation’ has deeper violet flowers which are more uniform than the species. A little more expensive but more handsome. I have seen this plant all over the country, and while it is not perfect everywhere, it is always colorful, upright and an inexpensive addition to the garden. They were spectacular in combination with colorful annuals in beds and containers at the must-see North Carolina Botanical Garden in Asheville, NC. A number of outstanding hybrids using "), _c('em', [_vm._v("A. aflatunense")]), _vm._v(" as a parent have been developed (see hybrids).")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-caeruleum")])]), _vm._v(" (ce-rue' lee-um)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Blue Globe Onion")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("12-24\"/18\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Russia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 2-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The deep blue flowers are held very tightly in a 1-2\" diameter umbel. The leaves are 3-sided and 6-12\" long. The cup-shaped flowers, which open in late May in zone 7 and about 2 weeks later in zone 3, persist for about 2 weeks and make excellent fresh or dried flowers. Unfortunately, it is difficult to establish in most American gardens as it comes from the steppes and deserts of Central Asia and requires hot, dry conditions to flourish. Plants may be divided easily to provide good-sized clumps. Occasionally bulbils are formed within the inflorescence (particularly on var. "), _c('em', [_vm._v("bulbiliferum")]), _vm._v(") and may be used for propagation. Seed should be treated as with "), _c('em', [_vm._v("A. aflatunense")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-christophii")])]), _vm._v(" (kris-tof' ee-eye)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Downy Onion, Star of Persia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("15-24\"/24\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Violet")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Turkey, Afghanistan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although short in stature, this is one of the largest flowering species in cultivation. Up to 100 metallic blue star-shaped flowers are carried on a spherical umbel often 10-12\" in diameter. The stems and the margins of the 2-7 strap-shaped leaves are covered with white hairs that are responsible for the common name. The leaves die before the flowers have completely opened.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When in flower, there is no more eye-catching member of the genus. It is also one of the best alliums for long-lasting dried flowers, looking good literally for years. A sunny, well-drained area at the front of the border is necessary for best performance. Excellent hybrids, in particular ‘Globemaster’ (which see), have been developed with this species as a parent.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _c('div', {
    staticStyle: {
      "height": "450px"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _c('p', {
    staticClass: "imagen"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/f0064-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Allium")]), _vm._v(" ‘Globemaster’")])])]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_c('p', {
    staticClass: "indentp"
  }, [_vm._v("Propagate by seed similar to "), _c('em', [_vm._v("A. aflatunense")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-giganteum")])]), _vm._v(" (gi-gan' tee-um)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Giant Onion")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-5'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Lilac")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Central Asia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zone 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_64"
    }
  }), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("This is, as the name implies, the giant of this genus. The bulb itself is 2-3\" in diameter and resembles a large, round ball. In early spring, 6 to 9 broad (5-8\" wide) gray-green leaves emerge as a rosette followed by a thick, strong scape (flower stem) carrying the many lilac flowers. By the time the scape is 6-12\" long, the leaves lie on the ground. Three to four weeks are required for the scape to grow to a final height of 4' but the wait is justified. There are over 100 individual flowers, each 1/2\" long, which are held closely together in a dense, 4\" diameter rounded umbel. The round seed heads are equally beautiful, turning silver-tan color as the flowers age.")])]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Plant in groups of three, more if you can afford more, in full sun and well-drained soils. It is an excellent late spring and early summer flower for the back of the border and because the leaves disappear soon after flowering, there is no “dead time” waiting for the leaves to wither as with tulips and daffodils. Plantings as far south as zone 8 have been excellent and if mulch is applied, the bulbs appear to be cold tolerant to zone 4. In zone 8, flowering occurs in mid May but not until early June in Michigan (zone 4). As a cut flower it is outstanding, and has gained much popularity with florists and designers.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("Propagation is accomplished by separating the two portions of the bulb which tend to split after 2 years.")])]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-karataviense")])]), _vm._v(" (ka-ra-tah-vee-en' se)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Turkistan Onion")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-12\"/15\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Silver-gray")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Turkey, Afghanistan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("This unique species is grown for the foliage as much as for the flowers. The thick, gray-green leaves (usually 2) are up to 4\" wide and mottled purple, particularly underneath and near the base. Many people feel that the leaves are more ornamental than the flower, which is a rather washed-out silver-lilac. I am not one of them. The dense umbels are 6-8\" across and compete with those of "), _c('em', [_vm._v("A. christophii")]), _vm._v(" for the largest in the genus. The plant is particularly suited to open, windy locations because of the strong, thick 6\" tall scape that carries the flowers. The leaves and seed capsules persist well after the flowers have abscised and remain handsome until mid June.")])]), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Seed-propagated plants (accomplished as with "), _c('em', [_vm._v("A. aflatunense")]), _vm._v(") require about 3 years to flower.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-moly")])]), _vm._v(" (mah' lee)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Lily Leek, Golden Onion")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("12-15\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southern Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_67"
    }
  }), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("Even before the time of Homer, the lily leek was endowed with magical properties. Reference to the “Moly” can be found in “The Odyssey”, in which Ulysses walked unharmed under its protection. It has been looked upon as a good luck charm for many years and this combination of magic and beauty makes the plant difficult not to include in the garden. Having said that, I have little success with these plants in my garden, perhaps because of the warm soil temperatures in the summer. The two flat, lancelike leaves are blue green and up to 2\" wide and 8-12\" long. The small 1/2\" star-shaped flowers are held in a 2\" wide, open umbel and possess a lovely shade of golden yellow. A dozen bulbs planted in a sunny well-drained area quickly increase to form a golden vista in late spring and early summer.")])]), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate by bulb offsets or seed. Seed-propagated plants will flower in one year.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Jeannine’ is a marked improvement on the species. She grows 12-18\" tall but is compact with bright yellow flowers, held on multiple scapes, in late spring.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-narcissiflorum")])]), _vm._v(" (nar-ciss-i-flo' rum)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Narcissus Onion")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-12\"/9\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Pink")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Northern Italy, Portugal")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_68"
    }
  }), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_vm._v("A wonderful dwarf species best suited for rock garden or a partially shaded nook in the garden. In bud, the flowers look like those of a small jonquil, but soon open to erect clusters of bright pink bell-shaped flowers. The 3-5 blue-green leaves are persistent through the season. This species and a few others ("), _c('em', [_vm._v("A. thunbergii")]), _vm._v(", "), _c('em', [_vm._v("A. tanguticum")]), _vm._v(") have small bulbs clustered together on a small rhizome.")])]), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-neopolitanum")])]), _vm._v(" (nee-ah-pol-i-tay' num)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Naples Onion")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-12\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southern Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 7-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two to three linear leaves, about 1/2 to 3/4\" wide and keeled, are held in a basal rosette resembling daffodil foliage. The scape carries a loose, many-flowered umbel (2 1/2\" across) of starry white flowers with rosy stamens. The individual flowers are about 3/4\" in diameter and are among the most fragrant in the genus. It is one of the earliest to flower, opening the end of April and persisting for about 4 weeks. Plants are not reliably hardy in zone 6, but if heavily mulched, will overwinter in zone 7a. Mulch should also be applied further south to reduce temperature fluctuations in the soil. Plant about 5\" deep in a sheltered corner of the garden, preferably at the foot of a low, south-facing wall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The fragrance of the flowers has made this a popular cut flower as well as an excellent species for greenhouse pot plant production. Cover 4-5 bulbs with an inch of soil in a 5\" diameter pot and place at 45°F for 8-10 weeks. Bring to a warm area and enjoy the flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("grandiflorum")]), _vm._v(" has 3\" diameter umbels consisting of white flowers with a dark eye. Plants are more vigorous than the species. It is used for forcing in pots and cut flower production and is more ornamental than the species.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-nigrum")])]), _vm._v(" (nye' grum)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Black Onion")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-3'/8\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southern Europe, North Italy")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bulbs produce 3-6 basal leaves in early spring and then send a long straight flower stem up to 3' in height. The many star-shaped white flowers are borne in a round 4-6\" wide umbel. Sometimes bulbils may form in the inflorescence. The ovary of each flower is dark green to black and appears to give the flowers a black center (thus the name "), _c('em', [_vm._v("nigrum")]), _vm._v("). The flowers occur relatively late in the spring and the seed heads remain highly ornamental for 3-4 additional weeks. These have been excellent additions to the Armitage garden, and persisted for about 3 years.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-oreophilum")])]), _vm._v(" (o-ray-o' fi-lum)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Mountain Onion")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("4-12\"/9\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Rose")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Turkey, Afghanistan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is an excellent species for the patio planter or front of the garden. The 2-3 linear leaves are flat, bluish green, and somewhat limp. The dozens of star- to bell-shaped flowers are held in a 2\" diameter umbel. They have a mild pleasant fragrance though the pungent onion smell is particularly noticeable when the leaves and stem are crushed. The flowers persist for many weeks but become thin and papery as they age. The foliage is usually withered by flowering time or may persist for a week or so after flowering. Plant in a sunny, well-drained area.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Zwanenberg’ has carmine-pink flowers that are a little brighter than those of the species.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-senescens")])]), _vm._v(" (sen-es' ens)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("German Garlic")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-12\"/6\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Lilac-pink")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe, Northern Asia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The cup-shaped flowers are clustered on a 1-2\" wide umbel in late spring to midsummer. The 4-9 basal green leaves are flat and somewhat grasslike. The plants are best for rock gardens or an area where the small plants will not get lost or overgrown. They tolerate full sun but a little afternoon shade is appreciated. The species itself is nothing to write home about, however, the variety sold as "), _c('em', [_vm._v("glaucum")]), _vm._v(" is popular and rather dramatic. The flowers are debatably more pink than in the species but the foliage is blue-green and twisted. Some authorities have named this variant "), _c('em', [_vm._v("A. spirale")]), _vm._v(" and it is known as the circle onion. They are not dramatic like ‘Globemaster’ but garner plenty of comments.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Comments abound in the onion world about two cultivars—‘Summer Skies’ and ‘Blue Skies’. According to Mark McDonough, a well-respected allium breeder in Massachusetts, neither cultivar is particularly outstanding, and he adds that they are not “anything close to being blue flowered, but they do make nice foliage clumps.” Personally, I thought they were quite lovely, although not blue. Mature plants stand about 15\" tall. They appear to be happier in the North than the South where they produce many more leaves and far fewer flowers. They probably should be listed as cultivars of "), _c('em', [_vm._v("A. lusitanicum")]), _vm._v(" (formerly "), _c('em', [_vm._v("A. senescens")]), _vm._v(" var. "), _c('em', [_vm._v("montanum")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Roseum’ has pink flowers and if twisted leaves are not terribly important, then this is the best choice of the species.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-schubertii")])]), _vm._v(" (shoo-ber' tea-eye)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Schubert Onion, Tumbleweed Onion")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("18-24\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Pink")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Mediterranean, Central Asia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("This onion defies description, suffice it to say that the flowers look like the hair on Don King’s head (or for my more mature readers, Phyllis Diller’s hairdo). I try in vain to teach this species to my students, and while the slides help, seeing the real thing up close and personal makes instant alliophiles. The 1/2\" wide, pink starry flowers are first produced on short flower stalks (pedicels) like a normal onion but then proceed to form additional infertile flowers on pedicels longer than the first ones. The effect reminds one of the physics experiment with the static machine that makes your hair stand on end.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As gruesome of the above description sounds, it really is a neat garden plant. The 4-8 blue-green leaves are produced early in the spring and deteriorate after flowering has finished. The stems are compact and stout and require no help to support their floral and seed display. The floral fireworks leaves behind the same exploding seed head, ornamental long after the pink of the flowers has faded into memory. The seed heads may be dried for winter decoration, however, if left to their own devices, they eventually fall off and become garden tumbleweeds, rolling around with each gust of wind, resulting in the apt common name. The main reasons so few of these bulbs are found in North American gardens are the cost and relative lack of cold hardiness. But they are worth it, for how else can you bring Don and Phyllis in your garden and not have to listen to them? Plants should be well mulched in zone 5.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-sphaerocephalon")])]), _vm._v(" (sfay-roe-sef' a-lon)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Drumstick Chives")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("18-3 6/15\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Purple")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is one of the finest alliums for both cut flowers and the garden. The 3-5 hollow, semi-cylindrical leaves resemble inflated chive leaves. The oval to round 2\" wide flower heads consist of 50-100 flowers. Each flower bud is green and with maturity, the flowers turn purple, giving the inflorescence a two-tone effect. Flowers open in mid June and persist for two-three weeks. The stamens are longer than the tepals and provide an airy feel to the flower heads. It is excellent in hot climates and performs very well as far south as zone 8. The flowers are persistent on the plant and as a cut flower, last up to 10 days in water. The only reason I can see that this species has been overlooked and underused in North American gardens is that it is rather skinny and at least a dozen bulbs are needed to make a show.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plant multiple bulbs 6\" apart and 6\" deep in a sunny exposure. One or two plants are not effective and a grouping is essential. By the way, here is another plant whose name neither the taxonomic nor bulb grower communities can agree on. For years, it has been sharing the names "), _c('em', [_vm._v("sphaerocephalum")]), _vm._v(" and "), _c('em', [_vm._v("sphaerocephalon")]), _vm._v(". The more recent literature suggests the latter is correct, so end of story. Bulblets may be separated after 2-3 years and seed may be treated similar to "), _c('em', [_vm._v("A. aflatunense")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-thunbergii")])]), _vm._v(" (thun-berg-ee' eye)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Japanese Onion")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("18-24\"/10\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Fall")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Violet")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Japan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I first saw this onion with my friend Galen Gates of the Chicago Botanic Garden. On that cool fall day, other plants were bedding down but the shiny grasslike green leaves and purple flowers were outstanding. He shared a few bulbs with me and they were equally good in my garden in Athens. The tufts of leaves persist throughout the season and in September to November, the starry violet flowers are fresh and inviting. The stamens and style are elongated and appear to dramatically increase the size of the umbel. Full sun is necessary for best performance.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Ozawa’, introduced by George Schenk, is the best known and most popular, growing about 9-12\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-triquetrum")])]), _vm._v(" (tri-kwee' trum)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Three-Cornered Onion")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("8-15\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Western Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is easily recognizable by feeling the three-sided scape which supports a 2 1/2\" diameter inflorescence of six to eight 1/2\" long pendulous, white flowers, borne primarily on one side of the flower stem. Each bell-shaped flower has a central stripe of green and the stigma is deeply 3-parted, another characteristic useful in separating the three-cornered onion from others. The flowers are fragrant, but not nearly as sweet as those of "), _c('em', [_vm._v("A. neapolitanum")]), _vm._v(". The foliage consists of three to four 1\" wide, keeled leaves. It is common in hedgerows in England and New Zealand. In the Gardens at UGA, this is one of our finest bulbs, spreading over the years through the creeping phlox, making even that colorful plant look better. They are spreading, but not invasive. Yet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plant bulbs in well-drained soils in full sun. Seeds germinate readily and can create a weed problem the following spring if growing conditions are conducive. The seeds are dispersed by ants and ants can travel a long way. Some gardeners remove the flowers as soon as flowers have wilted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate by the many bulblets formed after the first year or by seeds treated similarly to those of "), _c('em', [_vm._v("A. aflatunense")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("pendulinum")]), _vm._v(" has larger flowers borne on all sides of the umbel. It is more useful as a cut flower than the species.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. carinatum")]), _vm._v(", keeled garlic, has about 30 cup-shaped purple flowers in the pendulous umbels. The inflorescences usually include bulbils. var. "), _c('em', [_vm._v("pulchellum")]), _vm._v(" has rosy lilac flowers and lack bulbils.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. cernuum")]), _vm._v(", wild nodding onion, is native to the northeastern United States and bears nodding lilac-pink flowers. The scape never straightens out entirely, thus nodding onion is a particularly appropriate name. Plants are usually about 18\" tall but can be quite variable. Leaves persist into the late summer, and have little onion odor. Bulbs are carried on a short rhizome and are easy to grow. They provide a wonderful early summer show when placed in groups of three to six, and will tolerate light shade or full sun. Self-sowing can be a problem, if so, deadhead immediately after flowering.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0070-01.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Allium cernuum")])]), _vm._v(" "), _c('p', {
    staticClass: "indentp"
  }, [_c('em', [_vm._v("A. cyaneum")]), _vm._v(" has dark blue to purple star-shaped nodding flowers on 6-9\" tall scapes borne from small ovoid bulbs, clustered on a small rhizome. Plants are native to western China, and a terrific summer bloomer. The grassy foliage disappears soon after flowering.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. insubricum")]), _vm._v(" bears pink bell-shaped flowers and is often confused with "), _c('em', [_vm._v("A. narcissiflorum")]), _vm._v(". Plants differ by having green leaves and flowers that are pendulous both in bud and in flower. "), _c('em', [_vm._v("A. insubricum")]), _vm._v(" tolerates wetter conditions than "), _c('em', [_vm._v("A. narcissiflorum")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. mairei")]), _vm._v(" var. "), _c('em', [_vm._v("amabile")]), _vm._v(" flowers in late summer and fall like "), _c('em', [_vm._v("A. thunbergii")]), _vm._v(" and produces slender bulbs clustered on a rhizome and persistent grassy leaves. The funnel-shaped nodding flowers are magenta to deep pink and plants are 5-6\" tall. Plants used to be listed as "), _c('em', [_vm._v("A. amabile")]), _vm._v(". Good garden plants regardless, probably hardy in zones 6-8.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. obliquum")]), _vm._v(" is a bright lemon-yellow flowered species, bearing unique cup-shaped flowers. The yellow is a nice break from the more strident yellows of daisies and sundrops often found in the early summer garden.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_c('em', [_vm._v("A. ramosum")]), _vm._v(", fragrant flowered garlic, bears many bell-shaped white flowers with a dark red stripe in 2\" wide umbels. The foliage is narrow and persists until the flowers are produced in late summer or fall.")])]), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. rosenbachianum")]), _vm._v(" easily grows 4' tall and produces 4\" wide spherical umbels consisting of hundreds of star-shaped deep lavender flowers in the spring. ‘Album’ is a creamy white form growing about 3 1/2' tall. The foliage disappears quickly, leaving the long naked flower stem with its cargo of flowers and later seed heads. I grow mine through a large clump of "), _c('em', [_vm._v("Baptisia pendula")]), _vm._v(", so that after the flowers of the "), _c('em', [_vm._v("Baptisia")]), _vm._v(" are finished, the globes of the onion continue. They differ from "), _c('em', [_vm._v("A. giganteum")]), _vm._v(" in that their tepals become twisted and reflexed but whose umbel remains well formed as it dries and produces large quantities of seed. "), _c('em', [_vm._v("A. giganteum")]), _vm._v(" has tepals that remain unreflexed, the umbel falls apart by late summer and seldom produces much seed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. sikkimense")]), _vm._v(" has bell-shaped, pendant, deep blue to purple flowers held on short scapes, each about 8-10\" long. Plants are excellent in rock gardens, blooming in early to midsummer. Likely hardy in zones 6-8.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. stipitatum")]), _vm._v(" is another "), _c('em', [_vm._v("A. giganteum")]), _vm._v("/"), _c('em', [_vm._v("A. rosenbachianum")]), _vm._v(" lookalike. Plants bear 3-4' tall scapes topped with globular fragrant lilac flowers. It differs in that the tepals (petals) reflex downward and wither after flowering, while those of "), _c('em', [_vm._v("A. giganteum")]), _vm._v(" are persistent. The leaves are narrower, about 1-1 1/2\" wide.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. tuberosum")]), _vm._v(", garlic chives, has creamy white flowers and narrow chivelike leaves. It is similar to "), _c('em', [_vm._v("A. ramosum")]), _vm._v(" but differs by having star-shaped flowers with a faint green or brown stripe. Introduced from southeast Asia, it can become an aggressive weed in many parts of the country.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. ursinum")]), _vm._v(", ramsoms, is about 10\" tall and bears 15-20 white flowers in flat 2\" diameter umbels in late spring. The strongly onion-scented plants consist of two to three elliptical leaves with long petioles. Plants are more tolerant of shade than most alliums.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. virgunuculae")]), _vm._v(" produces stems with 2-12 pink, star-shaped flowers in October and November. The grassy leaves look good all season. A small grouping makes a lovely setting.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Hybrids:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hybrids of "), _c('em', [_vm._v("A. macleanii")]), _vm._v(" and "), _c('em', [_vm._v("A. aflatunense")]), _vm._v(" were developed by F. Bijl van Duyven-bode of J. Bijl Nurseries in Holland. Leaves decline quickly and flowers are sterile, therefore they persist on the plant for a long time. More expensive but well worth it.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Gladiator’ is 3-4' tall with large lilac-purple flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Lucy Ball’ is a sport of ‘Gladiator’ with dark violet flowers. Stands about 4' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Rien Poortvliet’ bears great lilac flowers on 3-4' tall stems.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("‘Globemaster’, a hybrid between "), _c('em', [_vm._v("A. christophii")]), _vm._v(" and "), _c('em', [_vm._v("A. macleanii")]), _vm._v(", is without doubt, one of the best ornamental onion I have ever tried. The robust plants stand about 2 1/2' tall on strong self-supporting stems. The stems must be strong because the lavender flowers are held in 4-6\" wide globular heads. The flowers continue to open over many weeks, the newer ones “replacing” the older ones. While other members of the genus have come and gone, ‘Globemaster’ still shines. The seed heads remain ornamental well into the summer. It was originally bred as a cut ")]), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_vm._v("flower in Holland by van Duyvenbode and as more gardeners discovered it, the price decreased significantly.")])]), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Millennium’ was bred by Mark McDonough and appears to have a good percentage of "), _c('em', [_vm._v("A. nutans")]), _vm._v(" in the parentage. Plants are about 1' tall and equally wide with rose-purple flowers in late summer. Zones 5-8.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Sugar Melt’ is only about 6\" tall when not in flower, but growing almost to a foot and a half when the flowers open in midsummer. The balls of flowers are light pink. Particularly attractive for rock gardens. Bred by Mark McDonough from "), _c('em', [_vm._v("Allium nutans")]), _vm._v(" and "), _c('em', [_vm._v("Allium senescens")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Alstroemeria")])]), _vm._v(" (ahl-stro-meer-e' a)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Peruvian Lily")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Alstroemeriaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Approximately 50 species, all native to South America, are known. They generally grow from tubers, produce alternate leaves and have wonderfully interesting flowers. Peruvian lilies have become extremely popular as cut flowers, produced in fields and greenhouses in California, Holland, Colombia, Israel and other cut flower-producing regions. Generally cut flower production involves hybrids of "), _c('em', [_vm._v("A. ligtu")]), _vm._v(" and "), _c('em', [_vm._v("A. aurea")]), _vm._v(" but most of these are poor garden plants in all but a few areas of the country. In areas on the West Coast, the orange-yellow flowers of "), _c('em', [_vm._v("A. aurea")]), _vm._v(" brighten gardens and once established can roam about at will. "), _c('em', [_vm._v("A. aurantiaca")]), _vm._v(" is another wonderful golden-orange species but seldom survives extremes of heat and cold common to most areas of the United States. ‘Lutea’ is particularly handsome.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-psittacina")])]), _vm._v(" (sit-a-seen' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Parrot Lily")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-3'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Red/Green")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("South America")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 7-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is a rather common plant in the Southeast, and once established, can become a bit of a nuisance. Having said that, they are a joy when the flowers, which are an odd mix of green and wine red, spotted or streaked with maroon, start to open in early to midsummer. The color combination sounds rather weird, but they are weirdly delightful. Flowers begin in early June and continue for 4-5 weeks. Like all members of the genus, they are excellent cut flowers, albeit a rather difficult color to place with anything else. That’s why bud vases are sold. Two to three flowers are produced in each terminal inflorescence. "), _c('em', [_vm._v("A. psittacina")]), _vm._v(" performs best in partial shade, but too much shade results in leafy, poor-flowering plants. Easy to divide, these are the ultimate pass-along plants.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Variegata’ has far more handsome foliage than the species and should be used more often. Perhaps not quite as aggressive but you will be giving some away soon enough.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Hybrids:")])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_vm._v("Large-flowered colorful alstroemerias, such as seen in the florist shop, have not been particularly resilient in the much of the country. However, a couple of fine fellows, Mark Bridgen, presently at Cornell University, and George Hare of California, have provided a number of hybrids that combine cold tolerance with excellent flowers. ")]), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("This are wonderful breakthrough plants for gardeners, although I still would not recommend them for my daughters in the Southeast. However, many more people have considerably more choice than ever before.")])]), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Freedom’ bears rose-pink flowers in early summer atop 2' tall stems. All Dr. Bridgen’s breeding was done in Connecticut, and plants are cold hardy to at least zone 5b.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Glory of the Andes’ is a variegated leaf form of ‘Sweet Laura’. The leaves have a nice creamy yellow margin.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Sweet Laura’ provides golden flowers with red petal tips, speckled with brown, on 1-2' tall plants. Flowers open in mid to late summer. A Bridgen hybrid.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘The Third Harmonic’ sports plants about 3' tall. The backs of the golden flowers are maroon. Each flower is flecked with black. Bred by George Hare, cold hardy to zone 7.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other beautiful hybrids are also available, but are more suited for containers, lacking the weather tolerance of the above cultivars. They include the coral peach and yellow flowers of ‘Princess Victoria’, the yellow and burgundy flowers of ‘Yellow Friendship’ and the light and dark pink blossoms of ‘Dusty Rose’.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Alyssum")])]), _vm._v(" (a-lis' um)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Madwort")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Brassicaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("The large genus consists of over 150 species, mostly native to alpine and northerly areas, and most do poorly in hot, wet summers. Plants are usually small in stature and are outstanding for rocky crevices or rock garden areas. The majority bear yellow flowers. Taxonomists removed the most popular old alyssum ("), _c('em', [_vm._v("A. saxatile")]), _vm._v(") to the genus "), _c('em', [_vm._v("Aurinia")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A number of fine species are occasionally offered and seed may also be found through specialty organizations, such as the North American Rock Garden Society. "), _c('em', [_vm._v("A. montanum")]), _vm._v(", mountain madwort, is an 8-10\" tall ground cover, with finely cut foliage and masses of bright yellow spring flowers. ‘Mountain Gold’ is a more compact, floriferous cultivar and ‘Luna’, a Fleuroselect winner in 2003, may be even better, at only 5-6\" tall. Hardy in zones 2 to 7.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. wulfenianum")]), _vm._v(" is prostrate, about 8\" tall, with gray leaves and light yellow flowers in early spring, while "), _c('em', [_vm._v("A. argenteum")]), _vm._v(" produces handsome foliage with gray on the top and green beneath.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All require excellent drainage and do best in full sun. None does particularly well in the South, although if planted in the fall, they are wonderfully bright in the spring, but decline as the heat of summer arrives.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('strong', [_vm._v("X")]), _vm._v(" "), _c('em', [_c('strong', [_vm._v("Amarcrinum")])]), _vm._v(" (a-mare-cry' num)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Amarcrinum")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Amaryllidaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("The intergeneric cross between "), _c('em', [_vm._v("Amaryllis belladonna")]), _vm._v(" and "), _c('em', [_vm._v("Crinum moorei")]), _vm._v(" is way underused, particularly in southern gardens. The hybrid, known as "), _c('em', [_vm._v("A. memoriacorsii")]), _vm._v(", bears 1 1/2' long straplike dark green leaves in the summer and fragrant pink flowers on 15\" long scapes in late summer to fall. Plant bulbs to a depth of about three times their diameter in late fall or early spring for best performance.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_73"
    }
  }), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_vm._v("I think these are wonderful bulbs, and can’t imagine my garden without them. Their biggest limitation for the rest of the country is the fact that they are cold hardy only to zone 7. However, there is enough beauty here to treat them as annual bulbs in containers or bring them in as you would with dahlias.")])]), _c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Dorothy Hannibal’ has lighter pink flowers than the species.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Fred Howard’ has light pink flowers with a darker pink streaking throughout the flowers. A handsome plant named in 1920 for Mr. Howard, a breeder in Los Angeles. This is occasionally (and incorrectly) labeled as "), _c('em', [_vm._v("A. howardii")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Amianthium")])]), _vm._v(" (am-ee-an-the' um)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Fly-poison")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Liliaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Who said fly traps have to come in a spray can or sticky strips? All parts of the plant are poisonous, although the folklore about poisoning flies is a bit of a mystery. Perhaps because an excellent fly poison results when the small bulbs are mixed with honey or syrup, although fly paper is a lot cheaper.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Only one species occurs in this genus, "), _c('em', [_vm._v("A. muscaetoxicum")]), _vm._v(", and it is native from Pennsylvania and New York south to Florida and west to Arkansas. Grazing cattle have been known to be poisoned, thus names like fall-poison and stagger grass have also been attached to these plants. Such morbidity makes for good stories but plants are also quite ornamental. They produce long racemes of clean white flowers, and when allowed to grow in large groups, brighten the woodland landscape. The basal leaves are usually more than a foot long but only about an inch wide. They flower in May in the South and in June further north. A wonderful population may be seen at the Atlanta History Center in the terrific native garden tended with great care by Sue Vrooman.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Amorphophallus")])]), _vm._v(" (a-mor-fo-fal' us)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Snake Palm")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Araceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("That plants of this genus belong in a garden is a given, that they belong in yours or mine may be debatable. Membership in the Araceae puts them in the same company as caladiums, calla lilies and jack-in-the-pulpits, characterized by the unmistakable spathe and spadix arrangement of flowers. Approximately 100 species of these bulbous plants are known, all are denizens of leafy moldy places in moist, shaded habitats. Some are used for their edible tubers, but if grown in the garden, their compound foliage, marbled stems and dramatic, often evil-smelling inflorescences should be enjoyed.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_vm._v("Flowers of this group of plants have memorable effluvia, often assailing the nostrils with a barrage of odor. Sir Joseph Hooker described the odor of the huge flower of "), _c('em', [_vm._v("A. titanum")]), _vm._v(" as a “mixture of rotting fish and burnt sugar, which turns your stomach over and makes your eyes run”. Perhaps that is why its common name is corpse flower! Knowing my fondness for such weird plants, Tony Avent of Plants Delight Nursery in Raleigh, North Carolina brought me a tuber of devil’s tongue many years ago. I have since planted dozens more, mostly for their fabulous stems and foliage. Not all plants want to flower every year, which is probably just as well as my neighbors, let alone my ")]), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_vm._v("wife Susan, would not be impressed. The scent of this species was described by a visitor at a flower show when “We detected the scent of pure rot. Following our noses, we came across two huge, liver-colored inflorescences atop five-foot stalks which arose from naked corms the size of pumpkins.” I have not been as vigorously assailed, but when they are flower in May, it is tough to walk by without noticing.")])]), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("They seem to be most at home in heavy shade and a reasonably moist area. When they do not flower, it is easy to forget they are there. However in June, long after most plants have risen and are growing well, "), _c('em', [_vm._v("Amorphophallus")]), _vm._v(" gives a big yawn, stretches, and breaks through the soil. Seeing that purple mottled stem rise like a phoenix and watching the foliage unfurl can keep me occupied for days. Generally a single leaf emerges and branches repeatedly, the two branches of each division basically equal. The name for this kind of leaf shape is “dichotomous”, in case one cares. Regardless of my ineptness at describing them, let’s just say the leaves and stem are by far the best parts of the plant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There has been an awakening in American gardening to plants in this genus, and one can now find a handful of species through specialty nurseries, or through the Internet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other similar genera occasionally presented to the gardener such as "), _c('em', [_vm._v("Dracontium")]), _vm._v(" and "), _c('em', [_vm._v("Sauromatum")]), _vm._v(" offer weirdness of habit, foul odor and curious, often disparaging comments. Who could ask for more?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you are confused by all the voodoo lilies, here are a few of the more obvious differences.")]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("Amorphophallus konjac")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("Dracontium vulgaris")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("Sauromatum venosum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Spathe color")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Dark purple")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Dark purple")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Dull violet with yellow")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Spathe shape")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("3-4' wide")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("1' long, 6\" wide, arching")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("2' long, pointed, flattened back")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Spadix")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Purple")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Purple")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Deep purple")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Leaf number")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Usually One")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Several")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("One")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Leaf shape")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Dichotomous")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Sickle-shaped")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Sickle-shaped")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-konjac")])])]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Devil’s tongue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-5'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer/fall")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Purple")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("India, Sumatra")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 6-10")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This was the beast that Tony shared with me, putting me on the slippery slope of aroids. At one time, it was called "), _c('em', [_vm._v("A. riveri")]), _vm._v(" subsp. "), _c('em', [_vm._v("konjac")]), _vm._v(", but it has recently been reclassified. It is the most common simply because it is the most cold hardy and most easily available. While its garden attributes may be debated, its importance as a food crop is well known in Indonesia, Southeast Asia, India and the Pacific Rim. In many regions, the corms are important standbys when the rice crop fails. In Japan, a traditional food made from the corm is known as konnyaku, and industrial uses for the carbohydrates (mannose, starches) in the dark-skinned corm have also been discovered. Gelling properties for convenience foods and dietary supplements for weight loss are being investigated.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_75"
    }
  }), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_vm._v("Plant tubers in partial shade, approximately 3 times deep as the tubers are wide. This may be a large hole. Do not be concerned if they do not flower, it may take 3-5 years before the tubers are significantly mature. Plants do not normally emerge until late spring or even early summer. Hang in there, the stems and leaves are well worth the wait.")])]), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Leo Song’ is similar to the species but has quite lovely creamy white stems, still mottled in purple.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Additional Species")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gardeners have always lusted for additional species, and today there are more than ever before. The aforementioned Mr. Avent lists nine different taxa in his 2007 catalog, unheard of 5 years ago. The International Aroid Society is a wonderful source of photos and growing information. However, be prepared to pay top dollar, and once paid, say thank you to the people who are making them available. If you are fortunate to find a good species, you have ornamental value, dietary value and nasal exercise all in one. Have fun.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. bulbifer")]), _vm._v(", the voodoo lily, has 30-36\" tall mottled stems and palmately lobed foliage. The leaves form small tubers in late summer that may be removed for new plants. The spadix is green with a tinge of pink and appears in the spring before the foliage. Hardy in zones 8, perhaps to 7 to 10.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. dunnii")]), _vm._v(" bears a white bulbous spadix half surrounded by a green and white mottled spathe. Plants are about 2' tall and still produce the wonderful speckled stalk and voodoo leaves. Plants have not been tested sufficiently but are likely hardy in zones 8 (7)-10.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. muelleri")]), _vm._v(" was introduced to gardeners by Tony Avent of Plant Delights Nursery in 2005. Plants have a large white spadix enclosed with a pink-purple spadix. The flower stem is mottled purple but the petioles are often mottled white. Like "), _c('em', [_vm._v("A. bulbifer")]), _vm._v(", this also produces small tubers on the stems.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. thaiensis")]), _vm._v(" holds flowers on a foot-long stalk, the inflorescence consists of a green spathe suffused with pink and a spadix that is white at the base, progressing to pink at the top. The plants are characterized by a single petiole marked with brown to purple spots.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_c('em', [_vm._v("A. titanum")]), _vm._v(", titan lily, giant voodoo lily, is certainly the most famous, and in its native Indonesian environment has flowers up to 15' tall. The mottled stems and foliage are equally impressive. Many botanical gardens now grow the tuber and often announce when the titan lily will be flowering. Do people actually stand in line to see something that smells, even if it’s huge? In 1999, when the titan lily flowered at Huntington Botanical Gardens in California, more than a few people showed up. According to the garden staff, “During the 19 days it was on public view, before and after blooming, the "), _c('em', [_vm._v("Amorphophallus titanum")]), _vm._v(" drew an unprecedented total of over 76,000 enthusiastic flower fans. Television coverage alone lasted for 18 consecutive days. Numerous front-page newspaper stories appeared, and countless radio interviews and news stories were broadcast, ranging from National Public Radio and the ")]), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("BBC to alternative rock station KROQ.” This does not even mention the refrigerator magnets, coffee cups and t-shirts that were sold by the hundreds. So, yes, people really do line up for the weird and wonderful. You have reached la-la land when you find yourself in such a line. Plants are seldom for sale, and if they are, they cost as much as a Beamer. Like the Beamer, they need to be brought in for the winter.")])]), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. yuloensis")]), _vm._v(" is probably hardy to at least zone 7b; produces wonderfully deeply cut foliage and cream-colored spathe and spadix.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("Ampleaster")])]), _vm._v(" (am-plee-as' ter)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("See "), _c('em', [_vm._v("Aster")])]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_c('em', [_c('strong', [_vm._v("Amsonia")])]), _vm._v(" (am-sown' ee-ah)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Blue Star Flower")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Apocynaceae")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This North American genus contains some fine low-maintenance, resilient species for the garden. Light blue to almost white star-shaped flowers are held in terminal panicles above the alternate leaves. There are approximately twenty species in the genus although only 3 or 4 are available to the gardener. Amsonias provide early blue flowers, disease and insect resistance, and fall color. The fruits (follicles) are long and narrow; in some species they are erect while others bear spreading or pendant fruit. Certainly one of my favorite plants is the common blue star flower, "), _c('em', [_vm._v("A. tabernaemontana")]), _vm._v(", however, the Arkansas amsonia, "), _c('em', [_vm._v("A. hubrichtii")]), _vm._v(" and the downy amsonia, "), _c('em', [_vm._v("A. ciliata")]), _vm._v(", are also excellent garden plants.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Amsonia Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Young leaves obviously hairy")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Approx width of leaves")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower color")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. ciliata")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Y")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("1.5\"")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Light blue")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. hubrichtii")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("N")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3/4\"")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Light blue")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. tabernaemontana")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("N")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("2\"")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Blue")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-ciliata")])]), _vm._v(" (sill-e' a-ta)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Downy Amsonia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1-3'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Sky Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southeastern United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 6-10")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An excellent plant for many gardens, plants provide handsome 1/2\" wide unblemished foliage and good flowering in the same package. The linear to lanceolate dark-green leaves have a fringe of silky hairs that are particularly handsome in the early season, but with maturity, they lose much of their silkiness. However, if the plant is cut back after flowering, the new growth returns as feathery as before. The leaves are crowded toward the upper end of the stems and the margins slightly curled back toward the underside of the leaves (revolute). The foliage is seldom touched by insects or disease. The light blue starry flowers open in spring and persist for 3-4 weeks. Some species of amsonia provide marvelous fall color in the garden. The foliage of downy amsonia is one of them, providing a golden yellow hue until frost.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("Plant in full sun or light, dappled shade and provide sufficient moisture to survive dry periods. Although no serious pests occur, stems may need cutting back at least ")]), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_vm._v("once during the season to keep them from falling over, particularly if planted in a shady area. If plants remain evergreen, cut back hard in very early spring.")])]), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Seed, division, and terminal cuttings taken during the spring are all viable means of propagation. Store the seed at about 40°F for 4-6 weeks because untreated seed germinates irregularly. Chipping or cutting away a small piece of one end of the seed and soaking overnight in water results in better germination. Division is not necessary for 8-10 years but is a quick way to increase a planting. Cut through the crown in late spring or fall so that each division consists of at least one growing point. Terminal cuttings from lateral branches collected in May and treated with a rooting hormone (one labeled for herbaceous plants) root faster and more uniformly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_78"
    }
  }), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("var. "), _c('em', [_vm._v("filifolia")]), _vm._v(" is really a neat-looking amsonia. I first saw this plant in the garden of plantsman Allen Bush in Louisville, Kentucky and was most impressed. Plants are prostrate, much like a ground cover, and have wonderfully feathery leaves. The light blue flowers occur in the spring. It is being sold as the variety and as ‘Georgia Pancake’, a particularly unattractive name for such an attractive plant.")])]), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-hubrichtii")])]), _vm._v(" (ew-brickt-ee' eye)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Threadleaf, Arkansas Amsonia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-3'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Pale Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("South-central United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 6-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many writers (this one included) have written the name incorrectly as "), _c('em', [_vm._v("hubrectii")]), _vm._v(", which is as wrong as E before I except after C. If there was one reason to update this book, it was to apologize, belatedly, to Leslie Hubricht, an extraordinary man who found the plant in 1942. Leslie (and others), apologies from me and my less than bright colleagues.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I wrote my original book in 1989, hardly anyone knew this plant; today it is probably as popular as any species in the genus. The foliage is feathery, like "), _c('em', [_vm._v("A. ciliata")]), _vm._v(", but leaves are threadlike and longer (3\"). The flowers are lighter blue than blue star flower and, in fact, are almost white as temperatures warm up in spring. The early flowers are easily visible but the foliage tends to cover the flowers that open later. The narrow foliage makes a marvelous display throughout the season, and some people claim that the golden-yellow spectacle in the fall is quite spectacular. While it is true that they turn golden in the fall, let’s not get too carried away with this spectacular thing. Without doubt, they provide excellent color compared to other herbaceous plants, but they certainly don’t compete with a maple. Plants are more colorful in the North than the South.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the Armitage garden, it tends to get a little too tall and floppy, and while I prefer common blue star, I enjoy the look of the foliage of this plant as well. Fall color in warm climates is highly overrated, and although a little better than blue star flower, plants are not as exciting in my garden as in the Midwest or North. Plants grow about 3' tall and equally wide. Full sun is best; plants do not tolerate shade well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cut back in early spring. Division or cuttings are effective methods to increase numbers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Hybrid:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Seaford Skies’ was discovered by Pamela Harper, from Seaford, Virginia, one of the great grand-dames of American gardening. Plants appear to be hybrids between "), _c('em', [_vm._v("A. hubrichtii x A. tabernaemontana")]), _vm._v(", providing the fernlike foliage and good fall color of the former with the vigor of the latter.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-tabernaemontana")])]), _vm._v(" (tay-ber-nay-mon-tan' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Common Blue Star Flower")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1-3'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Sky Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Eastern United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Leaves are wider, flowers are darker and plants are among the best for full sun to partial shade in most gardens in America. Plants are native from Pennsylvania to South Carolina and west to Kansas, and are found along roadsides or in sunny fields. This species is more cold hardy than the previous and much more common. The flowers are a good dark blue, but they may fade a little over time. The foliage also turns golden yellow in the fall, but does not compete with threadleaf amsonia. For me, blue star flower is always on my list of “no-brainers”. Plant and get out of the way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants have alternate willowlike leaves and many 1/2-3/4\" pale blue star flowers clustered in loose terminal inflorescences in spring to early summer. They are particularly lovely in the early spring as they break through the ground and rapidly extend to their mature stature. If grown in full sun, pruning is not necessary, however, if grown in shade, plants must be supported or cut back after flowering to maintain shape. Plants perform best in full sun, but they tolerate some shade as well. In my shaded garden, I grow plants through a circular support frame to keep plants from falling over. Deep, moist soils and partial shade are ideal.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0079-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Amsoina tabernaemontana")])])]), _c('p', {
    staticClass: "noindentp"
  }, [_c('a', {
    attrs: {
      "id": "page_79"
    }
  }), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_c('strong', [_vm._v("Cultivars:")])])]), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Blue Ice’ is the best-known cultivar, and is grown because of its compact habit (12-18\" tall). However, it does not appear to be as vigorous or as persistent as the species. It may be a hybrid, which may help to explain its relative wimpiness.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("montana")]), _vm._v(" (zones 5-9) is a dwarfer version of the species. Some taxonomists have split it into "), _c('em', [_vm._v("A. montana")]), _vm._v(". An exceptionally good plant, small enough to even find a place in the rock garden. ‘Short Stack’ was selected by Plant Delights Nursery as a more consistent, vigorous form. Plants are 10-12\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("salicifolia")]), _vm._v(" (sometimes listed as "), _c('em', [_vm._v("A. salicifolia")]), _vm._v(") has leaves 5-10 times longer than they are wide and is less erect than the species. The flowers have a white throat and a small beard within. Native to the southeastern United States. Propagation is similar to "), _c('em', [_vm._v("A. ciliata")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. illustris")]), _vm._v(" is native to the central United States and resembles "), _c('em', [_vm._v("A. tabernaemontana")]), _vm._v(", bearing similar foliage and flowers. Plants differ by having thicker leathery leaves and pendant fruit. Cold hardiness to about zone 5.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. ludoviciana")]), _vm._v(", Louisiana blue star, is native to southern Louisiana only and is distinguished by the white wool on the undersides of the leaves. Handsome even without flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. orientalis")]), _vm._v(" superficially resembles "), _c('em', [_vm._v("A. tabernaemontana")]), _vm._v(" but is native to southern Europe. On close inspection, one can see short hairs along the margin and midribs of the leaves, whereas the leaves of "), _c('em', [_vm._v("A. tabernaemontana")]), _vm._v(" are smooth (glabrous). Plants do not appear to be as cold hardy as common blue star flower.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. rigida")]), _vm._v(" is occasionally offered, bearing 2' tall stems and light blue flowers. Native to the Southeast, likely cold hardy to zone 6.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Genera:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Rhazya orientalis")]), _vm._v(" is so similar to "), _c('em', [_vm._v("A. orientalis")]), _vm._v(" that it is considered a synonym. The late spring and summer flowers range from bright blue to violet. Plants are native to Greece and Turkey.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Anacyclus")])]), _vm._v(" (an-a-psyc' lus)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Mount Atlas Daisy")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Asteraceae")])]), _c('p', {
    staticClass: "indent1"
  }, [_c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_vm._v("Of the approximately 9 species of annual and perennial species, only the Mount Atlas daisy, "), _c('em', [_vm._v("A. pyrethrum")]), _vm._v(" var. "), _c('em', [_vm._v("depressus")]), _vm._v(" ("), _c('em', [_vm._v("A. depressus")]), _vm._v(") is easily available to North American gardeners. Plants produce fine basal foliage, forming ferny mats with a lovely gray-green cast. Plants grow 4-6\" tall and bear 1-1 1/2\" wide single white daisies with yellow centers and purple to red backs. Being native to the Mediterranean, excellent drainage is a necessity, at least in the East, and plants are more persistent ")]), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_vm._v("in sunny, dry rock gardens, gravel pathways or embedded in rock walls than in the border. Plants are more productive in areas of low rainfall and low humidity. Our plants at Georgia were wonderful the first year but succumbed to the winter wetness. Hardy from zone 5 to 7.")])]), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate by division or easy from seed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Garden Gnome’ is occasionally listed but I see no difference from the species. It is likely a common name that someone put some single quotation marks around.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Silberkissen’ is even more compact than the species and bears gray foliage with silver hairs and pink-tinged white daisies.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Anaphalis")])]), _vm._v(" (an-naff' al-iss)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Pearly Everlasting")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Asteraceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Anaphalis produces masses of small white flowers in August and September, usually with a brownish yellow center, but it is the foliage that is special throughout the growing season. The gray-white leaves create a cooling effect in the border and tone down the bright reds and oranges of flowers beside them. They are reasonably tolerant of moisture and are particularly useful in areas that are too wet for other gray-green plants such as "), _c('em', [_vm._v("Artemisia")]), _vm._v(" and "), _c('em', [_vm._v("Perovskia")]), _vm._v(". This is not to say they will jump with glee when placed in a swamp, but they are especially tough and can withstand significant abuse. Rich soil is not a prerequisite, but evenly moist soils are recommended because the foliage looks shabby under dry conditions. They are also at home in the naturalized or wildflower garden in full sun to partial shade.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The leaves are alternate, entire, and sessile. The flower heads are small and crowded like small pearls at the ends of the branches. They can be cut and dried to make excellent “everlastings”.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Seed sown in late summer will produce flowering plants the next year but division is the most rapid means of propagation. Plants should be divided every 3-4 years.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Anaphalis Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Underside of leaves woolly")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower color")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. margaritacea")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("24-36")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. triplinervis")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("12-24")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-margaritacea")])]), _vm._v(" (mar-ga-ri-tay' see-a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Western Pearly Everlasting")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("24-36\"/24\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("North America, Northeast Asia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_vm._v("The 2-4\" long gray-green lanceolate leaves have a white, woolly pubescence on their undersides and the margins are rolled in. The rounded flower heads consist of dozens of 1/4 to 1/2\" diameter flowers that cover the plants like a carpet of snow in late summer. The common name refers to the long-lasting dried flowers. Under evenly moist conditions, plants grow up to 3' tall and equally wide. These are outstanding plants when a touch of gray is needed, and although they may take a couple of years ")]), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_vm._v("to look their best, once established, gardeners cherish it for its usefulness in the garden design. One of my favorite garden designers, Bobby Schwartz, of Shaker Heights, Ohio recommends it “be placed in the front of a deep border with tall asters, Joe Pye Weed or "), _c('em', [_vm._v("Helianthus")]), _vm._v(" ‘Lemon Queen’ behind it. Alternatively, it could be placed in the middle of a border with any of the above perennials behind it and "), _c('em', [_vm._v("Coreopsis verticillata")]), _vm._v(" ‘Moonbeam’ in front of it.” I love designers who understand that good garden design is based on knowing good plants from bad.")])]), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants are native to the western United States but also extend across the entire northern half of the country and into Canada. They are not found in the Southeast of the Rocky Mountains.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("cinnamomea")]), _vm._v(" is probably the most common form available. The 1\" long leaves are 3-nerved and bear a lovely cinnamon hue on the undersides. Hardy in zones 4-7. It is interesting to note that much of the taller anaphalis offered by American nurserymen is var. "), _c('em', [_vm._v("cinnamomea")]), _vm._v(", native to India, while the majority of everlastings in English gardens is our native "), _c('em', [_vm._v("A. margaritacea")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("yedoensis")]), _vm._v(" produces about 2\" long, 1-nerved hairy leaves. Native to Japan and likely a little more cold hardy.")])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_82"
    }
  }), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0082-01.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Anaphalis triplinervis")])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-triplinervis")])]), _vm._v(" (tri-plee-ner' vis)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Three-veined Everlasting")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("12-24\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Himalayas")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I think I like this plant even more than the former because I can satisfy my “what is it?” curiosity. Trying to guess what these gray-leaved plants are is a challenge, but the obvious three veins (three nerves) on the undersides of the leaves makes my guess a little more accurate. The dense, white, woolly pubescent leaves, like other species, contrast and soften other green leaves and bright flowers in the garden. The stems have a more or less zigzag or wavy form (flexuous) which is especially evident if a few leaves are removed. The flowers, which open in July, are long lasting and continue until frost. This makes an excellent low-growing plant for the front of the garden and should be used more often.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Summer Snow’ has clear white flowers over tufts of silvery gray foliage. The flowers are a “cleaner” white than those of the species.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. nepalensis")]), _vm._v(" var. "), _c('em', [_vm._v("monocephala")]), _vm._v(" ("), _c('em', [_vm._v("A. nubigena)")]), _vm._v(" is similar to "), _c('em', [_vm._v("A. triplinervis")]), _vm._v(" but is only 6-9\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Anchusa")])]), _vm._v(" (an-koo' sa)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Alkanet")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Boraginaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Of the 30 or so species, gardeners are lucky to see more than two or three. This is a good thing as most of the others are best left to nature; we have enough weeds without raising others. All are biennials or short-lived perennials (living for 2-3 years) and provide flowers in the blue range, a color often difficult to find in the spring and summer garden.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most members of the Boraginaceae are characterized by the presence of alternate leaves, hairy stems, and flower buds arranged in the shape of a scorpion’s tail (scorpioid cyme). Members of "), _c('em', [_vm._v("Anchusa")]), _vm._v(" also bear these characteristics. "), _c('em', [_vm._v("A. capensis")]), _vm._v(" may be one of the prettiest species for the front of the garden, but the 1-2' tall plant is best treated as a biennial or an annual. "), _c('em', [_vm._v("A. caespitosa")]), _vm._v(" grows about 3-5\" tall and bears extraordinary blue flowers, and is worth a try in the rock garden if plants or seeds can be obtained. The most popular and most tolerant species is "), _c('em', [_vm._v("A. azurea")]), _vm._v(", available in a number of stately cultivars. All species require excellent drainage for best performance.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-azurea")])]), _vm._v(" (a-zewr-ree' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Italian Alkanet")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-5'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Caucasus")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_vm._v("This tall-growing, coarsely hairy species can be a beautiful background specimen for full sun in the late spring garden. The 4-8\" long entire leaves are sessile or attached to the stem by the clasping base. The bright blue flowers are 1/2-3/4\" across and persist for about four weeks, depending on temperature. The important words in this discussion are “can be”, as they also can be a mess, with leaves turning black and plants askew. In the South, plants may reach 4' in height and require support. Do not ")]), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_vm._v("fertilize as they may become too lanky. I have seen some reseeding in rich soils but this is not a widespread problem.")])]), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagation is mainly by root cuttings. Take 1/2-3/4\" diameter cuttings, 2-3\" long, in early spring, place horizontally in moist, loose, well-drained soil at 65-75°F (also see "), _c('em', [_vm._v("Anemone")]), _vm._v("). Seed is commonly used; sow 1-2\" deep, place at 70-75°F and cover to maintain high humidity.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Dropmore’ was selected in 1905 and the deep blue flowers are still in demand. It reaches a height of 4' and is one of the more commonly offered cultivars.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Feltham Pride’ has deep blue flowers and grows about 3' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Little John’ is a compact version of the species (1 1/2' tall) with dark blue flowers and a compact habit.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Loddon Royalist’ is still the most popular and most available cultivar today. Plants grow about 3' in height and have lovely gentian-blue flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Morning Glory’ bears gentian-blue flowers on 4' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Opal’ was raised in 1906 and has azure blue flowers. This and ‘Dropmore’ are untidy in habit and occupy a great deal of garden space.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Royal Blue’ is similar to ‘Loddon Royalist’ but has a deeper blue color.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Andropogon")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Bluestem")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Poaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Grasses never go away, they only go to seed. The movement to ornamental grasses has continued unabated for years, and the inclusion of our prairie grasses into mainstream gardens simply accentuates the trend. There are number of bluestems, most are tall and rangy, but with the introduction of a few cultivars, gardeners and landscapers are more ready to try them out. Once established, they are all extremely drought tolerant and are favorites for reclamation purposes. Grow in full sun, mow or cut back hard in early spring.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The common name bluestem is often confused with little bluestem, "), _c('em', [_vm._v("Schizachyrium scoparium")]), _vm._v(" (which see).")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("- gerardii")])])]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Big Bluestem, Turkey Foot Grass")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("5-7'/4'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Tan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("America")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Its height lends the plants more towards windbreaks, or along highways for erosion control, than in the garden. However, its reliable cold hardiness and drought tolerance have also made it a favorite for large landscapes and naturalizing areas such as meadows. Plants are essentially clump formers, although in warmer areas of the country like parts of Texas, they tend to be more rhizomatous. They are gaining popularity as landscape plants because of quick growth and the blue-green foliage that turns a handsome red in late fall. The summer flowers are formed on branched inflorescences, which some say resemble turkey feet, then are followed by drooping seed heads. Both the seed heads and the flowers make useful cut stems for drying.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_84"
    }
  }), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_c('strong', [_vm._v("Cultivars:")])])]), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Niagara’ has been selected for vigorous growth and tolerance to moist soils. Used mainly in conservation sites, but handsome in their own right. They grow up to 7' tall and sport red coloration in the fall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pawnee’ was introduced to gardeners because it is only 4-5' tall, somewhat shorter than the species. Plants have a little darker green foliage and often take on a handsome red tinge in the fall.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. capillipes")]), _vm._v(", sometimes called chalky bluestem, bears narrow bluish foliage that turns a bronzy red in the fall. Plants grow 2-4' tall in clumps and do not spread aggressively. The silvery flowers occur in late summer and persist into the fall. Plants are native to warm areas in the southeastern U.S. and cold hardy only to zone 7. ‘Valdosta Blue’ was found by Bob McCartney near Valdosta, Georgia, and has deeper blue foliage than the species.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. glomeratus")]), _vm._v(", bushy bluestem, broom grass, is tolerant of moist soils, rather unusual in this genus, and is a clump-forming grass. I think the broomlike inflorescences (hence the common name) and the habit make this a far more attractive and user-friendly species than big bluestem. The bronze to red foliage color and the soft flowers make it a winner even in the winter. Plants are not without problems; they are still big (4-6' tall), and can reseed, so some caution is needed. Clumps should be cut to the ground in early spring. Zones 3-8.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Androsace")])]), _vm._v(" (an-dros' a-kee)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Rock Jasmine")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Primulaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("This relatively unknown group of plants consists of more or less xerophytic, low-growing alpines, all of which require excellent drainage. They are grown for their open, flat-faced flowers with a marked eye, borne over tight rosettes of leaves. In general, they prefer light sandy soils, low nutrient status, and good air movement. Most of the 100 or so species perform well in full sun, although "), _c('em', [_vm._v("A. geraniifolia")]), _vm._v(" is best in partial shade. While no species in this genus relishes the hot humid summers so common to the eastern United States, "), _c('em', [_vm._v("A. sarmentosa")]), _vm._v(", "), _c('em', [_vm._v("A. carnea")]), _vm._v(", "), _c('em', [_vm._v("A. lactea")]), _vm._v(" and "), _c('em', [_vm._v("A. lanuginosa")]), _vm._v(" are a little more forgiving. "), _c('em', [_vm._v("Androsace")]), _vm._v(" is most popular with gardeners on the West Coast and in Plains states where temperatures are cool and/or rainfall is limited.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species and Hybrids:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A few species and cultivars are offered by mail order nurseries as well as a few retail garden centers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. brigantiaca")]), _vm._v(" is larger, more robust and bears white flowers. "), _c('em', [_vm._v("A. carnea")]), _vm._v(" is a 4\" tall tufted ground cover with white or pink flowers. The species, along with the subspecies "), _c('em', [_vm._v("laggeri")]), _vm._v(" and "), _c('em', [_vm._v("rosea")]), _vm._v(" have all earned Medal of Honor awards from the RHS Garden Wisley in England. "), _c('em', [_vm._v("A. pyrenaica")]), _vm._v(" has gorgeous white flowers with a yellow eye.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("Hybrids between "), _c('em', [_vm._v("A. carnea")]), _vm._v(" and "), _c('em', [_vm._v("A. pyrenaica")]), _vm._v(" have become more popular in recent years. ‘Callisto’ bears white flowers with a red eye, ‘Jupiter’ produces white flowers ")]), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_vm._v("with a dark red eye, ‘Millstream’ bears light pink flowers, ‘Rhapsody’ has clean pink flowers with a red eye, and ‘Venus’ bears many white flowers, each with a small yellow eye.")])]), _c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. sarmentosa")]), _vm._v(" is offered by most nurseries that sell plants of this genus. Plants produce hairy, silver rosettes in early spring, later becoming less hairy. Plants spread by stolons to make a small patch and bear pink flowers with tiny yellow eyes. Most grow about 6\" tall. The variety "), _c('em', [_vm._v("chumbyi")]), _vm._v(" is more dwarf (about 3\") and bears deeper pink flowers. "), _c('em', [_vm._v("A. villosa")]), _vm._v(" is densely tufted with rosettes that look like little cushions, and usually bears lots of shaggy hairs on the leaves. Flowers are pink to white; var. "), _c('em', [_vm._v("jacquemontii")]), _vm._v(" bears pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Anemone")])]), _vm._v(" (a-nem' o-nee)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Windflower")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Ranunculaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Talk about a diverse genus! "), _c('em', [_vm._v("Anemone")]), _vm._v(" consists of approximately 100 species, from fibrous to tuberous rooted forms, from spring- to fall-flowering species. They are enjoyed around the world as greenhouse potted plants, florist cut flowers and garden plants. In 1629, John Parkinson wrote in "), _c('em', [_vm._v("Paradisi")]), _vm._v(" that “the sight of them doth enforce an earnest longing desire in the minde of anyone to be a possessour of some of them at the least, for ... is of it selfe alone almost sufficient to furnish a garden with their flowers for almost halfe the yeare ...”. Most species have compound leaves and apetalous (no petals) flowers, most of the color the result of the showy sepals. Three main groups of "), _c('em', [_vm._v("Anemone")]), _vm._v(" occur, based on their rootstalks and growth habit.")]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('strong', [_vm._v("Rootstalk")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('strong', [_vm._v("Flowering time")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('strong', [_vm._v("Examples")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Fibrous")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Late summer, fall")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. hupehensis, A")]), _vm._v(". x "), _c('em', [_vm._v("hybrida")]), _vm._v(",")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. tomentosa")]), _vm._v(", "), _c('em', [_vm._v("A. vitifolia")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Tuber, rhizomes")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("spring")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. blanda")]), _vm._v(", "), _c('em', [_vm._v("A. canadensis")]), _vm._v(",")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A.")]), _vm._v(" x "), _c('em', [_vm._v("lesseri, A. nemorosa, A. sylvestris")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Tuberous rooted")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("spring, early summer")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. coronaria")]), _vm._v(", "), _c('em', [_vm._v("A.")]), _vm._v(" x "), _c('em', [_vm._v("fulgens")]), _vm._v(", "), _c('em', [_vm._v("A. pavonia")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The tuberous types ("), _c('em', [_vm._v("A. blanda")]), _vm._v(", "), _c('em', [_vm._v("A. coronaria")]), _vm._v(") are best planted in mid to late October, approximately 3\" deep. All species appreciate shelter from the afternoon sun and do poorly if allowed to dry out. The early spring-flowering tuberous species usually become dormant by the time the hot sun of the summer arrives.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Confusion reigns about those ubiquitous Japanese anemones, which include a complex of closely related plants, none of which originated in Japan. It makes more sense to call them fall-flowering anemones. They include "), _c('em', [_vm._v("A. vitifolia")]), _vm._v(", "), _c('em', [_vm._v("A. tomentosa")]), _vm._v(", "), _c('em', [_vm._v("A. hupehensis")]), _vm._v(" and "), _c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("hybrida")]), _vm._v(" and are all vigorous growers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagation by seed is possible but for most, division is the quickest and surest method of multiplication. For tuberous/rhizomatous species, the tubers may be lifted in early June and divided. Ripe seed should be rubbed in dry sand to remove the cottony down adhering to the seed. The autumn-flowering forms are easily increased by division in the fall. Root cuttings of the fibrous forms are commonly employed to propagate those species.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_86"
    }
  }), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Anemone Species")])])]), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Root")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Number of sepals")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower color")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flowering time")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. blanda")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-8")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Tuber")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("9-14")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Blue")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Early spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. canadensis")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("12-24")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Rhizome")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("4-5")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. coronaria")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("7-15")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Tuber")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-20")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Various")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Early spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("hybrida")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("30-48")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Rhizome")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-11")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White, pink")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Fall")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. multifida")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-8")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Rhizome")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("5-10")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Early spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. nemorosa")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-8")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Rhizome")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("5-9")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Spring")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. sylvestris")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("10-18")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Rhizome")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("5-8")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Spring")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-blanda")])]), _vm._v(" (blan' da)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Grecian Windflower")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-8\"/8\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Sky Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Greece")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Grecian windflower is one of the earliest harbingers of spring. The plants’ small stature makes them suitable for naturalizing or for filling in small areas of the garden. Fernlike foliage arises from an oval tuber, followed by the flower. The narrow sepals are about 1/2\" long and the flowers nearly 2\" across. The flowers last but 2 weeks and then give rise to hairy seed heads known as achenes. These fruiting bodies persist for 3-4 weeks but are not particularly attractive and should be removed unless seeds are being collected. Although the flowers of the species are dark blue, cultivars are available in sky blue, white, pink or purplish red. Plant the tubers 1-3\" apart in dappled shade and in soil amended with organic matter. In the South (south of zone 6), plants do not spread as rapidly as in the North nor are they as long-lived. Regardless, plants will flower the first spring after planting, but one to two years is necessary to fully establish the tubers in the garden, especially if dried out when purchased. Once established, plants will self-sow and the seedlings will flower the next year. However, after all is said and done, given marauding critters like squirrels, chipmunks and voles combined with heat, drought and cold, an expectation of more than 3 years may be a tad unrealistic. They are inexpensive, buy some each year. Provide winter protection in zone 4 with leaves or pine boughs.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Charmer’ produces deep rose flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Blue Star’ has dark-blue flowers about 2-2 1/2\" in diameter.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bridesmaid’ and ‘White Splendor’ both bear flowers of pure white. There is little difference between them.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pink Star’ and ‘Rosea’ have differing shades of purple. The former has larger flowers than the latter.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Radar’ is one of the finest cultivars and has large mauve flowers with white centers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Violet Star’ bears violet flowers with white centers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘White Splendour’ has lovely single creamy white flowers.")])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_87"
    }
  }), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0088-01.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Anemone blanda")])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-canadensis")])]), _vm._v(" (kan-a-den' sis)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Meadow Anemone")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("12-24\"/spreader")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Northern United States, Canada")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The common name is particularly appropriate because the species will spread and fill an entire meadow. That it is somewhat invasive is probably its only flaw, and if placed in a difficult corner or other area where it can run, it will reign supreme in the spring and into early summer. The light green leaves are 5-7 parted and broader than long. They are hairy beneath and the leaf segments are toothed. Each clear white flower is almost 2\" across and consists of 4-5 sepals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants do best in partial shade but tolerate full sun. It is native to low-lying areas and thus requires moist conditions to become established. As long as its exuberant habit can be enjoyed, this is an excellent plant for those who think they can’t grow anything.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate by division any time from May to September.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-coronaria")])]), _vm._v(" (ko-ro-nah' ree-a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Poppy Anemone")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("7-10\"/8\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Various")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Mediterranean")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 6-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Poppy anemone is similar to Grecian anemone in that it is planted as a tuber and generally available from bulb catalogs or in colorful containers at garden centers.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_88"
    }
  }), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_vm._v("Gardeners seldom see the actual species anymore, for it has been replaced with more colorful hybrids. All strains have finely divided foliage and rounded sepals in various colors. Regardless of the pedigree, they make lovely spring garden plants as well as excellent cut flowers. They may be planted in the North (zone 6) as late as October and in the South in November for early spring flowering. Further north than zone 6, pot the tuber at the beginning of March and plant outside after threat of frost, and flowers will emerge in late May and early June.")])]), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Research in Georgia (zone 7b) has shown that planting as late as December does not affect the number of flowers (4-5 flowers/plant). The flowering season was also extended a few weeks with late planting. However, plantings in January, February, and March resulted in very few flowers, all of questionable quality. This was probably because insufficient cold was accumulated by the tubers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This research also indicates that tubers are best treated as annuals, dug up and discarded after flowering. Flower production declines and tubers decline after two years in the ground. Like "), _c('em', [_vm._v("A. blanda")]), _vm._v(", tubers are inexpensive and can be replaced at nominal cost.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0089-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Anemone coronaria")]), _vm._v(" ‘De Caen’")])]), _c('p', {
    staticClass: "noindentp"
  }, [_c('a', {
    attrs: {
      "id": "page_89"
    }
  }), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_c('strong', [_vm._v("Cultivars:")])])]), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘De Caen’ hybrids were developed early in the 18th century around the Caen and Bayeux districts of northern France and became known as the De Caen anemones. The flowers are single, saucer shaped and available as ‘Florist Mix’ or as separate colors. ‘The Bride’, white; ‘Mr. Fokker’, violet-blue; and ‘Sylphide’, violet rose are only a few of the cultivars that were developed within the De Caen series. ‘Hollandia’ (syn. ‘His Excellency’) has scarlet sepals with white bases surrounding a black center and appears to be a cultivar of "), _c('em', [_vm._v("A. coronaria")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Mona Lisa’ series is a strain of poppy anemone that is much preferable to the ‘De Caen’ series. Separate colors as well as a mixture have been developed. The flowers are larger, the stems are 1 1/2 to 2 times longer and the vase life of the cut flowers is longer.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘St. Brigid’ series has semi-double flowers and is available as a mixture or in separate colors. ‘Lord Lieutenant’, purple blue, ‘Mt. Everest’, white, ‘The Admiral’, pink-red, and ‘The Governor’, crimson scarlet are available in this series.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-hupehensis")])]), _vm._v(" (hew-puh-hen' sis)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Japanese Anemone")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-4'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Fall")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Pink")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Japan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants are similar and often confused with "), _c('em', [_vm._v("A.")]), _vm._v(" x "), _c('em', [_vm._v("hybrida")]), _vm._v(". This species has 5-7 rosy-mauve sepals, grows 2-2 1/2' tall and flowers a week or so earlier than the hybrid. It is generally shorter and may produce flowers that lack fertile pollen. Plants with 10-20 narrow sepals were found in 1695 in Japan, and finally sent to England in 1844 by Robert Fortune where they were called "), _c('em', [_vm._v("A. japonica")]), _vm._v(". Its proper name has finally been established as "), _c('em', [_vm._v("A. hupehensis")]), _vm._v(" var. "), _c('em', [_vm._v("japonica")]), _vm._v(", and has never been found in the wild except where it has been introduced. However, many fine cultivars belong to this variant.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bodnant Burgundy’ has handsome dark flowers and stands 2-3' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bowles’ Pink’ is hard to find in this country but has shown excellent performance in Europe. Single pink to rose-colored flowers occur in the fall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bressingham Glow’ produces deep rose-pink semi-double flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Hadspen Abundance’ has pink-rose single flowers with dark and light pink petals, and prominent golden-yellow stamens on 3' tall plants. Plants arose from Hadspen House, England.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pamina’ has proven to be an excellent addition to the Gardens at UGA, showing tolerance to heat and student abuse. The semi-double rose-pink flowers consist of overlapping sepals, and persist for weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Prince Henry’ has deep rose, semi-double flowers stands nearly 3' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Splendens’ has purple to pink flowers and is quite early to flower, up to 2 weeks earlier than other cultivars in some climates.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('strong', [_vm._v("-x")]), _vm._v(" "), _c('em', [_c('strong', [_vm._v("hybrida")])]), _vm._v(" (hi-bred' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Hybrid Anemone, Japanese Anemone")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2 1/2-3'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Fall")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White, Pink")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Hybrid Origin")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_vm._v("The nomenclature of "), _c('em', [_vm._v("Anemone")]), _vm._v(" is rather confused but nowhere is it as befuddled as with Japanese anemone and the various hybrids, however, things are becoming ")]), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_vm._v("a little more clear. A few plants are still sold as "), _c('em', [_vm._v("A. japonica")]), _vm._v(", but those are actually hybrids. It now seems clear that almost all fall-flowering anemones have been lumped in this hybrid category, including favorites once classified as "), _c('em', [_vm._v("A. tomentosa")]), _vm._v(" and "), _c('em', [_vm._v("A. vitifolia")]), _vm._v(". So far, only the closely related "), _c('em', [_vm._v("A. hupehensis")]), _vm._v(" remains split from the hybrids. I research these names long and hard, but like a sack full of puppies, the name game moves all over the place. There is no universal acceptance of this latest lumping, and in the next edition, everything may be changed again. So don’t get too concerned, especially with this group, because regardless of the name, the late flowerers are wonderful garden plants.")])]), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("They are often slow to establish, but after the second or third year become free flowering and can often be overly aggressive. In the South, plant early in the fall to allow root establishment or early in the spring. Planting in midsummer is possible but often plants don’t establish well. They perform best in well-drained soils and partial shade.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagation by division in the spring can be accomplished and is the easiest means of moving plants around the garden and avoiding overcrowding. However, root cuttings are also effective. Take thick sections of root approximately 3-4\" long from lifted plants and place vertically in a moist well-drained medium. Cover the tops of the root sections with a thin layer of sand or vermiculite and place in a cold frame or unheated greenhouse. This method of propagation should be accomplished when the plants are dormant in the winter.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some absolutely wonderful hybrids are available and although my preferences in anemones reside with the single forms, many cultivars are available with semi-double or double flowers. The only defect with many of the cultivars is that they are 4-5' tall and may need some support to look their best.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alba’ bears single, clear white 2-3\" diameter flowers and stands 3' tall. This is often listed in catalogs but is probably the same as ‘Honorine Jobert’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alice’ has semi-double light pink flowers and is 2-2 1/2' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Andrea Atkinson’ is 3-4' tall with semi-double white flowers with chartreuse eyes. Plants bear handsome dark green foliage that makes the white flowers stand out even more.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Coupe D’Argent’ literally translates to “cut silver”.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Elegans’ is early to flower and bears light pink single flowers that can be extraordinary in bloom. Plants may stand up to 4' tall and carry dozens of single, 3-4\" wide, clean pink flowers. The cultivars ‘Albert Schweitzer’ and ‘Max Vogel’ have been lumped into ‘Elegans’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Elegantissima’ grows 3-4' tall and bears double rosy sepals. A tetraploid plant, it is very vigorous.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Honorine Jobert’ was a sport of the pink-flowered "), _c('em', [_vm._v("A.")]), _vm._v(" x "), _c('em', [_vm._v("hybrida")]), _vm._v(" discovered in the garden of M. Jobert in Verdun, France in 1858. It has graced European gardens since the beginning of the American Civil War and is still the most popular and highly sought-after white anemone today. It is 3-4' tall and the clean white sepals contrast beautifully with the yellow stamens in the center. The flowers are only 2-3\" across, not as large as some of the newer clones, but the plant is floriferous and worthy of a place in the garden. It is difficult to know if you are purchasing this cultivar or ‘Alba’.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_91"
    }
  }), _c('div', {
    staticStyle: {
      "height": "500px"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_91"
    }
  }), _c('p', {
    staticClass: "imagen"
  }, [_c('a', {
    attrs: {
      "id": "page_91"
    }
  }), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/f0092-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_92"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Anemone x hybrida")]), _vm._v(" ‘Robustissima’"), _c('br'), _vm._v("Leaf"), _c('br'), _vm._v("Flowers")])])]), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }), _c('p', {
    staticClass: "bibp"
  }, [_c('a', {
    attrs: {
      "id": "page_92"
    }
  }), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_vm._v("‘Kriemhilde’ is still one of the finest semi-double pink flowering cultivars available today with 10-15 broad overlapping sepals. Introduced in 1909.")])]), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Loreley’ is seen more often in Europe but sometimes finds its way over here. Flowers are 3-4' tall with silvery pink semi-double flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Luise Uhink’ was bred by the German nurseryman Wilhelm Pfitzer, but is little known in this country. This is unfortunate as it has 3-4\" diameter semi-double white flowers on 4' tall stems and is a prolific flowerer.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Margarete’ has semi-double to double deep pink flowers and is about 2-3' tall. Sterile flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Montrose’, introduced in 1899, bears semi-double to double deep rose sterile flowers on 3' tall stems. Flowers consist of about 40 slightly twisted narrow sepals. The cultivar ‘Lady Gilmour’ has been determined to be the same thing.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Queen Charlotte’ bears lovely pink semi-double flowers which measure 3\" across. The tips of the sepals have a ragged appearance. It grows about 3' tall and was also bred by Pfitzer in Germany.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Richard Ahrens’ produces pink-lilac single to semi-double flowers that fade to almost white.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Robustissima’ produces mauve-pink flowers held well above the foliage. The leaves are gray-green underneath. It is more winter-hardy than the species and can be grown in zone 4. Plants are robust, to the point of thuggery, in the shade, better behaved and quite tolerant of full sun. Plants are still offered as "), _c('em', [_vm._v("A. tomentosa")]), _vm._v(" ("), _c('em', [_vm._v("A. vitifolia")]), _vm._v(") ‘Robustissima’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘September Charm’ is quite popular and with good reason. Plants produce an abundance of single rose-pink flowers that are darker on the outside than inside. Plants used to be classified as "), _c('em', [_vm._v("A. hupehensis")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Victor Jones’ has single rose-pink flowers held up by 3-3 1/2' tall purple stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Whirlwind’ is 4-5' tall and produces 4\" wide semi-double pure white flowers consisting of 20-30 narrow flattened sepals.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘White Giant’ grows to 4' tall and produces large semi-double flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-multifida")])]), _vm._v(" (mul-tee' fi-da)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Magellan Anemone")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-8\"/6\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Chile")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 2-6")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The main claim to fame of this low-growing garden species is that it is one of the most cold-tolerant species of this genus, allowing gardeners from Alaska to North Carolina to enjoy it. The hairy leaves are much divided and plants are covered with numerous 1\" creamy-white flowers on 12\" long scapes. The seed heads (achenes) are densely hairy. Culture is not difficult in sun or light shade.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Annabelle White’ grows about 12\" tall and is covered with creamy white flowers in early summer.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_93"
    }
  }), _c('div', {
    staticStyle: {
      "height": "500px"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_93"
    }
  }), _c('p', {
    staticClass: "imagen"
  }, [_c('a', {
    attrs: {
      "id": "page_93"
    }
  }), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/f0094-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_94"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Anemone")]), _vm._v(" ‘September Charm’")])])]), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-nemorosa")])]), _vm._v(" (nem-o-ro' sa)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Wood Anemone")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-8\"/8\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Wood anemones are widely distributed in Europe, absent only in the more southerly Mediterranean areas, so it should not be surprising that plants are extremely variable in size, color, and even structure of the flowers. There are usually 5-8 sepals, but forms lacking sepals, and those with 50 or more are known. The flowers are about 1 1/2-2\" wide and often tinged rose on the margins. The solitary stems bear leaves halfway up, and terminate in a solitary flower. The common flower color is white, but a number of clones have blue or pink flowers and a yellow-flowered variant has also been described.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The foliage is three times divided into deeply toothed linear segments. Plants arise from a wormlike rhizome that branches extensively beneath the ground. "), _c('em', [_vm._v("A. nemorosa")]), _vm._v(" performs best in slightly acid soil (pH 5.5-6.5) containing liberal amounts of peat or leaf mold and in dappled to deep shade. Plant in fall only.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many cultivars and varieties have been described but not all are easily found.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Blue flowers:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("allenii")]), _vm._v(" is about 1' tall and has large (2\" diameter), deep lavender-blue flowers. The reverse is streaked with purplish red dots of varying intensity.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Blue Beauty’ is the tallest of the blue forms growing 15-18\" in height and bears perfect sky blue cup-shaped blooms. It is the best blue form of the species.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bowles’ Mauve’ has lavender-blue flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("caerulea")]), _vm._v(" is about 6\" tall with sky blue 3/4\" wide flowers. The flower reverse is paler blue. Perhaps all the blue forms should be lumped under this category, as there is little difference between them.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Robinsoniana’ has 1 1/2\" diameter bright lavender-blue flowers. It grows 12-14\" tall and is one of the oldest varieties still offered by perennial growers. Probably discovered by William Robinson in Oxford Botanical Garden, having “been sent there by a lady in Ireland”.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_vm._v("Pink flowers:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("rosea")]), _vm._v(" is 10-14\" tall and carries nodding 1\" wide light rose flowers with a paler reverse. It is slow to increase vegetatively and seed production is poor.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_vm._v("White flowers:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Flore Pleno’ (‘Alba Plena’) stands 10\" tall and has semi-double to double flowers. It is an excellent garden plant.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("grandiflora")]), _vm._v(" has the largest flowers, sometimes attaining 3\" in diameter. Plants are vigorous and grow 20\" tall in rich soil.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Lady Doneraile’ is similar to ‘Lychette’ but only 10\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Lychette’ is one of the best white-flowered cultivars, bearing large 2\" diameter flowers that are pure white above and beneath. There are green blushes around the bases of the 6-8 sepals. I have seen plants grow up to 20\" tall, but they are normally 10-12\" in height.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_vm._v("‘Vestal’ has pure white sepals surrounding a center filled with broad stamen filaments (petaloid stamens). Closely resembles ‘Flore Pleno’ but the flowers are larger ")]), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_vm._v("and petaloid segments are more regular. They are different but in commerce, I am not sure what is being sold out there.")])]), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Viridifolia’ is for those gardeners who can’t get enough green. Flowers consist of dozen of green bracts making it look like the Jolly Green Giant on a bad hair day. However, since it flowers in early spring, there is not a lot of green competition at the time, so it is certainly interesting.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-sylvestris")])]), _vm._v(" (sil-ves' tris)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Snowdrop Anemone")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("10-18\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have been in a Denver snowstorm in March and the next day seen these plants push through the white stuff as if it were no more than a minor nuisance. One of the prettiest spring anemones, it combines light green, 3-5 parted leaves with fragrant 1 1/2-2\" diameter, dainty, white flowers. The 5-sepaled flowers are slightly nodding when fully open and are solitary on the flower stalk. The lovely flowers give way to interesting white, woolly fruit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. sylvestris")]), _vm._v(" requires light soil and a partially shaded area for best performance. The major drawback is that it runs freely, particularly in loose soils, and can overrun less aggressive plants. Plantlets, however, are not difficult to remove and gardening friends will be more than happy to accept a few. It visits me every now and then in Athens, but without doubt is more comfortable in Denver and Montreal. Cold weather is to its liking and it is more aggressive in northern climates than in the South.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Compacta’ is offered by a few nurseries and is a more dwarf, more compact form of the species. I have never found the species to be particularly large or in need of compaction, but such is the benefit of diversity.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("macrantha")]), _vm._v(" has larger and more abundant flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Elise Feldman’ is a relatively new introduction with almost fully double white flowers in the spring. The flowers are quite heavy and may fall over in inclement weather. Similar to ‘Flore pleno’, perhaps more consistent.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Flore pleno’ is a double-flowered white cultivar but is not nearly as pretty as the species.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dozens of species and hybrids are sold and can be dramatic additions to the garden. Most are more difficult to locate, and some may disappoint a little, but for the anemone enthusiast, there is no such thing as a bad anemone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. altaica")]), _vm._v(" is a tuberous form native to northern areas of Russia and the Arctic and therefore particularly cold hardy. Plants are about 8\" tall and bear single white flowers with blue or purple veins in the spring. Great for the rock garden.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. apennina")]), _vm._v(", Apennine windflower, is also tuberous and has a similar form to "), _c('em', [_vm._v("A. altaica")]), _vm._v(", but is not as cold hardy. Plants have larger leaves and bright blue spring flowers with yellow stamens.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. leveillei")]), _vm._v(" has kidney-shaped leaves basal leaves divided into three sessile lobes, each divided deeply. Plants grow 15-18\" tall. The 1-2\" wide white flowers are stained blue to pink on the outside. Hardy to about zone 6.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_96"
    }
  }), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_c('em', [_vm._v("A. multifida")]), _vm._v(" is native from Alaska to Quebec and Saskatchewan and south to California and Colorado. This fine native species forms 8-12\" high mounds of light green delicately cut foliage with two to three long stalked yellowish flowers in early spring. Flowers may be clear red or tinged with blue or purple. The styles are red or pink, and silky seed heads add additional interest after flowering. Some handsome colonies occur in the alpine area of the Denver Botanic Garden. ‘Major’ is better than the species due to the larger creamy yellow flowers. ‘Magellanica’ is taller, growing 18-24\" in height. Plants perform well in zones 3 to 6 as well as in the Northwest. Poor choices for the South.")])]), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. narcissiflora")]), _vm._v(", native to the mountains of Europe and Japan, grows about 12-18\" tall over deeply divided foliage. Plants bear 2-6 white to cream-colored flowers in an umbel in the spring. Each flower is about an inch wide. Plants do well in zones 4 to 7a.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. pavonina")]), _vm._v(" is native to southern Europe, mainly around the Mediterranean, and also arises from a tuber. Plants grow about 9-12\" tall and bear solitary 2-3\" wide flowers in the spring. The flowers, consisting of 7-9 segments, are often scarlet, however pink, purple and violet colors occur.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. quinquefolia")]), _vm._v(", American wood anemone, was initially considered to be a variety of "), _c('em', [_vm._v("A. nemorosa")]), _vm._v(" ("), _c('em', [_vm._v("A. n")]), _vm._v(". var. "), _c('em', [_vm._v("quinquefolia")]), _vm._v("). It is native from Quebec to Georgia and common in moist rich woodlands. The white flowers are 3/4-1\" across and appear in spring.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. rivularis")]), _vm._v(" is native to India and China and grows up to 3' tall in zones 5-7. The white flowers are stained blue throughout and are borne in 3-5 flowered umbels in late spring and summer. It is a terrific plant, particularly suited around semi-shaded ponds and water features.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. rupicola")]), _vm._v(" is another white-flowered species with blue or pink staining on the sepals but is only about 6-9\" tall. The basal leaves are three parted and strongly lobed while the solitary flowers are up to 2-3\" across. Hardy in zones 4-7.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. virginiana")]), _vm._v(", thimbleweed, is a native woodland species with greenish white to white 1\" wide flowers. The early spring flowers usually occur in 3's and consist of 5 sepals. Plants grow about 2' tall and are particularly suited to the woodland garden. Thimbleweed is hardy from zones 3 to 7.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Anemonella")])]), _vm._v(" (a-nem-o-nell' a)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Rue-anemone")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Ranunculaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("The rue-anemones have to be one of the prettiest diminutive woodland plants for the garden. They are native to a large slice of North America, from southwest Maine to northern Florida, west to Minnesota and Oklahoma. The genus is represented by "), _c('em', [_vm._v("A. thalictroides")]), _vm._v(" only. Many taxonomists have transferred the species to "), _c('em', [_vm._v("Thalictrum")]), _vm._v(" ("), _c('em', [_vm._v("T. thalictroides")]), _vm._v(") but the jury is still out, so I’ll leave it here for now. Plants with an eastern nativity tend to be white but as the plants extend west, flowers appear to have more pink in them.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_vm._v("In woodland gardens throughout the eastern United States, rue-anemone is a welcome and familiar sight in early spring. And in the Armitage garden, plants compete with the roots of a large white oak without complaint, and make the base of that noble tree even better. Plants grow about 8-10\" tall and bear foliage similar to anemone, except much daintier and finer. They are blue-green, basal and 1-2 ternate, ")]), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_vm._v("each terminal leaflet being 3-toothed at the apex. The 1/2\" wide flowers are arranged in 2-5 flowered umbels and consist of 5-10 petal-like sepals and numerous stamens. There are no petals.")])]), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0098-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Anemonella thalictroides")])]), _vm._v(" "), _c('p', {
    staticClass: "indentp"
  }, [_vm._v("They love to be grouped in partially shaded areas with moisture-retentive soils. If they dry out, they look ratty early. With the exception of slugs, few diseases or insects bother them. Plants are hardy in zones 4-9. By the way, the suffixes “opsis”, “ella” and “oides” means “looks like”; this plant resembles both an anemone and a thalictrum.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate by seed or division of well-developed clumps.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There has been an explosion of cultivars in the last few years. None of them is inexpensive but I see an “Anemonella Stage of Life” coming to a few gardeners.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Betty Blake’ produces light green to yellow green double flowers and flower for a long period of time.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Cameo’ is a light pink-flowered double form. They are similar in form to ‘Schoaf’s Double Pink’ but differ by having much lighter-colored flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Double White’ is similar to ‘Cameo’ but with cleaner white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Eco Pink’ from Don Jacobs of Eco-Gardens in Decatur, Georgia, has single pink flowers.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_98"
    }
  }), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_vm._v("‘Eco Starry Night’ has unique pointed sepals and bronzy foliage. Quite different.")])]), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Eco Atlas Double’ bears white pompon double flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("favilliana")]), _vm._v(" is a handsome double white form. Flowers persist much longer than the species but plants are slow to increase. Difficult to locate.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Jade Feather’ is also known as ‘Green Dragon’ or ‘Green Hurricane’. Regardless of the name, they are scary. The plants produce strange double flowers with twisted green sepals.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Rosea’ bears single light pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Schoaf’s Double Pink’ bears double rose-pink flowers. It was the result of a chance sighting by a Mr. Oscar Schoaf in a graveyard in Owatonna, Minnesota. While Mr. Schoaf brought the plants into cultivation in his garden, it was Mrs. Louise Koehler of Bixby, Minnesota who sent plants to friends and nurseries and so brought the plant out of obscurity. Propagated only by division, plants are slow to increase but now are relatively easy to locate. Like other anemonellas, they are expensive, but they are worth the hunt. They are stunning in Garden in the Woods, Framingham, Massachusetts.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Tairin’ has deep pink to rose single flowers and performs well for a long period of time in the spring.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Anemonopsis")])]), _vm._v(" (a-nem-o-nop' sis)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("False Anemone")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Ranunculaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("As I stared at this plant in a shady Cleveland garden, I knew the glossy foliage looked like an anemone but I couldn’t for the life of me place the flowers. All I could say to my inquisitor about this most handsome plant was that it looked like an anemone. It turned out to be a pretty good guess when one considers that the name "), _c('em', [_vm._v("Anemonopsis")]), _vm._v(" is translated “resembles anemone”. Only one species, "), _c('em', [_vm._v("A. macrophylla")]), _vm._v(", native to Japan, has been described and it is occasionally offered by specialty nurseries. The 1\" wide waxy lavender-pink flowers are held in loose racemes well above the glossy green basal leaves. The pendulous flowers occur in late summer and are particularly lovely if plants are planted on a bank where the flowers can be viewed from beneath. Partially shaded, moist conditions serve plants well. A terrific garden plant, they likely perform well in zones 4-7. Propagate from seed or division.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Angelica")])]), _vm._v(" (an-gel' i-ca)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Angelica")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Apiaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("Plants are better known for their medicinal properties than as an ornamental garden plant. The 50 or so species are found in the northern United States and Canada to Japan and Europe. In general, they are tall and stout, and at home in semi-shaded moist areas. The leaves are in 3’s (ternate) to pinnate and the petioles are usually sheathed around the stem. The garden forms available are impressive but often short lived.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick reference to Angelica Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (ft.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower color")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. archangelica")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("5-6")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Creamy-white")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. gigas")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3-5")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Purple")])])])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_99"
    }
  }), _c('a', {
    attrs: {
      "id": "page_100"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-archangelica")])]), _vm._v(" (ark-an-gel' i-ka)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Wild Parsnip")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("5-6'/4'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Creamy-white")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe, Asia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Say the name "), _c('em', [_vm._v("Angelica archangelica")]), _vm._v(" a few times and it begins to take on poetic qualities of its own. The specific name came from the Archangel Raphael. As you know archangels are high-ranking angels, and Raphael was charged to heal the earth. St. Raphael has a special charge of protecting the young, the innocent, and travelers. The Feast of St. Raphael is October 24.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The plant has been cultivated for generations in Asia and Europe for its confectionery properties and as a vegetable. The stems and petioles may be crystallized for candying and the young shoots are prepared similar to asparagus or cooked with rhubarb, to reduce the tartness. However, let not your taste or lack of it for rhubarb limit the use of this plant! As a cultivated plant, it lends a stateliness of its own to the garden. The large, flat, creamy-white to greenish compound umbels are handsome enough but the resulting seed heads can be absolutely majestic. These large plants can take over an area and will reseed if allowed to do so. Plants are monocarpic, meaning they die after seeding. Some gardeners have found that removing the flowers before they go to seed increases the chance of perennialization. Seedlings require two years to flower.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-gigas")])]), _vm._v(" (gee' gas)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Purple Parsnip")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-5'/4'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late summer, Fall")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Purple")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Japan, Korea, China")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Introduced to this country from Korea by Barry Yinger of Asiatica Nursery, this large coarse plant never fails to draw attention when in flower. The light green leaves are attached to the thick stems with inflated purple sheaths. The flowers are deep purple, in umbels 3-4\" across. Similar to the above species, the drying seed heads are also magical. Although tolerant of shade, if placed in too heavy shade, the dark flowers get lost. Plants love moisture and will be stunted in dry summers. Only recently finding its way into American nurseries, this is an exciting biennial plant for the late summer and fall garden. Plants will self-sow in favorable conditions and may be considered a “perennial biennial”. Seed-grown plants generally require two years before flowering. In the shaded Armitage garden, plants were magnificent in June into July although the seed heads never developed as well as I would have liked. The quality of the seed heads increases with sunny areas, cool night temperatures and low humidity.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. keiskei")]), _vm._v(", otherwise known as ashitaba, is a medicinal herb from Japan. I grew this in the Gardens at UGA and was most impressed with the ornamental value. The plants were robust, but compact, never growing taller than 2 1/2'. However, the foliage was glossy, shiny green and always caught the eye. Plants shone even more as temperatures became cooler and in our zone 7 climate were at their best in the fall, winter and spring. The flowers were white. Most of the time plants behave like a biennial and once flowered, it will disappear. However, I have seen this in John Elsley’s garden in Greenwood, South Carolina and he claims it was there for at least three years.")])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_100"
    }
  }), _c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0101-01.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Angelica gigas")])]), _vm._v(" "), _c('p', {
    staticClass: "indentp"
  }, [_c('em', [_vm._v("A. pachycarpa")]), _vm._v(" also has glossy green leaves and is also a biennial. Leaves are smaller and plants are more branched. Plants grow 4-6' tall, and are wonderfully ornamental.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Antennaria")])]), _vm._v(" (an-ten-ar' i-a)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Pussytoes")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Asteraceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("About 15 species are used in gardens, primarily because of the gray foliage that carpets the ground. The flowers are dioecious, meaning that male and female occur on separate plants. The actual flowers are nondescript but are surrounded by dry, chaffy scales which provide the color. However, the gray foliage is the most valuable garden asset.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_vm._v("Plants tolerate poor infertile soils and hot, dry locations. They are best suited for the front of the garden or rock garden. Pussytoes are gaining a steady following due to their toughness, their well-behaved habit and the gray-silver foliage. Some of the more common forms are native to Europe, however, a number of good species call ")]), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_vm._v("North America home. "), _c('em', [_vm._v("A. neglecta")]), _vm._v(" var. "), _c('em', [_vm._v("gaspensia")]), _vm._v(" is one of the neatest, bearing small silvery leaves on 2-3\" tall ground-hugging mats over which rise silvery-white flowers. "), _c('em', [_vm._v("A. parvifolia")]), _vm._v(", Contock pussytoes, native to southwest Canada and the western United States is also an excellent rock garden plant.")])]), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-dioica")])]), _vm._v(" (die-o-i' ka)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Common Pussytoes")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("4-10\"/18\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants send up crowded corymbs of light green flowers with pinkish tips that resemble the toes of your favorite pussycat. The spatulate basal leaves are about 1\" long and gray-green (some call them silver). The foliage becomes less gray-green as the season progresses and may be almost green by midsummer. The stoloniferous plants fill in rapidly and are occasionally used as an herbaceous lawn by more creative gardeners. If not used as a ground cover, they should be divided every 2 years. Plants are tolerant of poor soil but good drainage is necessary to reduce root rot.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate by division in the spring or by seed. The seeds are small and should be mixed with fine sand to insure even distribution in the seed tray. Provide temperatures of about 72-75°F and maintain consistent soil moisture. Transfer seedlings to 60°F conditions for subsequent growth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Devil’s Tower’ is about 4\" tall with silver leaves and pink flowers. Available from seed.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("hyperborea")]), _vm._v(" (var. "), _c('em', [_vm._v("tomentosa")]), _vm._v(") produces wide, densely hairy leaves.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("minima")]), _vm._v(" (‘Minima’) is only about 1\" tall and forms a dense carpet. Best for containers or sunny rock gardens.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("minima rubra")]), _vm._v(" is similar to the above but bears rosy red flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Nyewood’ is a more compact and slower-growing form than the species. The cherry-red flowers cover the tight silver-gray leaves in late spring to early summer. About 3\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("rosea")]), _vm._v(" (‘Rosea’) and var. "), _c('em', [_vm._v("rubra")]), _vm._v(" (‘Rubra’) have pink and rosy red flowers respectively and are 8-10\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. plantaginifolia")]), _vm._v(", ladies’ tobacco, is an interesting if not dramatic native species. The basal rather smooth leaves have three to seven conspicuous veins, resembling those of plantain. From this basal rosette arise the light tan tight flower heads on 8-12\" tall stems, which slowly form a colony of gray-green foliage. Useful in zones 3 to 7.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. rosea")]), _vm._v(" ("), _c('em', [_vm._v("A. dioica")]), _vm._v(" ‘Rosea’), rose pussytoes, is the most common offering and produces rose-pink flowers on 8\" tall plants. The leaves are a little thinner than those of "), _c('em', [_vm._v("A. dioica")]), _vm._v(". The fluffy rose-pink flowers rise well above the permanently gray-green foliage in late spring and early summer. Native to the mountains of western North America.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. rupicola")]), _vm._v(" is native to the northeastern United States and forms 2-3\" tall loose mats of gray-green foliage which turn beet red in the fall.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_102"
    }
  }), _c('a', {
    attrs: {
      "id": "page_103"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Anthemis")])]), _vm._v(" (an' them-is)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Golden Marguerite")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Asteraceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of the 80 species in the genus, only a few are worth growing and fewer yet are easily available in the United States. All have strongly scented, alternately arranged foliage that is divided 2-3 times. Flowers of some species such as "), _c('em', [_vm._v("A. punctata")]), _vm._v(" are white, and many hybrids also\nsport white ray flowers. However most of the species of anthemis have yellow or orange flowers borne singly on long stems. All need full sun and well-drained soils for best results. Most tolerate relatively poor soils and, in fact, become too leggy if fertilized heavily. The genus is most suitable for northern climates and while "), _c('em', [_vm._v("A. tinctoria")]), _vm._v(" prospers during spring and early summer in southern gardens, it usually collapses into a messy heap making it rather useless south of zone 7.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagation is easy by division and is necessary within 2-3 years for all species listed. Seeds germinate readily and are available for some cultivars of "), _c('em', [_vm._v("A. tinctoria")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Anthemis Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Foliage color")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower color")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. punctata subsp. cupaniana")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-9")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Gray-green")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. marschalliana")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("12-18")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Silver-green")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yellow")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. tinctoria")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("24-36")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Green")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yellow")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-punctata")])]), _vm._v(" (punk-tah' ta)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Sicilian Chamomile")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("8-12\"/36\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Italy")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The species is handsome enough but the only plant offered is subspecies "), _c('em', [_vm._v("cupaniana")]), _vm._v(". Scientists have been battling over this plant for a good while but for now, this is its taxonomic slot. Plants form sprawling gray-green mats that remind me of lacy artemisia and provide wonderful contrasts to other plants in the garden. They are most useful as edging or placed strategically at the front of the border or as an integral part of the rock garden.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The 1-2\" diameter white daisies consist of 20-25 rays around yellow centers and are borne on 10-12\" stems. The flowers are nothing to write home about but the contrast with the ferny, aromatic leaves is terrific. This subspecies remains relatively compact compared to others in the genus. Good drainage helps prevent plants dying during cool, rainy winters. If plants are not in flower and you are not sure if you are looking at "), _c('em', [_vm._v("Anthemis")]), _vm._v(" or "), _c('em', [_vm._v("Artemisia")]), _vm._v(", simply smell the foliage. The characteristic artemisia scent is totally lacking.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-marschalliana")])]), _vm._v(" (mar-shal-ee-ah' na)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Marschall’s Chamomile")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("12-15\"/24\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Caucasus")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_vm._v("Plants are dressed in finely divided silvery foliage atop which are borne 1-2\" diameter golden yellow daisy flowers. The pinnately segmented foliage has long hairs and is silky to the touch. If spent flowers are removed immediately, flowering will continue ")]), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_vm._v("throughout the summer. This is a better species for the South than "), _c('em', [_vm._v("A. tinctoria")]), _vm._v(". Excellent drainage is necessary and full sun is best but some afternoon shade is tolerated. subsp. "), _c('em', [_vm._v("biebersteiniana")]), _vm._v(", named for Baron Friedrich August Marschall von Bieberstein, is even more silvery and more compact.")])]), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-tinctoria")])]), _vm._v(" (tink-to' ree-a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Golden Marguerite")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-3'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is the most common "), _c('em', [_vm._v("Anthemis")]), _vm._v(" available and, with proper culture, is a magnificent plant in the northern United States and Canada. The 3\" long toothed leaves look a little like parsley and are somewhat downy beneath. The stem is not round but angled and the 1 1/2\" diameter flowers are single, yellow and plentiful, even if rather short-lived.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If grown in rich soil, plants often grow 3' tall and require staking. Do not fertilize heavily or the plants will be a mess. Cut back severely after flowering to encourage basal growth, and divide every 2 years. Sharon Illingworth, of Thunder Bay, Ontario, Canada takes cuttings from overwintered young shoots in early spring and roots them in vermiculite covered with plastic bags. Roots are formed within 14 days and good-sized plants for transplanting result by early June.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars and Hybrids:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('em', [_vm._v("A. tinctoria")]), _vm._v(" and "), _c('em', [_vm._v("A. sancti-johannis")]), _vm._v(" (a similar species with deep orange-yellow flowers) have hybridized freely and some of the listed cultivars may be hybrids between them.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alba’ is very un-alba-ish, bearing pale cream-colored flowers over dark green finely divided leaves.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘E. C. Buxton’ (‘Buxton’s Variety’) is a superb 2-2 1/2' tall cultivar which bears off-white daisies with lemon yellow centers. Probably still the best of the "), _c('em', [_vm._v("Anthemis")]), _vm._v(" cultivars.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Beauty of Grallagh’ includes plants sometimes sold as ‘Grallagh Gold’ and ‘Grallagh Glory’. Plants may bear bright gold to pale yellow to yellow-orange flowers atop 3' tall stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Kelwayi’ (‘Kelway’s Variety’) has been popular for many years. Plants bear a profusion of bright yellow flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Moonlight’ bears handsome light yellow blossoms with a deeper yellow center.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Sauce Hollandaise’ bears pure white ray flowers surrounding yellow centers. Grows about 2' tall. Cheryl Greenwood Kelly of Washington State University compares the flowers to “softly poached eggs; a feast for the eyes”. I have seen a plant listed as ‘Sauce Béarnaise’ but can not find it sold anywhere. I will let the chefs sort this one out.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Suzanna Mitchell’ bears silver-green mounds of feathered foliage and light cream yellow ray flowers surrounding gold centers. Plants are about 2' tall, cold hardy to zone 6.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘St. Johannes’ has bright orange flowers. The three previous cultivars are more compact than the species but even more dwarf cultivars would still be most welcome.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_104"
    }
  }), _c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_vm._v("‘Tetworth’ is a welcome addition to this plant group. A hybrid between "), _c('em', [_vm._v("A. tinctoria")]), _vm._v(" and "), _c('em', [_vm._v("A. punctata")]), _vm._v(" subsp. "), _c('em', [_vm._v("cupaniana")]), _vm._v(", plants bear the gray foliage and small stature of the latter but the profusion of flowers of the former. The semi-double white daisies are produced in early summer on 10-18\" tall plants.")])]), _c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Wargrave’ bears masses of pale yellow daisy flowers and deep green ferny foliage.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. carpatica")]), _vm._v(" ("), _c('em', [_vm._v("A. cretica")]), _vm._v(" subsp. "), _c('em', [_vm._v("carpatica")]), _vm._v(") forms 6\" tall cushions of gray-green hairy foliage and white daisy flowers. ‘Snow Carpet’ occasionally appears in catalogs. It seems to be the same as the above but is a much better name. Hardy from zones 3-7.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. triumfetti")]), _vm._v(" is similar to "), _c('em', [_vm._v("A. tinctoria")]), _vm._v(" but carries many handsome white flowers with yellow centers. Plants grow 18-24\" tall. Likely hardy only to zone 6 or 7.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Anthericum")])]), _vm._v(" (an-ther' i-cum)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("St. Bernard’s Lily")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Asphodelaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("About 50 species of this little-used genus are known but two are cultivated with some success in North America. Plants emerge from rhizomes, and flowering occurs in late spring and summer. All species are native to southern Europe, Turkey or Africa. Not easy to locate but well worth a spot in the garden.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Anthericum Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Flower color")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Flower stem branched")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. liliago")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("24-30")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. ramosum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("15-24")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-liliago")])]), _vm._v(" (lil-ee' a-go)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("St. Bernard’s Lily")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("24-30\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southern Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Native to alpine meadows, where it bears racemes of small, starry white flowers in the late spring or summer garden. The flowers are even more handsome up close where the upwardly curled styles and yellow stamens can be admired. Plants will grow 2-2 1/2' tall, but for best results, plant in groups of at least three. Full sun and well-drained soils are necessary. Plants do not perform well in the South.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Major’ is taller (3') than the species and bears flattened pure white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-ramosum")])]), _vm._v(" (ray mo' sum)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("15-24\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southern Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_105"
    }
  }), _c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_vm._v("Native to lower valleys than "), _c('em', [_vm._v("A. liliago")]), _vm._v(", this species is a little more heat tolerant and a better choice for hot summers. The gray-green upright foliage combines with many white flowers on a branched inflorescence. The flowers have yellow stamens and straight styles. Full sun and well-drained soils help make this plant successful in the garden.")])]), _c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Aquilegia")])]), _vm._v(" (ack-wi-lee' gee-a)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Columbine")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Ranunculaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A garden without columbine is simply unacceptable. The genus consists of approximately 65 species, and if all were available, they would probably all be outstanding garden plants. The flowers, which may be nodding or upright, consist of 5 petals with a short broad tube in front (petal tube) and backward-projecting spurs. The spurs were thought to resemble the claws of an eagle, the Latin translation being "), _c('em', [_vm._v("aquila")]), _vm._v(", thus the genus name. They are useful determiners of a species, in that some are reasonably straight, in others, the ends are hooked like a fish hook, yet others are curved. The 5 sepals are often the same color as the petals but may be different in some species and hybrids. After flowering, the seed is held in erect long, narrow follicles that are ornamental for many weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The leaves are held in groups of 3 leaflets (ternate), and in some species they are arranged in two groups of three (biternate). The leaves are always attached to the stem by long petioles. All columbines are spring or early summer flowering and perform best in a rich soil, light to moderate shade and with plenty of moisture. Many columbines are short lived, particularly if drainage is poor, and considered a bonus if they return after two or three years (although many reseed).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Species vary considerably, ranging from 3' tall species to miniatures, and vary in color from white to blue and purple to pink. In fact, for those gardeners who can’t control their columbine habit, there is even a green-flowered species, "), _c('em', [_vm._v("A. viridiflora")]), _vm._v(", which no one will like but you. The white-flowered "), _c('em', [_vm._v("A. fragrans")]), _vm._v(" is even sweetly fragrant. Several columbines reseed freely, particularly "), _c('em', [_vm._v("A. canadensis")]), _vm._v(" and "), _c('em', [_vm._v("A. vulgaris")]), _vm._v(". Natural hybridization occurs among species, so they should be planted in separate areas of the garden if one does not want illegitimate seedlings among the parents. In general, the hybrids do not come true from seed, however, many of the chance off-spring that do result are handsome in their own right and often quite vigorous. Many gardeners, myself included, feel that the hybrids are not nearly as stately as many of the species; however, they do satisfy the needs of the “bigger is better” crowd.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A huge amount of confusion still exists as to what cultivar and hybrid belong under what species. A trial of 96 columbines in 2003 by the Royal Horticultural Society found that nearly one-third were incorrectly labeled. Many of the cultivars and series are raised by one company and then introduced, often under different names, by one or several other companies over a short period. In our studies at the Gardens at UGA, we have seen the same problems, where one series is essentially the same as another, but with a quite different name. As a gardener, I really do not fret about it; as a researcher, it rots my socks. However, I have listed cultivars and hybrids to the best of my ability; someday DNA profiling will sort it out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nearly all the hybrids, cultivars and species are grown from seed. Propagation from seed is not difficult, however most respond to a cold treatment. Sow the seed in a well-drained medium, place in the cold (a refrigerator will do) for about 6 weeks. Many of the named cultivars of the hybrids as well as species may be purchased from seed.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_106"
    }
  }), _c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Aquilegia Species")])])]), _c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower Color (sepals/petals)")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Spurs straight (S) hooked (H) curved (C)")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Spur length (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Flower nodding (N) upright (U)")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. alpina")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Blue/blue (white)")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("C")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3/4-1")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("N")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. caerulea")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Blue/white")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("S")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("1-2")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("U")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. canadensis")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yellow/red")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("C")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("1/2-1")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("N")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. chrysantha")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yellow/pale yellow")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("H")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("2-2 1/2")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("U")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. flabellata")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White/white")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("C,H")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3/4-1")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("N")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("hybrida")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Various")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("S")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("2-6")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("U")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. longissima")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yellow/pale yellow")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("S")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("4-6")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("U")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. vulgaris")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Blue/blue")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("H")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("1/2-3/4")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("N")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-alpina")])]), _vm._v(" (al-pine' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Alpine Columbine")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1-3'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Switzerland")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This species belies its name as some of the most vigorous and stately plants in the Armitage garden have been "), _c('em', [_vm._v("A. alpina")]), _vm._v(". Most columbines will be a little taller in the South compared with the same plants in the North and this one is usually only 1-1 1/2' in northern areas but is 2 1/2-3' in the South. The gray green foliage is deeply divided into linear lobes. The basal leaves are biternate and the stem is hairy, particularly near the top. The abundant nodding flowers have short curved or slightly hooked spurs, flared 2\" wide sepals, and are usually blue throughout, although the petal tube is occasionally white. This is, without question, one of the finest classic columbines available for the garden. Plants often reseed, providing years of enjoyment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagation from seed is easy and although a cold treatment is beneficial, it is not necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("alba")]), _vm._v(" is a white form whose flowers contrast well with the dark green foliage. It grows a little shorter than the species.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Atroviolacea’ bears purple flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Blue Spurs’ is taller and has longer spurs than the species.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("superba")]), _vm._v(" is larger than the species but otherwise similar.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-caerulea")])]), _vm._v(" (ce-ru' lee-a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Rocky Mountain Columbine")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1-2'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Blue/White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Rocky Mountains")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_vm._v("This long-spurred blue and white-flowered species really isn’t much different than many of the hybrids of the same color but to encounter a stand of these flowers in the spring mountain meadows is close to a religious experience. The state flower of Colorado bears large (2-3\" across) upright-facing flowers and has been an important ")]), _c('a', {
    attrs: {
      "id": "page_108"
    }
  }, [_vm._v("parent in the development of long-spurred hybrids. The spurs are straight or outward curving and are often tipped with green. Although not as vigorous as many of the other species or hybrids, it is longer lasting, 4-5 years in the garden not being uncommon. Propagation is similar to "), _c('em', [_vm._v("A. alpina")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_108"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0108-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Aquilegia caerulea")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some catalogs provide an impressive list of cultivars but most belong with the hybrids, of which "), _c('em', [_vm._v("A. caerulea")]), _vm._v(" is only one of the parents.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Mrs. Nicholls’ has 3\" wide Cambridge blue outer petals and whitish blue inner petals. It is an old cultivar and, unfortunately, difficult to find.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("ochroleuca")]), _vm._v(" (syn. ‘Albiflora’) has creamy white flowers but is otherwise similar to the species.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Red Hobbit’ is an "), _c('em', [_vm._v("A. caerulea")]), _vm._v(" hybrid having been selected from ‘Crimson Star’. Rose-red flowers are produced on a compact 12-15\" tall plant.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_108"
    }
  }), _c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_vm._v("‘Rose Queen’ produces large long-spurred rose and white flowers.")])]), _c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-canadensis")])]), _vm._v(" (kan-a-den' sis)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Canadian Columbine")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-3'/1'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow/Red")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Eastern United States, Canada")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is one of my all-time favorite spring-flowering plants. To be sure, they are not as spectacular as many of the hybrids but have a certain grace and elegance that puts them in a class of their own. People in North Carolina certainly appreciated it when they named it the North Carolina Wildflower of the Year in 1987. Native to much of eastern North America, they are found in moist, shady areas. Plants look best in clumps of three or more and reseed to double the area within 2-3 years. The 1 1/2\" long nodding flowers appear in early spring and remain in bloom for approximately 6 weeks. The short spurs are slightly curved but do not have the obvious hook seen in "), _c('em', [_vm._v("A. vulgaris")]), _vm._v(" or "), _c('em', [_vm._v("A. flabellata")]), _vm._v(". In my garden, plants range from light pink/yellow to blood red/yellow. In climates with cooler nights the sepals are decidedly redder. Plants have somewhat evergreen foliage in southern climes and new growth begins as soon as temperatures rise above 40°F. Due to its vigor, this is one of the few columbines that can be placed at the back of the bed or used to hide a distracting object such as an electrical box or fire hydrant (although my dog Hannah was not fooled and learned the meaning of respect).")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0109-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Aquilegia canadensis")])])]), _c('p', {
    staticClass: "indentp"
  }, [_c('a', {
    attrs: {
      "id": "page_109"
    }
  }), _c('a', {
    attrs: {
      "id": "page_110"
    }
  }, [_vm._v("This species also shows a relative disdain for that voracious enemy of columbine—the leaf miner! Based on observations over the years, there is little doubt that when grown side by side, "), _c('em', [_vm._v("A. canadensis")]), _vm._v(" is less susceptible to leaf miner damage than many other species and certainly much more so than the hybrids. Leaf miners will mine this species also and eventually cause significant disfiguration, but not as rapidly as with others.")])]), _c('a', {
    attrs: {
      "id": "page_110"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagation by seed is easy. Do not be surprised to find plants emerging quite a distance from the initial planting. If fresh seeds are needed, wait until the seeds loosen and turn jet black. One of the favorite projects in my perennials class at Georgia is to place each student beside a plant in my garden just after the seeds have ripened in their cozy follicles. The assignment is to gather the seeds and fling them around the garden, leaving a legacy for the student and increasing my harvest for next spring. Everyone gets a grade of A; no worries about grade inflation here. Plants flower the second year from seed. Thinning the seedlings by transplanting young plants rejuvenates the clump as well as increases numbers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Corbett’ was selected by Richard Simon of Bluemont Nursery in Monkton, Maryland. This happens to be near another quaint town called Corbett, Maryland, a town in which the Clemens family lived. In the late 1960s, two young brothers, Andrew and Larry Clemens, went walking in the woods near their house, found some short yellow columbine plants, and brought them home. Their mother Shirley eventually shared some seed with their neighbor, Richard Simon, who introduced it under the town name approximately 25 years later. It is one of the great stories of American gardening, reaffirming the axiom “If you want to save a plant, share it with others.” Plants grow 8-10\" tall and bear pale yellow flowers. It is not as vigorous as the species and does better in areas of cooler nights. I still love it.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Little Lanterns’ is a dwarf form of the species, mirroring flower color, foliage and vigor, except that plants are no more than a foot tall. This is very similar to, or the same as, ‘Canyon Vistas’. I cannot tell the difference.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-chrysantha")])]), _vm._v(" (kris-anth' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Golden Columbine, Texas Columbine")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-4'/1'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("New Mexico, Arizona")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The flower size of Texas columbine is the antithesis of those of Canadian columbine, figures, eh? Although not possessing flashy colors, it is probably one of the most spectacular columbines when in flower, particularly when planted against a blue-flowered background. My students pointed out that my plants would probably be a little easier to see if they were not planted in the middle of late yellow daffodils. I have to find that darn color wheel. The flowers are 2-3\" across and the petals are a deeper yellow than the sepals. The 3\" long spurs spread away from the flower. This is a tall, loose grower that has been used as one of the parents of the long-spurred hybrids. If provided with sufficient moisture, no staking should be necessary.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_110"
    }
  }), _c('a', {
    attrs: {
      "id": "page_111"
    }
  }, [_c('strong', [_vm._v("Cultivars:")])])]), _c('a', {
    attrs: {
      "id": "page_111"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alba-plena’ has very pale yellow (almost white) flowers that are occasionally tinged with pink and about 1 3/4\" across.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Denver Gold’ is likely the same as var. "), _c('em', [_vm._v("hinckleyana")]), _vm._v(", but has a better name. A 2001 Plant Select"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_vm._v("®")])]), _vm._v(" winner.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("hinckleyana")]), _vm._v(", Hinckley’s columbine, is native to Texas and is more compact than the species. Seems to be more persistent.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("jaeschkanii")]), _vm._v(" and "), _c('em', [_vm._v("nana")]), _vm._v(" are dwarf varieties (1 1/2' tall), the former bearing yellow flowers and red spurs while the latter is the same color as the species.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Silver Queen’ has 3\" diameter white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Yellow Queen’ bears 2-3\" wide lemon-yellow flowers. This is a great plant, and looks even better when combined with blue or gray-foliaged plants. In the 2003 trials of the Royal Horticultural Society, this cultivar was presented the Award of Garden Merit.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-flabellata")])]), _vm._v(" (flay-bel-lah' ta)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Fan Columbine")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("8-18\"/1'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Japan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The leaves are unique in that they are thicker and bluer than most species and the fan-shaped, round leaf segments often overlap. The overlapping leaf segments and the bluish tinge to the leaves make this one of the easiest species for my students to identify and separate from the other dozen columbines I throw at them. Plants have been described as “squat or short and fat”, however, the term compact is kinder and more accurate. It is an excellent plant for the front of the garden or the rockery. The species bears lilac to blue flowers and the spurs are curved to hooked. The terminal flower opens first followed by those in the lower axils.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate from seed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alba’ is the most common form offered by nurseries. The creamy white nodding flowers are often tinged pink.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("pumila")]), _vm._v(" is the dwarf form of the species. var. "), _c('em', [_vm._v("pumila")]), _vm._v(" forma "), _c('em', [_vm._v("alba")]), _vm._v(", (‘Nana Alba’, ‘White Angel’) has white flowers. Expect to see these sold as ‘Dwarf’ or ‘Dwarf White’, or whatever creative terms are most marketable to garden centers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Cameo series consists of short compact forms, all of which do well in the shaded garden. The best are blue-white and pink-white. ‘Cameo White’ does not appear to be as vigorous.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fantasy series is among the most dwarf of the columbines offered. Similar to Cameo but even shorter, the series consists of numerous colors. Plants are excellent for protected areas, but not as good where other plants may overrun them.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Kurilensis’ (var. "), _c('em', [_vm._v("pumila")]), _vm._v(" ‘Kurilensis’) is only 4\" tall with blue, or blue and white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Mini-Star’ is a dwarf 6-8\" tall cultivar with blue sepals and white petals. One of the best selections for the rock garden.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("nana")]), _vm._v(" is similar in habit and flower to the above cultivar. They appear to be different names for the same thing.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_111"
    }
  }), _c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_vm._v("Spring Magic series is useful for the front of the garden bed and for containers. They are only a foot tall and are available in many colors.")])]), _c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('strong', [_vm._v("- x")]), _vm._v(" "), _c('em', [_c('strong', [_vm._v("hybrida")])]), _vm._v(" (hy-brid' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Hybrid Columbine")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("18\"-3'/1'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Various")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Hybrids")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The hybrids are particularly popular and with good reason. The flowers are large, upright, and in a wide range of colors. There are two generally accepted divisions in this group, long-spurred and short-spurred hybrids. Crosses involving "), _c('em', [_vm._v("A. canadensis")]), _vm._v(", "), _c('em', [_vm._v("A. chrysantha")]), _vm._v(", "), _c('em', [_vm._v("A. caerulea")]), _vm._v(", and "), _c('em', [_vm._v("A. formosa")]), _vm._v(" became known as the long-spurred hybrids and are most popular.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The recent upsurge in passion for hybrid columbines began with the McKana hybrids, an All-America bronze medal winner in 1955, which brought large flowers and pastel shades to the gardener. McKana hybrids superseded ‘Mrs. Scott Elliott’, another excellent strain. The breeding of hybrids continues at a furious pace and many excellent cultivars are available today.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Biedermeier’ is a 9-12\" compact blue and white cultivar, but other colors are also available in the mix. Often referred to as nosegay columbine. These contain a good deal of "), _c('em', [_vm._v("A. vulgaris")]), _vm._v(" parentage.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Dragonfly’ consists of a mix of colors on 18-24\" tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Fairyland Mix’ is a group of dwarf plants with short-spurred upright-facing flowers in various colors.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Firecracker’ is an exuberant 3' tall plant with dozens of flowers in explosive colors, mostly in rose and canary yellow with long yellow stamens. An outstanding plant in the Gardens at UGA in 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Fairytale series is a series of 2' tall plants, available in various colors such as ‘Fairytale Violet’, ‘Fairytale Yellow’, etc.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Kristall’ (‘White Star’, ‘Kristal Star’) grows 2 1/2-3' tall with large white flowers and long straight spurs. A good deal of "), _c('em', [_vm._v("A. caerulea")]), _vm._v(" in the parentage.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("McKana hybrids are a series of columbines that have stayed the test of time. Large long-spurred flowers, which occur in many colors, are borne over 18-24\" tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Musik series is almost as good as the Song Birds. They are available in many colors although yellow is the best. They are free flowering and relatively compact.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Origami series consists of numerous colors (blue/white, rose/white, etc.) on 2 1/2' tall plants. These are the same as plants sold under the Butterfly series. ‘Origami Rose and White’ and ‘Origami Yellow’ earned the RHS Award of Garden Merit in 2003. These contain a good deal of "), _c('em', [_vm._v("A. caerulea")]), _vm._v(" in their parentage.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_vm._v("Song Bird series is the work of the late Charles Weddle, one of this country’s finest plant breeders. The plants are 2-3' tall and come in vibrant colors which are truly impressive. Some of those available include ‘Blue Bird’, light blue and white; ‘Blue Jay’, deep blue and white; ‘Cardinal’, rich violet and white; ‘Chaffinch’ (rose pink and white), ‘Dove’, nodding small blue and white flowers; ‘Nightingale’, lavender ")]), _c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_vm._v("and white; ‘Robin’, pale pink and white. ‘Chaffinch’ and ‘Dove’ were also Award of Garden Merit winners in 2003. The Songbird series is still popular but is being replaced by others such as the Spring Magic and Origami series.")])]), _c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0113-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Aquilegia")]), _vm._v(" x "), _c('em', [_vm._v("hybrida")])]), _vm._v(" "), _c('p', {
    staticClass: "bibp"
  }, [_vm._v("‘Spring Song’ consists of 3' tall plants with spurs up to 3\" long. The flowers are available in mixed colors and some are nearly double.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Star series consists of 2-2 1/2' tall plants in various colors. ‘Blue Star’ and ‘Crimson Star’ (crimson sepals and white petals) are the most common. ‘Maxistar’ is yellow and at least 3' tall, and may be a cultivar of "), _c('em', [_vm._v("A. longissima")]), _vm._v(". All others have a good deal of "), _c('em', [_vm._v("A. caerulea")]), _vm._v(" in the parentage.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_vm._v("State series is also sold as Swan series but at least in America, state names will sell more plants than swans any day. Some are listed as cultivars of "), _c('em', [_vm._v("A. flabellata")]), _vm._v(", others as "), _c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("hybrida")]), _vm._v(". Many state swans are out there, including (but not inclusive) ‘Alaska’ (‘Swan White’), ‘Colorado’ (‘Swan Violet and White’), ‘Florida’ (‘Swan Yellow’), ‘Georgia’ (‘Swan Red and White’), ‘Kansas’ (‘Swan Red and Yellow’), ")]), _c('a', {
    attrs: {
      "id": "page_114"
    }
  }, [_vm._v("‘Louisiana’ (‘Swan Burgundy and White’), ‘Montana’ (‘Swan Rose and White’) ‘Vermont’ and ‘Virginia’ (‘Swan Blue and White’). In a large columbine trial by the Royal Horticultural Society in 2003, ‘Alaska’, ‘Florida’ and ‘Georgia’ earned the Award of Garden Merit.")])]), _c('a', {
    attrs: {
      "id": "page_114"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Windswept’ has short-spurred deep blue flowers on a 12-15\" tall plant.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Winky series consists of tall plants (2-3') in various colors. Red/white, purple/white and even ‘Tiddlywinks’ (mix) are part of this group.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many of the older long-spurred hybrids were crossed with "), _c('em', [_vm._v("A. vulgaris")]), _vm._v(" to yield the short-spurred hybrids. These are more popular in Europe than in the United States and are smaller in stature and bear smaller flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some hybrids are available from seed but self-sown seed will not necessarily resemble the parent. Leaf miner can be a serious pest and is more disruptive to the hybrids than to many of the species. If leaf miner damage makes you nauseous, the easiest control is to simply cut the plants down to the ground after flowering and destroy the leaves. New growth will soon appear at which time the life cycle of the miners will have been completed. An all-purpose insecticide may be applied in early spring as a preventative measure but is seldom effective once the damage is evident.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-longissima")])]), _vm._v(" (long-gis' si-ma)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Longspur Columbine")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-3'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southern United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The obvious attributes of this species are the very long (4\") slender spurs on pale yellow flowers. A grouping of 5-6 plants makes an impressive display. Unfortunately, though vigorous, it is a short-lived perennial seldom persisting for more than 2 years.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Longissima Hybrids’ resulted from crosses among some of the long-spurred hybrids and "), _c('em', [_vm._v("A. longissima")]), _vm._v(" and contains different colors.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-vulgaris")])]), _vm._v(" (vul-gah' ris)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Granny’s Bonnet")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1-2'/1'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring, Early Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So much natural interbreeding among "), _c('em', [_vm._v("A. vulgaris")]), _vm._v(" and other species has occurred that it is becoming more and more difficult to find the true "), _c('em', [_vm._v("A. vulgaris")]), _vm._v(". There is a great deal of variability but in general the flowers are blue or violet, with short incurved spurs which end in small knobs. It does not possess the classic statuesque form of "), _c('em', [_vm._v("A. alpina")]), _vm._v(", the sparkle of "), _c('em', [_vm._v("A. canadensis")]), _vm._v(", or the airiness of "), _c('em', [_vm._v("A. chrysantha")]), _vm._v(". However, it is a durable performer and has persisted well in gardens throughout the country, and has good heat tolerance, as shown by its performance in the State Botanical Garden of Georgia. Although I may be in the minority, I believe that some of the ugliest flowers in the plant kingdom are the doubles and near triple cultivars of "), _c('em', [_vm._v("A. vulgaris")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Adelaide Addison’ bears double purple and white flowers. For some reason, this is sometimes listed as ‘Nora’s Sister’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Altrosa’ produces rose-pink nodding flowers on 2-2 1/2' tall stems.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_114"
    }
  }), _c('a', {
    attrs: {
      "id": "page_115"
    }
  }, [_vm._v("var. "), _c('em', [_vm._v("alba")]), _vm._v(" is a good single white-flowered form.")])]), _c('a', {
    attrs: {
      "id": "page_115"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("Barlow series started out with ‘Nora Barlow’, a most interesting and unusual cultivar. Flowers are fully double and look more like small dahlias than columbines. The sepals are reddish pink with white margins and plants grow 2-2 1/2' tall. Nora was the granddaughter of Charles Darwin, and I can’t help but thinking of tortoises when I look at Nora. Association comes in strange forms. Nora has been around for decades but recent additions of ‘Blue Barlow’, ‘Rose Barlow’ and ‘Black Barlow now fill out the series.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Cap de Rossiter’ has wonderful small pink and white dahlia-like flowers and even though I am not keen on double columbines, this one quickly became a favorite in the Armitage gardens. Plants grow 2-3' tall and flowers are persistent.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Clematiflora’, stormy columbine, bear lovely light pink to burgundy spurless flowers. The flat, nodding flowers are carried on 2' tall branching stems. These are often sold under the Clementine series, and may appear under names like ‘Clemantine Blue’, ‘Clementine Purple’ and ‘Clementine Red’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Dorothy Rose’ has pendulous “hose in hose” dark pink flowers (looks like one flower is in another). Plants are about 2' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Double Rubies’ (‘Burgundy Double’) produces deep maroon double flowers on 3' tall plants. Flowers are very persistent. I have seen a very similar plant listed as ‘Ruby Port’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Grandmother’s Garden’ is simply a mix of "), _c('em', [_vm._v("A. vulgaris")]), _vm._v(" seedlings, each plant a different color, all plants 18-24\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Heidi’ bears handsome light pink nodding flowers on 18-24\" tall stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Lime Frost’ is a yellow and green variegated form with few flowers. Similar plants may be found under ‘Variegata’ or ‘Woodside Gold’. ‘Lime Sorbet’ produces interesting, if you like them, double, spurless, off-white flowers. How many ways can we mess up this beautiful plant?")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Mellow Yellow’ has golden yellow foliage with white or pale blue flowers in the spring. Plants are about 20\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Miss Jekyll’ produces nodding white flowers on 2' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Nivea’ has single white flowers and pale gray foliage. It is vigorous, often attaining 3' in height. Plants may be seen as var. "), _c('em', [_vm._v("nivea")]), _vm._v(" and are also referred to as Munstead white columbine, in reference to Gertrude Jekyll’s fondness for the plant.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Raspberry Tart’ is yet another gruesome deformed columbine offering, with raspberry red double flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Ruby Port’ is a tall double-flowered form with ruby flowers. Great name, great plant, similar to ‘Double Rubies’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("stellata")]), _vm._v(" is the correct name for most of the spurless forms of columbine. Once classified as ‘Clematiflora’ or "), _c('em', [_vm._v("A. vulgaris")]), _vm._v(" var. "), _c('em', [_vm._v("clematiflora")]), _vm._v(", all stand about 2 1/2' tall and have double flowers with minute or no spurs. ‘Pink Spurless’, ‘Firewheel’, ‘Green Apples’ and ‘Iceberg’ are color variants in this variety. All are interesting, but none is beautiful.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Trevor Bath’, introduced by Canyon Creek Nursery in Oroville, California, carries rosy, short-spurred semi-double flowers with white petals and rose-red sepals.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_115"
    }
  }), _c('a', {
    attrs: {
      "id": "page_116"
    }
  }, [_vm._v("‘Variegata’ ("), _c('em', [_vm._v("A. vervaeneana")]), _vm._v(" ‘Variegata’) or ‘Woodside Variegated’ has foliage marbled with yellow or gold. The foliage is reasonably handsome in the spring but tends to fade as temperatures rise. Flowers are usually blue but may be white or purple.")])]), _c('a', {
    attrs: {
      "id": "page_116"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Woodside Gold’ produces less marbled and more golden foliage than ‘Woodside Variegated’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘William Guinness’ (‘Magpie’), as would be expected, bears flowers the color of that fine stout. Double flowers are produced over the 2-3' tall plants in late spring.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hybrids are reasonably easy to find in today’s gardening market but there are dozens of lesser-known species that are fun to try. The only thing stopping gardeners is their availability. Here are few related species that, with a little hunting, may end up in your garden one of these days.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. atrata")]), _vm._v(" is a handsome 18-30\" tall columbine with 1-2\" wide, nodding purple-violet flowers. This is similar to another dark-flowered form, "), _c('em', [_vm._v("A. nigrescens")]), _vm._v(". Hardy to about zone 4.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. bertolonii")]), _vm._v(", alpine rock columbine, is only 4-9\" tall and bears rich blue-violet flowers. This is a wonderful dwarf columbine for the front of the border or rock garden.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. buergeriana")]), _vm._v(" produces nodding flowers of dull yellow petals and purple sepals on one- to two-foot tall plants. The straight short spurs are dull purple. ‘Calimero’ is a compact form with pendulous purple and cream yellow flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. einseleana")]), _vm._v(" is another alpine species with nodding blue-violet flowers and short (1/2\") straight spurs. Plants are smaller than "), _c('em', [_vm._v("A. alpina")]), _vm._v(" and usually grow 9-12\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. formosa")]), _vm._v(", formosa columbine, is native to the western United States and similar to "), _c('em', [_vm._v("A. canadensis")]), _vm._v(". Plants are taller and have sepals longer than the spurs. Even grown side by side, this species and "), _c('em', [_vm._v("A. canadensis")]), _vm._v(" are difficult to separate. The var. "), _c('em', [_vm._v("truncata")]), _vm._v(" is sometimes offered as "), _c('em', [_vm._v("A. eximia")]), _vm._v(" and differs from the species in having much reduced petals. The formosa group does not perform as well as "), _c('em', [_vm._v("A. canadensis")]), _vm._v(" in Eastern gardens.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. glandulosa")]), _vm._v(", Siberian columbine, is almost identical to "), _c('em', [_vm._v("A. flabellata")]), _vm._v(", having fanlike bluish foliage and nodding blue flowers. If one looks closely, the pistils of this species are pubescent while the pistils are smooth in the fan columbine. The spur is strongly hooked in this species while it is curved in "), _c('em', [_vm._v("A. flabellata")]), _vm._v(". Var. "), _c('em', [_vm._v("jucunda")]), _vm._v(" has white petals and is similar to "), _c('em', [_vm._v("A. flabellata")]), _vm._v(" ‘Alba’.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("helenae")]), _vm._v(" (‘Helenae’) is a hybrid between "), _c('em', [_vm._v("A. caerulea")]), _vm._v(" and "), _c('em', [_vm._v("A. flabellata")]), _vm._v(". It has the blue and white flowers of "), _c('em', [_vm._v("A. caerulea")]), _vm._v(" and the short half-inch long spurs of "), _c('em', [_vm._v("A. flabellata")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A")]), _vm._v(". ‘Hensol Harebell’ was always believed to be a hybrid between "), _c('em', [_vm._v("A. alpina")]), _vm._v(" and "), _c('em', [_vm._v("A. vulgaris;")]), _vm._v(" however, recent evidence suggests it may be a cultivar of "), _c('em', [_vm._v("A. alpina")]), _vm._v(". Plants bear deep blue flowers that continue well into summer. The branched flower stems produce an open, airy effect. Plants persisted about 2 years in the Armitage garden, and then various unrecognizable offspring took over.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_116"
    }
  }), _c('a', {
    attrs: {
      "id": "page_117"
    }
  }, [_c('em', [_vm._v("A. laramiensis")]), _vm._v(" is also native to the Rocky Mountains and bears small white flowers that barely surpass the foliage. Plants grow 6-9\" tall and are best for well-drained rock garden sites")])]), _c('a', {
    attrs: {
      "id": "page_117"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. olympica")]), _vm._v(" is native to southern Europe and sports blue and white flowers with incurved spurs. Plants stand about 2 1/2' tall. Hardy in zones 4-8.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. oxysepala")]), _vm._v(" is closely related to "), _c('em', [_vm._v("A. buergeriana")]), _vm._v(", and grows 2-3' tall with interesting claret sepals and yellow petals. The spurs are strongly hooked. Native to Siberia, the plants have not enjoyed great success in the Armitage garden, but I have seen excellent plants in the Northeast and Midwest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. pyrenaica")]), _vm._v(", native to the Pyrenees in northern Spain, bears nodding violet blue flowers with straight or slightly curved spurs. They are suitable for small areas or rock gardens due to their 8-12\" height.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. viridiflora")]), _vm._v(", green columbine, has nodding bicolored flowers with chocolate petals and yellow green sepals over blue-green foliage. Growing less than one foot tall, it is excellent for the rock garden.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Arabis")])]), _vm._v(" (ar' a-bis)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Rock-cress")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Brassicaceae")])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Most of the approximately 120 species distributed over the northern hemisphere are alpine in habit. All produce basal rosettes then send up stems that produce racemes of rose, purple or white flowers. Species are difficult to separate unless one looks closely at the stem leaves and flowers. The cultivated species are effective for the front of the garden or rock walls and are all less than 12\" tall. For the most part, the leaves persist in the winter, and if snow cover is not heavy, the foliage looks good at that time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Arabis")]), _vm._v(" is also well known to butterflies such as Mustard white, Sara orange-tip, Boisduval’s Marble, Edward’s Marble and California white butterfly, which all feed on rock cress.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Since the last edition was written, somebody snuck in a few taxonomic changes to the genus, but nothing too confusing. The most popular plant in gardens used to be known as "), _c('em', [_vm._v("A. caucasica")]), _vm._v(", wall rock-cress, but it is now properly classified as "), _c('em', [_vm._v("A. alpina")]), _vm._v(" var. "), _c('em', [_vm._v("caucasica")]), _vm._v(". Certainly, other species also have garden value. "), _c('em', [_vm._v("A. blepharophylla")]), _vm._v(" (native to California) has rose-purple flowers but is quite tender and needs winter protection in much of the country. A compact, white-flowering species with a large following in the United States is "), _c('em', [_vm._v("A. ferdinandi-coburgii")]), _vm._v(". The species has gray-green foliage but only the variegated forms are easily available to the gardener. "), _c('em', [_vm._v("A. procurrens")]), _vm._v(" grows to 9\" tall, has entire evergreen leaves, and larger white flowers. "), _c('em', [_vm._v("A. soyeri")]), _vm._v(" is about 10\" high with white flowers. One of my favorites is "), _c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("sturii")]), _vm._v(", which is only 2-3\" tall with glossy leaves and relatively large white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The majority of species are cool climate plants and perform far better in the North than in the South. In hot weather, the centers tend to “melt out” and the stems become long and spindly. I have been successful with "), _c('em', [_vm._v("A. procurrens")]), _vm._v(", "), _c('em', [_vm._v("A. alpina")]), _vm._v(" var. "), _c('em', [_vm._v("caucasica")]), _vm._v(" and "), _c('em', [_vm._v("A.")]), _vm._v(" x "), _c('em', [_vm._v("sturii")]), _vm._v(" in north Georgia, but none spread vigorously during the summer, and none persisted more than 2 years. All species should be planted in full sun in the North or afternoon shade (in the South), preferably in areas where drainage is excellent. Cut back after flowering if plants start to look a little dog-eared.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_118"
    }
  }, [_vm._v("All are easily propagated by division, cuttings, or seed.")])]), _c('a', {
    attrs: {
      "id": "page_118"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Arabis Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower color")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Stem leaves sessile")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. alpina")]), _vm._v(" var. "), _c('em', [_vm._v("caucasica")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("8-15")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. blepherophylla")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("4-8")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Rose, pink")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. ferdinandi-coburgii")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("4-6")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-alpina")])]), _vm._v(" (al-pine' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Mountain Rock-cress")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("8-15\"/18\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Mediterranean")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The plant forms a loose mat and the hairy, succulent foliage is particularly effective climbing over rocks or cascading down walls. The numerous white flowers are held in a loose raceme in early spring. Plants should be cut back severely after flowering, or by midsummer branches will be nude except for the terminal leaves. The subsequent year’s performance is also enhanced by late spring pruning. In the North, plants make a wonderful spring show and form large clumps that may need division every 2-3 years. In north Georgia, flowers are present by the end of February and persist until the end of April. Plant in the fall in the South for enjoyment the following spring (similar to a pansy) as plants tend to decline in the summer heat south of Zone 6.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All plants listed are cultivars of var. "), _c('em', [_vm._v("caucasica")]), _vm._v(", whose gray-green leaves and more compact habit help distinguish it from the species itself.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bakkely’ is a compact (4-6\") plant with single white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Corfe Castle’, discovered at Corfe Castle in England, is a handsome 6-8\" tall plant with deep magenta flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Douler Angevine’ has green leaves with a thick golden edge. The bright pink flowers contrast well with the leaves.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Flore-pleno’ is an excellent plant because the double white flowers are mostly sterile and little seed is produced. The lack of seed production results in more persistent flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Gillian Sharman’ bears gold-edged leaves and white flowers. Handsome, but difficult to locate.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pink Pearl’ has deep pink flowers on mat-forming plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Red Sensation’ produces rose-red flowers over silvery-green leaves.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Snow Cap’ is a large white-flowered cultivar more ornamental than the species.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Snow Drop’, ‘Snow Flake’ and ‘Snow White’ are all white, about 4-5 inches tall, and compact. I am not sure even the breeders could tell them apart, so don’t fret if you cannot.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_118"
    }
  }), _c('a', {
    attrs: {
      "id": "page_119"
    }
  }, [_vm._v("‘Variegata’ has yellow-white stripes on the leaves. It is an interesting cultivar but the leaf color detracts from the flowers and the plant is altogether too busy.")])]), _c('a', {
    attrs: {
      "id": "page_119"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("-"), _c('em', [_c('strong', [_vm._v("blepharophylla")])]), _vm._v(" (ble-fa-ro-fil' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Fringed Rock-Cress")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("4-8\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Rose-purple")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("California")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This tufted rock garden plant generally consists of rosettes of 1-3\" long entire to toothed leaves. The flower stems bear sessile, oblong leaves and terminate in short, dense racemes of carmine-red flowers. The petals are about 1/2\" long and the flowers are slightly fragrant.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alba’ bears white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Spring Charm’ is the best cultivar of this species, bearing fragrant rose-pink flowers on compact plants.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-ferdinandi-coburgii")])]), _vm._v(" (fer-di-nahn' dye ko-burg' eye)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Alpine Rock-Cress")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("4-6\"/10\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Bulgaria")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Named after King Ferdinand of Bulgaria, these plants provide carpets of white flowers over narrow-oblong leaves with long petioles. Like other members of the genus, plants require excellent drainage and cutting back in the summer. The species itself is seldom offered by nurseries, however, variegated forms are quite common. All bear white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0119-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Arabis bleharophylla")])])]), _c('p', {
    staticClass: "noindentp"
  }, [_c('a', {
    attrs: {
      "id": "page_119"
    }
  }), _c('a', {
    attrs: {
      "id": "page_120"
    }
  }, [_c('strong', [_vm._v("Cultivars:")])])]), _c('a', {
    attrs: {
      "id": "page_120"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Limedrop’ bears deep green leaves with a lime-green center. Plants grow 4\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Old Gold’ produces shiny green leaves variegated with gold. This is probably the most common cultivar offered, however, there is little difference between this and ‘Aureo-Variegata’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Reversed’ has mostly white leaves with green margins.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Variegata’ is the most available of the cultivars and bears handsome leaves splashed and edged with clean white. Debate continues as to whether this is a cultivar "), _c('em', [_vm._v("of A. ferdinandi-coburgii")]), _vm._v(" or "), _c('em', [_vm._v("A. procurrens")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A.")]), _vm._v(" x "), _c('em', [_vm._v("arendsii")]), _vm._v(" resulted from the natural hybridization of "), _c('em', [_vm._v("A. aubrietoides")]), _vm._v(" and "), _c('em', [_vm._v("A. alpina")]), _vm._v(" var. "), _c('em', [_vm._v("caucasica")]), _vm._v(" and includes a few excellent selections. ‘Compinkie’ has handsome pink flowers; ‘La Fraicheur’ bears deep rose-red flowers; ‘Rosabella’ produces rose-colored flowers that become paler as temperatures rise in the spring; ‘Rubin’ bears wine-colored flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. procurrens")]), _vm._v(" is a stoloniferous species similar to "), _c('em', [_vm._v("A. ferdinandi-coburgii")]), _vm._v(" but has shiny ovate leaves rather than narrow leaves. Plants appear to be more heat tolerant than other species. ‘Glacier’ has dark green leaves and white flowers. ‘Variegata’ is similar to plants of "), _c('em', [_vm._v("A. ferdinandi-coburgii")]), _vm._v(" ‘Variegata’ and may in fact be the same. Who cares, if rock-cress grows well in your garden, the variegated forms will look terrific and won’t die because they aren’t named correctly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("sturii")]), _vm._v(" is one of my favorite rock garden plants. It has small (<2\" long) dark green lustrous leaves arranged in compact mounds. Plants produce many small (1/2\") clean white flowers in early spring. The clean leaves, the white flowers and the compact growth habit make this a wonderful species. ‘Glacier’ is similar and is a good choice if "), _c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("sturii")]), _vm._v(" cannot be located.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Arachnoides")])]), _vm._v(" (a-rack-noi' deez)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Shield Fern")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Dryopteridaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The shield ferns are some of the most outstanding plants for the shaded garden, and have become more popular but are still not the easiest to find, and terribly underused. Those useful for American gardeners are native to China, Japan and Korea and are probably not hardy much north of zone 6. I have seen outstanding plantings of "), _c('em', [_vm._v("A. standishii")]), _vm._v(", the upside-down fern, in the wonderful garden of Mr. Charles Cresson in Swarthmore, Pennsylvania. This fern forms thin, bright green, narrow fronds whose black sori are visible from above, hence the common name. A far more coarse relative is spiny leatherfern, "), _c('em', [_vm._v("A. aristata")]), _vm._v(", whose glossy, dark green fronds are almost prickly to the touch.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_120"
    }
  }, [_vm._v("The pearl of the genus, however, has to be "), _c('em', [_vm._v("A. simplicior")]), _vm._v(" ‘Variegata’, East India holly fern or variegated shield fern, which has finally found its way out of obscurity and is no longer the unknown gem it once was. In fact, it is probably the most easily obtained of the shield ferns. The leathery fronds are notable for the prominent yellowish bands on each side of the glossy-green midribs; the color does not fade in hot ")]), _c('a', {
    attrs: {
      "id": "page_121"
    }
  }, [_vm._v("summers and the plant is evergreen to about 10°F. In the Armitage garden, plants ducked underground when temperatures fell to about 5°F, but emerged unscathed in early spring. Everyone stops to admire the clump and this handsome variegated species should be much more widely planted. Certainly, it is a winner for gardeners in zones 7-10, who have been desperate for some decent ferns for a long time. It may be marginally hardy in zone 6, with protection.")])]), _c('a', {
    attrs: {
      "id": "page_121"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Plant in partial shade and provide lots of water, particularly in early spring. Variegated shield fern is more tolerant of drying out than the upside-down fern.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Arisaema")])]), _vm._v(" (a-ris-aye' ma)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Jack-in-the-Pulpit")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Araceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some of the wildest, weirdest, most handsome and therefore most highly sought-after plants are found in the genus. With over 150 species of mostly tuberous plants, there is something for everyone. "), _c('em', [_vm._v("Arisaema")]), _vm._v(" is widely distributed, occurring from Tanzania (7°S) to Mexico through eastern North America and all the way north to about 51°N latitude. Leaves are almost always palmately compound and generally only one or two mottled stems are produced from the tuber. The flowers consist of a bewildering array of spathes and spadices, which provide some of the most unusual architectural arrangement of flowers in the plant kingdom. "), _c('em', [_vm._v("Arisaema")]), _vm._v(" is also unique in its ability of individual plants to change gender. Plants of some species start out bearing male flowers only on the spadix and spontaneously change to female (and vice versa) the next year.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants are woodland in nature and perform best in cool, moist areas with plenty of organic matter. Nearly all species go dormant in the summer after flowering and fruiting is complete. Some of the most interesting are native to Korea and Japan, growing to 3' in height ("), _c('em', [_vm._v("A. angustatum")]), _vm._v(") and bearing distinctive large flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A few years ago, it was difficult to find nurseries that offered more than one or two species, but today availability is not a problem. Jacks, along with other genera in this family, have become collectors’ favorites as well as those who simply like plants from the untrodden path. If you search the Internet, not only will you find impressive lists of species and cultivars, but also entire websites devoted to the Araceae. Scary, but most of the people swapping Jack stories don’t bite.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The downside is that as the demand continues, the difficulties of propagation still keep prices high for most species. Without doubt, this problem is being quickly resolved as modern propagation techniques make the tubers more available for the clamoring public.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plant tubers approximately 3-4\" deep and allow to remain undisturbed unless propagation is necessary. Commercial propagation of "), _c('em', [_vm._v("Arisaema")]), _vm._v(" is nearly always by seed. If collecting seed, the seed coat contains germination inhibitors and must be removed (use gloves, as some people are quite allergic to the pulp). Plant the clean seed; expect a couple of years before plants are mature. In the garden, tubers can be lifted and separated. However, try to control yourself and don’t disturb unless necessary.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_121"
    }
  }), _c('a', {
    attrs: {
      "id": "page_122"
    }
  }, [_vm._v("Since the provenance of "), _c('em', [_vm._v("Arisaema")]), _vm._v(" is so diverse, it is not surprising that the tolerance to cold and heat would also be diverse. The International Aroid Society updates records annually concerning hardiness, based on locations and temperatures without snow cover.")])]), _c('a', {
    attrs: {
      "id": "page_122"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Guide to Arisaema Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Spathe")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Spadix")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. candidissimum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Pale pink and white")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yellow-green")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("15-18\"")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. consanguineum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Green, purple, white stripes")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Green")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("24-60\"")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. dracontium")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Green")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Green")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("18-30\"")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. ringens")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Striped green and white")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Yellow-white")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("10-20\"")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. sikokianum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Striped purple")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("18-25\"")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. taiwanense")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Purple")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Purple")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("15-30\"")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. triphyllum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Greenish, mottled purple")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Green, brownish")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("12-30\"")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_vm._v("-"), _c('em', [_c('strong', [_vm._v("candidissimum")])]), _vm._v(" (kan-di-dis' si-mum)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White Jack")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("15-18\"/15\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Pink and White Spathe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Western China")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I first saw a group of these plants in the garden of Mrs. Helen Dillon in Dublin, Ireland and quickly became a convert to the white jack. The solitary leaf consists of 3 leaflets and generally emerges with or just after the flower. It is late to emerge (mid May in most areas) and is therefore less susceptible to late frosts. The loveliest part of the plant is the white spathe that is suffused with delicate pink. The spathe is only slightly hooded therefore the pink can be seen inside as well. The spadix is yellow-green and slightly fragrant. A pure white-flowered form is also occasionally offered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is one of the easiest species to find, but its popularity also results in sold-out stocks at the nursery. I have since planted this in the Armitage garden and seen it used as a summer plant in the garden of Wayne Winterrowd and Joe Eck in southern Vermont. In the North, plants are overwintered in a cold greenhouse and brought out again for summer bloom. A pure white-flowered form (without the pink) may occasionally be offered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plant in groups of a half dozen in a slightly shaded area rich in organic matter.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-consanguineum")])]), _vm._v(" (con-san-gwin-ee' um)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Himalayan Cobra Lily, Palm Tree Jack")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-5'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Red")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("China")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One of the most diverse species, plants under this name can be native to lowland areas all the way to elevations above 10,000'. Well-grown plants can easily attain 5' in height, and with its impressive palm tree-like leaf, consisting of 10-12 leaflets, each with an extended tip, it is an impressive sight. Heck, who even needs a flower? The green to purple inflorescences are often striped white and the tip of the pulpit has been teased out into a long, thin piece of spaghetti.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_122"
    }
  }), _c('a', {
    attrs: {
      "id": "page_123"
    }
  }, [_vm._v("I have often read how easy this plant is to grow, but not so in the Armitage garden. Perhaps the warm summer temperatures or lack of a long Himalayan winter are to blame, or perhaps I am buying the ones from the 10,000' mountain range rather than those that originated in the lowlands. I have lost my fair share, and those that do survive grow about 2-3' rather than the 5-6' I see in Oregon gardens. Regardless, I keep trying.")])]), _c('a', {
    attrs: {
      "id": "page_123"
    }
  }), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_123"
    }
  }), _c('a', {
    attrs: {
      "id": "page_124"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0123-01.jpg",
      "width": "400px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_124"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Arisaema dracontium")])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_vm._v("-"), _c('em', [_c('strong', [_vm._v("dracontium")])]), _vm._v(" (dra-kon' tee-um)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Green Dragon")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("18-30\"/20\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Green")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Eastern North America")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Extending as far north as Maine and south to northern Florida, green dragon is a frequent, if not common, woodland inhabitant. Although plants are distinctive, their complete green color also makes them easy to walk by without being noticed. However, those who stop a moment quickly enjoy this most interesting species. The single leaf consists of 7-15 oblong leaflets arranged in a horseshoe shape, underneath which the green spathe may be found. The narrow spathe is only about 2-3\" long but the spadix looks like cotton candy that has been pulled out to form a 10-12\" long string-like tail.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants arise from strong thick green stems and quickly rise to 3' in height; flowers appear by late spring to early summer. They are best placed in a shady area where they can be viewed along a path or walkway. To be honest, plants are as interesting than they are handsome, and the oblong tubers are inexpensive and easy to locate, and what’s the matter with interesting, anyway?")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-ringens")])]), _vm._v(" (rin' gens)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Cobra Jack")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("10-20\"/20\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Striped Green and White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Japan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A most wonderful species, the tubers produce two leaves each composed of three leaflets and an incurved contorted spathe that looks like a striped helmet. The hood of the spathe is a deep chocolate color while the white to yellow spadix is almost entirely enclosed. Plants are robust and produce some of the largest spathes, relative to the overall size of the plant, in this genus. It is easy to find and grow the cobra jack, and if cold hardiness is not a problem, this is probably the jack I would start with.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants are best suited to groups of three or more and tolerate wetter conditions than other species. Partial shade and soils with sufficient organic matter are essential for best performance.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-sikokianum")])]), _vm._v(" (si-koke-ee' aye-num)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Gaudy Jack")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("18-25\"/20\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Striped Purple and White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Japan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have grown nearly a dozen different jacks in the Armitage garden, but if I had to pick but one jack for my garden, it would come to a vote between this species and "), _c('em', [_vm._v("A. ringens")]), _vm._v(", and this one would probably win. The two leaves consist of five leaflets in the lower, three in the upper and emerge about the same time as the flower. The beauty of this plant lies in the contrast of the purple spathe and the elegant white spadix. The spathe forms a funnel-shaped tube ending in a long narrow projection. Inside the spathe nests the lovely pestle-shaped spadix, easily visible in early spring. The only drawback to this plant, other than cost and availability, is that it emerges very early in the spring and has been clubbed to death by late frosts on more than one occasion. I use peat moss and baskets to cover the plants in the spring if a frost is forecast, but I have lost my share. The later emergence of other jacks strains one’s patience but helps the wallet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants with silver markings on the leaves are also being selected, for foliar interest even when plants are not in flower. I hesitate to give cultivar status (‘Variegata’), however, if a variegated form is offered, this is what it is.")])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_124"
    }
  }), _c('a', {
    attrs: {
      "id": "page_125"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0125-01.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_125"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Arisaema ringens")])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-taiwanense")])]), _vm._v(" (tie-wan-en' se)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Taiwan Jack")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1 1/2-2 1/2'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Purple/Black")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Taiwan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 6-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I love this plant because it is a doer in the garden. Plants emerge with a strong cinnamon-colored tip, giving way to a wonderfully light green stem mottled with purple. The leaf consists of a dozen or so thin leaflets, each with a short thread at the end. The large purple to almost black inflorescence is also bizarre, forming at the base of the stem, tossing out a long thread from its mouth, and persisting for weeks and weeks. Plants grow 2-2 1/2' tall but are worth the bending down to admire.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Silver Heron’ is a silver-leafed form that I am lusting for. I have not tried it so don’t know how really silver the leaves are, particularly in the heat of summer.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_vm._v("-"), _c('em', [_c('strong', [_vm._v("triphyllum")])]), _vm._v(" (tri-fil' lum)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Jack-in-the-Pulpit")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("12-30\"/25\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Green, Mottled Purple")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Eastern North America")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_125"
    }
  }, [_vm._v("By far the most common species in the genus, it is nevertheless a most satisfying plant for the woodland garden. Plants are found from southern Canada to Louisiana and Texas, therefore variability should not be surprising. And variable it is! I have ")]), _c('a', {
    attrs: {
      "id": "page_126"
    }
  }, [_vm._v("seen plants a mere 12\" tall with 3-leaflet leaves, and giants that easily attain three feet in height and bear large 5-leaflet leaves. The color of the spathe also varies from deep purple to green with a few purple stripes. I am sure there is a taxonomist who could split out at least three botanical varieties from the populations commonly found in eastern North America.")])]), _c('a', {
    attrs: {
      "id": "page_126"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0126-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Arisaema sikokianum")])]), _vm._v(" "), _c('p', {
    staticClass: "indentp"
  }, [_vm._v("The entire plant, including the tuber, contains numerous microscopic bundles of needle-like crystals of calcium oxalate. If one is crazy enough to bite into it, one bite will be enough. The crystals pierce the tender tissues of the mouth, tongue and throat.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_126"
    }
  }), _c('a', {
    attrs: {
      "id": "page_127"
    }
  }, [_vm._v("These are not at all like the potato chip ads that bet you can’t eat just one! The best soothers are cool liquids and antihistamines. Despite these irritants, the dormant tubers were cooked by native Indians to produce a fine flour, similar to arrowroot. They were peeled, mashed and washed through sieves to obtain a fine starch solution that was dried, boiled or roasted, then ground to flour. The tubers were known as Indian turnip and that common name still is used today.")])]), _c('a', {
    attrs: {
      "id": "page_127"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants bear two leaves and emerge from early spring to early summer. The spathe may be striped with green or purple or possess a handsome deep purple hue. The green to brown spadix is generally exserted (sticks out) from the spathe. New tubers are formed in abundance and a source of small dormant tubers is not difficult to locate. Plant in groups of a dozen or more.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From a few plants a few years ago, today’s specialty catalogs offer dozens of species for the jackite. Here a few others I have tried, but many more are out there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. costatum")]), _vm._v(", Chinese cobra lily, produces one of the dark purple flowers in the group. The single 3-parted leaf is atop a 3-4' tall stem. The long-tailed spathe has handsome white striations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. flavum")]), _vm._v(", yellow jack, has relatively small flowers that are purple on the inside and somewhat yellow on the outside. Some catalogs go overboard with the golden yellow nonsense; they are not golden and not particularly vigorous. Zone 4-7.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. fargesii")]), _vm._v(" has been a terrific plant, coming back for many years. It is one of the trifoliate jacks, each large leaf consisting of three leaflets. The inflorescence is held above the foliage and with its white-striped purple spathe, it is really quite handsome, a word not often associated with the genus (weird perhaps, but not often handsome). For me, it grows about 1 1/2' tall. Although some think this and the next plant are the same, this species has done well in my garden. Zones 5-8.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. franchetianum")]), _vm._v(" is so similar to "), _c('em', [_vm._v("A. fargesii")]), _vm._v(" that many aroid enthusiasts simply treat them as the same. All parts of the plants, but especially the foliage, are similar. It also produces its flowers near the base of the stalk. The large trifoliate leaves (up to a foot across) are part of its mystique, and the striped purple and white spathe with its long narrow beak is particularly handsome. I have not had a great deal of luck with this species, but it may simply be too warm and too heavy a soil structure in my garden. ‘Hugo’ claims to big a more vigorous clone with larger flowers. Zones 6-8.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. griffithii")]), _vm._v(", Griffith cobra jack, is another fine dark-flowered jack that flowers at the base of the 18-22' tall stem. The spathe is curled back on itself and a long tongue also protrudes. Generally 3 leaves are produced at the top of the plant. Heat tolerant only to zone 7a, cold to zone 5.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. heterophyllum")]), _vm._v(", dancing jack, is one of the easiest species to be successful with. The green stems with the folded leaflets emerge in early spring, topped by a green inflorescence with a little purple on the spathe. Sounds kind of boring, but the spadix inside bears a 12\" long tongue that lolls outside the spathe then stands straight up. Great fun. Plants grow 2-3' tall, zones 5-8.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_127"
    }
  }, [_c('em', [_vm._v("A. speciosum")]), _vm._v(", big-leaf jack, is native to southwestern China and has only recently been introduced. The 2' tall plants have three, one-foot long leaflets and bear a ")]), _c('a', {
    attrs: {
      "id": "page_128"
    }
  }, [_vm._v("blackish purple spathe and a long white spadix. Plants are hardy to zone 7, but may make it to zone 6. ‘Himalayan Giant’is a taller (3') and more robust form and has more pink in the spathe than the species.")])]), _c('a', {
    attrs: {
      "id": "page_128"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. tortuosum")]), _vm._v(", whipcord jack, is also of great interest in that the long S-shaped spadix sticks out from the enveloping spathe like the tongue of a tired bulldog. These shade-tolerant plants grow 24-36\" tall and are useful in zones 7-10.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. takedae")]), _vm._v(", fancy-stalk jack, grows about 3' tall with a purple-splotched stem and a purple spathe. A beautiful plant in its own right, it has also become a parent. Hybrids between this species and "), _c('em', [_vm._v("A. sikokianum")]), _vm._v(" have been developed and they are absolutely lovely. The 2' tall plants with a purple spathe and whitish spadix is intermediate between the parents. Outstanding in the Armitage garden.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Arisarum")])]), _vm._v(" (a-ris-ar' um)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Mouse Plant")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Araceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An interesting group of 3 species from the Mediterranean and southwestern Europe that are grown for the fun of growing rather than their beauty. The most common species is "), _c('em', [_vm._v("A. proboscideum")]), _vm._v(", mouse plant. The tip of the long spadix dangles like a mouse’s tail in the air in early spring, eventually becoming covered by the dark green rounded foliage. The leaves make a pleasant mound but then poof, they want to go dormant in early summer. They are slow growers but if you like tails of mice, then it is indeed fascinating. Partial shade, moisture and humus-rich soil are necessary for success. Likely hardy to about zone 7 (zone 6 with protection).")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Armeria")])]), _vm._v(" (ar-meer' ee-a)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Sea Thrift")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Plumbaginaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Armeria")]), _vm._v(" consists of approximately 80 species, several suitable for edging, the rockery or front of the garden. Flowers appear in solitary, dense, globe-shaped heads high above the foliage on leafless stems. They are great garden plants and useful for cut flowers. Plants perform best in sunny locations but benefit from afternoon shade particularly in the South. Plants are tough as nails, and can be found in rock-hard clay upon which pedestrians trample, as well as poor sandy soils near any coast. The foliage is tufted, similar to tufts of grass, and flowers occur in dense heads. The most common species is "), _c('em', [_vm._v("A. maritima")]), _vm._v(", sea thrift, because of its availability, cultivars and toughness. However, a few other species are sold as well, although few obvious differences exist and horticultural classifications are principally based on stature and size of leaves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagation is by division and seed. Seeds placed under warm (70-75°F), moist conditions germinate in 14-21 days.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Armeria Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Leaves less than one inch wide")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower color")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. alliacea")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("12-18")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White-Pink")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. juniperifolia")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("2-4")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Lilac")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. maritima")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-12")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Various")])])])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_128"
    }
  }), _c('a', {
    attrs: {
      "id": "page_129"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_129"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-alliacea")])]), _vm._v(" (al-lee-ah' say-a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Plantain Thrift")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("12-18\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer ("), _c('em', [_vm._v("A. plantaginea")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Whitish-pink")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Central and Southern Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The white to pink flower head is approximately "), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_vm._v("3")])]), _vm._v("/"), _c('span', {
    staticClass: "small"
  }, [_vm._v("4")]), _vm._v("\" across and more oblong than the rounded flower shape of "), _c('em', [_vm._v("A. maritima")]), _vm._v(". The flowers are more white than pink but are particularly handsome. The leaves are much wider (1-2\" across) than the previous species, resembling those of plantain. They are mostly erect and have 3-7 veins running lengthwise.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Formosa hybrids ("), _c('em', [_vm._v("A. alliacea")]), _vm._v(" x "), _c('em', [_vm._v("A. leucocephala")]), _vm._v(" ‘Corsica’) form cushions of green and bear deep pink to white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("leucantha")]), _vm._v(" is a white-flowered form.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-juniperifolia")])]), _vm._v(" (jew-ni-pe-ri-fo' lee-a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Pyrenees Thrift")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-4\"/6\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Lilac")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spain")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This low-growing plant is occasionally offered by rock garden plant specialists but deserves greater use. It is densely tufted with peculiar linear, 3-angled leaves seldom longer than "), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_vm._v("3")])]), _vm._v("/"), _c('span', {
    staticClass: "small"
  }, [_vm._v("4")]), _vm._v("\". The small pale lilac flower heads are only about "), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_vm._v("3")])]), _vm._v("/"), _c('span', {
    staticClass: "small"
  }, [_vm._v("8")]), _vm._v("\" across and held on 1\" scapes. Place in a sunny location and well-drained soil.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alba’ produces a dense canopy of creamy white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Beechwood’ is a compact growing plant with short, compact, deep pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Beven’s Variety’ is a real gem. The tiny, green compact hummocks bear short, almost stemless, pink flowers. A 1993 Award of Garden Merit winner from trials at RHS Gardens Wisley.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Rubra’ bears rosy red flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-maritima")])]), _vm._v(" (ma-ri' ti-ma)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Common Thrift")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-12\"/10\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Pink")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This diverse species contains over 20 unique botanical varieties. Common thrift has pink, mauve-red, lilac, or white flowers depending on the variety or cultivar. The specific epithet is derived from the species’ salt tolerance and plants may be found growing on coastlines where few others can survive the saline conditions. As the name implies, it is the most common species of the genus and has undergone extensive selection. The 1-1"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_vm._v("1")])]), _vm._v("/"), _c('span', {
    staticClass: "small"
  }, [_vm._v("2")]), _vm._v("\" diameter flower head consists of many tiny flowers attached to the central flower dome, and persists for about 3 weeks in the North, a week less in the South. The plant forms a tuft of narrow, 4-8\" long linear leaves, each of which has one vein running lengthwise. It is relatively easy to grow, however in the South, it should be shaded from the afternoon sun.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Armeria maritima")]), _vm._v(" is also grown as a flowering potted plant. Approximately 12 weeks are required from seed to produce a flowering plant under greenhouse conditions. No cold treatment is necessary to induce flowering.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_129"
    }
  }), _c('div', {
    staticStyle: {
      "height": "450px"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_129"
    }
  }), _c('p', {
    staticClass: "imagen"
  }, [_c('a', {
    attrs: {
      "id": "page_129"
    }
  }), _c('a', {
    attrs: {
      "id": "page_130"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/f0130-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_130"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_130"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Armeria alliacea")])])])]), _c('a', {
    attrs: {
      "id": "page_130"
    }
  }, [_c('p', {
    staticClass: "indentp"
  }, [_vm._v("Seeds sown under high humidity and warm conditions produce seedlings ready to transplant in 3-4 weeks. They can be overwintered in a cool greenhouse or outside, and flower in the spring. Division is risky; more plants are damaged than reproduced.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alba’ is about 5\" tall with a creamy white flower, unusual in this species. It is handsome in the garden but, unfortunately, the white flowers discolor faster than colored flowers and decline more rapidly in heavy rains or winds.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bees’ Ruby’ is one of the most spectacular of the plantain thrifts. The intense bright cerise flowers are carried on smooth 18\" stems. This is probably a hybrid of "), _c('em', [_vm._v("A. alliacea")]), _vm._v(" x "), _c('em', [_vm._v("A. maritima")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bloodstone’ produces a 9\" tall stem of intense blood-red flowers, some of the largest in the group. This also may be an "), _c('em', [_vm._v("A. alliacea")]), _vm._v(" x "), _c('em', [_vm._v("A. maritima")]), _vm._v(" hybrid.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Cotton Tail’ is quite a handsome plant, for an armeria, producing white flowers on 8\" tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Dusseldorf Pride’ grows 6-8\" tall and carries large wine-red flower heads. It is gaining a following in this country.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_130"
    }
  }), _c('a', {
    attrs: {
      "id": "page_131"
    }
  }, [_vm._v("Joystick series includes large flower globes in white (‘Joystick White’) and rose (‘Joystick Lilac’) on 12\" tall plants.")])]), _c('a', {
    attrs: {
      "id": "page_131"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘La Pampa’ bears deep pink flowers over 6-9\" tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Laucheana’ produces 20-40 leaves resulting in a highly tufted rosette. It is about 6\" tall and has outstanding deep rose-pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Little Penny’ is tiny, only about 2\" tall, and is most at home in a container or small niche in the rock garden. Plants produce many rose-pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Merlin’ is only 6-9\" tall with pastel-pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Nifty Thrifty’ has a great name along with pink ball-shaped flower heads on 6-8\" stems. The leaves are variegated white and green.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Ornament’ is an excellent hybrid with evergreen foliage and large white and rose flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Robusta’ is the most vigorous form I have seen. It grows 12-15\" tall and produces 3\" wide pink flower heads.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Rubrifolia’ is 8-10\" tall with many rose-red flowers over the grassy leaves.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Ruby Glow’ grows 8-10\" tall with ruby-colored flowers similar to ‘Dusseldorf Pride’. It can get rather washed out in the South.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Splendens’ is 8-10\" tall and bears intense red flowers. This is one of the most ornamental cultivars.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Victor Reiter’ is a clump former, only about 6\" tall, with narrow leaves (less than a quarter inch wide) and many pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Vindictive’ is a compact, free-flowering cultivar growing 6\" tall and bearing bright rosy-red flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species and Genera:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. girardii")]), _vm._v(" ("), _c('em', [_vm._v("A. setacea")]), _vm._v(") bears many pink flowers on 3-4\" tall stems over tufts of grasslike foliage. This is an excellent plant for the front of the garden.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. pseudoarmeria")]), _vm._v(", pinkball thrift, is similar and has large, 1-2\" diameter, white to rose flower heads. When well grown, the flowers look like those of chives. The foliage can appear limp and flaccid and in constant need of water when conditions are unfavorable.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_131"
    }
  }), _c('a', {
    attrs: {
      "id": "page_132"
    }
  }, [_c('em', [_vm._v("Arenaria montana")]), _vm._v(", mountain sandwort, is a similarly tough plant, but with white flowers and growing no more than 6\" tall. Plants are exceptional rock garden additions but do poorly in poorly-drained soils and hot climates. Zones 4-6.")])]), _c('a', {
    attrs: {
      "id": "page_132"
    }
  }, [_c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Arnica")])]), _vm._v(" (ar' ni-ca)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Arnica")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Asteraceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The genus consists of about 30 species, all similar in appearance to each other and confused with the leopard’s banes and inulas. "), _c('em', [_vm._v("Arnica")]), _vm._v(" differs from similar genera such as "), _c('em', [_vm._v("Doronicum")]), _vm._v(" and "), _c('em', [_vm._v("Inula")]), _vm._v(" by having opposite stem leaves rather than alternate. A good number of species are native to the Northwest and the Rocky Mountains and a couple are useful for the rock garden in areas with cool summer nights. They are relatively difficult to locate but two species, "), _c('em', [_vm._v("A. montana")]), _vm._v(", mountain arnica, and "), _c('em', [_vm._v("A. chamissonis")]), _vm._v(", are sometimes available. Both have deep yellow flowers on upright stems and flower in late spring and early summer. "), _c('em', [_vm._v("A. montana")]), _vm._v(" bears light green basal leaves and is easily the most popular in European gardens while "), _c('em', [_vm._v("A. chamissonis")]), _vm._v(" bears lustrous deep green foliage and a lighter yellow flower. The former is native throughout Europe while the latter is native from Alaska to the mountains of New Mexico.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Artemisia")])]), _vm._v(" (are-ti-meez' ee-a)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Wormwood")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Asteraceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This large genus (about 200 species) has an ancient and curious history, the aromatic properties having attracted herbalists for many hundreds of years. The common name resulted from the fact that many species were recommended to expel worms from the intestinal tract by herbalists such as Dioscorides and Pliny the Roman. The chemical santonin, derived from some of the Asiatic species, is still used for treatment of intestinal worms. Mugwort, "), _c('em', [_vm._v("A. vulgaris")]), _vm._v(", was widely used to flavor beer prior to the introduction of hops while hypochondriasis, gout, scurvy, kidney stones, and liver problems all received the medical attention of "), _c('em', [_vm._v("Artemisia")]), _vm._v(" prior to the 19th century.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_132"
    }
  }, [_vm._v("The large genus contains 4-6' tall plants that become woody with age, as well as mat-formers that never grow over 18\" tall. Some of the famous members of this noble genus are French tarragon, "), _c('em', [_vm._v("A. dracunculus")]), _vm._v("; the symbol of the Old West—the tumbling sagebrush, "), _c('em', [_vm._v("A. tridentata")]), _vm._v("; and the cause of much heartache and headache, absinthe, "), _c('em', [_vm._v("A. absinthium")]), _vm._v(". All species except "), _c('em', [_vm._v("A. lactiflora")]), _vm._v(" are characterized by having small, alternate leaves and inconspicuous, often dioecious flowers (male and female flowers on separate plants). The leaves on many species are finely divided, and are highly aromatic when crushed. Smelling crushed leaves is one of the best ways to determine the difference between plants of this genus and gray-leaved plants of closely-related genera such as "), _c('em', [_vm._v("Anthemis")]), _vm._v(" and "), _c('em', [_vm._v("Senecio")]), _vm._v(". Fragrance of the foliage is now being analyzed in laboratories as a means to separate cultivars within a species. For example, in the "), _c('em', [_vm._v("A. arborescens")]), _vm._v(" group of plants, ‘Powis Castle’ and other similar selections, ‘Faith Raven’ and ‘Brass Band’ had similar fragrance “fingerprints”. The major component was identified as thujone. Other plants in the same species had different fingerprints, often exhibiting little thujone. Fragrance fingerprinting may be ")]), _c('a', {
    attrs: {
      "id": "page_133"
    }
  }, [_vm._v("the only way to tell some of these cultivars apart, or find out that they are all the same but with 3 or 4 different names. Some species like to hide behind the fragrance of other herbs. "), _c('em', [_vm._v("A. chamaemelifolia")]), _vm._v(", chamomile wormwood, is a terrific little mat former that has a distinctive chamomile smell when leaves are bruised.")])]), _c('a', {
    attrs: {
      "id": "page_133"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Many species are from arid regions and are particularly suitable for dry, sunny areas and make few soil demands. In the South, however, where summers are humid and hot, many of the mat-forming species tend to open their centers and fall apart. Some species such as the lovely "), _c('em', [_vm._v("A. splendens")]), _vm._v(" are sensitive to wet soils and must be grown in loose rocky areas. The shrubby forms are more useful as they can be rejuvenated in the spring with hard pruning. This gives the pruner a wonderful sense of power and teaches the prunee to behave. Prune woody forms, such as ‘Powis Castle’, in the spring, not the fall. I killed a good number of artemisias by cutting the plants back hard in the fall. Woody perennials like salvia, perovskia and artemisia can all be given a “haircut” to clean them up but wait until active growth starts in the spring before severely cutting back. Most of the ornamental species have silvery-green foliage and are used as a foil for harsh colors in the garden, providing a cool note in hot, sunny weather. Applying fertilizer, particularly nitrogen, causes more harm than good to most species and tall, spindly growth results. Except for "), _c('em', [_vm._v("A. lactiflora")]), _vm._v(", plants are best grown lean and dry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The method of propagation differs for herbaceous and shrubby species. In general, herbaceous species are divided in the fall or early spring. Cuttings with a small piece of stem attached may be taken in late summer and placed in a clean bed consisting of a 3:1 ratio of perlite and peat. With the shrubby species, take 3-4\" long semi-hard-wood cuttings in late summer or fall and place in a cold frame in a similar medium. A rooting hormone is beneficial. Roots should be present in 3-4 weeks. Artemisia may be propagated under intermittent mist but cuttings rot quickly so plantlets must be removed as soon as roots form.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A number of silver foliage plants are similar to "), _c('em', [_vm._v("Artemisia")]), _vm._v(", including "), _c('em', [_vm._v("Achillea")]), _vm._v(", "), _c('em', [_vm._v("Senecio")]), _vm._v(" and "), _c('em', [_vm._v("Seriphidium")]), _vm._v(". The foliage of "), _c('em', [_vm._v("Artemisia")]), _vm._v(" is usually palmately divided or finely dissected and aromatic whereas the foliage of "), _c('em', [_vm._v("Seriphidium")]), _vm._v(" is generally simple and non-aromatic. One of the finest foliage plants for warm, dry areas is "), _c('em', [_vm._v("S")]), _vm._v(". "), _c('em', [_vm._v("palmeri")]), _vm._v(", native to southern California.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Artemisia Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Woody")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Silver Foliage")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. abrotanum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("36-48")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. absinthium")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("24-36")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. lactiflora")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("48-72")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. ludoviciana")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("24-48")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. schmidtiana")]), _vm._v(" ‘Nana’")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("6-12")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. stelleriana")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("15-24")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")])])])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_133"
    }
  }), _c('a', {
    attrs: {
      "id": "page_134"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_134"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_vm._v("-"), _c('em', [_c('strong', [_vm._v("abrotanum")])]), _vm._v(" (a-broe' tan-um)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southernwood")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-4'/18\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Gray Foliage")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southern Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All sorts of common names are also associated with this species. Romance overflowed everywhere with names like boy’s love, lad’s love, maiden’s ruin, maid’s love and maid’s passion but others like medicinal wormwood, Sabbath day posy, sloven-wood and sweet Benjamin were also tagged on to the plant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This species has light green (sometimes with some silver-green), finely divided, intensely fragrant foliage. Under good cultural conditions, plants grow 4' tall. The pinnately divided foliage is softly hairy at first and becomes less so later in the season. Some people like to plant it near a garden bench or a path so that the foliage can be brushed against to take advantage of the fragrance. Prune back hard in spring and early summer if necessary, otherwise plants will look weedy by midsummer. Flowers are yellowish-white but rather inconspicuous.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Tangerine’ has finely divided, feathery light green foliage on upright stems. Leaves have a citrus scent. Plants, like most artemisia, are deer-resistant.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-absinthium")])]), _vm._v(" (ab-sin' thee-um)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Wormwood, Absinthe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-3'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Gray Foliage")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Many of the artemisias have been used as herbal remedies and as local curatives for various ailments. "), _c('em', [_vm._v("A. absinthium")]), _vm._v(" was used to cure stomach aches and intestinal worms. Perhaps it is best known, however, as an important ingredient in the preparation of absinthe, a dry, bitter popular spirit containing 68% alcohol. Scientists then discovered that "), _c('em', [_vm._v("A. absinthium")]), _vm._v(" contains thujone, which, if ingested repeatedly, caused a disorder known as absinthism. Effects of absinthism included delirium, hallucinations, and permanent mental illness. First made by Pernod in 1797, production was banned in Switzerland, then France, but continued to be manufactured in Spain until 1939. The effects of absinthe were graphically displayed by the French painter, Degas, in his famous painting, “Absinthe”. Absinthe may still be purchased today, but is an imitation and contains no parts of the absinthe plant. Tea was also made from this plant and as L.H. Bailey stated in 1944, “Wormwood tea is an odorous memory with every person who was reared in the country”.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This woody artemisia has deciduous, finely divided silvery-gray foliage. The 2-5\" long leaves are more silvery than the previous species but not as fragrant. The flowers are tiny, gray and carried on long branched panicles. Plant in a dry, well-drained location in full sun.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("The Lambrook name, from East Lambrook Manor, the garden of Margery Fish, is associated with a number of artemisias. ‘Lambrook Mist’ has gray-green aromatic foliage. For the most persistent foliage, remove the flowering shoots.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_134"
    }
  }, [_vm._v("‘Lambrook Silver’ is about 2 1/2' tall and more gray-green than the type. If necessary, cut back heavily in the summer to discourage floppiness. This is the best artemisia for the North and the gray, finely divided foliage provides an effective break for ")]), _c('a', {
    attrs: {
      "id": "page_135"
    }
  }, [_vm._v("green-leaved plants in the garden. Both ‘Lambrook Mist’ and ‘Lambrook Silver’ were given Garden of Merit awards from the Royal Horticultural Society in 1993. ‘Lambrook Giant’ is a taller form and occasionally offered. ‘Silver Frost’ bears finely cut silver-green foliage and grows 15-18\" tall.")])]), _c('a', {
    attrs: {
      "id": "page_135"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-lactiflora")])]), _vm._v(" (lak-ti-flo' ra)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White Mugwort")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("4-6'/4'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Cream")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("China, India")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is the oddball of the group, having green foliage, conspicuous flowers, and growing best in moist areas. The 8-9\" long leaves are pinnately compound, each leaflet is about 3\" long, coarsely lobed and toothed, and the green rosette is evergreen in milder zones. Under suitable growing conditions, it easily attains 6' and requires staking. The magnificent cream-white flowers are borne in large 1-2' long plumelike panicles and persist well into the fall. This is an ideal background plant whose late-season flowers provide a nice change from the daisies that are so abundant at that time. It is also useful to cut for dried flowers. Plants do best in sunny locations in soils that do not dry out (unlike other species).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate by division every 3-4 years.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Guizhou’ has a good deal of variability, and is now referred to as the Guizhou Group. Plants were selected by Blooms of Bressingham and bear dark green (close to black) foliage and stems. Sprays of creamy white flowers are formed above the foliage in early summer. A handsome plant.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Jim Russell’ is 3-4' tall with white flowers and dark green foliage, not as dark as ‘Guizhou’. Plants grow as a clump, they do not run.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Variegata’ has green and gray leaves with white flowers. Propagation is exacting and plants are particularly difficult to locate.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-ludoviciana")])]), _vm._v(" (loo-do-vik-ee' aye-na)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White Sage")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-4'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Gray Foliage")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("North America")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This deciduous, non-woody species provides compact growth and good silver foliage color. It differs from most of the other gray-leaved species in having entire, rather than dissected leaves. The 2-4\" long leaves are white-woolly beneath and almost hairless above. The stems are white, and branched towards the top. The gray flowers are produced in late summer on narrow, branched, compound panicles. The roots can run rampant underground and quickly result in large clumps. This is the best species for southern gardens as it tolerates warm temperatures, is less prone to disease, and grows back quickly after pruning.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate by division in late summer or fall and cuttings in late spring and summer.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Latiloba’ has wide (3\" across) gray-green leaves with 3-5 lobes near the ends. It stands")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("12-24\" high and makes an effective ground cover. It is not as heat tolerant as the species.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_135"
    }
  }), _c('div', {
    staticStyle: {
      "height": "500px"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_135"
    }
  }), _c('p', {
    staticClass: "imagen"
  }, [_c('a', {
    attrs: {
      "id": "page_135"
    }
  }), _c('a', {
    attrs: {
      "id": "page_136"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/f0136-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_136"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_136"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Artemisia ludoviciana")]), _vm._v(" ‘Silver King’")])])]), _c('a', {
    attrs: {
      "id": "page_136"
    }
  }), _c('p', {
    staticClass: "bibp"
  }, [_c('a', {
    attrs: {
      "id": "page_136"
    }
  }), _c('a', {
    attrs: {
      "id": "page_137"
    }
  }, [_vm._v("‘Silver King’ may not really exist, but may simply be a variant of ‘Silver Queen’. Hardy to zone 3 and offers excellent deep silver foliage. The flower plumes sport red fall color not found in the species. Very invasive where comfortable.")])]), _c('a', {
    attrs: {
      "id": "page_137"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Silver Queen’ produces sparse female flowers and wide silvery leaves with deeply cut jagged margins. ‘Silver Queen’ is a little shorter, but with slightly larger leaves, than ‘Silver King’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Valerie Finnis’ stands only 15-18\" tall and produces handsome silver entire leaves. Unlike the previous two cultivars, she is non-invasive. I have not yet been impressed with her performance in the heat as plants tend to lose lower leaves in warm weather. Years of heavy summer rains are also destructive. However, if placed in well-drained soils, plants can be handsome.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-schmidtiana")])]), _vm._v(" (shmit-ee' aye-na)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Silvermound Artemisia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("15-24\"/18\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Silver Foliage")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Japan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The species is about 2' tall but seldom seen in gardens. It is represented by the dwarf form ‘Nana’ and usually sold as ‘Silver Mound’. The finely cut silver foliage grows in a silky cushion that completely covers the small, drooping yellow flowers. The handsome mounding habit has resulted in this plant being immensely popular in the North. The mounded shape is retained most of the season in the Northeast and Canada but, unfortunately, it “melts out” in hot summers and is disappointing south of zone 6. Melt out also occurs in the Midwest, only later. The center of the plant opens and any semblance of a mound is lost, making it a particularly poor choice for southern gardens. It is rather woody at the base and cuttings consisting of the leaf, petiole and a piece of the stem should be taken in the summer.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-stelleriana")])]), _vm._v(" (stel-la-ree-ah' na)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Beach Wormwood")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("15-24\"/30\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Silver Foliage")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Northeast Asia, United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants are known as old lad and perennial dusty miller as well as beach wormwood and are cold hardy to zone 4. They are highly tolerant of salt air and saline water but intolerant of poorly drained soils. The white silky leaves are densely hairy, lobed and divided. Many 1/4\" wide yellow flowers are borne in a narrow panicle.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Broughton Silver’ is also known as ‘Mori’s Form’, a compact, low-growing silvery plant recently introduced from Japan. A handsome selection for rock gardens or raised beds. It is probably the same as ‘Silver Brocade’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Silver Bouquet’, recently released from the University of British Columbia, is a low-growing mat former with excellent silver foliage.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Silver Brocade’ is another low-growing (6-12\") gray-leafed form that is becoming a standard for low-lying artemisias. Its prostrate and compact habit sets it apart from other cultivars. Excellent drainage is necessary. Plants have a tough time in the Southeast, but if planted in containers, it is terrific. Also introduced by the University of British Columbia Botanical Garden.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_137"
    }
  }), _c('a', {
    attrs: {
      "id": "page_138"
    }
  }, [_vm._v("‘Silverado’ is offered by a few nursery people as a non-melting substitute for ‘Silver Mound’. Similar foliage but not quite as “moundy”.")])]), _c('a', {
    attrs: {
      "id": "page_138"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species and Hybrids:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. frigida")]), _vm._v(", mountain fringe, native to the Plains States, bears deeply cut silver foliage with woody stems and tufts of yellow flowers. Plants grow 8-12\" tall and are useful for the front of the garden. ‘Laramie’ is a compact selection (8-10\" tall) from Rice Creek Gardens in Blaine, Minnesota. An Award of Garden Merit winner in 1993 from the Royal Horticultural Society.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A")]), _vm._v(". x ‘Huntington’ (‘Huntington Gardens’) is likely a hybrid with "), _c('em', [_vm._v("A. absinthium")]), _vm._v(" in its bloodlines. Plants become woody at the base and grow about 18\" tall, but can reach 4 feet. The handsome silver foliage is deeply cut and soft to the touch. As with other taxa of wormwood, wet soils are sure death. However, plants appear to be relatively heat tolerant. Hardy in zones 5 to 7.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. pontica")]), _vm._v(", Roman wormwood, is also very fragrant and bears finely divided light green foliage, somewhat resembling the leaves of common yarrow. Plants grow up to 2' tall but can be pruned to stay low to the ground. Handsome plants, however, they can reseed where comfortable and have been cursed as thug-esque as often as lauded as garden-esque. ‘Old Warrior’ is shorter (18\") and more silver than the species.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Powis Castle’ took the gardening world by storm when it was introduced and is still one of the finest plants in cultivation. Two stories of its origin may be found. Graham Stuart Thomas suggested that it was a hybrid of "), _c('em', [_vm._v("A. arborescens")]), _vm._v(" and "), _c('em', [_vm._v("A. absinthium")]), _vm._v(" raised by Mr. J. Hancock at Powis Castle in Wales. However, according to Dr. J.D. Twibell, Mr. Hancock obtained the material as a cutting from a gardener in Yorkshire, England and was already propagating and distributing the plant when he moved to Powis in 1972. Regardless of its origins, is an outstanding filigreed silver artemisia. It blends relative hardiness with beauty and combines with many plants to perfection. Plants are sterile, or occasionally throw out a small flower, and are uniform. They are reliably cold hardy to zone 6 and heat tolerant to zone 8. Although not as popular as it once was, this is still an excellent plant. Prune in spring or summer, not fall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. purshiana")]), _vm._v(", pursh sagebrush, is similar to ‘Silver King’ but only 2-3' tall with narrower, less divided, almost entire, leaves. It also flowers about a week earlier and more profusely. This is listed as a synonym of "), _c('em', [_vm._v("A. ludoviciana")]), _vm._v(" by some authorities or a selection of "), _c('em', [_vm._v("A. ludoviciana")]), _vm._v(" by others.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. pycnocephala")]), _vm._v(" is native to California and has handsome gray-green cut foliage. However, ‘David’s Choice’ is better, forming 1' tall mounds of finely textured silver foliage, much like ‘Powis Castle’. Selected near Point Reyes, California, plants do best in coastal climates. Zones 6-9.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. rupestris")]), _vm._v(" is a finely cut sub-shrub growing to about 18\" tall. Cold hardy to zone 4, plants are tough and easy to grow in well-drained soils.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Tiny Green’ is a low-growing (3-5\" tall) spreading wormwood with gray-green foliage small yellow flowers in midsummer. An excellent choice for the sunny rock garden. Zones 5-9.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_138"
    }
  }, [_c('em', [_vm._v("A. vulgaris")]), _vm._v(" is simply an aggressive ground cover for some but an invasive weed for most others. Plants grow only 6\" tall and produce green foliage, rooting at every node. ")]), _c('a', {
    attrs: {
      "id": "page_139"
    }
  }, [_vm._v("For thuggishness, ‘Limelight’ is the worst of all, promising a beautiful green and yellow variegated foliaged ground cover. What most people get after a few years is an impossible-to-remove invader, whose variegated leaves do nothing for you when hurting your back trying to get rid of it.")])]), _c('a', {
    attrs: {
      "id": "page_139"
    }
  }, [_c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Arum")])]), _vm._v(" (ar' um)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Arum")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Araceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Approximately twenty species belong to this genus and all are characterized by a spadix consisting of unisexual flowers, the females at the base, the males above them with sterile flowers between (similar to the genus "), _c('em', [_vm._v("Arisaema")]), _vm._v("). The large spathe is the showy part and envelops the spadix in the spring. Plants emanate from tubers; the shoots generally arising from the top of the tuber and the roots produced from the base of the shoots. More and more woodland species are being offered to gardeners for use in shady, moist areas. Some of the most handsome foliage to be found on any garden plant belongs to "), _c('em', [_vm._v("A. italicum")]), _vm._v(" ‘Pictum’.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-italicum")])]), _vm._v(" (ee-ta' li-kum)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Italian Arum")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("12-20\"/18\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Creamy White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southern Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Arum italicum")]), _vm._v(" is a woodland species native to Italy, the Mediterranean and south to the Canary Islands. The habit is unusual to most gardeners in that new foliage appears late in the fall (November in my garden) and remains green over winter. The leaves are followed by creamy-yellow spathes in spring similar in structure to jack-in-the-pulpit ("), _c('em', [_vm._v("Arisaema triphyllum")]), _vm._v(") flowers. They are easy to distinguish from jack-in-the-pulpits because arum has simple leaves while “jacks” have compound leaves. The flowers disappear in summer and are replaced with strong columns of bright orange-red berries as ornamental as any part of the plant. The berries are equally common in northern and southern gardens, but may persist longer in the North. Although most at home in the woodland garden, plants are particularly handsome at the front of any shade area. The 12\" long, hastate (like an arrowhead) leaves are at their best in late fall and winter. For this reason, it is an exceptional plant for the winter garden. Combined with the winter foliage of "), _c('em', [_vm._v("Bergenia")]), _vm._v(" or "), _c('em', [_vm._v("Heuchera")]), _vm._v(", and the architectural forms of ornamental grasses such as "), _c('em', [_vm._v("Miscanthus")]), _vm._v(", the garden may be enjoyed 12 months of the year. Of course, these handsome scenes are not quite as handsome if 3 feet of snow is on the ground. Similar to "), _c('em', [_vm._v("Arisaema")]), _vm._v(", plants contain calcium oxalate; try to refrain from eating them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate the species and cultivars by division after leaves appear in fall. Seed of the species must be stratified (provided with cool, moist conditions) in the fall and left until spring at which time some germination may occur. Seed often requires a year to germinate.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("A number of nurseries, mostly in Europe, have introduced slight variants (‘Bill Baker’, ‘Cyclops’) to well-known cultivars, but few are available in North America.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Dick and Dot’, from Heronswood Nursery is certainly interesting if not beautiful. The white spathe has purple dots throughout and surrounds a white spadix. You have to get down on your hands and knees to enjoy the sight, but it is worth the creaky joints.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_139"
    }
  }), _c('div', {
    staticStyle: {
      "height": "450px"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_139"
    }
  }), _c('p', {
    staticClass: "imagen"
  }, [_c('a', {
    attrs: {
      "id": "page_139"
    }
  }), _c('a', {
    attrs: {
      "id": "page_140"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/f0140-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_140"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_140"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Arum italicum")]), _vm._v(" ‘Pictum’")])])]), _c('a', {
    attrs: {
      "id": "page_140"
    }
  }), _c('p', {
    staticClass: "bibp"
  }, [_c('a', {
    attrs: {
      "id": "page_140"
    }
  }), _c('a', {
    attrs: {
      "id": "page_141"
    }
  }, [_vm._v("‘Eco Italian’ is similar but the foliage is much lighter in color, with more white than the species.")])]), _c('a', {
    attrs: {
      "id": "page_141"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Jet Black Wonder’ (not to be confused with the "), _c('em', [_vm._v("Alocasia")]), _vm._v(" of the same name) was introduced by Plant Delights Nursery. The dark green leaves have some black spotting, but the purple petioles are its saving grace. They bear greenish spathes and a white spadix.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Marmoratum’ has broad gray-green leaves marbled with splotches of yellow-green. The leaves are larger than those of the more common ‘Pictum’ and the yellow-green spathe is purple at the base. Unfortunately, it is difficult to find in the trade. This may be because the name is used interchangeably with ‘Pictum’ and the distinction between the two has almost disappeared.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pictum’ is still the best form of this species and has dark green leaves that are narrowly spear shaped and conspicuously blotched with gray and cream. It grows approximately 18\" tall, spreads by tuberous roots, and is an excellent ground cover. In the fall, shiny clustered spikes of bright orange berries brighten the landscape.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘White Winter’ is probably the most ornamental form I have seen but difficult to find. The green leaves are heavily mottled with silvery lines.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. creticum")]), _vm._v(", from Crete and Turkey, has green leaves similar to more common species, but bears golden yellow spathe and a dull yellow spadix. Zone 7b.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. dioscoridis")]), _vm._v(" is extremely variable but generally has large triangular leaves and purple-spotted spathes with a dark spadix within. Flowers are rather malodorous, smelling of dung and carrion. Bet you can’t wait to find this one. Plants are winter hardy only to zone 7 or 8.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. maculatum")]), _vm._v(", lords and ladies, or cuckoo-plant, bears glossy green leaves, often with black spots and creamy-yellow spathes. They differ from "), _c('em', [_vm._v("A. italicum")]), _vm._v(" by having a violet-yellow or violet flushed spadix compared to the yellow spadix of "), _c('em', [_vm._v("A. italicum")]), _vm._v(". Orange-red berries are produced in late summer and fall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. pictum")]), _vm._v(" is interesting in that its flowering time is quite different than that of the above species. Dark green leaves in the fall are accompanied by dark purple spathes and spadices are quite beautiful, and smelly enough for crazy gardeners as well. Native to the Mediterranean area, plants are likely hardy only to zone 7.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Aruncus")])]), _vm._v(" (ah-run' kus)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Goat’s Beard")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Rosaceae")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_141"
    }
  }, [_vm._v("Only two species occur and each possesses excellent qualities for the garden. Male and female flowers occur on different plants (dioecious) and are carried in tall showy panicles (compound inflorescences). The light green foliage is bipinnately compound. A little afternoon shade is useful and moisture is necessary for best growth and flowering in southern areas of the country (zone 5 to 7), although plants perform best in full sun further north. Consistent moisture is important regardless of locale; the leaf ")]), _c('a', {
    attrs: {
      "id": "page_142"
    }
  }, [_vm._v("margins of plants grown in dry areas will turn brown and crispy. In general, species of "), _c('em', [_vm._v("Aruncus")]), _vm._v(" do terribly south of zone 7a.")])]), _c('a', {
    attrs: {
      "id": "page_142"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate by division in the spring or by seed collected fresh and placed in a warm (70-75°F), humid area. Germination will occur in two to three weeks. If seed is old, place at 40°F for about 4 weeks prior to putting them in the warmth.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-dioicus")])]), _vm._v(" (die-o-eye' kus)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Goat’s Beard")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("4-6'/6'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Creamy White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe, Asia, North America")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zone 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is a spectacular plant when given sufficient moisture, dappled shade, and plenty of room. The flowers of "), _c('em', [_vm._v("Aruncus")]), _vm._v(" are either male or female but the two sexes are rather unisexual in appearance and difficult to tell apart from a distance. The 2-3' long light green leaves are bi- to tripinnately compound and each lanceolate leaflet is sharply doubly serrated. Plants are similar to some of the tall white forms of "), _c('em', [_vm._v("Astilbe")]), _vm._v(" and can be confused. Three ways may be used to separate "), _c('em', [_vm._v("Aruncus")]), _vm._v(" from taller astilbes such as "), _c('em', [_vm._v("Astilbe biternata")]), _vm._v(" and ‘Prof. van der Wielen’. In general, leaves of "), _c('em', [_vm._v("Astilbe")]), _vm._v(" are usually singly serrated, those of "), _c('em', [_vm._v("Aruncus")]), _vm._v(" are doubly serrated, there are always 10 stamens in "), _c('em', [_vm._v("Astilbe")]), _vm._v(" flowers, there are either 20 (male) or 0 (female) stamens in "), _c('em', [_vm._v("Aruncus")]), _vm._v(". They are small and difficult to count but nobody will laugh. Finally, in each fruit "), _c('em', [_vm._v("Astilbe")]), _vm._v(" has many seeds, "), _c('em', [_vm._v("Aruncus")]), _vm._v(" has two to four seeds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the northern states, plants are far more tolerant of afternoon sun than in the South. I have tried to grow goat’s beard in Athens, Georgia (zone 7b) for many years and have not succeeded. It is either too hot or I can’t provide sufficient moisture or both. However, I have seen fine specimens in Raleigh, North Carolina (zone 7a). Because of these experiences, I don’t recommend its use south of zone 7a (although it will survive even further south, it will not perform well).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Where well grown, large plumelike panicles of small ("), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_vm._v("1")])]), _vm._v("/"), _c('span', {
    staticClass: "small"
  }, [_vm._v("8")]), _vm._v("\") creamy flowers appear in late spring and provide a magnificent sight. I read that males are more sought-after than females because the plumes are supposedly fuller. I have stared at clumps of goat’s beard for hours trying to determine the garden differences between male and female plants. As I stuck my head through foliage, flowers and fruit, the conclusion was painfully obvious—gender makes little difference. One can argue that the male plumes are more feathery and upright than the drooping seed-laden females, but unless you are a chauvinist of some kind, it does not matter. Plants form large clumps in rich soils but unfortunately many of today’s smaller gardens can not afford the space.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In an earlier edition of this book, I casually mentioned that one could divide plants if additional plants were desired. A letter arrived a few months later showing me the error of my ways. "), _c('em', [_vm._v("“I would like to know what kind of mischievous smile you had when you wrote ... that Aruncus is propagated ... by division ... Let me briefly tell you my experience with a 6-7 year old clump. It took: 1 pick (which broke), three shovels (one of which broke), an ax and two people (in your next book, you might suggest that a husband/wife team not attempt this project together). Then it went through pruners (dumb on my part) to loppers (still quite dumb), to a pruning saw (we’re getting smarter), to a big hand saw, with serious consideration on getting out the chain saw.")])])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_142"
    }
  }), _c('a', {
    attrs: {
      "id": "page_143"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0143-01.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_143"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Aruncus dioicus")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('em', [_vm._v("At one point there was discussion of laying it on its side, varnishing it, and making end tables out of it. Anyway, it was an experience to remember.”")]), _vm._v(" Robyn Duback, Robyn’s Nest Nursery, Vancouver, Washington.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Cultivars and Hybrids:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("astilboides")]), _vm._v(" is a smaller version (18-24\") of the species, and although difficult to find in the American trade, is worth the hunt. The leaves are more deeply serrated and the inflorescence less compound.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Glasnevin’, from the wonderful Botanic Gardens at Glasnevin, Dublin, bears deeper green fuller leaves and is dwarfer than the species. Apparently, it is also more tolerant of dry soils.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_143"
    }
  }), _c('a', {
    attrs: {
      "id": "page_144"
    }
  }, [_vm._v("‘Kneiffii’ is only 3' tall with foliage deeply cut into threadlike segments. This foliage is wonderfully handsome but the flowers are not as dramatic.")])]), _c('a', {
    attrs: {
      "id": "page_144"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Misty Lace’ is a terrific hybrid that is intermediate between "), _c('em', [_vm._v("A. dioicus")]), _vm._v(" and "), _c('em', [_vm._v("A. aethusifolius.")]), _vm._v(" It had its beginnings at Bluemont Nursery in Maryland, the excellent establishment of Richard Simon. Three plants were brought back to the University of Georgia, two immediately died, but one grew vigorously. With the help of Dr. Hazel Wetzstein, plants were successfully propagated in tissue culture and were released in 2005. Its attributes are the compact habit (2-3' tall), tolerance to heat and cold (zones 3-7b) and excellent foliage even after flowering. This is a great addition to the genus.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Child of Two Worlds’ is a shorter, more airy form with pendulous white flowers. This cultivar is thought to be a form of "), _c('em', [_vm._v("A. sinensis.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. aethusifolius")]), _vm._v(", native to Korea, is an nice addition to the perennial trade and is a true miniature. It attains a mature height of 8-12\", has deeply cut dark green leaves and a panicle of creamy white flowers. Plants tolerate partial shade, and are most at home in the rock garden or the front of the border. A little more heat tolerant than "), _c('em', [_vm._v("A. dioicus.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Asarum")])]), _vm._v(" (a-sar' um)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Wild Ginger")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Aristolochiaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Asarum")]), _vm._v(" contains about 70 species, most of which are native to north temperate areas. The common name comes from the ginger-like smell that arises from the roots when bruised or cut. The plant that provides true ginger, however, is "), _c('em', [_vm._v("Zingiber officinale.")]), _vm._v(" Wild ginger spreads by rhizomes, produces only a few leaves and is generally less than 6\" tall. Many excellent species are native to North America, but recent explorations to China and Japan have resulted in a cornucopia of ginger delights. Whereas I was hard-pressed to come up with 6-7 selections for the second edition of this book, it is easy to find a couple of dozen today. One of our great plantsmen, Barry Yinger, offered over 120 selections in his Asiatica catalog in 2007! These include species with outstanding foliage textures, variegations, small flowers and immense ones. "), _c('em', [_vm._v("A. splendens")]), _vm._v(" is an outstanding Chinese species with large dark green leaves mottled with silver throughout. It has remained evergreen in the Armitage garden to 10°F. "), _c('em', [_vm._v("A. kumageanum")]), _vm._v(" (my favorite) and "), _c('em', [_vm._v("A. magnificum")]), _vm._v(", one of the biggest species (12-15\" tall), were introduced from Japan by the Arnold Arboretum. A good deal of study and collection have occurred in this genus and Japanese species continue to be described. Recently, two additional Japanese species, "), _c('em', [_vm._v("A. fudsinoi")]), _vm._v(" and "), _c('em', [_vm._v("A. minamitanianum")]), _vm._v(" were described from plants at Kew Gardens. Many of these species will never be common garden plants but with the possible aid of tissue culture, they may be available on a limited scale in the future.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_144"
    }
  }, [_vm._v("All species prefer woodland conditions of slightly acid soils, heavy shade, constant moisture and good drainage. In the wild, plants generally occur in the dappled shade of deciduous forests. In the garden, they are used mainly as shade-tolerant ground covers whose glossy green leaves, often mottled with white or yellow, are amazingly eye-catching for such diminutive plants. The urn-shaped flowers consist ")]), _c('a', {
    attrs: {
      "id": "page_145"
    }
  }, [_vm._v("of sepals only and are borne underneath the foliage. The “little brown jugs” are wonderfully handsome but are seldom seen by the uninitiated. The sepals usually end in turned-back lobes, referred to as the calyx lobes, and may be handsome in their own right. Hidden from flying insects, the flowers are pollinated by ground-hugging insects.")])]), _c('a', {
    attrs: {
      "id": "page_145"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Some taxonomists have split this genus into 2 main sections, placing evergreen species in the genus "), _c('em', [_vm._v("Hexastylis")]), _vm._v(" and the deciduous species in "), _c('em', [_vm._v("Asarum.")]), _vm._v(" I have retained all species under "), _c('em', [_vm._v("Asarum.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Species may be propagated by seed although the most foolproof method is division in spring or early fall.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-arifolium")])]), _vm._v(" (ar-i-foe-lee' um)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Arrow-leaf Ginger")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-8\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Dull Brown")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southeastern United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In this large native ginger, the evergreen leaves are up to 8\" long, 10\" across and usually visibly mottled. They are triangular to arrow-shaped (deltoid to sagittate) and smooth throughout. A great deal of variability occurs, resulting in some plants having different degrees of leaf mottling, which shows up more in the spring than in the summer. The leaves and roots also have a pleasant smell when crushed. In early spring, the tan-colored buds are easily visible, especially if the old leaves are removed. In later spring, flask-shaped brown flowers with prominent spreading lobes occur, although significant variability also occurs with the flowers. For most gardeners, this is a reliable, excellent ginger.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Beaver Creek’ was selected by Jean Frett at the Mt. Cuba Center in Delaware. Plants are similar to the species but appear to be more vigorous.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-canadense")])]), _vm._v(" (can-a den' see)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Canadian Ginger")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("4-8\"/10\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Dull Brown")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Canada, United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most of the popular gingers today are evergreen but for the toughest and most cold tolerant, this aggressive deciduous species fits the bill. Down and out in the winter, two soft-green kidney-shaped downy leaves emerge early in the spring about the same time as the flowers. Plants tend to ramble (some say rocket) a good bit, and given cool, moist areas, large colonies may occur within a few years. The 1\" wide flowers are obviously hairy, greenish on the outside and brown within. The three flared, pointed flower lobes look they have been peeled back to allow ground-hugging bugs to do their pollinating. They are certainly not as exciting as the flowers on the Asian species, but fun to look at regardless.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Canadian ginger is probably the most cold hardy of the gingers and one of the most popular, even as far south as Zone 7.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Eco Choice’ and ‘Eco Red Giant’ are more dense and larger than the species, respectively.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_145"
    }
  }), _c('a', {
    attrs: {
      "id": "page_146"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_146"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-europaeum")])]), _vm._v(" (eur-o' pay-um)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("European Wild Ginger")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-8\"/8\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Dull Brown")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This excellent ground cover is at home in the woodland garden. The 2-3\" wide kidney-shaped leaves are leathery, glossy dark green, and evergreen. The leaves are hairy, particularly on the veins on the upper surface. The small dull brown flowers are also hairy and bear three pointed lobes about half as long as the flower.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I believe the foliage is some of the most handsome in the genus, but the flowers are among the most forgettable. This is one of the hardiest and easiest species to establish in the North. I have seen this stuff taking over pathways and shade gardens of my gardening friends in Long Island and like Santa Claus, I always return with a sack of ginger on my back. Unfortunately, plants don’t tolerate high temperatures associated with southern summers as well, and although they still work in the South, they are better in the Northeast and Midwest. Moist, shady conditions are needed for best performance.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-maximum")])]), _vm._v(" (max'-i-mum)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Panda Face Ginger")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-12\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Brown")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("China")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 7-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This plant has made significant headway in the American market for good reasons. The 6\" long, evergreen leaves provide a handsome clump of glossy green foliage and plants are well worth giving a try. The 2\" wide flowers are larger than others, and they are also among the most eye-catching, being purple on the outside and white with dark purple margins on the inside. The plants are useful in the shade garden or in containers where the flowers can be enjoyed without having to get on one’s knees. Plants are cold hardy only to about zone 7.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("‘Green Panda’ is offered, however it does not seem to be different than the species.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("‘Ling Ling’ is one of the more sought-after forms, bearing handsome mottled foliage with the same beautiful flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-shuttleworthii")])]), _vm._v(" (shut-tle-worth-ee' eye)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Shuttleworth Ginger")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("4-9\"/8\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Brown")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southeastern United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants bear beautiful mottled evergreen heart-shaped to rounded foliage. The 1-2\" long urn-shaped flowers are pale brown to red with broad calyx lobes. Plants are not as winter hardy, but are more heat tolerant than the Canadian or European gingers. They are native from Virginia to Alabama and Georgia.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Callaway’, selected from Callaway Gardens in Pine Mountain, Georgia, is probably a selection of "), _c('em', [_vm._v("A. shuttleworthii")]), _vm._v(" var. "), _c('em', [_vm._v("harperi")]), _vm._v(". Plants were introduced by one of America’s great plantsmen, Fred Galle. Plants are more compact than the species, growing only about 6\" tall with handsome mottled foliage. This is one of the finest mat formers but unfortunately, one of the slowest growers. In the Armitage garden, it has taken about 8 years to form a clump 18\" square, but oh what a clump it is!")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_146"
    }
  }), _c('a', {
    attrs: {
      "id": "page_147"
    }
  }, [_vm._v("‘Cahaba River’ also has silver mottling and relatively large purple flowers beneath the foliage. Plants were found by Barry Yinger near the Cahaba River in central Alabama.")])]), _c('a', {
    attrs: {
      "id": "page_147"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Velvet Queen’ is similar to, but produces larger leaves than ‘Callaway’. The same beautiful silver mottling may be found on this selection but the larger leaves and flowers provide a larger clump in less time.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-speciosum")])])]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Alabama Ginger")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("9-12\"/12\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Purple")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southeastern United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I include this species not only because it is a beautiful native ginger but also because it is making a comeback, at least in American gardens. Plants are native to small areas of the Southeast, mainly Alabama, and lack of availability has made plants difficult to include in gardens. The large triangular leaves are lightly mottled and evergreen, and can be mistaken for arrow-leaf ginger. However, the flowers are much larger, and deep purple around the edges, with purple lines radiating from the center. I only wish it were more cold hardy so growers in the North could enjoy it as much as I do.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0147-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Asarum shuttleworthii")]), _vm._v(" ‘Callaway’")])]), _c('p', {
    staticClass: "noindentp"
  }, [_c('a', {
    attrs: {
      "id": "page_147"
    }
  }), _c('a', {
    attrs: {
      "id": "page_148"
    }
  }, [_c('strong', [_vm._v("Related Species:")])])]), _c('a', {
    attrs: {
      "id": "page_148"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("There has been such an incredible influx of gingers since the last edition, thanks mainly to people like Barry Yinger, Ozzie Johnson, Tony Avent, Dick Lighty and other forward-looking plantspeople, that it is impossible to list them all. In fact, it is impossible to list even those I am enamored with, and I know but a small fraction. Here is a decent effort.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. caudatum")]), _vm._v(" has slightly hairy rounded evergreen leaves and densely hairy petioles when young. The reddish brown flowers are most fascinating due to the long twisted tails (“cauda”) on the lobes. Native to Washington eastward to western Montana, and south to northeastern Oregon. A white-flowered form, forma "), _c('em', [_vm._v("alba")]), _vm._v(", is an interesting plant, although the flowers are mostly hidden by the foliage. Zones 4-8.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. hartwegii")]), _vm._v(", Sierra wild ginger, is a western representative, native to Oregon and California. The green leaves have conspicuous silver veining and the outstanding mottling has earned the common name of cyclamen-leafed wild ginger. ‘Silver Heart’ has a silver streak through the midsection of the green leaf. Terrific plants but excellent drainage is a must.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. heterophyllum")]), _vm._v(" generally bears round green leaves and urn-shaped flowers. While walking around the woodland at Mt. Cuba in Delaware, Dr. Richard Lighty, the former director of the garden, pointed out a clump of marvelously variegated "), _c('em', [_vm._v("A. heterophyllum")]), _vm._v(". Seeing that beautiful form simply reinforced the fact that all species of this genus are highly variable and that green and mottled forms will occur in most of them. Plants are native to the eastern United States.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. virginiacum")]), _vm._v(" is native to Virginia and the Carolinas and has evergreen, heart-shaped, 2-3\" long dark green leaves often with white spots on the upper side. Similar to "), _c('em', [_vm._v("A. minor")]), _vm._v(" and "), _c('em', [_vm._v("A. shuttleworthii")]), _vm._v(", however the flowers are smaller. ‘Silver Splash’ has a more distinctive silver mottling pattern on the foliage. Zones 5-9.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. splendens")]), _vm._v(", Chinese ginger, is a fine spreading form with large silver-mottled glossy leaves and 2\" purple flowers with white centers. Plants are evergreen and quite at home in zones 6-9.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Asclepias")])]), _vm._v(" (as-klee' pe-as)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Silkweed, Milkweed")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Asclepidaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although many plants in this genus are highly ornamental, some argue that few, if any, milkweeds are worthy of inclusion in the formal garden. "), _c('em', [_vm._v("A. curassavica")]), _vm._v(", blood flower, is as ornamental as any species but is considered an annual in most of the country. However, if people loosen up a little, and get out of the formal garden frame of mind, then milkweeds become exceptional plants. Meadow gardens, native plantings, and informal wildlife sanctuaries are the domain of many of these plants. And to be sure, planting milkweeds is part of good stewardship, as they attract butterflies from all over the neighborhood. I have a love/hate relationship with these things, so I am quite impressed when I find an entire nursery like the Milkweed Farm, Bluemont, Virginia devoted to distributing milkweed")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_148"
    }
  }, [_vm._v("A couple of species are crossover plants, popular in both formal and informal settings. The most brilliant is probably butterfly weed, "), _c('em', [_vm._v("A. tuberosa")]), _vm._v(", but swamp milk-weed, "), _c('em', [_vm._v("A. incarnata")]), _vm._v(" has also turned a few gardeners’ heads. Once established, milkweeds ")]), _c('a', {
    attrs: {
      "id": "page_149"
    }
  }, [_vm._v(" usually prosper. Anyone who has farmed and tried to rid fields of one of the great agronomic pests, common milkweed, "), _c('em', [_vm._v("A. syriaca")]), _vm._v(", knows how tenacious members of this genus can be. Oh, how I remember, as a lowly “weeder” on a farm in southern Quebec, cursing this plant. However, to be fair, some highly creative people have found that other creative people will actually pay a pretty good dollar for the inflated pods of the common milkweed to be used as dried ornaments. And if you stick your nose in the flowers, you will be rewarded with a wonderful honey scent.")])]), _c('a', {
    attrs: {
      "id": "page_149"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("All members of this genus have milky sap (although butterfly weed is much less obvious than others), inflated seed pods (follicles), and silky seeds. All species are highly coveted by aphids and if you grow milkweed, you will also be farming aphids. A horde of ladybugs or a strong stream of water will help keep them under control.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Asclepias Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower Color")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Leaf Arrangement")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. incarnata")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Rose-pink")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Opposite")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. tuberosa")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Orange")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Alternate (spiral)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-incarnata")])]), _vm._v(" (in-kar-nay' ta)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Swamp Milkweed")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-4'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Rose-pink")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("North America")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Swamp milkweed has opposite 3-6\" long leaves and clusters of rosy pink flowers atop 3-4' tall plants in late spring and summer. The flowers have a faint vanilla scent and are real come-ons for many butterflies. In particular, the foliage is a primary source of food for monarch butterflies. The sap of this species is milkier than in butterfly weed, thus complicating cutting for flowers. Plants can be found in ditches, swamps and any moisture-retaining soil. In the garden, find a low area, although well-drained sites are tolerated. All taxa have red-brown seeds with a silky tail within the seed pods.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Cinderella’ has been selected for the larger rosy pink flowers and more compact flower heads. Flowers have an interesting fragrance of vanilla.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Ice Ballet’ produces persistent white flowers on 3-5' stems. When butterflies hover, which they will, the contrast is fabulous.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Soulmate’ bears rose-purple clusters of flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-tuberosa")])]), _vm._v(" (tew-be-ro' sa)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Butterfly Weed")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-3'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Orange")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Eastern North America")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_149"
    }
  }, [_vm._v("The orange flowers of butterfly weed are so vibrant that they seem to jump out at you. There is a good deal of variation in flower color and I’ve seen plants ranging from pure yellow to dark red at the edge of woods in north Georgia. Plants were and may still be used in the treatment of pleurisy, a common ailment in early colonial times in which inflammation of the pleura around the lungs resulted in coughing, wheezing and great pain. It was so effective in treating this ailment that it became known as pleurisy weed. ")]), _c('a', {
    attrs: {
      "id": "page_150"
    }
  }, [_vm._v("Mature plants do not transplant well, thus removing plants from the wild should not be attempted. The 4-4 1/2\" long leaves are more or less alternate but may spiral up the stiff stems. The stems are topped by umbels of many small flowers in spring and continue to bloom at least six weeks in the garden. Cut flowers have a good vase life if immediately placed in warm water, then transferred to the refrigerator for 12 hours. Some gardeners flame the base of the stem to reduce the flow of sap, but flowers will not decline if flaming is not attempted, and you will not burn your house down either. Cutting the flowers also results in additional flowering three to four weeks later.")])]), _c('a', {
    attrs: {
      "id": "page_150"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Flowers allowed to remain on the plant give way to narrow 3-6\" long ornamental follicles that provide an additional dimension to the plant. They should be removed before they open because the seeds spill out at that point, and ornamental soon gives way to messy. Butterfly weed is slow to emerge in the spring and patience is a must.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some research on forcing the flowers in the greenhouse has shown that "), _c('em', [_vm._v("A. tuberosa")]), _vm._v(" requires short nights (i.e. long days) in order to flower. Growers use a 60W incandescent light bulb from 11:00 p.m. to 2:00 a.m. each night to “trick” the plants into thinking the nights are short. Under the normal long nights of winter, plants just sit there and decline.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Seed germination is highly variable and results as low as 5% to as high as 90% have been reported. If fresh seed is collected, cleaned, and sown immediately, 50-80% germination will result. Old seed or seed that is purchased germinates more uniformly if seeds are sown in a well-aerated soil mix, watered in well, covered with plastic, and placed in the refrigerator or other cool place for about six weeks. A good deal of variation in flower color results from seed-sown material. Root cuttings can be used to increase forms that have merit (see "), _c('em', [_vm._v("Anemone")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0150-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Asclepias tuberosa")])])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_150"
    }
  }), _c('a', {
    attrs: {
      "id": "page_151"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0151-01.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_151"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Asclepias tuberosa")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('strong', [_vm._v("Cultivars")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("‘Gay Butterflies’ is a mix of yellow-, orange- and red-flowered forms. Plants are generally 2-3' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("‘Hello Yellow’ bears vibrant yellow flowers atop 24-30\" plants. A showstopper.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. purpurascens")]), _vm._v(", purple milkweed, caught me totally by surprise. As a real skeptic of anything milkweed-ish, you can imagine my own surprise at embracing this beautiful deep purple-flowered plant. It is a milkweed, but the flowers catch your eye immediately on turning the corner. Plants are about a foot tall, and flower in late May to early June. Not as fragrant as "), _c('em', [_vm._v("A. syriaca")]), _vm._v(", but not bad either.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. verticillata")]), _vm._v(", horsetail milkweed, has narrow, sessile, whorled leaves and small creamy white flowers along the length of the unbranched stems. Flowers occur from June to September. Native to open areas of Massachusetts, southern Ontario west to the Canadian prairies and south through Texas, Mexico and Florida. Handsome and tough.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_151"
    }
  }), _c('a', {
    attrs: {
      "id": "page_152"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_152"
    }
  }, [_c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Asphodeline")])]), _vm._v(" (as-fo-de' line)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Jacob’s Rod")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Asphodelaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eighteen to twenty species occur in the Mediterranean area and north to Austria. The leafy unbranched stems arise from rhizomes and produce many-flowered conical inflorescences. All species were at one time part of the genus "), _c('em', [_vm._v("Asphodelus")]), _vm._v(", but in 1830 this genus was created. They are most easily distinguished from "), _c('em', [_vm._v("Asphodelus")]), _vm._v(" by having erect and leafy stems. Taxonomists are also arguing about the family, and recently the Asphodelaceae was formed, to which the genus belongs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Stems of plants of "), _c('em', [_vm._v("Asphodelus")]), _vm._v(" are generally leafless and branched. Plants perform best in full sun and can be spectacular in late spring and early summer. Of the numerous species found in the wild, only king’s spear, "), _c('em', [_vm._v("Asphodeline lutea")]), _vm._v(", is readily available.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-lutea")])]), _vm._v(" (loo-tee' a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("King’s Spear")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-4'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring–Early Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Mediterranean")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is the true asphodel of the ancients, connected in Greek mythology with the dead and the underground. It was planted on graves and associated with Persephone, goddess of agriculture and fertility, who was kidnapped by Hades, god of the dead. In this gruesome story, Persephone appears crowned with a garland of asphodels. It was suggested that the grayish foliage and the yellow flowers intimated the gloom of the underworld and the pallor of death. Sounds pretty awful, doesn’t it?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It really is a fine plant, regardless of what the mythologists did to it. The deep green leaves are grasslike with paler veins and are found all the way to the inflorescence. Each of the many starlike fragrant flowers is about an inch long and open from bottom to top on a 6-18\" long raceme. I have seen outstanding plants in cool summer climates but seldom have they reached their potential in the harsher summers of the South and central plains. In the heat, the open flowers decline rapidly while the top flowers are still waiting to open. The stems are rather ugly; this should be inter-planted among other plants so the flowers can be the focal point.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("A double form, var. "), _c('em', [_vm._v("flore-pleno")]), _vm._v(", has been described but is difficult to locate.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. liburnica")]), _vm._v(" has soft yellow flowers but the racemes are more lax and plants grow only 1-2' tall. The primrose color makes this a fine plant for the garden. The foliage extends only about halfway up the stem and flowers open a little later than those of "), _c('em', [_vm._v("A. lutea")]), _vm._v(". Native to southern Europe, plants perform well in zones 4 to 7, as well as on the West Coast.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. taurica")]), _vm._v(" is 1-2' tall and bears handsome white flowers. Sometimes confused with "), _c('em', [_vm._v("Asphodelus albus")]), _vm._v(", however, the leafy stem and more diminutive stature of "), _c('em', [_vm._v("A. taurica")]), _vm._v(" should help to keep them separate.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Aster")])]), _vm._v(" (as' tur)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Aster")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Asteraceae")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_152"
    }
  }, [_vm._v("This large genus consists of species native to North and South America, Europe, Africa and Asia. While many remain weedlike, horticultural improvements have greatly enhanced their garden value in recent years. Many species are native to the ")]), _c('a', {
    attrs: {
      "id": "page_153"
    }
  }, [_vm._v("United States and have common names such as New York aster and New England aster. Perhaps it is this familiarity with our roadside asters that have held back the popularity of the named cultivars in this country. Although many useful species are native to North America, credit for much of the improvement must be given to English and German nurserymen. Many selections were raised in the late 1890s and new ones continue to be introduced every year. Asters are also raised in greenhouses and fields as commercial cut flowers and are becoming an important item in the flower designer’s palette. The most important species for cut flowers are "), _c('em', [_vm._v("A. ericoides")]), _vm._v(" and "), _c('em', [_vm._v("A. novi-belgii")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page_153"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The leaves are alternate and the daisy flowers are borne either singly on the flower stem or in multiple-flowered panicles or corymbs. Some species of the genus "), _c('em', [_vm._v("Aster")]), _vm._v(" are similar to some "), _c('em', [_vm._v("Erigeron")]), _vm._v(" species, particularly our native forms. In general, "), _c('em', [_vm._v("Erigeron")]), _vm._v(" mostly flowers in the spring and summer and has bracts beneath the flower in a single circle all about the same length. "), _c('em', [_vm._v("Aster")]), _vm._v(" generally flower in summer and fall and the bracts underneath the flowers occur in two rings of different sizes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Species and their cultivars range in height from 6\" ("), _c('em', [_vm._v("A. alpinus")]), _vm._v(") to the giant 8' "), _c('em', [_vm._v("A. simplex")]), _vm._v(", however, so much hybridization has occurred in cultivation that proper identification is highly questionable. If you don’t know what species you are looking at, don’t worry about it, it is probably a hybrid of some kind. A great deal of breeding work has been accomplished with "), _c('em', [_vm._v("A. novi-belgii")]), _vm._v(", and cultivars and hybrids of that species alone are now available in heights from 6\" to 6'. Flower color of most species is white or in the blue-purple range (although many pink cultivars have been selected). Yellow does or does not occur in aster depending on whether you follow the taxonomic lumpers or splitters. Goldilocks is the common name of the 18\" tall fall-flowering "), _c('em', [_vm._v("A. linosyris")]), _vm._v(", however, the taxonomic splitters have renamed this plant as "), _c('em', [_vm._v("Linosyris vulgaris")]), _vm._v(".")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_153"
    }
  }, [_vm._v("Speaking of taxonomists, the "), _c('em', [_vm._v("Aster")]), _vm._v(" genus has taken a major hit, similar to the genus "), _c('em', [_vm._v("Chrysanthemum")]), _vm._v(". Based on characteristics such as chromosome number, inflorescence shape, the presence of rhizomes, and characteristic basal leaves, the genus has been split into new and gruesomely unspellable genera. The main genus to which the asters have been transferred is "), _c('em', [_vm._v("Symphyotrichum")]), _vm._v(" (sim-fee-o’ trick-um"), _c('em', [_vm._v(")")]), _vm._v(", but other equally tongue-twisting genera have also been constructed. This is mainly the case of the American asters (New England, Carolina aster, etc.) but Old World asters are also undergoing change. They have all been coolly embraced by botanists and totally ignored by gardeners (perhaps because we can’t pronounce them). For the latest in names of native species, check the Integrated Taxonomic Information System ("), _c('em')]), _c('em', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "http://www.itis.usda.gov",
      "target": "_blank"
    }
  }, [_vm._v("www.itis.usda.gov")]), _vm._v(".).")]), _vm._v(" However, as far as the all-knowing Royal Horticultural Society goes, nothing has changed anywhere in the genus. As for me, I am at a crossroads; I want to give the new names some love, but I also realize that no one will have a clue what I am talking about if I toss out the old ones. So in keeping with other taxonomists, I too will sit on the fence, and provide both names as the various species are discussed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Division is the easiest means of propagation. The outside portions of the clumps should be split and replanted in early spring or fall. The centers of stronger-growing species become bare within 1-2 years and if not divided every few years, plants will degenerate and lose their ornamental usefulness (an exception to this "), _c('em', [_vm._v("A. amellus")]), _vm._v(", which should be left undisturbed for 2-3 years). Terminal cuttings of most species can also be rooted. Collect 1-2\" long cuttings with two to three leaves in the spring "), _c('a', {
    attrs: {
      "id": "page_154"
    }
  }, [_vm._v("or early summer and insert in a clean mixture of sand and perlite and rooting will occur within 2-3 weeks. This is the best and sometimes the only method to clean up prized plants that suffer from aster wilt caused by "), _c('em', [_vm._v("Verticillium vilmorinii")]), _vm._v(". Since the fungus resides in the rootstock, terminal cuttings of new growth may result in clean plants. "), _c('em', [_vm._v("A. novi-belgii")]), _vm._v(" types are most susceptible while "), _c('em', [_vm._v("A. novae-angliae")]), _vm._v(" is least affected. The other major problem of New England and New York asters is powdery mildew ("), _c('em', [_vm._v("Erysiphe cichoracearum")]), _vm._v("). Some cultivars are more susceptible than others, but fungicides should be applied to all cultivars starting around July 1 to reduce infection. Rust can also be troublesome with many species of asters. Maintain good air circulation, cut out stems if the plants are too dense, and stay away from highly susceptible cultivars.")])]), _c('a', {
    attrs: {
      "id": "page_154"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Asters are useful for fall flowering but some flower in the summer and may reflower in the fall if spent blossoms are removed immediately. Tall varieties need staking and should be avoided if one is an anti-staker. This is still a major drawback to asters, particularly the New England and New York types. Regardless of where they are grown, most cultivars must have support or they look shabby. Staking can be reduced and even eliminated in many medium-sized cultivars if plants are grown in full sun, and pinched back once or twice in spring and early summer. This is also a good practice for all tall flowering plants and results in more compact, dense plants. Pinch back 4-6\" of growth from each growing point but do not do it later than June 15 in the North and July 1 in the South, or you may remove the developing flowers. A sharp pair of hedge trimmers does the job in the Armitage garden.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants that are sold under the name of China aster are "), _c('em', [_vm._v("Callistephus chinensis")]), _vm._v(". These are beautiful plants but are annuals and not to be confused with the perennial asters.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Aster Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (ft.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flowers single or in clusters")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flowering time")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. alpinus")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("1/2-3/4")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Single")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Early Summer")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. amellus")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("2-2 1/2")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Single, Cluster")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Summer")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. carolinianus")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("7-12")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Single")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Late Fall")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. cordifolius")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("4-6")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Cluster")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Early Fall")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. divaricatus")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("1-2")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Cluster")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Summer")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. ericoides")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3-4")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Cluster")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Late Summer")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("frikartii")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("2-3")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Cluster")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Summer")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. lateriflorus")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("2-3")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Cluster")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Fall")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. novae-angliae")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("4-6")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Cluster")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Fall")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. novi-belgii")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("1-6")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Cluster")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Fall")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. oblongifolius")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3-4")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Cluster Late")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("fall")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. sedifolius")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("2-3")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Cluster")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Fall")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. tataricus")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3-6")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Cluster")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Late Fall")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. thomsonii")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("1-3")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Cluster")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Early Fall")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. tongolensis")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("1-2")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Single")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Early Summer")])])])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_154"
    }
  }), _c('a', {
    attrs: {
      "id": "page_155"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_155"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-alpinus")])]), _vm._v(" (al-pine' us)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Alpine Aster")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-9\"/1'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Purple")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants are variable, but usually bear solitary, 1-2\" diameter purple flowers with 20-40 ray flowers and yellow centers. The foliage is entire and is gray-green in the spring but loses the gray color in the heat of the summer, particularly in the South. This is an excellent front-of-the-garden plant for cooler areas of the country. “Cooler” is the most important word in that sentence. It is absolutely not tolerant of hot, humid climates, and at the best of times is not a particularly long-lasting species in much of the country, 3-4 years being an average life span. Terrific plant for the West and upper plains states. Plants perform better with excellent drainage and gritty soils.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Seed germinates readily when placed in moist, warm (70-75°F) conditions.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("albus")]), _vm._v(" has white flowers but is a rather spindly grower.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Beechwood’ is seldom offered but has flowers of clear blue with yellow centers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Dark Beauty’ has dark blue, almost purple flowers in early summer. This is also sold as ‘Trimix’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Goliath’ is so called because of the 2 1/2-3\" diameter light blue flowers. It is taller than the species and grows to 15\".")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Happy End’ offers soft pink flowers, gray foliage in the spring, and a compact habit.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pinkie’ has bright pink 2\" wide on 10-12' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Wargrave Variety’ (‘Wargrave Park’) has pale pink flowers tinged with purple, which, unfortunately, tend to fade in bright sun.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_vm._v("-"), _c('em', [_c('strong', [_vm._v("amellus")])]), _vm._v(" (a-mel' lus)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Italian Aster")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-2 1/2'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Purple")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Italy")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants have pubescent stems and leaves giving a rough appearance and feel. The leaves are entire, sessile and about 5\" long. The large, 2-2 1/2\" diameter purple flowers consist of 20-30 narrow petals with orange-yellow centers. They are borne singly or in dense corymbs in early fall and bloom continuously to frost. The species itself, however, is seldom seen and improvements have been made to reduce height, increase color range, and reduce floppiness. Most of the new cultivars are 1-2' tall and do not need staking unless overfertilized or if temperatures become exceptionally high. It is a particularly fine species for zones 5 and 6 and is good, but not as spectacular, in the heat and humidity of zones 7 and 8. "), _c('em', [_vm._v("A. amellus")]), _vm._v(" is one of the parents of the hybrid "), _c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("frikartii")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Blue King’ bears large violet-blue flowers on 2' tall stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Brilliant’ has bright purple-pink flowers with yellow centers on 2 1/2' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Butzemann’ produces sprays of small, violet-blue flowers. Only about 2' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Joseph Lakin’ has flat heads of blue flowers, 18\" to 2' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘King George’ is an exceptionally fine selection offering deep purple flowers on 2-3' tall stems. It is floriferous and requires no support.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_155"
    }
  }), _c('a', {
    attrs: {
      "id": "page_156"
    }
  }, [_vm._v("‘Nocturne’ is often cited as a pink-flowered form but appears to be more bluish purple than pink. Although not as floriferous as ‘King George’, it is nevertheless a good selection.")])]), _c('a', {
    attrs: {
      "id": "page_156"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Peach Blossom’ has violet-pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pink Zenith’ and ‘Lady Hindlip’ bear pink flowers with yellow centers on 2-3' tall stems. The former is darker pink and shorter (2') than the latter.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Rudolph Goethe’ was selected in 1914 and is still popular today. It bears violet flowers on 2-3' tall stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Sonia’ is probably the best pink-flowered form, producing many 2\" diameter rich pink flowers with yellow centers on 1-2' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Violet Queen’ produces many deep violet-blue flowers with yellow eyes. This plant is probably as close to the species in color as any cultivar.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-carolinianus")])]), _vm._v(" (car-o-lyn-ee-aye' nus)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Climbing Aster")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("7-12'/4'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Fall"), _c('br'), _vm._v("("), _c('em', [_vm._v("Ampleaster carolinianus")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Pink")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southeastern United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 6-9")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you are fortunate enough to live in mild areas of the country, you might want to give this aster a try. Its common name is a bit deceptive because plants don’t climb by themselves but consist of long, lanky, arching stems. The plant is actually a big, messy shrub and but if you train it on a fence or run it through a trellis or even chicken wire, it is really rather impressive. Not a clematis, but then how many clematis flower in October?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is a terrific rollicking plant, but takes up a good deal of space. Growing up to 12' in length, each stem produces dozens of 1-2\" wide pink to purple flowers with yellow centers along their lengths. Easy to grow in full sun but partial shade is tolerated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate from divisions or terminal cuttings. Plants may be grown further north if a few cuttings are taken indoors before frost.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_vm._v("-"), _c('em', [_c('strong', [_vm._v("cordifolius")])]), _vm._v(" (kord-i-foe-lee' us)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Heart-leaf Aster")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("4-6'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer"), _c('br'), _vm._v("("), _c('em', [_vm._v("Symphyotrichum cordifolium)")])]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Pale Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Eastern North America")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants are usually highly branched with many small flowers, each generally less than 1\" wide. Ten to twenty narrow ray flowers ranging from dark blue to off-white surround a yellow center. Although a good deal of variability occurs, smooth stems and scabrous (with short stiff hairs) pointed leaves are common. The thin, sharply toothed leaves have provided the plant with common names such as bee weed and bee tongue. Although plants often look bedraggled in the wild, cultivation tends to make them stand up straight and put their shoulders back. The lower leaves are heart shaped (cordate) and the upper leaves are ovate to lanceolate. The small blossoms lend themselves to cut flowers, particularly as fillers with larger flowers in arrangements. The species itself is offered but numerous cultivars have also been selected. Plants grow well in both the North and the South but leaf spotting becomes a bigger problem in the humidity of the South.")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_156"
    }
  }), _c('a', {
    attrs: {
      "id": "page_157"
    }
  }, [_c('strong', [_vm._v("Cultivars:")])])]), _c('a', {
    attrs: {
      "id": "page_157"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Avondale’ has light blue flowers on 18-24\" stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Elegans’ bears many white flowers and is one of the best selections.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Ideal’ is 4-6' tall with many violet-blue flowers. In the cut flower trials at the University of Georgia, plants were vigorous and yielded dozens of flower heads. Unfortunately, without fungicide applications, leaves tend to develop black spots in the summer.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Photograph’ produces lilac flowers in arching sprays rather than upright inflorescences.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Silver Spray’ has small white flowers with yellow centers. Plants are 3-4' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-divaricatus")])]), _vm._v(" (di-var-i-cah' tus)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White Wood Aster")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1-2'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer"), _c('br'), _vm._v("("), _c('em', [_vm._v("Eurybia divaricata")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("North America")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This spreading aster is native from Maine to Georgia but for some reason is seen far more often in European gardens than in this country. It bears many thin, nearly black, cascading branches, at the end of which are corymbs of small (3/4\" diameter), starlike white flowers with yellow centers, that are quite attractive to butterflies.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0157-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Aster divaricatus")])])]), _c('p', {
    staticClass: "indentp"
  }, [_c('a', {
    attrs: {
      "id": "page_157"
    }
  }), _c('a', {
    attrs: {
      "id": "page_158"
    }
  }, [_vm._v("The blossoms may be small, but they are so plentiful that the plant is covered with clouds of flowers from mid August through September in the South and as late as October in the North. The leaves are about 3\" long, heart shaped, and coarsely toothed.")])]), _c('a', {
    attrs: {
      "id": "page_158"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("This is one of the few asters that tolerates shade. Plants may be used at the edge of woodlands or placed at the front of the border to grow through other plants. However, while shade is tolerated, more flowers and fewer foliar diseases occur in areas of morning sun and good air movement. Flowers are particularly pretty running in and among bergenias, a combination made popular by Gertrude Jekyll, the grand dame of English gardening. If, like me, you are not a big bergenia fan, allow the plants to ramble over hostas. In hot summers, in the Midwest and further south, it tends to be leggy. I cut my plants back to about 12\" in early June.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Division, terminal cuttings taken in the spring, or seed sown in the spring or fall are appropriate methods of propagation.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Eastern Star’ is only about 12-18\" tall, a endearing characteristic to be sure. The same dark stems and white flowers with yellow centers occur. Plants have done well in the Gardens at UGA and have become quite popular. Plants bloom from late summer to early fall.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-ericoides")])]), _vm._v(" (e-ri-koi- deez)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Heath Aster")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-4'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer, Fall"), _c('br'), _vm._v("("), _c('em', [_vm._v("Symphyotrichum ericoides")]), _vm._v(" var. "), _c('em', [_vm._v("ericoides")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("United States, Mexico")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another roadside weed, but one that can become a fine garden plant and an economically important one to boot. The many needlelike, sessile leaves are pubescent, stiff, and very narrow, seldom more than an inch long (like "), _c('em', [_vm._v("Erica")]), _vm._v(", heath). One of its old names was "), _c('em', [_vm._v("A. multiflorus")]), _vm._v(" (many-flowered), an equally descriptive name for this plant. The leaves are generally paler green than many other aster species. The daisies consist of 15-25 ray flowers, each only about 3/4\" wide, giving each head a starry appearance. The bracts beneath the flowers end in broad, conspicuous green tips and a minute spine. Useless information, unless one wants to try to identify various species in this frustrating genus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The small but numerous flowers (literally hundreds of flowers are produced) have resulted in cultivars used as commercial cut flowers from South America, Holland and the United States. They are used as fillers (like baby’s breath) and are harvested by the acre in fields and greenhouses. Most available cultivars were selected mainly for cut flower production but these are useful for garden plants as well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants multiply efficiently by rhizomes, and division is the quickest and easiest means of propagation.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Blue Star’ bears hundreds of star-shaped dark blue flowers on 3' tall stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Blue Wonder’ has blue flowers with a tinge of pink.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Esther’ has white flowers with a tinge of pink and is similar in growth habit to ‘Monte Cassino’, but is only about 18-24\" tall.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_158"
    }
  }), _c('a', {
    attrs: {
      "id": "page_159"
    }
  }, [_vm._v("‘Golden Spray’ has wiry stems and grows 3-4' tall. The small white flowers have a large golden center that lends a somewhat golden appearance to plants in full bloom.")])]), _c('a', {
    attrs: {
      "id": "page_159"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Monte Cassino’ is not particularly well known to gardeners but it is a most popular cultivar for cut flower producers. It bears many stems with clusters of small white flowers on 24-30\" stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pink Cloud’ produces clouds of starry light pink flowers on 3' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Ringdove’ was selected for its multitude of half-inch wide lilac-rose flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Snow Flurry’ is more of a ground cover than an upright grower. The arching stems are only 6-9\" tall and covered in small white daisies. Good for falling over banks and walls. This is a neat plant.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘White Wonder’ is similar in growth habit to ‘Blue Wonder’ but has creamy white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('strong', [_vm._v("-x")]), _vm._v(" "), _c('em', [_c('strong', [_vm._v("frikartii")])]), _vm._v(" (fri-kart' ee-eye)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Frikart’s Aster")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-3'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Lavender")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Hybrid")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("frikartii")]), _vm._v(" was raised in Switzerland around 1920 and was the result of crossing "), _c('em', [_vm._v("A. amellus")]), _vm._v(" x "), _c('em', [_vm._v("A. thomsonii")]), _vm._v(". The large flowers of "), _c('em', [_vm._v("A. amellus")]), _vm._v(" combined with the long flowering season of "), _c('em', [_vm._v("A. thomsonii")]), _vm._v(" provided one of the best and most popular asters when it was introduced. Interestingly, it is a little taller than either parent. The dark green, pubescent foliage is mildew resistant and remains reasonably disease free throughout the season. The 2-3\" diameter, lavender-blue flowers start in late June in the South, late July further north and continue for about eight weeks. Plants should be placed in full sun and fertilized sparingly. The cultivars that resulted from this cross became instantly popular because of their mounding habit and summer flowers. However, their popularity has diminished considerably in this country in the last 10 years, as the mounding habit became sprawling and the persistence in the garden was questionable.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Four selections were named from the original Swiss hybrid: ‘Wonder of Staffa’, ‘Monch’, ‘Eiger’ and ‘Jungfrau’ but the latter two are seldom seen in North America. ‘Flora’s Delight’ was bred by the late Alan Bloom of Blooms of Bressingham using "), _c('em', [_vm._v("A. thomsonii")]), _vm._v(" ‘Nana’ and "), _c('em', [_vm._v("A. amellus")]), _vm._v(" ‘Sonia’ in the hope of widening the color range offered by Frikart. Named after his wife, ‘Flora’s Delight’ is a little shorter than the Frikart hybrids and produces daisies of lilac-blue. Plants require well-drained soils and full sun.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Monch’ is reputed by many garden authorities to be the best "), _c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("frikartii")]), _vm._v(" clone. It bears lavender blue flowers and stands 2 1/2-3' tall with a 3' spread. Plants differ from ‘Wonder of Staffa’ by being less prone to falling, and having darker blue flowers.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_159"
    }
  }, [_vm._v("‘Wonder of Staffa’ supposedly has lighter blue flowers than ‘Monch’ but the differences between these cultivars have been overstated. It is a challenge, to say the least, to distinguish between the flowers of each cultivar even when placed side by side. ‘Wonder of Staffa’ may be slightly taller (although I have seen little difference) than ")]), _c('a', {
    attrs: {
      "id": "page_160"
    }
  }, [_vm._v("‘Monch’ and in warm climates might require more support. Perhaps differences in cultivars have been obscured over the years as the demand continued to grow. It is possible that some material has been seed propagated to keep up with demand or that stock blocks have been mixed up on occasion.")])]), _c('a', {
    attrs: {
      "id": "page_160"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Seeds of Frikart’s aster are available but are phonies. The resulting flowers occur in many different shades of lavender and blue.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-lateriflorus")])]), _vm._v(" (lat-er-i-flor' us)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Calico Aster")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-3'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Summer, Fall")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("North America")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("("), _c('em', [_vm._v("Symphyotrichum lateriflorum")]), _vm._v(" var. "), _c('em', [_vm._v("lateriflorum)")])]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One description of this species reads “many branched stems with narrow lanceo-late dark green leaves and small bristly white flowers”. Hardly makes you want to run out and buy a dozen. The species itself stands about 3' and flowers are often borne along one side ("), _c('em', [_vm._v("lateri")]), _vm._v("-) of the stem in late summer and early fall. The tiny toothed leaves turn a nice coppery hue in the fall. If no improvements had occurred, it is doubtful that plants would have made their way into many gardens. However, a number of cultivars have gained this plant many fans. Native to the Plains states, plants need well-drained soils and full sun. Plants will tolerate hot days and warm nights, but are far better in areas where the night temperatures cool off.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Coombe Fishacre’ is likely a hybrid with "), _c('em', [_vm._v("A. lateriflorus")]), _vm._v(" in its blood. Plants have dark green leaves with small pink ray flowers and dark centers. Not as horizontal as the favorite, var. "), _c('em', [_vm._v("horizontalis")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("horizontalis")]), _vm._v(" (‘Horizontalis’) is one of the oldest and still a marvelous plant when grown in full sun and well-drained soils. Dark green leaves on horizontal branched stems make this bushlike aster unique. Add the white flowers with reddish centers, also borne on one side of those stems, and one has a wonderful garden plant. It may be used as a shrublike mass or even as a low-growing hedge. Flowers in mid fall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Lady in Black’ has superceded most of the other offerings. Plants possess dark purple foliage that usually remains attractive throughout the season if temperatures are not consistently in the 90s. Tiny white asters with rosy centers appear in dense, branching sprays in early fall on rigid, purplish stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Prince’ is as good as if not better than ‘Horizontalis’. Plants are about 3' tall, have the same small white flowers but also have handsome deep purple foliage. The foliage and flowers make an excellent contrast. In hot summers and in shady areas, the purple color turns green. Much better in climates with relatively cool nights and lower humidity.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-novae-angliae")])]), _vm._v(" (no'vay-ang' glee-aye)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("New England Aster")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("4-6'/4'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Violet-purple")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Eastern United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("("), _c('em', [_vm._v("Symphyotrichum novae-angliae")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_160"
    }
  }, [_vm._v("This common wild flower is one of the largest and prettiest in the genus but is seldom seen, having been superceded by newer but not always better cultivars. The ")]), _c('a', {
    attrs: {
      "id": "page_161"
    }
  }, [_vm._v("entire, 4-5\" long leaves are numerous and very hairy. This species and a few others similar to it may be separated from many others by looking at the base of the leaves. The two basal lobes of the leaves clasp the stem, poking out on either side. The flowers are 1 1/2-2\" across and consist of 40-50 ray flowers surrounding a yellow center. The flowers are excellent for cutting and last longer in water than those of "), _c('em', [_vm._v("A. novi-belgii")]), _vm._v(", New York aster. My friend Chris Hussey found out the hard way that harvesting the hairy stems of New England asters can cause a serious skin rash on hands and arms. Chris strongly recommends gloves and a long-sleeved shirt when tackling these fellows.")])]), _c('a', {
    attrs: {
      "id": "page_161"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0161-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Aster")]), _vm._v(" x "), _c('em', [_vm._v("frikartii")]), _vm._v(" ‘Monch’")]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alma Potschke’ is an excellent 3-4' tall bright rose selection. The flowers are 1-2\" across and have slightly curled petals. It is more compact (but still requires support) than other selections and less prone to topple.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_161"
    }
  }), _c('a', {
    attrs: {
      "id": "page_162"
    }
  }, [_vm._v("‘Barr’s Pink’ has 1 1/2\" wide bright rose-pink, semi-double flowers on 4' tall stems. ‘Barr’s Blue’ and ‘Barr’s Violet’ are similar in habit with blue and violet flowers respectively.")])]), _c('a', {
    attrs: {
      "id": "page_162"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Harrington’s Pink’ was developed by Mr. Millard Harrington of Williamsburg, Iowa, and is still a popular aster today. This 3-5' tall plant bears large (1 1/2\" diameter) salmon-pink flowers in September through October.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Hella Lacy’, named for the wife of garden writer Allen Lacy, is 3-4' tall and covered with 2\" wide violet-blue daisies in the fall. Quite big and lanky in the heat.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Honeysong Pink’ bears pink flowers with bright yellow centers. Plants are strong growers on 3' tall stems. A favorite of Mr. Bud Heist of Heistaway Gardens in Conyers, Georgia. In the South, people know that if Bud endorses a plant, it is a winner.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Lye End Beauty’ has lovely cerise flowers but grows 4-5' tall and must be supported.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Lyon’s White’ produces dozens of clean white flowers on 4-5' tall plants in late September (October in the South).")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Martha’ has silvery pink flowers growing 3-4' tall and may be a cross between ‘Hella Lacy’ and ‘Alma Potschke’. Selected by Allen Lacy.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Mt. Everest’ is 3' tall with good, clear white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Purple Dome’ is a terrific introduction from Mt. Cuba Center in Delaware. Late-flowering on compact 18-24\" stature, the plants maintain a mounded habit even while supporting hundreds of deep blue flowers. Under high humidity environments, leaf and stem diseases can become problems in mid July and August. In Atlanta, plants do well most years but the heat and humidity take their toll in a cumulative manner. Its popularity has waned significantly but it can still be a great aster for the front of the sunny garden.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Rosa Sieger’ has large salmon-rose flowers on 4' tall plants. Very eye-catching.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Rose Serenade’ is about 30\" tall and bears soft pink flowers in early fall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘September Ruby’ has 1\" diameter, deep ruby red flowers on 3-5' high stems. If planted in rich soils or overfertilized, heights up to 5' are not uncommon for this cultivar. Although classified as a late bloomer, flowering begins in late May in north Georgia and continues through late June. If the flowers are removed, it blooms again in September. Flowering is 3-4 weeks later in the Northeast but seldom do flowers peak in the fall. This is true with many so-called fall-flowering asters.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Treasure’ is 4-6' tall with light purple to violet flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Wedding Lace’ is 3-4' tall with clean white flowers in early fall.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-novi-belgii")])]), _vm._v(" (no' vee-bel-gee' eye)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("New York Aster, Michaelmas Daisy")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1-6'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Violet")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Eastern United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_c('em', [_vm._v("Symphyotrichum novi-belgii")]), _vm._v(" var. "), _c('em', [_vm._v("novi-belgii")])]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_162"
    }
  }, [_vm._v("There are literally hundreds of cultivars of this roadside weed. The specific epithet, "), _c('em', [_vm._v("novi-belgii")]), _vm._v(", arose when the state of New York was once known as New Belgium. The history of breeding of Michaelmas daisies is a who’s who of horticulture including the Honorary Vickary Gibbs, Ernest Ballard, A.H. Harrison, Barrs of Taplow and Alan Bloom, all of whom threw their talents into the aster fray. The smooth or nearly glabrous leaves differentiate them from New England asters. The leaves clasp the ")]), _c('a', {
    attrs: {
      "id": "page_163"
    }
  }, [_vm._v("stem similar to New England asters, but flowers normally have only 15-25 ray flowers. The flowers are not as good for cutting as the New England asters but provide excellent color in the late summer and fall garden. They are called Michaelmas daisies because they bloom around September 29, St. Michael’s Day in the British Isles.")])]), _c('a', {
    attrs: {
      "id": "page_163"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0163-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Aster novae-angliae")]), _vm._v(" ‘September Ruby’")]), _vm._v(" "), _c('p', {
    staticClass: "indentp"
  }, [_vm._v("Somewhere along the way, many cultivars were placed under the name "), _c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("dumosus")]), _vm._v(". This was likely the result of European growers listing plants under this name and American growers following suit. The species, "), _c('em', [_vm._v("A. dumosus")]), _vm._v(" ("), _c('em', [_vm._v("Symphyotrichum dumosus")]), _vm._v(" var. "), _c('em', [_vm._v("dumosus")]), _vm._v(") is a bushy, rather short plant (1-3') native to fields and meadows from Florida to Texas, and north to Maine, Ontario and Illinois. It seems that any cultivar under 15\" tall has summarily been pushed into "), _c('em', [_vm._v("A.")]), _vm._v(" x "), _c('em', [_vm._v("dumosus")]), _vm._v(". I can find no taxonomic evidence for the name change so I will maintain the listing of short cultivars under "), _c('em', [_vm._v("A. novi-belgii")]), _vm._v(". It is likely that all the cultivars I list under “dwarf cultivars” are listed in most catalogs under "), _c('em', [_vm._v("A.")]), _vm._v(" x "), _c('em', [_vm._v("dumosus")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Propagate all cultivars by division or by terminal cuttings.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_163"
    }
  }), _c('a', {
    attrs: {
      "id": "page_164"
    }
  }, [_c('strong', [_vm._v("Cultivars:")])])]), _c('a', {
    attrs: {
      "id": "page_164"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_c('em', [_vm._v("Dwarf cultivars")]), _vm._v(" (less than 15\" tall). ("), _c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("dumosus")]), _vm._v("). Many of the dwarf cultivars are excellent for the front of the garden and, best of all, require no staking. Dozens more are available than these listed, but how many can we use?")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alert’ produces double crimson-red flowers on 12-15\" plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alice Haslem’ was raised in the 1950s by Mr. A. H. Harrison of Gayborder Nurseries, in Derbyshire England. She has wonderful double rosy pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Audrey’ bears 1\" wide lilac flowers on 12\" tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Buxton’s Blue’ is only 4-6\" tall but produces many small dark blue flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Daniela’ produces sculptured mounds of lavender-violet flowers, about 1-1 1/2' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Heinz Richard’ forms compact 12\" mounds of foliage covered with semi-double salmon-pink flowers in late summer and early fall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Jenny’ (‘Jenny Margaret Rose’), also from the Gayborder Nursery, bears lovely red flowers on 12-15\" tall stems. Many Michaelmas daisies bear the Gayborder name and all are in this height range.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Kassel’ has semi-double carmine-rose flowers in early fall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Kristina’ bears white daisy flowers on 15\" tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Lady-in-Blue’ is about 12\" tall with blue flowers in the fall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Little Pink Beauty’ is one of my favorites, becoming covered in semi-double pink flowers in the fall. There is a complementary ‘Little Blue Beauty’ lurking about in catalogs as well.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Nesthakchen’ sounds like a sneeze but bears rather striking compact pinkish red flowers on 12\" tall plants. More mildew resistant than most others.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Newton Pink’ is another good pink, bearing semi-double flowers, on 12-15\" tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Niobe’ produces single white flowers with yellow eyes on 6-10\" tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Peter Harrison’ is a handsome Gayborder gentleman offering pink flowers in September and October on his trim 15-18\" frame.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pink Bouquet’ is about 12\" tall with soft pink, daisylike flowers in late summer and fall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Prof. Anton Kippenburg’ is 9-12\" tall and carries lavender-blue semi-double flowers. This excellent cultivar has withstood the test of time.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Rosemarie Sallman’ is about 2' tall with pink-purple semi-double flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Sapphire’ was introduced to North American gardeners in 2005. Plants are covered with lavender ray flowers surrounding yellow centers on a 12-16\" tall mounding plant.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Snow Cushion’ is a late bloomer (late September-October) with white flowers on 6-8\" tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Snowsprite’ has semi-double white flowers with yellow centers. It grows to 15\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Violet Carpet’ bears rich violet daisy flowers forming 8\" tall carpets.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Wood’s Dwarfs’ are wonderful 8-12\" tall plants with purple-blue (‘Wood’s Purple’) and pink (‘Wood’s Pink’) and light blue (‘Wood’s Light Blue’) flowers. In the Armitage garden, they begin flowering around mid September and persist for 4-6 weeks.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_164"
    }
  }), _c('a', {
    attrs: {
      "id": "page_165"
    }
  }, [_vm._v("‘Zwergenhimmel’ is included because nobody can pronounce it, find it or grow it.")])]), _c('a', {
    attrs: {
      "id": "page_165"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("However, it does exist, once more pointing out that breeders really don’t care if anybody in the English-speaking world ever buys the plant. In case you are wondering, plants have light blue flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('em', [_vm._v("Medium cultivars")]), _vm._v(" (less than 4'). Many require staking, especially those with large flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Ada Ballard’ has double lavender-blue flowers atop 3' tall stems. Most of the asters bearing the Ballard name will be medium to tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Arctic’ bears double white flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Beechwood’ Rival’ produces wine-red flowers on 3' tall stems. At least five cultivars carry the Beechwood name, a popular series of cultivars all with rather large flowers and about 3' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bonningdale Blue’ and ‘Bonningdale White’ grow nearly 3' tall and produce 1-2\" wide blue and white semi-double to double flowers in September and October.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Carnival’ has rosy red flowers on 3' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Christine Soanes’ produces carmine-rose flowers on 2 1/2' plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Crimson Brocade’ is about 3' tall and produces crimson-red flowers in late fall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Eventide’ produces 2\" wide semi-double violet-blue flowers on 3-4' high plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Ernest Ballard’ has reddish pink semi-double flowers up to 3\" wide. Many of the medium-sized cultivars are the result of the work of Mr. Ernest Ballard of Colwall, Malvern, England, who stands as a leader in the breeding of Michaelmas daisies. One of his traits was breeding large (1-3\" diameter) flowers on 2 1/2 -3' tall plants. Most Ballard family members have at least one cultivar as their namesake.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Patricia Ballard’ has semi-double rose pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Priory Blush’ is at least 4' tall with double white flowers tinged with a little pink. Very handsome but needs some judicious early summer pruning.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Royal Ruby’ and ‘Royal Velvet’ are 20-30\" tall and produce semi-double red and violet-purple flowers, respectively. Both raised by Alan Bloom of Bressinghams.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Sailor Boy’ is about 3 1/2' tall with semi-double violet-blue flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘The Bishop’ (‘The Archbishop’) bears deep red flowers on 2-3' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Winston Churchill’ would be proud of the handsome red daisy flowers on 2-3' tall stems. They were fantastic in our cut flower trials at Georgia.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('em', [_vm._v("Tall cultivars")]), _vm._v(" (over 4'). I recommend none for the South and hesitate to recommend them at all. They are too tall for most gardens, require extensive support, and can become highly aggressive. All could use some pruning in the summer; however, if grown well, they are showstoppers. They are exceptional in flower and can be grown as long as they are pinched at least once in the spring or early summer and then supported.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Cardinal’ has deep rosy-red flowers surrounding a yellow center.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Climax’ is a 5' tall giant with outstanding large (3-4\" across), light blue flowers in early fall. This was raised over 80 years ago and is one of the few old-time Michaelmas daisies still in cultivation.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Fellowship’ bears large clear semi-double pink flowers on 4-5' tall stems.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_165"
    }
  }), _c('a', {
    attrs: {
      "id": "page_166"
    }
  }, [_vm._v("‘Mount Everest’ has large (2-3\") semi-double white flowers in September and October.")])]), _c('a', {
    attrs: {
      "id": "page_166"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘White Ladies’ is 5-6' tall with clear white flowers and an orange-yellow center.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-oblongifolius")])]), _vm._v(" (ob-long-i-foe' lee-us)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Aromatic Aster")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-4'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Fall")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Blue-purple")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-3")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("("), _c('em', [_vm._v("Symphyotrichum oblongifolium")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The aromatic aster is loaded with blue-purple daisylike flowers that persist into late October, and is one of the last wild flowers to bloom. Plants are native to dry prairies and rocky bluffs from Pennsylvania to Wisconsin and south to North Carolina and Texas. The base of the flowers contains glandular hairs, which when brushed lightly, release a fresh, hard to describe but pleasant fragrance. This aster grows from rhizomes (as do most asters) and will attain height of about 2-4' in the wild. Up to a dozen well-branched stems occur on a mature plant, and each holds narrow 1\" long leaves. The flowers are violet to pink to blue, each about an inch wide. The plants are spectacular at the San Antonio Botanical Garden, and they earned a Plant of Merit designation from the Missouri Botanical Garden in 2003. Enough said.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘English Countryside’ is still being sorted out. She appears to be mostly "), _c('em', [_vm._v("A. oblongifolius")]), _vm._v(", but also seems to have a hefty chunk of New England aster in her as well. Plants bear beautiful lavender-blue flowers that absolutely smoother the plant in late fall. However, it may too late for Northern gardeners or as Judy Laushman of Oberlin, Ohio so aptly states “It flowers so late in northeast Ohio it’s in danger of being snowed on.” Plants definitely need a hard prune by early June in the South, late June in the North, or they will be far too vigorous. Found in Athens, Georgia. by the great garden designer Anne English.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Fanny’s Aster’ is covered with blue flowers in late fall and grows up to four feet tall. An absolutely terrific aster, particularly in the South. Introduced by Nancy Goodwin, nursery lady and plantsperson extraordinaire, who acquired it from Ruth Knopf of Boone Hall Plantation in South Carolina. Turns out her maid, Fanny, passed it on to Ruth.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘October Skies’ is a low-growing version of ‘Raydon’s Favorite’, introduced by the Primrose Path Nursery. They have excellent lavender flower power but grow only about 2' tall, even without pruning.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Raydon’s Favorite’ may be even better, with purple flowers with yellow centers in the fall on stiff, hairy 2-3' tall plants. The foliage also has a nice hint of mint. Plants originally came from south Texas, and are especially beautiful at the San Antonio Botanical Garden, a treasure of a place that should be on every plantsperson’s map. Plants need full sun and well-drained soils.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-sedifolius")])]), _vm._v(" (say-di-fo' lee-us)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Rhone Aster")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-3'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Fall")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Lilac")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southern Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_166"
    }
  }, [_vm._v("This relatively unknown aster has rough hairy, linear, entire leaves and many stems resulting in a bushy habit. Each stem terminates in a corymb of 30-40 small ")]), _c('a', {
    attrs: {
      "id": "page_167"
    }
  }, [_vm._v("(1-1 1/4\"across) starry blossoms. The individual flowers are not particularly ornamental but the plants are literally covered in a sea of lavender blue. The ray flowers are widely spaced around the yellow center. Plants should be grown in full sun and tolerate most soils assuming drainage is adequate.")])]), _c('a', {
    attrs: {
      "id": "page_167"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Division is the surest and easiest means of propagation but seed sown and placed at 70-75°F under constant moisture germinates readily.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Nanus’ is the most common form, the species seldom seen anymore. It is 18\"-2' tall and the flowers are only slightly smaller (1\") than those of the species.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-tataricus")])]), _vm._v(" (ta-tar' ri-cus)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Tatarian Daisy")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-6'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Fall")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Blue")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Siberia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One of the reasons for the popularity of this tall aster is that plants rarely require staking. Although it will reach heights of 6' or more, seldom does growth exceed 3-4' the first year. Plants resemble Swiss chard in the spring and summer but in early fall, flower stalks begin to emerge from the leafy mass. The erect stems are covered with straight bristly hairs (hispid) and the entire, lanceolate leaves are large (the basal leaves are up to 6\" wide and 2' long), and sessile. The flower stems branch near the top resulting in dozens of blue to purple ray flowers with yellow centers. One of the best features of this aster is its late flowering. Although many asters flower until frost, they often look tired and worn out. This species does not start flowering until late September or early October so it still looks fresh in November. Tough to beat as a late-flowering garden plant. Plants will make large colonies within a few years, and division not only allows for more plants but keeps the garden from becoming one big chard patch.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Blue Lake’ absolutely puzzles me. Looking at the plant in bloom, it has all the characteristics of "), _c('em', [_vm._v("A. tataricus")]), _vm._v(", however, it blooms in the summer, unlike the very late flowering of the species. Stunning and a showstopper, give it a go.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Jindai’ was found by Rick Darke and Skip March, two excellent American plantsmen, in the Jindai Botanical Garden near Tokyo. It is a better selection for most gardens in that it is only 3-4' tall. I have grown plants side by side with the species, the difference in height is dramatic, and ‘Jindai’ may flower a little later than the species.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-thomsonii")])]), _vm._v(" (tom-son' ee-eye)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Thomson’s Aster")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1-3'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Lilac")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Western Himalayas")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The leaves are coarsely toothed and the 1-2\" diameter lilac flowers are borne on long slender flower stems. One of the outstanding characteristics is its long blooming period and, as one of the parents of "), _c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("frikartii")]), _vm._v(", this trait was passed on to that hybrid.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_167"
    }
  }, [_vm._v("‘Nanus’ is only 12-18\" tall and is essentially the only form of "), _c('em', [_vm._v("A. thomsonii")]), _vm._v(" represented in gardens. It resembles a dwarf "), _c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("frikartii")]), _vm._v(". The 1-3\" long, pointed foliage is gray-green ")]), _c('a', {
    attrs: {
      "id": "page_168"
    }
  }, [_vm._v("and the starry, blue flowers are about 1-1 1/2\" in diameter. This is an excellent plant for the front of the garden where late color is desired. One of the favorite species of aster lovers.")])]), _c('a', {
    attrs: {
      "id": "page_168"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0168-01.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Aster tataricus")])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-tongolensis")])]), _vm._v(" (ton-go-len' sis)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("East Indies Aster")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1-2'/1'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Early Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Violet")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Western China")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rosettes of dark green hairy leaves and solitary, 2\" diameter violet-blue flowers with bright orange centers are characteristics of this aster. The strong stems carry the flowers well and no support is necessary. Plants are stoloniferous and significant clumps can form under suitable conditions. Unfortunately, this summer-flowering aster is not long lived and survives only 2-3 years in the South, perhaps a little longer in zone 5.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Divide after flowering to keep plants vigorous.")])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_168"
    }
  }), _c('a', {
    attrs: {
      "id": "page_169"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/f0169-01.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_169"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Aster tatricus")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentp"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Berggarten’ has 2-3\" diameter violet-blue flowers with orange-yellow eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Napsbury’ has violet blue daisies consisting of narrow ray flowers around a bright orange center.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Wartburg Star’ bears 1 1/2\" diameter lavender-blue flowers with orange centers. Flowers are 2\" across and can bloom for weeks on end. The foliage is dark green and usually looks good. Flowers appear in June. The best of the cultivars offered.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species and Hybrids:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Good grief, only hard core asterites can still be reading this stuff. Yet, believe it or not, there are still many little-known species are out there, just waiting to be discovered. Our native asters are becoming much more appreciated as the movement to more natural landscapes becomes commonplace, while the European breeders have added dozens of cultivars and hybrids to the palette. Here are a few I have fallen over, there are many more I have yet to trip on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("alpellus")]), _vm._v(" is a cross between "), _c('em', [_vm._v("A. alpinus")]), _vm._v(" and "), _c('em', [_vm._v("A. amellus")]), _vm._v(". ‘Summer Greeting’ has light blue ray flowers around orange centers; ‘Triumph’ has darker blue ray flowers. Plants are 12-15\" tall.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_169"
    }
  }), _c('a', {
    attrs: {
      "id": "page_170"
    }
  }, [_c('em', [_vm._v("A. azureus")]), _vm._v(", ("), _c('em', [_vm._v("Symphyotrichum")]), _vm._v(" "), _c('em', [_vm._v("oolentangiense")]), _vm._v(" var. "), _c('em', [_vm._v("oolentangiense")]), _vm._v(") is also one of our native asters from the Plains states. Plants grow 2-3' tall and bear deep blue to violet flowers and heart-shaped leaves. Sometimes called the sky blue aster. Zones 4-9.")])]), _c('a', {
    attrs: {
      "id": "page_170"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. diplostephioides")]), _vm._v(", native to southeastern Tibet and western China, bears narrow reflexed lavender ray flowers with dusty lavender to reddish orange disc flowers. Plants are about 2' tall and flower in late spring and early summer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. grandiflorus")]), _vm._v(" ("), _c('em', [_vm._v("Symphyotrichum grandiflorum")]), _vm._v("), great aster, is one of the latest asters to flower and bears some of the largest flowers (up to 1 1/2\" wide). They are violet-blue and held on 2-3' tall plants. Native from Virginia to Florida and hardy in zones 5-9.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. laevis")]), _vm._v(" ("), _c('em', [_vm._v("Symphyotrichum laeve")]), _vm._v(" var. "), _c('em', [_vm._v("laeve")]), _vm._v("), smooth aster, combines dozens of blue ray flowers with yellow centers, dark stems and slightly blue-green smooth foliage on 3' tall plants. Although a fairly common roadside plant, a little tending can make an eye-catching garden plant. ‘Bluebird’ bears 1\" wide violet-blue flowers and arching stems with handsome blue-green foliage. Plants are best if pinched by June 15th, otherwise they look leggy and un-catalog like. This selection was introduced by Richard Lighty of the Mt. Cuba Center.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. linariifolius")]), _vm._v(" ("), _c('em', [_vm._v("Ionactis linariifolius")]), _vm._v("), savory-leafed aster, is 1-2' tall with 1\" entire, linear, stiff, sessile leaves. The many 1\" wide flowers are porcelain-blue to violet. Zones 4-8.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Little Carlow’ is a hybrid between cultivars of "), _c('em', [_vm._v("Aster cordifolius")]), _vm._v(" and "), _c('em', [_vm._v("Aster novi-belgii")]), _vm._v(". It typically grows to 2' tall with a similar spread and features clusters of 1-1 1/2\" diameter sky blue asters (blue rays and yellow discs) which bloom in fall. The blue flower color (as opposed to the more common purple) sets this plant apart from most other asters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. macrophyllus")]), _vm._v(" ("), _c('em', [_vm._v("Eurybia macrophylla")]), _vm._v("), bigleaf aster, native to the eastern United States, is about 4' tall and flowers in August and September. It produces 8-10\" long serrated, heart-shaped (cordate) basal leaves with long petioles. The uppermost leaves become less cordate and are sessile (no petiole) at the top. Plants produce dense mats of foliage in the spring, and with sufficient light and moisture, produce leafy stems carrying 1\" diameter pale blue to violet flowers in a rounded, many-flowered corymb in the fall. They are late to flower but not as late as "), _c('em', [_vm._v("A. tataricus")]), _vm._v(". A white-flowered form (‘Alba’) is also known.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. pilosus")]), _vm._v(", ("), _c('em', [_vm._v("Symphyotrichum pilosum")]), _vm._v(" var. "), _c('em', [_vm._v("pilosum")]), _vm._v(") is one of the first perennials to invade abandoned agricultural fields and is considered a weed by most people who drive by it on the side of the road. However, with a little love and care, plants will become much less sprawling and will be covered with white flowers in late fall. The leaves are almost needlelike and similar to those of "), _c('em', [_vm._v("A. ericoides")]), _vm._v(". I have seen wonderful garden specimens at the Mercer Arboretum and Botanic Gardens in Houston.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. ptarmicoides")]), _vm._v(" ("), _c('em', [_vm._v("Oligoneuron album")]), _vm._v("), upland aster, bears many white flowers in the summer on low-growing plants. The foliage is still erect, up to 6\" long and less than 1/2\" wide. Likely hardy from zones 3 to 8.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_170"
    }
  }, [_c('em', [_vm._v("A. puniceus")]), _vm._v(" ("), _c('em', [_vm._v("Symphyotrichum puniceum")]), _vm._v(" var. "), _c('em', [_vm._v("puniceum")]), _vm._v("), swamp aster, can produce thick treelike stems up to 6' tall although a great deal of variability occurs in the ")]), _c('a', {
    attrs: {
      "id": "page_171"
    }
  }, [_vm._v("wild. Plants are most at home in damp swampy conditions and look particularly ragged in dry soils. The stems and leaves are generally quite hairy and the leaves clasp the stem in the same manner as New England aster. Flowers are usually light blue, not the Phoenician purple that the Latin name suggests.")])]), _c('a', {
    attrs: {
      "id": "page_171"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. sibiricus")]), _vm._v(", Siberian aster, are well-branched plants producing violet flowers with yellow discs in the early fall. A handsome plant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. spectabilis")]), _vm._v(", ("), _c('em', [_vm._v("Eurybia spectabilis")]), _vm._v("), looks similar to Frikart’s aster but grows only 1-2' tall and flowers much later. Plants are covered with showy violet-blue flowers on many-branched stems. Native from Massachusetts to North Carolina, plants are way underused.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. umbellatus")]), _vm._v(" ("), _c('em', [_vm._v("Doellingeria umbellata")]), _vm._v(" var. "), _c('em', [_vm._v("umbellata")]), _vm._v("), is found from Newfoundland to Georgia and bears umbel-like heads of small white flowers with yellow centers on 4-5' tall stoloniferous plants. Plants spread aggressively by rhizomes. This is another example of a species that perks up significantly given a little garden care.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("versicolor")]), _vm._v(", bicolor aster, resulted from a cross between "), _c('em', [_vm._v("A. laevis")]), _vm._v(" and "), _c('em', [_vm._v("A. novi-belgii")]), _vm._v(". Plants grow 3' tall with ray flowers that open blue or white and change to purple.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. vimineus")]), _vm._v(" ("), _c('em', [_vm._v("Symphyotrichum lateriflorum")]), _vm._v(" var. "), _c('em', [_vm._v("lateriflorum")]), _vm._v("), native to Kansas and Oklahoma, also bears very stiff narrow leaves but has a twiggy dense appearance. The leaves are slightly gray-green and many off-white flowers are held on slightly arching branches. ‘Lovely’ bears lovely lilac-pink flowers in late summer and early fall. Not well known and deserving of far more use. The new nomenclature system lumps this species in with "), _c('em', [_vm._v("A. lateriflorus")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. zzzzzz")]), _vm._v(" I give up, haven’t you?")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Asteromoea")])]), _vm._v(" see "), _c('em', [_vm._v("Kalimeris")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Astilbe")])]), _vm._v(" (as-til' bee)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("False Spirea")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Saxifragaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Astilbes have enjoyed immense popularity for many years and can be excellent plants for shady, moist conditions. The individual flowers are small and without much merit, but the plumelike inflorescences range from 6\" to 2' tall and can be extraordinarily striking. About 25 species of "), _c('em', [_vm._v("Astilbe")]), _vm._v(" have been described, and hundreds of cultivars are offered. Some are less than 1' tall and useful for the front of the garden or rockeries while others are over 4' in height and better suited for the back of the garden. No cultivar requires staking, and all last for years under good garden conditions. The mid to deep green foliage is 2 or 3 times divided into groups of three (biternate to triternate) and is often copper colored when young (particularly red-flowered hybrids). The biggest enemy of "), _c('em', [_vm._v("Astilbe")]), _vm._v(" is dryness; if the soil dries out, the foliage develops brown margins and whole leaves may wither and die prematurely. Ample moisture and rich soils result in a rewarding planting. This is more of a problem in areas of hot days and warm nights, but that can be said for the performance of many perennials. In my garden, I revel in the many astilbes that look good, but I don’t try to compare them to those in Banff, Alberta.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_171"
    }
  }), _c('a', {
    attrs: {
      "id": "page_172"
    }
  }, [_vm._v("Plants are particularly effective grouped around the edge of ponds or other water features in the garden. If grown in areas to their liking, they provide incomparable beauty during flowering and then will fade nicely as the season progresses.")])]), _c('a', {
    attrs: {
      "id": "page_172"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Astilbes can also be used as potted plants forced into flower in the greenhouse. Plant the crowns in 6\" pots in late summer and allow them to establish good root and foliage systems during the fall. Place them in a cold frame or bury under straw mulch so they receive approximately 3 months of sub 40°F temperatures. At that time, bring the pots inside and water and fertilize as foliage and flowers appear. Astilbes also make excellent cut flowers if harvested when the inflorescence is half open. Propagate from divisions in spring or fall. Some of the species may be raised from seed but the hybrids must be propagated vegetatively. Seed should be sown in moist sand-peat mixture and placed at 70-75°F for 2 weeks followed by 40°F for 4 weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Astilbe Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (in.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flowering season")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower color")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("arendsii")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("24-48")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Various")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. biternata")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("36-60")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. chinensis")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("8-15")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Summer")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Red-pink")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. chinensis")]), _vm._v(" var. "), _c('em', [_vm._v("taquetii")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("24-48")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Late Summer")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Lilac")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("rosea")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("24-36")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Summer")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Salmon, pink")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. simplicifolia")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("12-18")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Summer")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Pink, white")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('strong', [_vm._v("-x")]), _vm._v(" "), _c('em', [_c('strong', [_vm._v("arendsii")])]), _vm._v(" (ah-rendz' ee-ie)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Hybrid Astilbe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-4'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Various")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Hybrid Origin")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zone 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Over 95% of the astilbes sold in this country probably belong to this group of hybrids. Not enough can be said about the accomplishments of Georg Arends (1862-1952), of Ronsdorf, West Germany, who studied and hybridized such genera as "), _c('em', [_vm._v("Bergenia")]), _vm._v(", "), _c('em', [_vm._v("Sedum")]), _vm._v(", "), _c('em', [_vm._v("Phlox")]), _vm._v(" and "), _c('em', [_vm._v("Campanula")]), _vm._v(". His passion, however, was "), _c('em', [_vm._v("Astilbe")]), _vm._v(". One of his first introductions (1903) using "), _c('em', [_vm._v("A. chinensis")]), _vm._v(" and "), _c('em', [_vm._v("A. japonica")]), _vm._v(" was a light pink cultivar called ‘Peach Blossom’, still enjoyed by gardeners today (this has since been reclassified as "), _c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("rosea")]), _vm._v(" to designate hybrids of "), _c('em', [_vm._v("A. chinensis")]), _vm._v(" and "), _c('em', [_vm._v("A. japonica")]), _vm._v(" parentage only).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Additional clones arose from crosses among other species including "), _c('em', [_vm._v("A. grandis")]), _vm._v(", "), _c('em', [_vm._v("A. thunbergii")]), _vm._v(", "), _c('em', [_vm._v("A. davidii")]), _vm._v(", and "), _c('em', [_vm._v("A. astilboides")]), _vm._v(". In 1933, a major breakthrough came with the appearance of a bronze leafed, red-flowered cultivar later named ‘Fanal’. Arends continued crossing combination after combination and between 1902 and 1952 introduced over 74 cultivars, many of which are available in North American nurseries. Astilbes also caught the attention of other nurseries such as the Lemoine Nursery in Nancy, France and Blooms of Bressingham in Diss, England. Well over fifty cultivars are available, ranging from those with copper to dark green foliage; flower colors from clear white to blood red; and flowering times of early June to mid August.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_172"
    }
  }, [_vm._v("It is impossible to name all cultivars within the confines of this book but the following list includes some personal favorites as well as other popular selections. ")]), _c('a', {
    attrs: {
      "id": "page_173"
    }
  }, [_vm._v("Many cultivars have been reclassified under "), _c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("hybrida")]), _vm._v(", "), _c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("japonica")]), _vm._v(", "), _c('em', [_vm._v("A")]), _vm._v(" x "), _c('em', [_vm._v("rosea")]), _vm._v(" and "), _c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("thunbergii")]), _vm._v(", but differences from the garden point of view are absolutely inconsequential.")])]), _c('a', {
    attrs: {
      "id": "page_173"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_vm._v("White flowers:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Avalanche’ is about 2' tall with wide, arching inflorescences.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bridal Veil’ is about 2 1/2' tall with white-pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bumalda’ produces rosy white plumes and grows about 2' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Deutschland’ bears dense flower spikes on 2' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Diamond’ has fairly clean white flowers on 2-3' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Ellie’ bears large white flowers on thick mid to dark green foliage. Showier than most whites.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Gladstone’ (‘W.E. Gladstone’) produces 18-24\" tall plants with creamy white inflorescences.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Irrlicht’ has rosy white flowers over dark green foliage. It grows 2-2 1/2' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Professor van der Wielen’ has loose flower spikes on 3' high plants. A terrific plant which can also substitute for goat’s beard. A hybrid of "), _c('em', [_vm._v("A. thunbergii")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Queen of Holland’ bears white flowers tinged with pink and bronze foliage.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Snowdrift’ is a sport of ‘Irrlicht’ and produces clear white flowers over 2 1/2' tall stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘White Gloria’ is an early-flowering cultivar about 2' tall. The tight flowers are not as graceful as some of the more airy-flowered forms, but they flower well and without complaint.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_vm._v("Pink to salmon flowers:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Anita Pfeifer’, bred in 1930 by the Arends nursery, produces bright salmon-rose flowers on 24-30\" plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Astary Pink’ is a seed-propagated form that grows only 10-15\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Betsy Cuperus’ is one of the oldest cultivars, bred in 1917, and is occasionally offered today. Long sprays of blush pink flowers are held on 3' tall plants. A hybrid of "), _c('em', [_vm._v("A.")]), _vm._v(" x "), _c('em', [_vm._v("thunbergii")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bremen’ grows about 3' tall and bears deep pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bressingham Beauty’ has arching plumes of clear pink flowers on 3 1/2' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Catherine Deneuve’ is almost as beautiful as her namesake. Fluffy rose-pink flowers top 24-30\" tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Cattleya’ bears orchid-pink, long blooming flowers on 3' high plants. A cultivar that performs well all over the country.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Country and Western’ grows about 20\" tall and sports light pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Düsseldorf’ grows 2-2 1/2' tall and produces salmon-pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Elizabeth Bloom’ has dark green foliage with handsome pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Erica’ is about 3' tall and has large open panicles of clear pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Europa’ is an early-flowering cultivar bearing pale pink flowers over 2' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Flamingo’ has bright pink flowers produced on many branched stems. The dark green foliage is a nice contrast. 18-20\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Gloria’ flowers in midsummer with rosy lavender flowers on 30\" tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Grete Pungel’ is at least 3' tall, has pink flowers and blooms in early to midsummer. An Arends introduction dating back to 1924.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_173"
    }
  }), _c('div', {
    staticStyle: {
      "height": "500px"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_173"
    }
  }), _c('p', {
    staticClass: "imagen"
  }, [_c('a', {
    attrs: {
      "id": "page_173"
    }
  }), _c('a', {
    attrs: {
      "id": "page_174"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/f0174-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_174"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_174"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Astilbe")]), _vm._v(" x "), _c('em', [_vm._v("arendsii")])])])]), _c('a', {
    attrs: {
      "id": "page_174"
    }
  }), _c('p', {
    staticClass: "bibp"
  }, [_c('a', {
    attrs: {
      "id": "page_174"
    }
  }), _c('a', {
    attrs: {
      "id": "page_175"
    }
  }, [_vm._v("‘Irene’ has lovely light pink flowers on 2' tall plants.")])]), _c('a', {
    attrs: {
      "id": "page_175"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Lollypop’ is a reasonably new deep pink-flowered form with dark green foliage, which looks good even when not in flower.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Love and Pride’ (who names these things?) has purple-pink flowers on 2 1/2' tall plants. The foliage is bronze in the spring, but greens up later.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Mainz’ produces handsome lavender-pink flowers with dark green foliage.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Ostrich Plume’ bears many bright pink arching spikes over 3' tall plants. An "), _c('em', [_vm._v("A.")]), _vm._v(" x "), _c('em', [_vm._v("thunbergii")]), _vm._v(" hybrid.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Peaches and Cream’ is more pink than white, but the two colors on the same plume account for the name. Plants are about 2' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pink Lightning’ grows about 2' tall with handsome, deep pink flowers over dark green foliage.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Rheinland’ is popular and has early clear pink flowers on 2' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Sheila Haxton’, a new introduction from Blooms of Bressingham, has "), _c('em', [_vm._v("A. chinensis")]), _vm._v(" ‘Pumila’ in its parentage. The flowers are deep pink and a little over 2' tall. Plants have performed very well in the Gardens at UGA.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Touch of Pink’ is 2-2 1/2' tall with glossy green leaves. The flowers are sort of white with pink or pink with white, depending on climate.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('em', [_vm._v("Red to magenta flowers:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘America’ bears lilac rosy flowers on open plumes. Old-fashioned but tough.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘August Light’ produces intense red flowers on 2-2 1/2' tall plants. Red stems in the spring add to its appeal.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Burgundy Red’ has dark red flowers over glossy green foliage.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Etna’ has dark red plumes with dark green foliage on 2' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Elisabeth van Veen’ bears raspberry red flowers on stiff upright 2' tall plants. This is sometimes sold as ‘Elizabeth’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Fanal’, first offered in 1933, is one of the most popular astilbes offered. It is small (2' in height), early to flower, and produces blood red blooms above dark bronze leaves.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Federsee’ adapts well to dry conditions. Plants produce 2' long panicles of carmine-rose flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Fire’ (‘Feuer’) produces eye-catching fiery-red flowers on 30\" plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Gertrud Brix’ is also carmine-red and plants are only 2' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Glow’ is only 1-1 1/2' tall with intense red flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Granet’ is about 2' tall and bears carmine red blooms.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Jo Ophorst’ has late-flowering, stiff magenta spikes on 3' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Lilli Goos’, raised in 1930, is still a handsome red to pink late-flowering cultivar. About 30\" tall with dark green foliage.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Mars’ is an early violet-flowering cultivar growing about 2' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Montgomery’ is a terrific scarlet-red flowering plant 2-3' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Radius’ is an exceptionally good red-flowered cultivar. Plants grow 2-3' tall and the flowers persist for weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Red Charm’ has a good deal of "), _c('em', [_vm._v("A. thunbergii")]), _vm._v(" in its pedigree, accounting for its robust size (3-4' tall) and arching red flower plumes. Close to true red as any cultivar I’ve seen.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_175"
    }
  }), _c('a', {
    attrs: {
      "id": "page_176"
    }
  }, [_vm._v("‘Red Light’ has intense red flowers and exceptionally handsome shiny green foliage.")])]), _c('a', {
    attrs: {
      "id": "page_176"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Red Sentinel’, an early-flowering cultivar, produces red flowers on 3' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Spartan’ bears dark red flowers on 2-3' tall deep green plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Spinell’ bears salmon-red flowers atop 3' tall stems.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Vesuvius’ has early bright salmon flowers on 2' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-biternata")])]), _vm._v(" (bye-ter-nay' ta)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Native Astilbe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("3-5'/3'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southeastern United States")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Must be me. I have written about this plant for years and years, in fact, in the last edition I said that it was “an uncut diamond . . . just waiting to be discovered.” Still waiting, I am afraid. I may be the only person in North America who enjoys this plant. I still keep hoping others will give it a try.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants grow at least 3' tall and 5' plants are not uncommon in moist organic soils. The serrated foliage is biternate (blade divided into 3 segments, which are again divided into 3 segments) and slightly hairy. The yellowish white flowers are held in large drooping panicles which, while they can’t compete with the shocking reds and carmines of some of the cultivars, lend a wonderful classical feel to the garden. Compared to the hybrids, it is most similar to ‘Professor van der Wielen’, which can be substituted if "), _c('em', [_vm._v("A. biternata")]), _vm._v(" cannot be located. Partial shade, rich soil and ample moisture are necessary for best performance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants can be propagated from seed, division or root cuttings. One of the most successful propagations occurred inadvertently when we tilled our University garden in the fall. The next spring a half dozen plants emerged, the result of our tiller cutting the roots of dormant plants. Not recommended but effective.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-chinensis")])]), _vm._v(" (chin-en' sis)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Chinese Astilbe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1 1/2-2'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Rosy White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("China")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The species is seldom seen in gardens, and was once almost totally represented by the dwarf variety "), _c('em', [_vm._v("pumila")]), _vm._v(". Recently, renewed interest in this tough species has resulted in a number of new cultivars for North American gardeners. The dark green ternate (in 3 segments) foliage is rounded at the base of the hairy segments and is doubly serrated. A group of plants makes an excellent ground cover for a moist, shaded area. The flowers are held in branched, rather narrow panicles and while the species itself is rosy white, most of the cultivars are rose to purple. Plants are doubly handsome due to the deeply incised bronze-green foliage. Although garden performance is far better in moist soils, it is one of the more drought-tolerant astilbes.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Finale’ grows about 18\" tall and bears handsome spikes of light pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Intermezzo’ has salmon-pink flowers on 24-30\" tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Maggie Daley’ bears fuzzy lavender-purple flowers over glossy green foliage. Plants stand about 2 1/2' tall.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_176"
    }
  }, [_vm._v("‘Pumila’ (var. "), _c('em', [_vm._v("pumila")]), _vm._v(") is the most common form offered. Plants bear dense branched inflorescences of lavender-purple. It is obvious that not all material labeled as var. ")]), _c('a', {
    attrs: {
      "id": "page_177"
    }
  }, [_c('em', [_vm._v("pumila")]), _vm._v(" has been propagated vegetatively or originated from the same parent stock. I have seen this variety as an 8\" ground cover and as a 2-2 1/2' border subject. Some of the variations can be attributed to climate and presence of soil moisture (plants will be taller and more vigorous in consistently moist soils than in those that dry out), however, even in the same climatic zones and in relatively similar moisture regimes, variation in height is considerable (or plants are mixed up).")])]), _c('a', {
    attrs: {
      "id": "page_177"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Purple Glory’ stands about 2' tall with tight purple inflorescences.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Serenade’ bears rosy pink flowers a little later than other cultivars on 15-18\" plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Sister Theresa’ is a stiff upright grower, with light pink flowers. Plants grow about 2' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Spatsommer’ is very late and produces bright rose flowers on 2' plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Veronica Klose’ grows 18-24\" tall with many purple-rose flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Visions series has more upright flowers than others in the species and deep bronze green foliage. The flowers are pink-purple. In the Armitage garden it is outstanding. Recently, two selections of ‘Visions’ were introduced with similar habits and good flowering characteristics. ‘Visions in Pink’ and ‘Visions in Red’ appear to be as good as the original cultivar and should become popular.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("taquetii")]), _vm._v(" has always been known as "), _c('em', [_vm._v("A. taquetii")]), _vm._v(" (ta-get' ee-eye) but has recently been reclassified as a variant of "), _c('em', [_vm._v("A. chinensis")]), _vm._v(". This variety is most commonly represented in gardens by the very vigorous and late-flowering ‘Superba’ but other cultivars have been offered. Compact columnar panicles up to 5 inches tall extend the flowering season of "), _c('em', [_vm._v("Astilbe")]), _vm._v(" into late summer and occasionally early fall. In north Georgia, flowering ceases in early to mid June whereas those of "), _c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("arendsii")]), _vm._v(" hybrids finish 2-4 weeks earlier. Further north, flowering may continue into late August. The flower stems are far more hairy and the flowers are more dense than those of the "), _c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("arendsii")]), _vm._v(" hybrids and make excellent cut flowers, persisting over a week in water. The seed heads retain the majesty of the flower spires and persist throughout the winter. Many cultivars (and hybrids) of this variety have recently appeared. They will still often be found under "), _c('em', [_vm._v("A. taquetii")]), _vm._v(" in most catalogs.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pink’ produces flowers that are more pink than they are purple, the common color of this variety. The pink is still not a true pink, but is a little less harsh than the common forms.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Purple Candles’ bears purple-red flowers on 3' tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Purple Lance’ is large (4-4 1/2' tall) with big purple-red blooms appearing in late summer. The flower plumes are longer and considerably narrower than others. In cool summers, even the flower stems will be red.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Superba’ is the most common form, bearing tall narrow stalks of lavender-purple flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('strong', [_vm._v("-x")]), _vm._v(" "), _c('em', [_c('strong', [_vm._v("rosea")])]), _vm._v(" (ros' ee-a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Rose Astilbe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-4'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Pink")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Hybrid")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The result of crossing "), _c('em', [_vm._v("A. chinensis")]), _vm._v(" and "), _c('em', [_vm._v("A. japonica")]), _vm._v(", a 3' tall white-flowered species, this hybrid has the habit of "), _c('em', [_vm._v("A. japonica")]), _vm._v(" and the flower color of "), _c('em', [_vm._v("A. chinensis")]), _vm._v(". The original hybrid is seldom seen in gardens, having been superseded by various selections.")])]), _c('div', {
    staticClass: "group"
  }, [_c('a', {
    attrs: {
      "id": "page_177"
    }
  }), _c('div', {
    staticStyle: {
      "height": "500px"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_177"
    }
  }), _c('p', {
    staticClass: "imagen"
  }, [_c('a', {
    attrs: {
      "id": "page_177"
    }
  }), _c('a', {
    attrs: {
      "id": "page_178"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/f0178-01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_178"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_178"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Astilbe chinensis")]), _vm._v(" ‘Pumila’")])])]), _c('a', {
    attrs: {
      "id": "page_178"
    }
  }), _c('p', {
    staticClass: "noindentp"
  }, [_c('a', {
    attrs: {
      "id": "page_178"
    }
  }), _c('a', {
    attrs: {
      "id": "page_179"
    }
  }, [_c('strong', [_vm._v("Cultivars:")])])]), _c('a', {
    attrs: {
      "id": "page_179"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Peach Blossom’ is 3-4' tall and produces salmon-pink blooms clustered in large racemose panicles.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Queen Alexandra’ is a deeper pink but otherwise similar to ‘Peach Blossom’. These cultivars are both excellent for damp places, and intolerant of drought conditions. They were some of the first hybrids (1903) raised by Georg Arends.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-simplicifolia")])]), _vm._v(" (sim-pli-si-fo' lee-a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Star Astilbe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1-1 1/2'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Japan")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This dwarf species has undergone considerable selection and hybridization, having caught the attention of Arends in 1911. The 3\" leaves are either simple (not compound) or a single group of three (ternate leaves). Hybridization has resulted in more compound leaves than simple leaves and has made identification more difficult. The leaves are nearly always glossier than other hybrids or species and are good looking even without flowers or fruit. It forms compact mounds of medium green, glossy, deeply cut foliage that gives rise to white starlike flowers in airy, open panicles in June and July in the South and July and August in the North. The seed heads are nearly as ornamental as the flowers and provide an additional 1-2 months of useful garden effect.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Most cultivars are likely hybrids between "), _c('em', [_vm._v("A. simplicifolia")]), _vm._v(" and other species, but resemble "), _c('em', [_vm._v("A. simplicifolia")]), _vm._v(". They are slower to establish than the "), _c('em', [_vm._v("A")]), _vm._v(". x "), _c('em', [_vm._v("arendsii")]), _vm._v(" hybrids and require 2-3 years to reach mature size.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("alba")]), _vm._v(" has white flowers which are “cleaner” than those of the species.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Aphrodite’ is one of the larger cultivars in this species, growing 15-20\" tall, and bears salmon-red flowers over dark green leaves. The upright, rather than arching, plumes set this plant apart from the others.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Atrorosea’ has 18-20\" tall bright rose-salmon plumes.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bronze Elegance’ produces rose pink blooms in August over bronze foliage. Very handsome.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Carnea’ grows about 15\" tall and bears deep salmon flowers in late summer.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Dunkellachs’, raised in 1940, has recently appeared in the United States. A little taller than other cultivars, plants grow about 2' tall and produce large trusses of salmon flowers over deep bronze foliage.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Hennie Graafland’ grows about 16\" tall and produces rosy flowers over shiny dark green leaves. Flowers in July and remains handsome for 4-6 weeks.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Inshriach Pink’ produces 10\" tall pink spikes over bronze-green crinkled foliage. Raised by the nurseryman Jack Drake of Inshriach Nursery in Aviemore, Scotland.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Sprite’, raised by Alan Bloom, is the most popular cultivar and was named the 1994 Perennial Plant of the Year by the Perennial Plant Association. It has airy, shell-pink blooms over bronze foliage and grows 12-18\" tall. The rust-colored seed heads are particularly outstanding.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘White Sensation’ is a relatively new offering characterized by many white-flowering stems and glossy green foliage. Plants stand about 18\" tall.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_179"
    }
  }), _c('a', {
    attrs: {
      "id": "page_180"
    }
  }, [_vm._v("‘White Wings’ appears to have "), _c('em', [_vm._v("A. simplicifolia")]), _vm._v(" in its veins. Plants are about 18-24\" tall, with bright dark green leaves and white flowers.")])]), _c('a', {
    attrs: {
      "id": "page_180"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘William Buchanan’ is one of the most dwarf cultivars. Growing only about 6-8\" tall, pale pink flowers are formed over dense curly foliage.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A.")]), _vm._v(" x "), _c('em', [_vm._v("crispa")]), _vm._v(" has been in horticultural literature since 1924, however, compared to other hybrids, it is relatively unknown. The 12-15\" tall hybrid, also raised by the Arends nursery, forms a mat of dark green fernlike foliage that turns bronze in the fall. The flowers of the species are creamy white but flowers of ‘Liliput’ are salmon-pink. ‘Perkeo’ is the most available cultivar in North America and bears dark pink flower spikes and grows 8-10\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. glaberrima")]), _vm._v(" reaches only about 3-5\". The leaves are bronze and the flowers are purple. It is generally offered as ‘Saxatilis’.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Astilboides")])]), _vm._v(" (a-stil-boy' deez)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Saxifragaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This genus is the result of a taxonomic split from the genus "), _c('em', [_vm._v("Rodgersia")]), _vm._v(", and in this case, the split seems to make sense. Only one species is recognized, "), _c('em', [_vm._v("A. tabularis")]), _vm._v(" (syn. "), _c('em', [_vm._v("Rodgersia tabularis")]), _vm._v("). Leaves are not compound as in "), _c('em', [_vm._v("Rodgersia")]), _vm._v(" but are immense, circular and slightly lobed. They are peltate, meaning that the petiole attaches to the middle of the leaf, and may be 3' across. The leaves resemble those of "), _c('em', [_vm._v("Darmera peltata")]), _vm._v(" while the flowers resemble those of a large astilbe. The inflorescence is made up of long plumes of creamy white flowers that extend well above the foliage. Both sepals and petals are found on the flowers, whereas those of "), _c('em', [_vm._v("Rodgersia")]), _vm._v(" are apetalous.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants grow at least three feet tall and equally wide. These are not plants for the small garden. Although hardy in zones 5-7, plants are not easy to establish unless assured of moist, cool conditions. A wonderful plant where well-grown, sure to elicit all sorts of comments.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Astrantia")])]), _vm._v(" (a-stran' tee-a)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Masterwort")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Apiaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This interesting genus encompasses about 10 species although none is particularly common in American gardens. Plants are useful for moist, shady areas and benefit from copious amounts of organic matter. The white to pink flowers are surrounded by a “collar” of bracts which produce a starlike effect. The flower head is a compound umbel and consists of both sterile and fertile flowers. The sterile flowers have long flower stalks (pedicels) and the fertile flowers are short stalked. Night temperatures are too warm to grow "), _c('em', [_vm._v("Astrantia")]), _vm._v(" much further south than zone 7a unless at higher altitudes. Cool night temperatures, partial shade, and consistent soil moisture are necessary for best performance. "), _c('em', [_vm._v("Astrantia major")]), _vm._v(", the most common garden species, is well known in flower gardens in Europe, particularly the British Isles, and is now finding its way over here. It is about time! They persist for 10-14 days as a cut flower and are produced commercially as such in the Netherlands and California.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_180"
    }
  }), _c('a', {
    attrs: {
      "id": "page_181"
    }
  }, [_c('em', [_vm._v("Astrantia")]), _vm._v(" is easily increased by division of the black roots in autumn or early spring. It also spreads by runners just below the surface and reseeds itself where it is comfortable.")])]), _c('a', {
    attrs: {
      "id": "page_181"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Astrantia Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Height (ft.)")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Flower color")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. major")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("2-3")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Greenish white to white with tinge of pink")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. maxima")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("2-3")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Rose-pink")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-major")])]), _vm._v(" (may' jor)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Great Masterwort")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-3'/1 1/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Greenish White")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The 2-3\" diameter flowers are greenish white with a collar of green bracts and borne in a many-flowered umbel. The basal leaves have a petiole, 3-7 deeply cut lobes and are toothed while the leaves on the flower stem have widely expanded petioles which clasp directly to the stem, and are seldom toothed. The bracts are often tinged purple which give the effect of pink flowers. Plants spread rapidly under good growing conditions and form a formidable clump. A tremendous amount of variation occurs within the species, due to the large amount of seed and the propensity to shift colors. White, rose, and pink flowers can all occur in the same planting over a few years. I’ve noticed that some enterprising nurserypeople have taken advantage of this natural occurrence and offer a range of colors under the name Rainbow. The rainbow will only get more colorful if planted where they can multiply.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plant in semi-shaded moist areas. They are at their best in cool, moist, shaded areas.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Abbey Road’ is a recent introduction with dusky purple flowers on 18-22\" stems. This may be a hybrid with "), _c('em', [_vm._v("A. maxima")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alba’ bears white flowers. In shaded areas, flowers light up the area more than the species.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Claret’ has become quite popular, being another dark red-flowering form on 20-24\" stems. Plants have dark stems and appear to be quite floriferous. It is difficult to tell the many dark red forms apart so try what is available in your local garden center.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Hadspen Blood’ is about 2' tall with deep crimson bracts. Plants originated in the gardens of Nori and Sandra Pope in Hadspen, England.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_c('em', [_vm._v("involucrata")]), _vm._v(" is a subspecies and includes a number of cultivars with an extra long collar of pink bracts. One of the most impressive cultivars is ‘Margery Fish’, better known as ‘Shaggy’, a most apt description of the flowers. The true cultivar should be vegetatively reproduced from cuttings, although some seedlings with long bracts will occur.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Lars’ has shown excellent vigor and produces dark red flowers.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_181"
    }
  }), _c('a', {
    attrs: {
      "id": "page_182"
    }
  }, [_vm._v("‘Magnum Blush’ has creamy white flowers with a tinge of pink.")])]), _c('a', {
    attrs: {
      "id": "page_182"
    }
  }, [_c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Moira Reid’ is a most interesting plant with large pink flowers and salmon-peach collars.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Moulin Rouge’ is one of the newer cultivars and bears dark red flowers. Plants grow 18-24\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Roma’ is about 2 1/2' tall and produces deep pink flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Rosea’ bears rose-colored flowers with deeply incised leaves.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Rose Symphony’ is a wonderfully handsome plant with rosy pink flowers with a silver collar of bracts. Plants are about 2' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Ruby Wedding’ has ruby red centers surrounded by ruby red bracts beneath. One of the darkest red of the bunch.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Silver Glow’ bears pale green, almost to the point of being silvery white. About 3' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Snow Star’ (‘Star of Snow’) has white flowers with tinges of green throughout. Plants grow 2 1/2 to 3' tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Sunningdale Variegated’ is most handsome in the spring when the margins of the light green leaves are splashed with yellow and cream. The variegation fades in summer. This is an elegant plant.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-maxima")])]), _vm._v(" (mahk' si-ma) Large")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Masterwort")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-3'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Late Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Rose-pink")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Southern Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 5-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I really like this species and it is good to see its availability increasing in this country. The flowers are larger and much more rose-pink than white, as in "), _c('em', [_vm._v("A. major")]), _vm._v(". The foliage is usually 3-parted, although some 5-parted leaves may occur. The basal leaves are petioled, however, the upper leaves are usually sessile and appear wrapped around the stems.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The plants are not as vigorous or self-sowing as "), _c('em', [_vm._v("A. major")]), _vm._v(" but the flowers are subtly eye-catching.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Alba’ is a white-flowered form, but quite difficult to locate.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Buckland’ appears to be a hybrid of "), _c('em', [_vm._v("A. major")]), _vm._v(" x "), _c('em', [_vm._v("A. maxima")]), _vm._v(", bearing flowers similar in color to the former and intermediate in size. Perhaps one of the best characteristics is that flowers are sterile, and persist considerably longer than on either parent.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("Related Species:")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. carniolica")]), _vm._v(", lesser masterwort, is similar but smaller (6-12\" tall) than "), _c('em', [_vm._v("A. major")]), _vm._v(". The purple flowers of ‘Rubra’ contrast well with the greenish bracts surrounding them. Some taxonomic authorities lump this species with "), _c('em', [_vm._v("A. major")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Athyrium")])]), _vm._v(" (a-thi' ree-um)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Lady Fern")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Dryopteridaceae")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_182"
    }
  }, [_vm._v("Approximately 68 species of "), _c('em', [_vm._v("Athyrium")]), _vm._v(" have been listed by one fern expert or another but only half a dozen are found in North American gardens. Some of the most common and handsome hardy ferns are to be found in the genus. "), _c('em', [_vm._v("Athyrium")]), _vm._v(" is a large genus ")]), _c('a', {
    attrs: {
      "id": "page_183"
    }
  }, [_vm._v("widespread in temperate and tropical regions in which the sori (spore cases) are generally curved and the indusium, a thin layer of cells surrounding the sorus, is attached only on one side. Most have a delicate texture and thrive in moist, humid conditions. All species are deciduous and die down over the winter. Ferns in this genus are some of the most reliable, colorful and easiest ones to grow. Some taxonomists have placed the genus in the Woodsiaceae, but that change has not been universally accepted.")])]), _c('a', {
    attrs: {
      "id": "page_183"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Quick Reference to Athyrium Species")])]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Amount of color on fronds")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Habit")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. filix-femina")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("None")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Upright, 2-3'")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("A. niponicum")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Highly")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Spreading, 1-2'")])])])]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-filix-femina")])]), _vm._v(" (fi' liks fem' mi-na)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Lady Fern")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("2-3'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Northern Hemisphere")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Valued for ease of cultivation, this graceful fern is one of the most satisfying for new fern gardeners. Although the frond shape can be highly variable, they are often up to 3' tall and 1' wide and generally stand up on their own. The vigorous flush of new growth in the spring is wonderful. If placed in dense shade, they will grow well enough, however they may not be sufficiently strong to withstand winds, rabbits or dogs. Morning sun and loamy humus-rich soils are highly recommended.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("Dozens of cultivars have been selected. The RHS Plant Finder lists well over 30 variants, subspecies and cultivars of the lady fern. They range from dwarf forms (‘Congestum’), bunched fronds (‘Corymbiferum’), crested like a celosia (‘Cristatum’, ‘Glomeratum’), slender pinnae (‘Setigerum’), balled-up pinnae (‘Frizelliae’), and long terminal narrow crest (‘Victoriae’). I can handle the Victoria lady fern reasonably well and even the dwarf ‘Cruciato-cristatum’ (otherwise known as ‘Dre’s Dagger’), but many of these ulcerated forms are ugly enough to induce nausea and few can compete with the classic beauty of the species itself.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("var. "), _c('em', [_vm._v("asplenoides")]), _vm._v(", southern lady fern, grows 2-3' tall and spreads more aggressively than its northern cousin. Native to southern and eastern United States. Plants tolerate more sun than most other green ferns. Zones 4-8.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Aurea’ is a light green (not really golden) selection of "), _c('em', [_vm._v("A. filix-femina")]), _vm._v(" ‘Plumosum’. The fronds consist of lacy pinnae. Introduced by Carol and Angelo Randaci of The Fernery, Covington, Kentucky.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Axminster’ is also of ‘Plumosum’ parentage, having highly divided fronds, providing a lacy appearance.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Encourage’ is a selection of "), _c('em', [_vm._v("Athyrium filix-femina")]), _vm._v(" ‘Vernoniae Cristatum’, crested lady fern. It is distinctly crested and tasseled but is faster growing than other crested forms and is also notable for producing light green fronds. Another Randaci introduction.")])]), _c('p', {
    staticClass: "bib"
  }, [_c('a', {
    attrs: {
      "id": "page_183"
    }
  }), _c('a', {
    attrs: {
      "id": "page_184"
    }
  }, [_vm._v("‘Lady in Red’ is a selection of "), _c('em', [_vm._v("A. filix-femina")]), _vm._v(" var. "), _c('em', [_vm._v("angustum")]), _vm._v(", northern lady fern, and is slow grower. However, her red stems, particularly in the spring, are quite pleasant.")])]), _c('a', {
    attrs: {
      "id": "page_184"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-niponicum")])]), _vm._v(" (nip-on-i' cum)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Japanese Painted Fern")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("1-2'/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("East Asia")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-8")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Japanese painted fern is native to China, Korea and Japan and has handsome green fronds. Although a reliable and useful plant, it is usually offered as its colorful variant, var. "), _c('em', [_vm._v("pictum")]), _vm._v(" (‘Pictum’). This is a great plant, and has been a great plant for many years. It took a while, but finally the Perennial Plant Association chose it as the Perennial Plant of the Year for 2004.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The fronds, a soft metallic gray suffused with reddish or bluish hues, are among the most colorful on any fern. The color is maintained in the old fronds and the emerging shades of the new ones paint a pleasant contrast. Plants tolerate deep shade but display their best color when they receive some direct sunlight, preferably in the morning. Even though a great deal of variability occurs, they will be of bragging quality in 2-3 years. Provide a humusy soil and sufficient water for best performance.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("All of these are cultivars of var. "), _c('em', [_vm._v("pictum")]), _vm._v(" or have it in the parentage. Many have appeared only in the last three to five years.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Apple Court’ has its moments, bearing the purple, silver and green markings of a typical Japanese painted fern, but is also crested at the end of the fronds. Originating from Apple Court Nursery in the UK, introduced by Plant Delights Nursery.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Branford Beauty’ is an upright, clump-forming selection with subtle shades of green, purple, silver, and gray on the fronds. Plants are hybrids between lady fern and Japanese painted fern.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Burgundy Lace’ has eye-popping purple fronds with streaks of silver. The purple coloring is more intense in the spring, but the silvery sheen remains all season. Upright grower to about 2'.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Ghost’ is probably the best known, producing upright ferns with silvery markings (ghost-like?) on the fronds. Plants are hybrids between lady fern and Japanese painted fern. These are some of the best hybrids in the Armitage garden.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Ocean’s Fury’ produces light silver fronds with crested pinna and red midribs. Personally, I can’t see the fury or the ocean, but it could be an excellent hardy fern.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Pewter Lace’ bears handsome metallic foliage. A little less silver than ‘Silver Falls’ and no red to speak of on the fronds.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Red Beauty’ has red veins and stems in the silvery green foliage. Seems very similar to ‘Branford Red’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Silver Falls’ has long arching fronds clothed and bedecked in silver patterns, which is highlighted by the red-purple veins.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Wildwood Twist’ has smoky gray and green fronds that twist a little as they grow. Probably a hybrid between "), _c('em', [_vm._v("A. niponicum")]), _vm._v(" x "), _c('em', [_vm._v("A. otophorum")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Ursula’s Red’ has more red in the fronds than the normal species. Selected by Ursula Herz in South Carolina.")])]), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_184"
    }
  }), _c('a', {
    attrs: {
      "id": "page_185"
    }
  }, [_c('strong', [_vm._v("Related Species:")])])]), _c('a', {
    attrs: {
      "id": "page_185"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. distentifolium")]), _vm._v(", alpine lady fern, has light green finely textured fronds. Native to the alpine areas of North America and Eurasia, plants are extremely cold hardy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. japonicum")]), _vm._v(" ("), _c('em', [_vm._v("Lunathyrium japonicum")]), _vm._v(") black lady fern, Japanese lady fern, grows about 18\" tall and produces blackish-green, upright arching, triangular fronds. Fiddleheads begin to unfurl in late spring after most other ferns are already leafed out. Spreads slowly by creeping rhizomes. According to Missouri Botanical Garden and USDA plant databases, this fern is synonymous with and sometimes sold as "), _c('em', [_vm._v("Deparia petersenii")]), _vm._v(", ("), _c('em', [_vm._v("Athyrium petersenii")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. otophorum")]), _vm._v(", Asian lady fern, is native to China and Japan. This is a taller, more subtle, colored fern with large pewter green fronds with a reddish to purplish stem (stipe) and midrib (rachis). Not quite as hardy (Zone 6) as Japanese painted fern but almost as handsome. Provide some direct sun and humus-rich soil.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("A. thelypteroides")]), _vm._v(", silver spleenwort, silver glade fern, is a southeast American native. Plants have silvery sori (spore cases) on the undersides of the fronds, which together with small yellowish hairs, give a pale sheen to the plants as they wave in the breeze. Plants grow vigorously upright (to 4' in height), but are not invasive.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Aubrieta")])]), _vm._v(" (o-bree' sha)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Rock Cress")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Brassicaceae")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The genus consists of about a dozen species and a large number of cultivars. Some of the available garden forms are cultivars of "), _c('em', [_vm._v("A. deltoidea")]), _vm._v(", although most are hybrids, listed as "), _c('em', [_vm._v("A.")]), _vm._v(" x "), _c('em', [_vm._v("cultorum")]), _vm._v(", probably with "), _c('em', [_vm._v("A. deltoidea")]), _vm._v(" and "), _c('em', [_vm._v("A. gracilis")]), _vm._v(" in the parentage. "), _c('em', [_vm._v("Aubrieta")]), _vm._v(" is closely related to "), _c('em', [_vm._v("Arabis")]), _vm._v(", also commonly known as rock cress. The differences are not obvious and with the introduction of many cultivars, it is more difficult for the uninitiated to tell them apart. In general, "), _c('em', [_vm._v("Aubrieta")]), _vm._v(" is more compact with smaller foliage having 1-2 teeth on each side of the leaf blade. The flowers are larger and have a cylindrical calyx (sepals) below the petals about half as long as the petals. Flowers of "), _c('em', [_vm._v("Aubrieta")]), _vm._v(" are lilac to red with a few blue forms, while flowers of "), _c('em', [_vm._v("Arabis")]), _vm._v(" are usually white or pink. A summary follows.")]), _vm._v(" "), _c('table', {
    staticClass: "topbot",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('strong', [_vm._v("Habit")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_c('strong', [_vm._v("Petal length")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('strong', [_vm._v("Flower color")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_c('strong', [_vm._v("Foliage toothed")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_c('strong', [_vm._v("Sepals tubular")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("Aubrieta")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("More compact")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("3/4\"")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Lilac, red")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("Yes")])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('em', [_vm._v("Arabis")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("Less compact")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("1/2\"")]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_vm._v("White, pink")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center",
      "valign": "top"
    }
  }, [_vm._v("No")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plants in both genera have alternate, silver-green, pubescent, evergreen foliage. Neither genus is tolerant of warm nights, often declining in warm climates, and should be treated the same in the garden. Many cultivars can be propagated by seed and those not available from seed may be propagated by terminal cuttings or division.")]), _vm._v(" "), _c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-deltoidea")])]), _vm._v(" (del-toi’ dee-a)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Rock Cress")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("6-8\"/2'")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Lilac")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Sicily to Asia Minor")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 4-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_185"
    }
  }, [_vm._v("The species and hybrids ("), _c('em', [_vm._v("A.")]), _vm._v(" x "), _c('em', [_vm._v("cultorum")]), _vm._v(") perform best where sunny conditions and well-drained soils are present. So much interbreeding occurs within varieties that ")]), _c('a', {
    attrs: {
      "id": "page_186"
    }
  }, [_vm._v("a great deal of variability occurs. The foliage is somewhat wedge shaped with large teeth. The 3/4\" long, red to lilac flowers are clustered in racemes that emerge from the leaf axils. They are best grown cascading over rocks or walls where water will not collect. After the plants flower in the spring, the stems continue to grow and become leggy by midsummer. Some of the hybrids are more compact, but in general, they are best cut back to 6-8\" to allow new growth to emerge, otherwise stems will be naked in the middle with a few leaves on the end. This is especially true in the South where plants will not survive if allowed to deteriorate. Plants tend to lose vitality and may deteriorate badly after a few years unless new plants are purchased.")])]), _c('a', {
    attrs: {
      "id": "page_186"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Seed is available for many cultivars and germinates in about 2 weeks under moist, warm (70-75°F) conditions. Division, however, is the easiest means of propagation. Stem cuttings may also be taken from new growth in the spring or after cutting back in late spring or early summer.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars")]), _vm._v(":")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Aurea’ has golden green foliage and blue to violet flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Aurea Variegata’ (‘Golden King’) has green leaves with yellow variegation. It is otherwise similar to ‘Aurea’.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Barker’s Double’ has double purple-blue flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bengal Hybrids’ are seed-propagated forms with a mixture of lavender, purple and rose flowers on 6-8\" tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Bressingham Red’ produces double red flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Campbellii’ has double rose-purple flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Carnival’ is very free flowering and produces hummocks of purple-violet flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Cascade Hybrids’ provide flowers in shades of purple, red and lavender.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Dr. Mules’ is similar to ‘Carnival’ but a little less floriferous.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Greencourt Purple’ has semi-double to double lavender-purple flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Gurgedyke’ also has maroon-purple flowers. Free-flowering and compact.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘J.S. Baker’ bears bluish flowers with a white eye.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Leichtlinii’ has handsome bright red flowers on 4\" tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Purple Gem’ bears deep purple flowers over 6\" tall plants.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Red Carpet’ produces 6\" tall plants that form a mat of red-rose flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Royal Blue’ has dark blue flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Royal Red’ bears flowers in shades of red and magenta.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Whitewell Gem’ produces 6\" mats of deep blue flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Vindictive’ has large (up to 1\" wide) rosy-red flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Variegata’ has yellow-edged foliage in a tight clump. Lavender-blue flowers are a bonus.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrt"
  }, [_c('em', [_c('strong', [_vm._v("Aurinia")])]), _vm._v(" (ow-rin' ee-a)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentr"
  }, [_vm._v("Basket-of-Gold")]), _vm._v(" "), _c('p', {
    staticClass: "noindentrb"
  }, [_vm._v("Brassicaceae")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_186"
    }
  }, [_vm._v("There is general agreement among taxonomists that this plant should be called "), _c('em', [_vm._v("Aurinia")]), _vm._v(", so we can finally dispense with the old name of "), _c('em', [_vm._v("Alyssum")]), _vm._v(", although from the gardener’s point of view, it matters not at all. Of the approximately seven species, "), _c('em', [_vm._v("A. saxatilis")]), _vm._v(" is the most popular because of the intense yellow early spring flowers. I grew ")]), _c('a', {
    attrs: {
      "id": "page_187"
    }
  }, [_vm._v("this species with ease in East Lansing, Michigan and Guelph, Ontario, but had little success in north Georgia. In the South, if planted in early fall, performance is beautiful the first spring but plants gradually melt out during the summer. Planting under the shade of summer-flowering perennials may help it return in subsequent years but it should be replanted each fall for best form and color.")])]), _c('a', {
    attrs: {
      "id": "page_187"
    }
  }, [_c('p', {
    staticClass: "table1"
  }, [_c('em', [_c('strong', [_vm._v("-saxatilis")])]), _vm._v(" (saks-ah' ti-lis)")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Basket-of-Gold")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("12\"/18\"")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Spring")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Yellow")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Eastern Europe")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  }, [_vm._v("Zones 3-7")]), _vm._v(" "), _c('p', {
    staticClass: "table"
  })]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_187"
    }
  }), _c('a', {
    attrs: {
      "id": "page_188"
    }
  }, [_vm._v("When "), _c('em', [_vm._v("Aurinia")]), _vm._v(" is in flower, the canary-yellow flowers can be seen shimmering across the length of a football field. It requires full sun and excellent drainage and should be cut back after flowering. The foliage is gray green and spreads into clumps very rapidly. The yellow flowers combine beautifully with purple flowers of "), _c('em', [_vm._v("Verbena")]), _vm._v(" ‘Homestead Purple’ or "), _c('em', [_vm._v("Phlox divaricata")]), _vm._v(" ‘Louisiana’. It is a classic rock garden and wall plant.")])]), _c('a', {
    attrs: {
      "id": "page_188"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Seed germinates in 2-3 weeks in moist, warm (70-75°F) conditions. Seeds are available for the species and a few cultivars but division in the fall is the easiest method of propagation. Cuttings may also be taken in the spring or fall.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('strong', [_vm._v("Cultivars:")])]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Citrina’ (‘Sulphurea’) has lemon gold flowers and grows 12-15\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Compacta’ is similar to ‘Gold Ball’ but more compact.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Dudley Nevill Variegated’ has apricot-salmon flowers over leaves with cream-colored margins. Interesting if you like the color combination.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Flore’ (‘Flore-plena’) has double flowers but is generally less vigorous than the singles.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Gold Ball’ starts to flower in early to mid April in the South and about 2 weeks later further north. Plants have a globose habit and grow about 8\" tall.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Golden Queen’ is certainly not much different than ‘Gold Ball’. The plants grow into a 9-12\" mound with light yellow flowers.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Sunny Border Apricot’, raised by the fine nursery, Sunny Border of Kensington, Connecticut, has apricot flowers. Very handsome.")]), _vm._v(" "), _c('p', {
    staticClass: "bib"
  }, [_vm._v("‘Tom Thumb’ is only 3-6\" tall but vigorous.")])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_188"
    }
  }), _c('a', {
    attrs: {
      "id": "page_Arm_color_1_1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0001-01.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_Arm_color_1_1"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Acanthus hungaricus")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0001-02.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Achillea")]), _vm._v(" ‘Flowers of Sulphur’")]), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('div', {
    staticStyle: {
      "height": "500px"
    }
  }, [_c('p', {
    staticClass: "imagen"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "height": "100%",
      "src": "images/1_f0001-03.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Aconitum napellus")])])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0001-04.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Actaea")]), _vm._v(" ‘Black Negligee’")])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_Arm_color_1_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_Arm_color_1_2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0002-01.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_Arm_color_1_2"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Adiantum pedatum")]), _vm._v(" with "), _c('em', [_vm._v("Osmunda cinnamomea")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0002-02.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Aegopodium podagrarium")]), _vm._v(" ‘Variegatum’")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0002-03.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Agapanthus")]), _vm._v(" Headbourne hybrids")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0002-04.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Agastache")]), _vm._v(" ‘Blue Fortune’")])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_Arm_color_1_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_Arm_color_1_3"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0003-01.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_Arm_color_1_3"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Ajuga reptans")]), _vm._v(" ‘Black Scallop’")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0003-02.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Allium giganteum")]), _vm._v(" with canna lily")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0003-03.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Allium giganteum")]), _vm._v(" fruit")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0003-04.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Allium")]), _vm._v(" ‘Globemaster’ "), _c('em', [_vm._v("(")]), _vm._v("with "), _c('em', [_vm._v("Delphinium)")])])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_Arm_color_1_3"
    }
  }), _c('a', {
    attrs: {
      "id": "page_Arm_color_1_4"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0004-01.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_Arm_color_1_4"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Amsonia hubrichtii")]), _vm._v(" with "), _c('em', [_vm._v("Iris pallida")]), _vm._v(" ‘Variegata’")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0004-02.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Amsonia hubrichtii")]), _vm._v(" (fall color)")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0004-03.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Aquilegia canadensis")]), _vm._v(" with "), _c('em', [_vm._v("Adiantum pedatum")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0004-04.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Aquilegia canadensis")]), _vm._v(" ‘Little Lanterns’")])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_Arm_color_1_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_Arm_color_1_5"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0005-01.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_Arm_color_1_5"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Aquilegia")]), _vm._v(" × "), _c('em', [_vm._v("hybrida")]), _vm._v(" ‘Blue Bird’")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0005-02.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Arisaema dracontium")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0005-03.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Arisaema taiwanense")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0005-04.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Arisaema triphyllum")])])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_Arm_color_1_5"
    }
  }), _c('a', {
    attrs: {
      "id": "page_Arm_color_1_6"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0006-01.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_Arm_color_1_6"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Artemisia lactiflora")]), _vm._v(" ‘Guizhou’")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0006-02.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Arum italicum")]), _vm._v(" ‘Pictum’ (fruit)")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0006-03.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Aruncus")]), _vm._v(" ‘Misty Lace’")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0006-04.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Asarum canadense")])])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_Arm_color_1_6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_Arm_color_1_7"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0007-01.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_Arm_color_1_7"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Aster")]), _vm._v(" ‘English Countryside’")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0007-02.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Astilbe chinensis")]), _vm._v(" ‘Visions’")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0007-03.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Astilbe simplicifolia")]), _vm._v(" ‘Sprite’")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0007-04.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Astilbe")]), _vm._v(" × "), _c('em', [_vm._v("arendsii")]), _vm._v(" ‘Radius’")])]), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_Arm_color_1_7"
    }
  }), _c('a', {
    attrs: {
      "id": "page_Arm_color_1_8"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0008-01.jpg",
      "width": "550px"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_Arm_color_1_8"
    }
  }, [_c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Astilboides tabularis")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/1_f0008-02.jpg",
      "width": "550px"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', [_vm._v("Astrantia maxima")])])])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(120),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(144),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(147),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(150),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(153),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(156),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(159),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(162),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(165),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(168),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(170),
  /* template */
  __webpack_require__(171),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(174),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(177),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(180),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(182),
  /* template */
  __webpack_require__(183),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781610583800',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(187)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(189);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 189 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.5f077ba390df3b1047cc.js